// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` 
/* Css For OCDS */

/************ TABLE OF CONTENTS ***************
1. Fonts
2. Reset
3. Global
4. Main Header/style-one/style-two
5. Main Slider/style-one/style-two
6. Intro Section
7. Welcome Section
9. Cta Section
8. Research Fields
10. Testimonial Section
11. Researches Section
12. Team Section
14. Video
15. Fact Counter
16. News Section
19. Clients Section
20. Main Footer
21. Footer Bottom
22. Research Style Two
23. Innovative Solution
24. Discover Section
25. Testimonial Section
26. Chooseus Section
27. News Style Two
28. Page Title
29. Research Page Section
30. Research Details
31. Professor Page Section
32. Professor Details
33. About Section
34. Error Section
35. Blog Page Section
36. Blog Details
37. Blog Sidebar
38. Contact Section
39. Google Map


**********************************************/



/*** 

====================================================================
  Reset
====================================================================

 ***/
 * {
    margin:0px;
    padding:0px;
    border:none;
    outline:none;
  }
  
  
  /*** 
  
  ====================================================================
    Global Settings
  ====================================================================
  
   ***/
  
  
  body {
     font-size:15px;
    color:#002c5d;
    line-height:28px;
    font-weight:400;
    background:#ffffff;
    font-family: 'Muli', sans-serif;
    background-size:cover;
    background-repeat:no-repeat;
    background-position:center top;
    -webkit-font-smoothing: antialiased;
  }
  
    @media (min-width:1200px) {
    .container {
      max-width: 1170px;
      padding: 0px 15px;
    }
  }
  
  .container-fluid{
    padding: 0px;
  }
  
  .large-container{
    position:static;
    max-width:1480px;
    padding:0px 15px;
    margin:0 auto;
  }
  
  .auto-container{
    position:static;
    max-width:1200px;
    padding:0px 15px;
    margin:0 auto;
  }
  
  .small-container{
    max-width:680px;
    margin:0 auto;
  }
  
  .boxed_wrapper{
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    min-width: 300px;
  }
  
  
  a{
    text-decoration:none !important;
    transition:all 500ms ease;
    -moz-transition:all 500ms ease;
    -webkit-transition:all 500ms ease;
    -ms-transition:all 500ms ease;
    -o-transition:all 500ms ease;
  }
  
  a:hover{
    text-decoration:none;
    outline:none;
  }
  
  input,button,select,textarea{
    font-family: 'Muli', sans-serif;
    font-weight: 400;
    font-size: 15px;
    color: #555;
  }
  
  ul,li{
    list-style:none;
    padding:0px;
    margin:0px; 
  }
  
  input{
    transition: all 500ms ease;
  }
  
  button:focus,
  input:focus,
  textarea:focus{
    outline: none;
    box-shadow: none;
    transition: all 500ms ease;
  }
  
  p{
    position: relative;
    font-size: 15px;
    line-height: 28px;
    font-family: 'Muli', sans-serif;
    font-weight: 400;
    color: #002c5d;
    margin: 0px;
    transition: all 500ms ease;
  }
  
  h1,h2,h3,h4,h5,h6{
    position:relative;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 400;
    color: #001b44;
    margin: 0px;
    transition: all 500ms ease;
  }
  
  /* Preloader */
  
  .preloader {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-position: center center;
    background-repeat: no-repeat;
    /* background-image: url(../images/icons/preloader.png); */
  }
  
  .preloader-close{
    position: fixed;
    z-index: 999999;
    color: #fff;
    padding: 10px 20px;
    cursor: pointer;
    right: 0;
    bottom: 0;
    font-weight: 600;
  }
  
  .preloader.style-two .preloader-close{
  
  }
  
  .loader-wrap {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 999999;
  }
  
  .loader-wrap .layer-one {
    position: absolute;
    left: 0%;
    top: 0;
    width: 33.3333%;
    height: 100%;
    overflow: hidden;
  }
  
  .loader-wrap .layer-two {
    position: absolute;
    left: 33.3333%;
    top: 0;
    width: 33.3333%;
    height: 100%;
    overflow: hidden;
  }
  
  .loader-wrap .layer-three {
    position: absolute;
    left: 66.6666%;
    top: 0;
    width: 33.3333%;
    height: 100%;
    overflow: hidden;
  }
  
  .loader-wrap .layer .overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #002c5d;
  }
  
  
  .centred{
    text-align: center;
  }
  
  .pull-left{
    float: left;
  }
  
  .pull-right{
    float: right;
  }
  
  
  figure{
    margin: 0px;
  }
  
  img {
    display: inline-block;
    max-width: 100%;
    height: auto;
    transition-delay: .1s;
    transition-timing-function: ease-in-out;
    transition-duration: .7s;
    transition-property: all;
  }
  
  /** button **/
  
  .theme-btn-one, .theme-btn-one.nav-link{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #fff !important;
    border-radius: 4px;
    text-align: center;
    background: #001b44;
    padding: 15px 44px;
    text-transform: uppercase;
    z-index: 1;
  }
  
  .theme-btn-one:hover:after{
    transform: scaleX(1);
    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  }
  
  .theme-btn-one:after{
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 4px;
    transform: scaleX(0);
    transform-origin: 50% 100%;
    transition-property: transform;
    transition-duration: 0.5s;
    transition-timing-function: ease-out;
  }
  
  .theme-btn-two,  #Button_react{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #fff !important;
    border-radius: 4px;
    text-align: center;
    padding: 10px 29px;
    text-transform: uppercase;
    z-index: 1;
  }
  
  .theme-btn-two:hover:after,  #Button_react:hover:after{
    transform: scaleX(1);
    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  }
  
  .theme-btn-two:after, #Button_react:after{
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 4px;
    background: #001b44 !important;
    transform: scaleX(0);
    transform-origin: 50% 100%;
    transition-property: transform;
    transition-duration: 0.5s;
    transition-timing-function: ease-out;
  }
  
  
  .pagination{
    position: relative;
    display: block;
  }
  
  .pagination li{
    display: inline-block;
    margin-right: 7px;
  }
  
  .pagination li:last-child{
    margin-right: 0px;
  }
  
  .pagination li a{
    position: relative;
    display: inline-block;
    font-size: 20px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    height: 50px;
    width: 50px;
    line-height: 50px;
    text-align: center;
    color: #001b44;
    background: transparent;
    border-radius: 5px;
    border: 1px solid #eae0d9;
    z-index: 1;
    transition: all 500ms ease;
  }
  
  .pagination li a i{
    font-size: 14px;
  }
  
  .pagination li a:hover,
  .pagination li a.active{
    color: #fff;
  }
  
  .sec-pad{
    padding: 95px 0px 130px 0px !important;
  }
  
  .sec-pad-2{
    padding: 130px 0px !important;
  }
  
  
  .scroll-top{
    width: 50px;
    height: 120px;
    position: fixed;
    display: inline-block;
    bottom: 10%;
    right: 40px;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Nunito Sans', sans-serif;
    z-index: 99;
    color: #ffffff;
    background: #3e252d;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    text-transform: uppercase;
    z-index: 1;
    transition: 1s ease;
  }
  
  .scroll-top i{
    position: relative;
    display: block;
    font-size: 30px;
    font-weight: 400;
    margin-bottom: 10px;
  }
  
  .scroll-top:hover{
    
  }
  
  .scroll-top.open {
    bottom: 40px;
  }
  
  .sec-title{
    position: relative;
    display: block;
    margin-bottom: 50px;
  }
  
  .sec-title .top-title{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Muli', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 12px;
    padding-top: 28px;
    z-index: 1;
  }
  
  .sec-title .top-title:before{
    position: absolute;
    content: '';
    background: #001b4421;
    width: 50px;
    height: 50px;
    border-radius: 5px;
    left: -25px;
    top: 8px;
    z-index: -1;
  }
  
  .sec-title .top-title:after{
    position: absolute;
    content: '';
    background: #001b4421;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    width: 24px;
    height: 24px;
    border-radius: 3px;
    left: 9px;
    top: 0px;
    z-index: -1;
  }
  
  .sec-title h2{
    position: relative;
    display: block;
    font-size: 44px;
    line-height: 54px;
    font-weight: 700;
  }
  
  .sec-title.light h2{
    color: #fff;
  }
  
  .sec-title p{
    font-size: 18px;
    line-height: 26px;
    margin-top: 16px;
  }
  
  
  
  /*** 
  
  ====================================================================
                          Home-Page-One
  ====================================================================
  
  ***/
  
  
  /** main-header **/
  
  .main-header{
    position:relative;
    left:0px;
    top:0px;
    z-index:999;
    width:100%;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
    transition:all 500ms ease;
    -moz-transition:all 500ms ease;
    -webkit-transition:all 500ms ease;
    -ms-transition:all 500ms ease;
    -o-transition:all 500ms ease;
  }
  
  .sticky-header{
    position:fixed;
    opacity:0;
    visibility:hidden;
    background: #fff;
    left:0px;
    top:0px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    width:100%;
    z-index:0;
    transition:all 500ms ease;
    -moz-transition:all 500ms ease;
    -webkit-transition:all 500ms ease;
    -ms-transition:all 500ms ease;
    -o-transition:all 500ms ease;
  }
  
  .fixed-header .sticky-header{
    z-index:999;
    opacity:1;
    visibility:visible;
    -op-animation-name: fadeInDown;
    animation-name: fadeInDown;
    -op-animation-duration: 500ms;
    animation-duration: 500ms;
    -op-animation-timing-function: linear;
    animation-timing-function: linear;
    -op-animation-iteration-count: 1;
    animation-iteration-count: 1;
  }
  
  /** header-top **/
  
  .main-header .header-top{
    position: relative;
    width: 100%;
    padding: 0px 50px;
    border-bottom: 1px solid #eae0d9;
  }
  
  .main-header .header-top .top-inner{
    position: relative;
    display: flex;
     align-items: center;
    justify-content: space-between;
  }
  
  .main-header .header-top .left-info{
    position: relative;
    padding:  0;
    margin-bottom: 0 !important;
  }
  
  .main-header .header-top .location-box{
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 11px 30px 11px 30px;
    border-left: 1px solid #eae0d9;
    border-right: 1px solid #eae0d9;
  }
  
  .main-header .header-top .right-info{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 11px 0px;
  }
  
  .main-header .header-top .left-info li{
    position: relative;
    display: inline-block;
    font-size: 15px;
    line-height: 20px;
    color: #002c5d;
    font-weight: 600;
    margin-right: 30px;
    padding-left: 25px;
  }
  
  .main-header .header-top .left-info li:last-child{
    margin-right: 0px;
  }
  
  .main-header .header-top .left-info li p{
    font-size: 15px;
    line-height: 20px;
    color: #002c5d;
    font-weight: 600;
  }
  
  .main-header .header-top .left-info li p a{
    color: #002c5d;
  }
  
  .main-header .header-top .left-info li p a:hover{
  
  }
  
  .main-header .header-top .left-info li i{
    position: absolute;
    left: 0px;
    top: 0px;
    font-size: 18px;
    font-weight: 400;
  }
  
  .main-header .header-top .left-info li p span{
    font-weight: 700;
    color: #001b44;
    text-transform: uppercase;
  }
  
  .main-header .header-top .location-box .location-carousel{
    position: relative;
    display: block;
    max-width: 560px;
    width: 100%;
    padding-right: 110px;
  }
  
  .main-header .header-top .location-box .location-carousel p{
    font-size: 15px;
    font-weight: 600;
  }
  
  .main-header .header-top .location-box .location-carousel p span{
    font-weight: 700;
   }
  
  .main-header .header-top .location-box .location-carousel .owl-nav{
    position: absolute;
    top: 0px;
    right: 0px;
  }
  
  .main-header .header-top .location-box .location-carousel .owl-nav .owl-prev,
  .main-header .header-top .location-box .location-carousel .owl-nav .owl-next{
    position: relative;
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    background: #001b4421;
    text-align: center;
    border-radius: 5px;
    font-size: 10px;
    color: #001b44;
    cursor: pointer;
    z-index: 1;
    margin: 0px 2.5px;
    transition: all 500ms ease;
  }
  
  .main-header .header-top .location-box .location-carousel .owl-nav .owl-prev:hover,
  .main-header .header-top .location-box .location-carousel .owl-nav .owl-next:hover{
    color: #fff;
  }
  
  .main-header .header-top .location-box .apply-btn{
    position: relative;
    padding-left: 30px;
  }
  
  .main-header .header-top .location-box .apply-btn a{
    position: relative;
    display: inline-block;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .main-header .header-top .location-box .apply-btn a i{
    font-size: 14px;
    margin-left: 8px;
  }
  
  .main-header .header-top .location-box .apply-btn a:hover{
    color: #001b44;
  }
  
  .main-header .header-top .right-info .list{
    margin-right: 30px;
  }
  
  .main-header .header-top .right-info .list li{
    position: relative;
    display: inline-block;
    font-size: 15px;
    font-weight: 600;
    margin-right: 15px;
  }
  
  .main-header .header-top .right-info .list li:last-child{
    margin-right: 0px !important;
  }
  
  .main-header .header-top .right-info .list li a{
    color: #002c5d;
  }
  
  .main-header .header-top .right-info .list li a:hover{
  
  }
  
  .main-header .header-top .right-info .social-links li{
    position: relative;
    display: inline-block;
    font-size: 15px;
    margin-right: 13px;
  }
  
  .main-header .header-top .right-info .social-links li:last-child{
    margin-right: 0px;
  }
  
  .main-header .header-top .right-info .social-links li a{
    color: #001b44;
  }
  
  .main-header .header-top .right-info .social-links li a:hover{
  
  }
  
  /** header-lower **/
  
  .main-header .header-lower{
    position: relative;
  }
  
  .main-header  .main-menu  {
    float: left;
  }
  
  .main-header .logo-box{
    position: relative;
    float: left;
    background: #002c5d;
    padding: 6px ;
    margin: 0 10px ;
    }

  #img_nav{ 
    background: #002c5d;
    padding: 6px;
    margin: 0 10px  ;

  }
  
  .main-header .menu-right-content{
    margin-top: 20px;
    /* padding-right: 50px; */
  }
  
  .main-header .menu-right-content li{
    position: relative;
    display: inline-block;
  }
  
  .main-header .menu-right-content .search-btn button{
    position: relative;
    display: inline-block;
    font-size: 18px;
    font-weight: 700;
    line-height: 26px;
    top: 2px;
    color: #000;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .main-header .menu-right-content .search-btn button:hover{
  
  }
  
  .main-header .language{
    position:relative;
    display: inline-block;
    /* margin: 0px 15px 0px 35px; */
  }
  
  .main-header .language .lang-btn{
    position:relative;
    display: inline-block;
    background: #001b4421;
    padding: 12px 15px 13px 14px;
    border-radius: 4px;
    height: 52px;
    cursor: pointer;
  }
  
  .main-header .language .lang-btn .icon{
    position: relative;
    display: inline-block;
    font-size: 18px;
    color: #001b44;
    margin-right: 5px;
  }
  
  .main-header .language .lang-btn .txt{
    position: relative;
    display: inline-block;
    vertical-align: middle;
    font-size: 13px;
    font-weight: 700;
    font-family: 'Nunito Sans', sans-serif;
    color: #001b44;
  }
  
  .main-header .language .lang-btn .arrow{
    position: relative;
    display: inline-block;
    vertical-align: middle;
    padding-left: 4px;
    font-size: 14px;
    color: #001b44;
  }
  
  .main-header .language .lang-dropdown{
    position: absolute;
    left: 0;
    top: 100%;
    width: 150px;
    background: #001b44;
    padding: 5px 0px;
    opacity: 0;
    visibility: hidden;
    z-index: 1;
    transform: translateY(20px);
    transition: all 300ms linear;
  }
  
  .main-header .language:hover .lang-dropdown{
    opacity: 1;
    visibility: visible;
    transform: translateY(0px);
  }
  
  .main-header .language .lang-dropdown li{
    position: relative;
    display: block;
    border-bottom: 1px solid rgba(255,255,255,0.2);
  }
  
  .main-header .language .lang-dropdown li:last-child{
    border: none;
  }
  
  .main-header .language .lang-dropdown li a{
    position: relative;
    display: block;
    padding: 5px 15px;
    font-size: 14px;
    line-height: 24px;
    color: #fff;
    text-align: left;
  }
  .navigation.clearfix li a:hover {
    color: #ff5956 !important;
}
  
  
  /** main-menu **/
  
   .main-menu .navbar-collapse{
    padding:0px;
    display:block !important;
  }
  
   .main-menu .navigation{
    margin:0px;
  }
  
   .main-menu .navigation > li{
    position:inherit;
    float:left;
    z-index:2;
    padding:36px 0px 33px 0px;
    margin: 0px 18px;
    transition:all 300ms ease;
  }
  
   .main-menu .navigation > li:last-child{
    margin-right:0px !important;
  }
  
   .main-menu .navigation > li:first-child{
    margin-left: 0px !important;
  }
  
   .main-menu .navigation > li > a, .nav_ocd{
    position:relative;
    display:block;
    text-align:center;
    font-size:14px;
    line-height:30px;
    font-weight:700;
    opacity:1;
    font-family: 'Nunito Sans', sans-serif;
    color:#001b44;
    z-index:1;
    padding-right: 17px;
    text-transform: uppercase;
    transition:all 500ms ease;
  }
  
   .main-menu .navigation > li.dropdown > a:before{
    position: absolute;
    display: inline-block;
    content: "\\f062";
    top: 0px;
    right: 0px;
    font-family: 'Font Awesome 5 Free';
    font-size: 12px;
    color: #bdadad;
    font-weight: 700;
    transform: rotate(20deg);
    transition: all 500ms ease;
  }
  
   .main-menu .navigation > li.dropdown.current > a:before,
   .main-menu .navigation > li.dropdown:hover > a:before{
    transform: rotate(0deg);
  }
  
   .main-menu .navigation > li > a span{
    position: absolute;
    top: -15px;
    right: -15px;
    font-size: 11px;
    color: #fff;
    font-weight: 500;
    width: 37px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    border-radius: 20px;
  }
  
   .main-menu .navigation > li > a span:before{
    position: absolute;
    content: '';
    width: 8px;
    height: 8px;
    left: 15px;
    bottom: -3px;
    transform: rotate(-45deg);
    z-index: -1;
  }
  
   .main-menu .navigation > li.dropdown.current > a:before,
   .main-menu .navigation > li.dropdown:hover > a:before{
  
  }
  
   .main-menu .navigation > li.current > a,
   .main-menu .navigation > li:hover > a{
    
  }
  
   .main-menu .navigation > li > ul,
   .main-menu .navigation > li > .megamenu{
    position:absolute;
    left: inherit;
    top:100%;
    width:250px;
    z-index:100;
    display:none;
    opacity: 0;
    visibility: hidden;
    padding: 10px 0px;
    background-color: #001b44;
    border-radius: 0px 0px 10px 10px;
    transform: translateY(30px);
    transform-origin: top;
    transition:all 500ms ease;
  }
  
   .main-menu .navigation > li > ul.from-right{
    left:auto;
    right:0px;  
  }
  
   .main-menu .navigation > li > ul > li{
    position:relative;
    width:100%;
    padding: 0px 30px;
  }
  
   .main-menu .navigation > li > ul > li:last-child{
    border-bottom:none; 
  }
  
   .main-menu .navigation > li > ul > li > a,
   .main-menu .navigation > li > .megamenu li > a{
    position:relative;
    display:block;
    padding:14px 0px 13px 0px;
    line-height:24px;
    font-weight:600;
    font-family: 'Nunito Sans', sans-serif;
    font-size:15px;
    text-transform:capitalize;
    color: rgba(255,255,255,0.5);
    border-bottom: 1px solid rgba(255,255,255,0.2);
    text-align: left;
    transition:all 500ms ease;
    -moz-transition:all 500ms ease;
    -webkit-transition:all 500ms ease;
    -ms-transition:all 500ms ease;
    -o-transition:all 500ms ease;
  }
  
   .main-menu .navigation > li > .megamenu li > a:hover{
    color: #fff;
  }
  
   .main-menu .navigation > li > ul > li > a:hover{
    padding-left: 18px;
    color: #fff;
  }
  
   .main-menu .navigation > li > ul > li > a:before{
    position: absolute;
    display: inline-block;
    content: "\\f062";
    top: 15px;
    left: 0px;
    font-family: 'Font Awesome 5 Free';
    font-size: 12px;
    color: #fff;
    font-weight: 700;
    opacity: 0;
    transform: rotate(20deg);
    transition: all 500ms ease;
  }
  
   .main-menu .navigation > li > ul > li > a:hover:before{
    top: 11px;
    opacity: 1;
  }
  
   .main-menu .navigation > li > ul > li:last-child > a,
   .main-menu .navigation > li > .megamenu li:last-child > a{
    border-bottom: none;
  }
  
   .main-menu .navigation > li > .megamenu li > a:hover{
  
  }
  
   .main-menu .navigation > li > ul > li.dropdown > a:after{
    font-family: 'Font Awesome 5 Free';
    content: "\\f105";
    position:absolute;
    right:20px;
    top:14px;
    display:block;
    line-height:24px;
    font-size:16px;
    font-weight:800;
    text-align:center;
    z-index:5;  
  }
  
   .main-menu .navigation > li > ul > li > ul{
    position:absolute;
    left: 100%;
    top:-2px;
    width:250px;
    margin-left: 10px;
    z-index:100;
    display:none;
    padding: 10px 0px;
    background-color: #001b44;
    border-radius: 10px;
    transform: translateY(30px);
  }
  
   .main-menu .navigation > li > ul > li > ul:before{
    position: absolute;
    content: '';
    width: 10px;
    height: 100%;
    left: -10px;
    top: 0px;
  }
  
   .main-menu .navigation > li > ul > li > ul.from-right{
    left:auto;
    right:0px;  
  }
  
   .main-menu .navigation > li > ul > li > ul > li{
    position:relative;
    width:100%;
    padding: 0px 30px;
  }
  
   .main-menu .navigation > li > ul > li > ul > li:last-child{
    border-bottom:none; 
  }
  
   .main-menu .navigation > li > ul > li > ul > li:last-child{
    border-bottom:none; 
  }
  
   .main-menu .navigation > li > ul > li > ul > li > a{
    position:relative;
    display:block;
    padding:14px 0px 13px 0px;
    line-height:24px;
    font-weight:600;
    font-family: 'Nunito Sans', sans-serif;
    font-size:15px;
    text-transform:capitalize;
    color: rgba(255,255,255,0.5);
    border-bottom: 1px solid rgba(255,255,255,0.2);
    text-align: left;
    transition:all 500ms ease;
    -moz-transition:all 500ms ease;
    -webkit-transition:all 500ms ease;
    -ms-transition:all 500ms ease;
    -o-transition:all 500ms ease;
  }
  
   .main-menu .navigation > li > ul > li > ul > li > a:before{
    position: absolute;
    display: inline-block;
    content: "\\f062";
    top: 15px;
    left: 0px;
    font-family: 'Font Awesome 5 Free';
    font-size: 12px;
    color: #fff;
    font-weight: 700;
    opacity: 0;
    transform: rotate(20deg);
    transition: all 500ms ease;
  }
  
   .main-menu .navigation > li > ul > li > ul > li > a:hover:before{
    top: 11px;
    opacity: 1;
  }
  
   .main-menu .navigation > li > ul > li > ul > li:last-child > a{
    border-bottom: none;
  }
  
   .main-menu .navigation > li > ul > li > ul > li > a:hover{
    color: #fff;
    padding-left: 18px;
  }
  
   .main-menu .navigation > li > ul > li > ul > li.dropdown > a:after{
    font-family: 'Font Awesome 5 Free';
    content: "\\f105";
    position:absolute;
    right:20px;
    top:12px;
    display:block;
    line-height:24px;
    font-size:16px;
    font-weight:900;
    z-index:5;  
  }
  
   .main-menu .navigation > li.dropdown:hover > ul,
   .main-menu .navigation > li.dropdown:hover > .megamenu{
    visibility:visible;
    opacity:1;
    transform: translateY(0);
    transition:all 500ms ease;
    -moz-transition:all 500ms ease;
    -webkit-transition:all 500ms ease;
    -ms-transition:all 500ms ease;
    -o-transition:all 500ms ease;
  }
  
   .main-menu .navigation li > ul > li.dropdown:hover > ul{
    visibility:visible;
    opacity:1;
    transform: translateY(0);
    transition:all 300ms ease;
    -moz-transition:all 300ms ease;
    -webkit-transition:all 500ms ease;
    -ms-transition:all 300ms ease;
    -o-transition:all 300ms ease; 
  }
  
   .main-menu .navigation li.dropdown .dropdown-btn{
    position:absolute;
    right:-32px;
    top:66px;
    width:34px;
    height:30px;
    text-align:center;
    font-size:18px;
    line-height:26px;
    color:#3b3b3b;
    cursor:pointer;
    display: none;
    z-index:5;
    transition: all 500ms ease;
  }
  
   .main-menu .navigation li.current.dropdown .dropdown-btn,
   .main-menu .navigation li:hover .dropdown-btn{
    
  }
  
   .main-menu .navigation li.dropdown ul li.dropdown .dropdown-btn{
    display: none;
  }
  
  .menu-area .mobile-nav-toggler {
    position: relative;
    float: right;
    font-size: 40px;
    line-height: 50px;
    cursor: pointer;
    color: #3786ff;
    display: none;
  }
  
  .menu-area .mobile-nav-toggler .icon-bar{
    position: relative;
    height: 2px;
    width: 30px;
    display: block;
    margin-bottom: 5px;
    background-color: #ffffff;
    transition: all 300ms ease;
  }
  
  .menu-area .mobile-nav-toggler .icon-bar:last-child{
    margin-bottom: 0px;
  }
  
  /** megamenu-style **/
  
   .main-menu .navigation > li.dropdown > .megamenu{
    position: absolute;
    width: 100%;
    padding: 30px 50px;
    left: 0px;
  }
  
   .main-menu .navigation li.dropdown .megamenu li h4{
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    padding: 3px 0px;
    color: #fff;
  }
  
  
  /** mobile-menu **/
  
  .nav-outer .mobile-nav-toggler{
    position: relative;
    float: right;
    font-size: 40px;
    line-height: 50px;
    cursor: pointer;
    color:#3786ff;
    display: none;
  }
  
  .mobile-menu{
    position: fixed;
    right: 0;
    top: 0;
    width: 300px;
    padding-right:30px;
    max-width:100%;
    height: 100%;
    opacity: 0;
    visibility: hidden;
    z-index: 999999;
  }
  
  .mobile-menu .navbar-collapse{
    display:block !important; 
  }
  
  .mobile-menu .nav-logo{
    position:relative;
    padding:3px 109px 0px;
    text-align:left;  
  }
  
  .mobile-menu-visible{
    overflow: hidden;
  }
  
  .mobile-menu-visible .mobile-menu{
    opacity: 1;
    visibility: visible;
  }
  
  .mobile-menu .menu-backdrop{
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    transform: translateX(101%);
    transition: all 900ms ease;
    -moz-transition: all 900ms ease;
    -webkit-transition: all 900ms ease;
    -ms-transition: all 900ms ease;
    -o-transition: all 900ms ease;
  }
  
  .mobile-menu-visible .mobile-menu .menu-backdrop{
    opacity: 0.70;
    visibility: visible;
    transition:all 0.7s ease;
    transform: translateX(0%);
  }
  
  .mobile-menu .menu-box{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
    background: #002c5d;
    padding: 0px 0px;
    z-index: 5;
    opacity: 0;
    visibility: hidden;
    border-radius: 0px;
    transform: translateX(101%);
  }
  
  .mobile-menu-visible .mobile-menu .menu-box{
    opacity: 1;
    visibility: visible;
    transition:all 0.7s ease;
    transform: translateX(0%);
  }
  
  .mobile-menu .close-btn{
    position: absolute;
    right: 15px;
    top: 15px;
    width: 30px;
    height: 30px;
    line-height: 28px;
    border: 2px solid #fff;
    border-radius: 50%;
    text-align: center;
    font-size: 15px;
    color: #ffffff;
    cursor: pointer;
    z-index: 10;
    transition:all 0.9s ease;
  }
  
  .mobile-menu-visible .mobile-menu .close-btn{
    transform:rotate(360deg);
  }
  
  .mobile-menu .close-btn:hover{
    transform:rotate(90deg);
  }
  
  .mobile-menu .navigation{
    position: relative;
    display: block;
    width: 100%;
    float: none;
  }
  
  .mobile-menu .navigation li{
    position: relative;
    display: block;
    border-top: 1px solid rgba(255,255,255,0.10);
  }
  
  .mobile-menu .navigation:last-child{
    border-bottom: 1px solid rgba(255,255,255,0.10);
  }
  
  .mobile-menu .navigation li > ul > li:first-child{
    border-top: 1px solid rgba(255,255,255,0.10);
  }
  
  .mobile-menu .navigation li > a{
    position: relative;
    display: block;
    line-height: 24px;
    padding: 10px 25px;
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    text-transform: uppercase;
    transition: all 500ms ease; 
  }
  
  .mobile-menu .navigation li ul li > a{
    font-size: 16px;
    margin-left: 20px;
    text-transform: capitalize;
  }
  
  .mobile-menu .navigation li > a:before{
    content:'';
    position:absolute;
    left:0;
    top:0;
    height:0;
    border-left:5px solid #fff;
    transition: all 500ms ease; 
  }
  
  .mobile-menu .navigation li.current > a:before{
    height:100%;
  }
  
  .mobile-menu .navigation li.dropdown .dropdown-btn{
    position:absolute;
    right:6px;
    top:6px;
    width:32px;
    height:32px;
    text-align:center;
    font-size:16px;
    line-height:32px;
    color:#ffffff;
    background:rgba(255,255,255,0.10);
    cursor:pointer;
    border-radius:2px;
    transition: all 500ms ease; 
    z-index:5;
  }
  
  .mobile-menu .navigation li.dropdown .dropdown-btn.open{
    background:#fff; 
    color: #3b3b3b;
    transform:rotate(90deg);  
  }
  
  .mobile-menu .navigation li > ul,
  .mobile-menu .navigation li > ul > li > ul,
  .mobile-menu .navigation > li.dropdown > .megamenu{
    display: none;
  }
  
  .mobile-menu .social-links{
    position:relative;
    padding:30px 25px;
  }
  
  .mobile-menu .social-links li{
    position:relative;
    display:inline-block;
    margin:0px 10px 10px;
  }
  
  .mobile-menu .social-links li a{
    position:relative;
    line-height:32px;
    font-size:16px;
    color:#ffffff;
    transition: all 500ms ease; 
  }
  
  .mobile-menu .social-links li a:hover{
    
  }
  
  div#mCSB_1_container{
    top: 0px !important;
  }
  
  .mobile-menu .contact-info {
    position: relative;
    padding: 80px 30px 20px 30px;
  }
  
  .mobile-menu .contact-info h4 {
    position: relative;
    font-size: 20px;
    color: #ffffff;
    font-weight: 700;
    margin-bottom: 20px;
  }
  
  .mobile-menu .contact-info ul li {
    position: relative;
    display: block;
    font-size: 15px;
    color: rgba(255,255,255,0.80);
    margin-bottom: 3px;
  }
  
  .mobile-menu .contact-info ul li a{
    color: rgba(255,255,255,0.80);
  }
  
  .mobile-menu .contact-info ul li a:hover{
    
  }
  
  .mobile-menu .contact-info ul li:last-child{
    margin-bottom: 0px;
  }
  
  
  /** search pop-up style **/
  
  
  .main-header .search-btn .search-toggler{
    position: relative;
    font-size: 22px;
    color: #222;
    font-weight: 400;
    background: transparent;
    cursor: pointer;
    display: inline-block;
    transition: all 500ms ease;
  }
  
  .main-header .search-btn .search-toggler{
    
  }
  
  .search-popup{
    position:fixed;
    left:0;
    top:0px;
    width:100%;
    height:100%;
    z-index:99999;
    visibility:hidden;
    opacity:0;
    overflow:auto;
    background: rgba(0, 0, 0, 0.9);
    transform:translateY(101%);
    transition:all 700ms ease;
    -moz-transition:all 700ms ease;
    -webkit-transition:all 700ms ease;
    -ms-transition:all 700ms ease;
    -o-transition:all 700ms ease;
  }
  
  .search-popup.popup-visible{
    transform:translateY(0%);
    visibility:visible;
    opacity:1;
  }
  
  .search-popup .overlay-layer{
    position:absolute;
    left:0px;
    top:0px;
    right:0px;
    bottom:0px;
    display:block;
  }
  
  .search-popup .close-search{
    position:absolute;
    right:25px;
    top:25px;
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border: 2px solid #fff;
    border-radius: 50%;
    font-size:10px;
    font-weight: 700;
    color:#ffffff;
    cursor:pointer;
    z-index:5;
    transition: all 500ms ease;
  }
  
  .search-popup .close-search:hover{
  
  }
  
  .search-popup .search-form{
    position: relative;
    padding: 0px 15px 0px;
    max-width: 1024px;
    margin: 0 auto;
    margin-top: 150px;
    margin-bottom: 100px;
    opacity: 0;
    transform: translateY(50px);
    z-index: 10;
  }
  
  .search-popup.popup-visible .search-form {
    opacity: 1;
    transform: translateY(0px);
    transition: all 500ms ease 500ms;
    -moz-transition: all 900ms ease 500ms;
    -webkit-transition: all 900ms ease 500ms;
    -ms-transition: all 900ms ease 500ms;
    -o-transition: all 900ms ease 500ms;
  }
  
  .search-popup .search-form .form-group{
    margin-bottom: 30px;
  }
  
  .search-popup .search-form fieldset{
    position:relative;
    border-radius:12px;
  }
  
  .search-popup .search-form fieldset input[type="search"]{
    position:relative;
    height:70px;
    padding:20px 250px 20px 30px;
    background:#ffffff;
    line-height:30px;
    font-size:24px;
    color:#233145;
    border-radius:7px;
    box-shadow: none;
    outline: none;
    border: none;
  }
  
  .search-popup .search-form fieldset input[type="submit"]{
    position:absolute;
    display:block;
    right:0px;
    top:0px;
    text-align:center;
    width:220px;
    height:70px;
    padding:20px 10px 20px 10px;
    color:#ffffff !important;
    line-height:30px;
    font-size:20px;
    cursor:pointer;
    text-transform:uppercase;
    border-radius:0px 7px 7px 0px;
  }
  
  .search-popup .search-form fieldset input[type="submit"]:hover{
    transform: translateY(0px);
  }
  
  .search-popup h3{
    text-transform:uppercase;
    font-size:20px;
    font-weight:600;
    color:#ffffff;
    margin-bottom:20px;
    letter-spacing:1px;
    text-align:center;  
  }
  
  .search-popup .recent-searches{
    font-size:16px;
    color:#ffffff;
    text-align:center;
  }
  
  .search-popup .recent-searches li{
    display:inline-block;
    margin:0px 10px 10px 0px; 
  }
  
  .search-popup .recent-searches li a{
    display:block;
    line-height:24px;
    border:1px solid #ffffff;
    padding:7px 15px;
    color:#ffffff;
    border-radius:3px;
    transition:all 0.5s ease;
  }
  
  .search-popup .recent-searches li a:hover{
    
  }
  #logo_nav{
    padding: 5px !important;
  }
  .sticky-header .logo-box{
    padding: 0 24px 14px 0    !important;
    float: left !important;
  }
  
  .sticky-header  .main-menu .navigation > li{
    padding: 24px 0px 21px 0px !important;
  }
  
  .sticky-header .menu-right-content{
    margin-top: 9px !important;
  }
  
  
  /** banner-section **/
  
  .banner-section{
    position: relative;
    background: #001b4421;
  }
  
  .banner-carousel{
    position: relative;
  }
  
  .banner-section.style-one .banner-carousel .slide-item{
    position: relative;
    overflow: hidden;;
  }
  
  .banner-section.style-one .banner-carousel .slide-item{
    padding: 171px 0px 180px 0px;
    min-height: 877px;
  }
  
  .banner-carousel .slide-item.style-two .content-box{
    padding-left: 60px;
  }
  
  .banner-section.style-one .banner-carousel .slide-item .image-layer{
    position:absolute;
    right:0;
    width:43%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  
  .banner-section .banner-carousel .slide-item .image-layer{
    position:absolute;
    top:0;
    height:100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transform:scale(1);
    transition: all 6000ms linear;
  }
  
  .banner-section .banner-carousel .active .slide-item .image-layer{
    transform:scale(1.15);
  }
  
  .banner-section.style-one .banner-carousel .slide-item.style-two .image-layer{
    right: inherit;
    left: 0;
  }
  
  .banner-carousel .content-box{
    position: relative;
    display: block;
    z-index:5;
    width: 100%;
  }
  
  .banner-carousel .content-box span{
    position: relative;
    display: inline-block;
    font-size: 15px;
    line-height: 20px;
    font-weight: 700;
    margin-bottom: 13px;
    text-transform: uppercase;
    opacity: 0;
    transform: translateY(-100px);
    transition: all 700ms ease;
  }
  
  .banner-carousel .active .content-box span{
    opacity: 1;
    transform: translateY(0);
    transition-delay: 700ms;
  }
  
  .banner-carousel .content-box h1{
    position: relative;
    display: block;
    font-size: 60px;
    line-height: 68px;
    font-weight: 800;
    margin-bottom: 23px;
    opacity: 0;
    transform: translateX(100px);
    transition: all 1000ms ease;
  }
  
  .banner-carousel .active .content-box h1{
    opacity: 1;
    transform: translateX(0);
    transition-delay: 1000ms;
  }
  
  .banner-carousel .content-box p{
    position: relative;
    display: block;
    color: #002c5d;
    font-size: 18px;
    line-height: 30px;
    font-weight: 500;
    margin-bottom: 41px;
    opacity: 0;
    transform: translateX(-100px);
    transition: all 1300ms ease;
  }
  
  .banner-carousel .active .content-box p{
    opacity: 1;
    transform: translateX(0);
    transition-delay: 1300ms;
  }
  
  .banner-carousel .content-box .btn-box{
    position: relative;
    opacity: 0;
    transform: translateY(100px);
    transition: all 1600ms ease;
  }
  
  .banner-carousel .active .content-box .btn-box{
    opacity: 1;
    transform: translateY(0);
    transition-delay: 1600ms;
  }
  
  .owl-dots-none .owl-dots,
  .owl-nav-none .owl-nav{
    display: none !important;
  }
  
  .banner-carousel .slide-item.style-one .content-box .pattern-layer .pattern-1{
    position: absolute;
    left: -130px;
    top: -80px;
    width: 300px;
    height: 300px;
    background: #e5dbd5;
    border-radius: 50%;
  }
  
  .banner-carousel .slide-item.style-one .pattern-layer .pattern-1{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 57%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  
  .banner-carousel .slide-item.style-one .pattern-layer .pattern-2{
    position: absolute;
    right: 0px;
    top: 0px;
    width: 43%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  
  .banner-carousel .slide-item.style-two .pattern-layer .pattern-1{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 43%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  
  .banner-carousel .slide-item.style-two .pattern-layer .pattern-2{
    position: absolute;
    right: 0px;
    top: 0px;
    width: 57%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  
  .bg-color-1{
    background: #001b44;
  }
  
  
  
  /** clients-section **/
  
  .clients-section{
    position: relative;
  }
  
  .clients-section .clients-logo-box{
    position: relative;
    display: block;
    background: #001b44;
    padding: 50px 0px;
    border-right: 1px solid rgba(255,255,255,0.2);
    margin-bottom: 28px;
  }
  
  .clients-section .clients-logo-box img{
    display: block;
    max-width: 100%;
    width: auto;
    margin: 0 auto;
    transition: all 300ms ease;
  }
  
  .clients-section .clients-logo-box .logo-title{
    position: absolute;
    left: 40px;
    bottom: -38px;
    width: calc(100% - 80px);
    background: #001b4421;
    text-align: center;
    border-radius: 5px;
    opacity: 0;
    visibility: hidden;
    transition: all 500ms ease;
  }
  
  .clients-section .clients-logo-box:hover .logo-title{
    bottom: -28px;
    opacity: 1;
    visibility: visible;
  }
  
  .clients-section .clients-logo-box .logo-title:before{
    position: absolute;
    content: '';
    background: #001b4421;
    width: 20px;
    height: 20px;
    left: 50%;
    margin-left: -13px;
    top: -8px;
    transform: rotate(45deg);
  }
  
  .clients-section .clients-logo-box .logo-title a{
    position: relative;
    display: block;
    padding: 15px 20px 11px 20px;
    font-size: 16px;
    line-height: 30px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 600;
    color: #001b44;
    z-index: 1;
  }
  
  
  /** welcome-section **/
  
  .welcome-section{
    position: relative;
    padding: 95px 0px 120px 0px;
  }
  
  .welcome-section .image-box{
    position: relative;
    display: block;
    margin-top: 6px;
  }
  
  .welcome-section .image-box img{
    width: 100%;
  }
  
  .tabs-box .tab{
    position:relative;
    display:none;
    transition: all 900ms ease;
    -moz-transition: all 900ms ease;
    -webkit-transition: all 900ms ease;
    -ms-transition: all 900ms ease;
    -o-transition: all 900ms ease;
  }
  
  .tabs-box .tab.active-tab{
    display:block;  
  }
  
  .tabs-box .tab{
    transform:scale(0.9,0.9) translateY(0px);
  }
  
  .tabs-box .tab.active-tab{
    transform:scale(1) translateY(0px);
  }
  
  .tabs-box-2 .tab-2{
    position:relative;
    display:none;
    transition: all 900ms ease;
    -moz-transition: all 900ms ease;
    -webkit-transition: all 900ms ease;
    -ms-transition: all 900ms ease;
    -o-transition: all 900ms ease;
  }
  
  .tabs-box-2 .tab-2.active-tab-2{
    display:block;  
  }
  
  .tabs-box-2 .tab-2{
    transform:scale(0.9,0.9) translateY(0px);
  }
  
  .tabs-box-2 .tab-2.active-tab-2{
    transform:scale(1) translateY(0px);
  }
  
  #content_block_1 .content-box{
    position: relative;
    display: block;
  }
  
  #content_block_1 .content-box .tab-btn-box{
    position: relative;
    margin-bottom: 43px;
  }
  
  #content_block_1 .content-box .tab-btns li{
    position: relative;
    display: inline-block;
    float: left;
    background: #001b4421;
    padding: 25px 70px 25px 70px;
    border-radius: 5px;
    width: 270px;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  #content_block_1 .content-box .tab-btns li:after{
    position: absolute;
    content: '';
    background: #d9cec7;
    width: 1px;
    height: 30px;
    right: 50px;
    top: 14px;
    }
  
  #content_block_1 .content-box .tab-btns li:hover{
    background: #002c5d;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);
    color: white;
  }
  #content_block_1 .content-box .tab-btns li.active-btn
 {
     background: #fff; 
     box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);
  }
  
  #content_block_1 .content-box .tab-btns li.active-btn:hover
  {
      background: #002c5d; 
      box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);
   }
  #content_block_1 .content-box .tab-btns li:last-child{
    float: right;
  }
  
  #content_block_1 .content-box .tab-btns li i.employ-icon{
    position: absolute;
    left: 20px;
    top: 20px;
    font-size: 30px;
    color: #001b44;
    transition: all 500ms ease;
  }
  
  #content_block_1 .content-box .tab-btns li h5{
    font-size: 18px;
    line-height: 25px;
    font-weight: 600;
  }
  
  #content_block_1 .content-box .tab-btns li i.arrow-icon{
    position: absolute;
    top: 12px;
    right: 17px;
    font-size: 20px;
    color: #b4a4a4;
    transition: all 500ms ease;
  }
  
 
  #content_block_1 .content-box .tab-btns li.active-btn i.bi{
    transform: rotate(180deg) !important;
  }
  
  #content_block_1 .content-box .inner-box h5{
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 14px;
    font-weight: 600;
  }
  
  #content_block_1 .content-box .inner-box h2{
    font-size: 36px;
    line-height: 44px;
    font-weight: 700;
    margin-bottom: 22px;
  }
  
  #content_block_1 .content-box .inner-box p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 38px;
  }
  
  #content_block_1 .content-box .inner-box .list li{
    position: relative;
    display: inline-block;
    float: left;
    width: 50%;
    padding: 0px 0px 0px 85px;
  }
  
  #content_block_1 .content-box .inner-box .list li .icon-box{
    position: absolute;
    left: 0px;
    top: -6px;
  }
  
  #content_block_1 .content-box .inner-box .list li h4{
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
  }
  
  #content_block_1 .content-box .inner-box .list{
    margin-bottom: 41px;
  }
  
  #content_block_1 .content-box .inner-box .link a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #001b44;
    text-transform: uppercase;
  }
  
  #content_block_1 .content-box .inner-box .link a i{
    position: relative;
    font-size: 30px;
    margin-right: 8px;
    font-weight: 400;
    top: 6px;
  }
  
  #content_block_1 .content-box .tabs-content .inner-box .link a:hover{
  
  }
  
  .welcome-section .sec-title{
    margin-bottom: 53px;
  }
  
  
  /** about-section **/
  
  .about-section{
    position: relative;
  }
  
  .about-section .inner-container{
    position: relative;
    display: block;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }
  
  .about-section #content_block_2 .content-box{
    margin-right: 30px;
  }
  
  #content_block_2 .content-box{
    position: relative;
    display: block;
    overflow: hidden;
  }
  
  #content_block_2 .content-box .image-box{
    position: relative;
    display: block;
    overflow: hidden;
  }
  
  #content_block_2 .content-box .image-box img{
    width: 100%;
  }
  
  #content_block_2 .content-box .inner-box{
    position: relative;
    background: #001b44;
    padding: 67px 30px;
  }
  
  #content_block_2 .content-box .image-box:before{
    position: absolute;
    top: 0;
    left: -75%;
    display: block;
    content: '';
    width: 50%;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .3) 100%);
    transform: skewX(-25deg);
  }
  
  #content_block_2 .content-box:hover .image-box:before{
    animation: shine 1s;
  }
  
  @keyframes shine {
    100% {
      left: 125%;
    }
  }
  
  #content_block_2 .content-box .inner-box .icon-box{
    position: relative;
    display: inline-block;
    margin-bottom: 23px;
  }
  
  #content_block_2 .content-box .inner-box h3{
    display: block;
    font-size: 24px;
    line-height: 32px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 27px;
  }
  
  #content_block_2 .content-box .inner-box a, #Button_react{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    color: #fff;
    font-weight: 700;
    border-radius: 5px;
    text-transform: uppercase;
    padding: 15px 65px 13px 20px;
  }
  
  #content_block_2 .content-box .inner-box a i, #Button_react i{
    position: absolute;
    top: 14px;
    right: 11px;
    font-size: 24px;
    font-weight: 400;
  }
  
  #content_block_2 .content-box .inner-box a:before, #Button_react:before{
    position: absolute;
    content: '';
    background: #001b44;
    width: 2px;
    height: 100%;
    right: 46px;
    top: 0px;
  }
  
  .about-section #content_block_3 .content-box{
    position: relative;
    padding: 95px 60px 100px 0px;
  }
  
  #content_block_3 .content-box .text p{
    font-size: 17px;
  }
  
  #content_block_3 .content-box .text{
    margin-bottom: 30px;
  }
  
  #content_block_3 .content-box .link a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #001b44;
    text-transform: uppercase;
  }
  
  #content_block_3 .content-box .link a i{
    position: relative;
    font-size: 30px;
    margin-right: 8px;
    font-weight: 400;
    top: 6px;
  }
  
  #content_block_3 .content-box .link a:hover{
  
  }
  
  #content_block_3 .content-box .link{
    position: relative;
    margin-bottom: 41px;
  }
  
  #content_block_3 .content-box .author-text{
    position: relative;
    display: block;
    background: #001b4421;
    padding: 41px 28px 0 69px;
    border-radius: 100px 100px 100px 0px;
    margin-bottom: 20px;
    min-height: 130px;
  }
  
  #content_block_3 .content-box .author-text:before{
    position: absolute;
    content: '';
    background: #001b4421;
    width: 40px;
    height: 40px;
    left: 0px;
    bottom: -40px;
    clip-path: polygon(0% 0%, 100% 0%, 0% 100%, 0% 100%, 0% 0%);
  }
  
  #content_block_3 .content-box .author-text h3{
    position: relative;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
  }
  
  #content_block_3 .content-box .author-text h3:before{
    position: absolute;
    content: '';
    width: 3px;
    height: 70px;
    left: -42px;
    top: -2px;
  }
  
  #content_block_3 .content-box .author-text h3:after{
    position: absolute;
    content: '';
    width: 3px;
    height: 35px;
    left: -33px;
    top: -2px;
  }
  
  #content_block_3 .content-box .author-info{
    position: relative;
    display: block;
    padding: 3px 0px 10px 100px;
  }
  
  #content_block_3 .content-box .author-info .author-thumb{
    position: absolute;
    left: 20px;
    top: 0px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  
  #content_block_3 .content-box .author-info .author-thumb img{
    width: 100%;
    border-radius: 50%;
  }
  
  #content_block_3 .content-box .author-info h4{
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
  }
  
  #content_block_3 .content-box .author-info .designation{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    color: #002c5d;
  }
  
  #content_block_3 .content-box .author-info .signature{
    position: absolute;
    top: 0px;
    right: 50px;
  }
  
  #content_block_3 .content-box .sec-title{
    margin-bottom: 30px;
  }
  
  .about-section .pattern-layer{
    position: absolute;
    left: 0px;
    top: 423px;
    right: 0px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom center;
    width: 100%;
    height: 380px;
  }
  
  
  /** service-section **/
  
  .service-section{
    position: relative;
    padding: 95px 0px 120px 0px;
  }
  
  .service-block-one{
    margin-top: 20px;
  }
  
  .service-block-one .inner-box{
    position: relative;
    display: block;
    text-align: center;
  }
  
  .service-block-one .inner-box .image-box{
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  .service-block-one .inner-box .image-box img{
    width: 100%;
    border-radius: 10px;
    transition: all 500ms ease;
  }
  
  .service-block-one .inner-box:hover .image-box img{
    transform: scale(1.1);
  }
  
  .service-block-one .inner-box .lower-content{
    position: relative;
    padding: 0px 70px;
  }
  
  .service-block-one .inner-box .lower-content .content-box{
    position: relative;
    margin-top: -117px;
    transition: all 500ms ease;
  }
  
  .service-block-one .inner-box:hover .lower-content .content-box{
    opacity: 0;
  }
  
  .service-block-one .inner-box .lower-content .content-box .inner{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 10px;
    padding: 67px 15px 22px 15px;
    margin-bottom: 21px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  .service-block-one .inner-box .lower-content .content-box .inner .icon-box{
    position: relative;
    display: inline-block;
    margin-bottom: 12px;
  }
  
  .service-block-one .inner-box .lower-content .content-box .inner h4{
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
  }
  
  .service-block-one .inner-box .lower-content .content-box .link a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    color: #001b44;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .service-block-one .inner-box .lower-content .overlay-content{
    position: absolute;
    left: 30px;
    top: 30px;
    background: #001b44;
    border-radius: 10px;
    width: calc(100% - 60px);
    overflow: hidden;
    visibility: hidden;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .service-block-one .inner-box:hover .lower-content .overlay-content{
    top: 0px;
    opacity: 1;
    visibility: visible;
  }
  
  .service-block-one .inner-box .lower-content .overlay-content p{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    color: rgba(255, 255, 255, 0.744);
    font-weight: 500;
    padding: 30px 15px 32px 15px;
    text-align: justify;
  }
  
  .service-block-one .inner-box .lower-content .overlay-content a{
    position: relative;
    display: block;
    padding: 6px 15px 13px 15px;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .service-block-one .inner-box .lower-content .overlay-content a i{
    position: relative;
    font-size: 30px;
    margin-right: 8px;
    font-weight: 400;
    top: 6px;
  }
  
  .service-section .pattern-layer{
    position: absolute;
    left: 0px;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 580px;
    background-size: cover;
    background-repeat: no-repeat;
  }
  
  .service-section .sec-title{
    margin-bottom: 33px;
  }
  
  .service-section .owl-dots{
    position: relative;
    display: block;
    text-align: center;
    margin-top: 40px;
  }
  
  .owl-dot-style-one .owl-dots .owl-dot span{
    position: relative;
    display: inline-block;
    width: 3px;
    height: 10px;
    background: #c2b3aa;
    margin: 0px 5px;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .owl-dot-style-one .owl-dots .owl-dot.active span,
  .owl-dot-style-one .owl-dots .owl-dot span:hover{
    height: 20px;
  }
  
  .service-section .anim-icon{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    max-width: 1200px;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
  
  .service-section .anim-icon .icon-1{
    position: absolute;
    left: -25px;
    top: 45px;
    width: 170px;
    height: 250px;
    background-repeat: no-repeat;
  }
  
  .service-section .anim-icon .icon-2{
    position: absolute;
    top: 140px;
    right: 130px;
    background: #001b4421;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    animation: zoom-fade 5s infinite linear;
  }
  
  
  /** recruitment-technology **/
  
  .recruitment-technology{
    position: relative;
    padding: 0;
  }
  
  .recruitment-technology .image-box{
    position: relative;
    display: block;
    margin-right: -100px;
  }
  
  .recruitment-technology .image-box img{
    max-width: none;
    float: right;
  }
  
  #content_block_4 .content-box .inner-box .single-item{
    position: relative;
    display: block;
    background: #fff;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
    padding: 27px 30px 33px 30px;
    border-radius: 10px;
  }
  
  #content_block_4 .content-box .inner-box .single-item:last-child{
    margin-bottom: 0px;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner{
    position: relative;
    padding-left: 100px;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner .icon-box{
    position: absolute;
    left: 0px;
    top: 3px;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    padding-left: 82px;
    margin-bottom: 8px;
    transition: all 500ms ease;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner h3 a{
    display: inline-block;
    color: #001b44;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner h3 a:hover{
  
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner h3 a i{
    position: relative;
    font-size: 30px;
    margin-left: 8px;
    font-weight: 400;
    top: 5px;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  #content_block_4 .content-box .inner-box .single-item:hover .inner h3 a i{
    opacity: 1;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner h3 span{
    position: absolute;
    left: 0px;
    top: 6px;
    font-size: 20px;
    transition: all 500ms ease;
  }
  
  #content_block_4 .content-box .inner-box .single-item:hover .inner h3 span{
    opacity: 0;
  }
  
  #content_block_4 .content-box .inner-box .single-item:hover .inner h3{
    padding-left: 0px;
  }
  
  #content_block_4 .content-box .inner-box .single-item .inner h3:before{
    position: absolute;
    content: '';
    width: 40px;
    height: 2px;
    left: 32px;
    top: 19px;
    transition: all 500ms ease;
  }
  
  #content_block_4 .content-box .inner-box .single-item:hover .inner h3:before{
    opacity: 0;
  }
  
  #content_block_4 .content-box .sec-title{
    margin-bottom: 43px;
  }
  
  
  /** industries-section **/
  
  .industries-section{
    position: relative;
    overflow: hidden;
    padding: 95px 0px 120px 0px;
  }
  
  .industries-section .sec-title .top-title:before{
    background: #624b52;
  }
  
  .industries-section .sec-title .top-title:after{
    background: #624b52;
    border-left: 2px solid #001b44;
    border-bottom: 2px solid #001b44;
  }
  
  .industries-section .sec-title{
    margin-bottom: 37px;
  }
  
  .industries-section .tabs-content{
    position: relative;
    display: block;
    margin: 35px -375px 0px 30px;
  }
  
  .industries-section .tabs-content .image-box{
    position: relative;
    display: block;
    border-radius: 10px;
  }
  
  .industries-section .tabs-content .image-box:before{
    position: absolute;
    content: '';
    background: -webkit-linear-gradient(-90deg, rgba(255, 0, 85, 0), #00183b 100%);
    width: 100%;
    height: 100%;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
  
  .industries-section .tabs-content .image-box img{
    width: 100%;
    border-radius: 10px;
  }
  
  .industries-section .tabs-content .inner-box{
    position: relative;
  }
  
  .industries-section .tabs-content .inner-box .content-box{
    position: absolute;
    left: 0px;
    bottom: 0px;
    padding: 0px 70px;
    width: 100%;
    z-index: 1;
    display: flex;
    align-items: center;
  }
  
  .industries-section .tabs-content .inner-box .content-box .text h2{
    position: relative;
    display: block;
    font-size: 36px;
    line-height: 45px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 2px;
  }
  
  .industries-section .tabs-content .inner-box .content-box .text span{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    color: #fff;
    font-style: italic;
    font-weight: 500;
  }
  
  .industries-section .tabs-content .inner-box .content-box .link{
    position: relative;
    float: right;
    margin-left: 60px;
  }
  
  .industries-section .tabs-content .inner-box .content-box .link a{
    position: relative;
    display: inline-block;
    font-size: 38px;
    font-weight: 700;
    color: #001b44;
    width: 62px;
    height: 62px;
    line-height: 62px;
    background: #fff;
    text-align: center;
    border-radius: 50%;
    z-index: 1;
  }
  
  .industries-section .tabs-content .inner-box .content-box .link a:hover{
    color: #fff;
  }
  
  .industries-section .tabs-content .inner-box .content-box .text{
    position: relative;
    display: inline-block;
    margin-right: 60px;
  }
  
  .industries-section .tabs-content .inner-box .content-box .line {
    position: relative;
    display: block;
    height: 1px;
    background: rgba(255,255,255,0.2);
    width: calc(100% - 120px);
    flex: 1 1;
    top: 3px;
  }
  
  .industries-section .tab-btns li{
    position: relative;
    display: block;
    padding: 9px 0px 27px 70px;
    cursor: pointer;
    margin-bottom: 14px;
    min-height: 50px;
    transition: all 500ms ease;
  }
  
  .industries-section .tab-btns li:before{
    position: absolute;
    content: '';
    background: rgba(255,255,255,0.2);
    width: 50px;
    height: 1px;
    left: 70px;
    bottom: 0px;
    transition: all 500ms ease;
  }
  
  .industries-section .tab-btns li.active-btn:before,
  .industries-section .tab-btns li:hover:before{
    width: calc(100% - 70px);
  }
  
  .industries-section .tab-btns li:last-child{
    margin-bottom: 0px;
  }
  
  .industries-section .tab-btns li .icon-box{
    position: absolute;
    left: 0px;
    top: 0px;
  }
  
  .industries-section .tab-btns li h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    color: #fff;
    font-weight: 700;
    transition: all 500ms ease;
  }
  
  .industries-section .tab-btns li.active-btn h3,
  .industries-section .tab-btns li:hover h3{
  
  }
  
  .industries-section .pattern-layer{
    position: absolute;
    left: 10px;
    top: -175px;
    width: 1060px;
    height: 1170px;
    background-repeat: no-repeat;
  }
  
  
  /** process-section **/
  
  .process-section{
    position: relative;
    padding: 95px 0px 120px 0px;
  }
  
  .process-section .sec-title{
    margin-bottom: 75px;
  }
  
  .process-block-one .inner-box{
    position: relative;
    display: block;
  }
  
  .process-block-one .inner-box:before{
    position: absolute;
    content: '';
    /* background: url(../images/icons/arrow-1.png); */
    width: 58px;
    height: 70px;
    top: 30px;
    right: -45px;
    background-repeat: no-repeat;
  }
  
  .process-block:last-child .process-block-one .inner-box:before{
    display: none;
  }
  
  .process-block-one .inner-box .icon-box{
    position: relative;
    display: inline-block;
    width: 146px;
    height: 128px;
    text-align: center;
    line-height: 128px;
    margin-bottom: 43px;
    z-index: 1;
  }
  
  .process-block-one .inner-box .icon-box:before{
    position: absolute;
    content: '';
    /* background: url(../images/icons/icon-bg-1.png); */
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    right: 0px;
    background-repeat: no-repeat;
    z-index: -1;
  }
  
  .process-block-one .inner-box .icon-box:after{
    position: absolute;
    content: '';
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: -2;
    box-shadow: 5px 5px 100px 30px black;
  }
  
  .process-block-one .inner-box .icon-box span{
    position: absolute;
    top: -20px;
    right: -30px;
    width: 60px;
    height: 60px;
    line-height: 60px;
    background: #fff;
    font-size: 20px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    text-align: center;
    border-radius: 50%;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);
  }
  
  .process-block-one .inner-box .lower-content h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  
  .process-block-one .inner-box .lower-content p{
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 13px;
  }
  
  .process-block-one .inner-box .lower-content a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 24px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .col-lg-4.col-md-6.col-sm-12.process-block:hover .process-block-one .inner-box .lower-content a {
    color: #ff5956;
  }
  .single-award-block .inner-box:hover    {
    background: #001b44;
    color: white;
    cursor: pointer;
}
 
.single-award-block:hover ul li p {
  color: white;
}
.single-award-block:hover img {
color: red ;  
}
  
  .process-block-one .inner-box .icon-box .anim-icon .icon-1{
    position: absolute;
    left: -12px;
    top: -20px;
    width: 176px;
    height: 158px;
    background-repeat: no-repeat;
    z-index: -2;
  }
  
  .process-block-one .inner-box .icon-box .anim-icon .icon-2{
    position: absolute;
    left: -3px;
    top: 10px;
    width: 10px;
    height: 11px;
    background-repeat: no-repeat;
  }
  
  .process-block-one .inner-box .icon-box .anim-icon .icon-3{
    position: absolute;
    right: -3px;
    bottom: 10px;
    width: 10px;
    height: 11px;
    background-repeat: no-repeat;
  }
  
  
  /** team-section **/
  
  .team-section{
    position: relative;
    padding: 95px 0px 100px 0px;
  }
  
  .team-section .sec-title .top-title:before,
  .team-section .sec-title .top-title:after{
    background: #e2d7d0;
  }
  
  .team-section .sec-title .top-title:after{
    border-left: 2px solid #001b4421;
    border-bottom: 2px solid #001b4421;
  }
  
  .team-section .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 820px;
    background-repeat: no-repeat;
    background-size: cover;
    background: bottom center;
  }
  
  .progress-box .bar{
    position:relative;
    width:100%;
    height:2px;
    background:#d9cec7;
    border-radius:0px;
    margin-bottom:12px;
  }
  
  .progress-box .bar:before{
    position: absolute;
    content: '';
    width: 2px;
    height: 14px;
    left: 0px;
    top: -6px;
  }
  
  .progress-box .bar-inner{
    position:relative;
    display:block;
    width:0px;
    height:2px;
    border-radius:3px;
    transition:all 1500ms ease; 
  }
  
  .progress-box .bar-inner:before{
    position: absolute;
    content: '';
    width: 2px;
    height: 30px;
    top: 0px;
    right: 0px;
  }
  
  .progress-box .count-text{
    position:absolute;
    top: 11px;
    right: 11px;
    font-size:16px;
    color: #001b44;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    opacity:0;
    transition:all 500ms ease;  
  }
  
  .progress-box .bar-inner.counted .count-text{
    opacity:1;  
  }
  
  #content_block_5 .content-box .text{
    margin-bottom: 48px;
  }
  
  #content_block_5 .content-box .text p{
    font-size: 17px;
    font-weight: 500;
  }
  
  .progress-box h6{
    position: relative;
    display: block;
    font-size: 14px;
    line-height: 24px;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .progress-box{
    position: relative;
    margin-bottom: 33px;
  }
  
  #content_block_5 .content-box .link a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 24px;
    font-family: 'Nunito Sans', sans-serif;
    color: #001b44;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  #content_block_5 .content-box .link a i{
    position: relative;
    font-size: 30px;
    margin-right: 8px;
    font-weight: 400;
    top: 6px;
  }
  
  #content_block_5 .content-box .link a:hover{
  
  }
  
  .team-block-one .inner-box{
    position: relative;
    display: block;
    margin-bottom: 22px;
  }
  
  .team-block-one .inner-box .image-box{
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: 20px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  }
  
  .team-block-one .inner-box .image-box:before{
    position: absolute;
    content: '';
    background: #001b44;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .team-block-one .inner-box:hover .image-box:before{
    opacity: 1;
  }
  
  .team-block-one .inner-box .image-box img{
    width: 100%;
    border-radius: 20px;
    transition: all 500ms ease;
  }
  
  .team-block-one .inner-box:hover .image-box img{
    opacity: 0.2;
  }
  
  .team-block-one .inner-box .image-box .singature{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%) rotate(-30deg);
    font-size: 44px;
    line-height: 50px;
    font-family: 'Mrs Saint Delafield', cursive;
    color: #fff;
    font-weight: 400;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .team-block-one .inner-box:hover .image-box .singature{
    opacity: 1;
  }
  
  .team-block-one .inner-box .image-box .share-box{
    position: absolute;
    right: 0px;
    bottom: 0px;
    width: 96px;
  }
  
  .team-block-one .inner-box .image-box .share-box p{
    position: absolute;
    right: 0px;
    bottom: 0px;
    background: #001b4421;
    color: #001b44;
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    text-transform: uppercase;
    padding: 6px 10px;
    text-align: center;
    width: 100%;
    cursor: pointer;
    border-radius: 15px 0px 15px 0px;
  }
  
  .team-block-one .inner-box .image-box .share-box p i{
    margin-right: 8px;
  }
  
  .team-block-one .inner-box .image-box .share-box .social-links{
    position: absolute;
    right: -144px;
    bottom: 0px;
    background: #001b4421;
    text-align: center;
    z-index: 1;
    width: 144px;
    border-radius: 15px 0px 15px 0px;
    opacity: 0;
    visibility: hidden;
    transition: all 500ms ease;
  }
  
  .team-block-one .inner-box .image-box .share-box:hover .social-links{
    right: 0px;
    opacity: 1;
    visibility: visible;
  }
  
  .team-block-one .inner-box .image-box .share-box .social-links li{
    position: relative;
    display: inline-block;
    float: left;
    width: 25%;
    border-right: 1px solid #d9cec7;
  }
  
  .team-block-one .inner-box .image-box .share-box .social-links li:last-child{
    border-right: none;
  }
  
  .team-block-one .inner-box .image-box .share-box .social-links li a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    color: #001b44;
    width: 100%;
    height: 36px;
    line-height: 36px;
    text-align: center;
  }
  
  .team-block-one .inner-box .image-box .share-box .social-links li a:hover{
  
  }
  
  .team-block-one .inner-box .lower-content{
    position: relative;
    display: block;
    padding-top: 14px;
    text-align: center;
  }
  
  .team-block-one .inner-box .lower-content h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 0px;
  }
  
  .team-block-one .inner-box .lower-content h3 a{
    display: inline-block;
    color: #001b44;
  }
  
  .team-block-one .inner-box .lower-content h3 a:hover{
  
  }
  
  .team-block-one .inner-box .lower-content .designation{
    position: relative;
    display: block;
    font-size: 17px;
    font-weight: 500;
    margin: 0px;
  }
  
  .team-section .inner-column{
    padding-top: 35px;
  }
  
  
  /** news-section **/
  
  .news-section{
    position: relative;
    padding: 95px 0px 130px 0px;
  }
  
  .news-block-one .inner-box{
    position: relative;
    display: block;
  }
  
  .news-block-one .inner-box .image-box{
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: 10px;
  }
  
  .news-block-one .inner-box .image-box img{
    width: 100%;
    border-radius: 10px;
    transition: all 500ms ease;
  }
  
  .news-block-one .inner-box:hover .image-box img{
    transform: scale(1.05);
  }
  
  .news-block-one .inner-box .image-box:before{
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    display: block;
    content: '';
    width: 0;
    height: 0;
    background: rgba(255,255,255,.2);
    border-radius: 100%;
    transform: translate(-50%, -50%);
    opacity: 0;
  }
  
  .news-block-one .inner-box:hover .image-box::before{
    animation: circle .75s;
  }
  @keyframes circle {
    0% {
      opacity: 1;
    }
    40% {
      opacity: 1;
    }
    100% {
      width: 200%;
      height: 200%;
      opacity: 0;
    }
  }
  
  .news-block-one .inner-box .image-box .post-date{
    position: absolute;
    right: 0px;
    top: 30px;
    width: 70px;
    height: 70px;
    line-height: 22px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px 0px 0px 5px;
  }
  
  .news-block-one .inner-box .lower-content{
    position: relative;
    padding-right: 30px;
  }
  
  .news-block-one .inner-box .lower-content .inner{
    position: relative;
    margin-top: -137px;
    background: #001b44;
    padding: 33px 30px 32px 30px;
    border-radius: 0px 10px 0px 10px;
    z-index: 2;
  }
  
  .news-block-one .inner-box .lower-content .inner .category p{
    position: relative;
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    color: #fff;
    line-height: 12px;
    border-bottom: 1px solid #d1cdcf;
    margin: 0px;
  }
  
  .news-block-one .inner-box .lower-content .inner .category i{
    position: relative;
    font-size: 20px;
    margin-right: 8px;
    top: 3px;
  }
  
  .news-block-one .inner-box .lower-content .inner .category{
    margin-bottom: 15px;
    position: relative;
  }
  
  .news-block-one .inner-box .lower-content .inner h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 32px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 14px;
  }
  
  .news-block-one .inner-box .lower-content .inner h3 a{
    display: inline-block;
    color: #fff;
  }
  
  .news-block-one .inner-box .lower-content .inner h3 a:hover{
  
  }
  
  .news-block-one .inner-box .lower-content .inner .post-info li{
    position: relative;
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    padding-right: 12px;
    margin-right: 11px;
  }
  
  .news-block-one .inner-box .lower-content .inner .post-info li:last-child{
    padding: 0px;
    margin: 0px;
  }
  
  .news-block-one .inner-box .lower-content .inner .post-info li a{
    color: #fff;
  }
  
  .news-block-one .inner-box .lower-content .inner .post-info li i{
    margin-right: 10px;
  }
  
  .news-block-one .inner-box .lower-content .inner .post-info li a:hover{
  
  }
  
  .news-block-one .inner-box .lower-content .inner .post-info li:before{
    position: absolute;
    content: '';
    background: rgba(255,255,255,0.3);
    top: 7px;
    right: 0px;
    height: 14px;
    width: 1px;
  }
  
  .news-block-one .inner-box .lower-content .inner .post-info li:after{
    position: absolute;
    content: '';
    background: rgba(255,255,255,0.3);
    top: 7px;
    right: -3px;
    height: 14px;
    width: 1px;
  }
  
  .news-block-one .inner-box .lower-content .inner .post-info li:last-child:before,
  .news-block-one .inner-box .lower-content .inner .post-info li:last-child:after{
    display: none;
  }
  
  .bg-color-2{
    background: #001b4421;
  }
  
  
  /** testimonial-section **/
  
  .testimonial-section{
    position: relative;
    padding: 95px 0px 120px 0px;
  }
  
  .testimonial-section .sec-title .top-title:after {
    border-left: 2px solid #001b4421;
    border-bottom: 2px solid #001b4421;
  }
  
  .testimonial-section .sec-title .top-title:before,
  .testimonial-section .sec-title .top-title:after {
    background: #e2d7d0;
  }
  
  .testimonial-block-one{
    margin: 30px 0px 70px 0px;
  }
  
  .testimonial-block-one .inner-box{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 10px;
    padding: 37px 40px 42px 50px;
    margin-right: 10px;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);
  }
  
  .testimonial-block-one .inner-box .border-shap{
    position: absolute;
    left: 10px;
    top: -10px;
    width: 100%;
    height: 328px;
    background-repeat: no-repeat;
  }
  
  .testimonial-block-one .inner-box:before{
    position: absolute;
    content: '';
    background: #fff;
    width: 40px;
    height: 61px;
    left: 40px;
    bottom: -60px;
    clip-path: polygon(0% 0%, 100% 0%, 0% 100%, 0% 100%, 0% 0%);
  }
  
  .testimonial-block-one .inner-box .quote-box{
    position: absolute;
    right: 0px;
    top: 0px;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #001b44;
    border-radius: 0px 10px 0px 30px;
  }
  
  .testimonial-block-one .inner-box .quote-box img{
    position: relative;
    display: inline-block;
  }
  
  .testimonial-block-one .inner-box .author-box{
    position: relative;
    padding: 0px 0px 0px 80px;
    margin-bottom: 19px;
  }
  
  .testimonial-block-one .inner-box .author-box .author-thumb{
    position: absolute;
    left: 0px;
    top: 3px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  
  .testimonial-block-one .inner-box .author-box .author-thumb img{
    width: 100%;
    border-radius: 50%;
  }
  
  .testimonial-block-one .inner-box .author-box .rating li{
    position: relative;
    display: inline-block;
    font-size: 15px;
    margin-right: 6px;
  }
  
  .testimonial-block-one .inner-box .author-box .rating li:last-child{
    margin-right: 0px;
  }
  
  .testimonial-block-one .inner-box .author-box .rating{
    position: relative;
    margin-bottom: 7px;
  }
  
  .testimonial-block-one .inner-box .author-box h3{
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
  }
  
  .testimonial-block-one .inner-box .author-box h3 span{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Muli', sans-serif;
    font-weight: 700;
    color: #a38f96;
    text-transform: uppercase;
  }
  
  .testimonial-block-one .inner-box .text p{
    font-size: 17px;
    font-weight: 500;
  }
  
  .testimonial-section .sec-title{
    margin-bottom: 27px;
  }
  
  
  /** awards-section **/
  
  .awards-section{
    position: relative;
    padding: 95px 0px 130px 0px;
  }
  
  .awards-section .image-box img{
    width: 100%;
  }
  
  .single-award-block .inner-box{
    position: relative;
    display: block;
    border: 1px solid #eae0d9;
    background: #fff;
    padding: 23px 30px 22px 30px;
    border-radius: 10px;
    margin-bottom: 30px;
  }
  
  .single-award-block .inner-box .upper-box{
    position: relative;
    padding: 0px 0px 16px 75px;
    border-bottom: 1px solid #eae0d9;
    margin-bottom: 22px;
    min-height: 77px;
  }
  
  .single-award-block .inner-box .upper-box .icon-box{
    position: absolute;
    left: 0px;
    top: 6px;
  }
  
  .single-award-block .inner-box .upper-box h3{
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
  }
  
  .single-award-block .inner-box .lower-box li{
    position: relative;
    display: block;
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 4px;
  }
  
  .single-award-block .inner-box .lower-box li:last-child{
    margin-bottom: 0px;
  }
  
  .single-award-block .inner-box .lower-box li span{
    position: relative;
    display: inline-block;
    width: 90px;
  }
  
  .awards-section .sec-title{
    margin-bottom: 55px;
  }
  
  .awards-section .inner-block .single-award-block:last-child .inner-box{
    margin-bottom: 0px;
  }
  
  .awards-section .pattern-layer{
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  
  /** main-footer **/
  
  .main-footer{
    position: relative;
  }
  
  .footer-top{
    position: relative;
    padding: 124px 0px 80px 0px;
  }
  
  .footer-top .footer-widget .widget-title{
    position: relative;
    display: block;
    margin-bottom: 25px;
  }
  
  .footer-top .footer-widget .widget-title h3{
    position: relative;
    font-size: 22px;
    line-height: 30px;
    color: #fff;
    font-weight: 700;
  }
  
  .footer-top .about-widget .text p{
    font-size: 17px;
    line-height: 28px;
    color: #ae979f;
    font-weight: 500;
    margin-bottom: 15px;
  }
  
  .footer-top .about-widget .text p:last-child{
    line-height: 30px;
    margin: 0px;
  }
  
  .footer-top .about-widget .text{
    margin-bottom: 24px;
  }
  
  .footer-top .about-widget .text p i{
    position: relative;
    display: inline-block;
    font-size: 14px;
    transform: rotate(20deg);
  }
  
  .footer-top .about-widget{
    margin-right: 50px;
  }
  
  .footer-top .about-widget .social-links li{
    position: relative;
    display: inline-block;
    margin-right: 15px;
  }
  
  .footer-top .about-widget .social-links li:last-child{
    margin-right: 0px;
  }
  
  .footer-top .about-widget .social-links li h5{
    font-size: 18px;
    line-height: 28px;
    font-weight: 700;
    color: #fff;
  }
  
  .footer-top .about-widget .social-links li a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    color: #fff;
  }
  
  .footer-top .links-widget .links-list li{
    position: relative;
    display: block;
    width: 50%;
    float: left;
    margin-bottom: 15px;
  }
  
  .footer-top .links-widget .links-list li a{
    position: relative;
    display: inline-block;
    font-size: 17px;
    line-height: 28px;
    color: #ae979f;
    font-weight: 500;
  }
  
  .footer-top .links-widget .links-list li a:hover{
  
  }
  
  .footer-top .contact-widget .info-box li{
    position: relative;
    display: block;
  }
  
  .footer-top .contact-widget .info-box li a{
    position: relative;
    display: inline-block;
    font-size: 17px;
    line-height: 28px;
    color: #ae979f;
    font-weight: 500;
  }
  
  .footer-top .contact-widget .info-box li a:hover{
  
  }
  
  .footer-top .contact-widget .single-info-box{
    position: relative;
    display: block;
    margin-bottom: 36px;
  }
  
  .footer-top .contact-widget .single-info-box:last-child{
    margin-bottom: 0px;
  }
  
  .main-footer .footer-subscribe{
    position: relative;
    display: block;
  }
  
  .main-footer .footer-subscribe .text{
    margin-bottom: 15px;
  }
  
  .main-footer .footer-subscribe h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    color: #fff;
    font-weight: 700;
  }
  
  .main-footer .footer-subscribe .subscribe-form .form-group{
    position: relative;
    margin: 0px;
  }
  
  .main-footer .footer-subscribe .subscribe-form .form-group input[type='email']{
    position: relative;
    display: block;
    width: 100%;
    height: 54px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding: 10px 0px;
    padding-right: 160px;
    font-size: 17px;
    color: #ae979f;
    font-weight: 500;
    background: transparent;
    transition: all 500ms ease;
  }
  
  .main-footer .footer-subscribe .subscribe-form .form-group input::-webkit-input-placeholder{
    color:#ae979f;
  }
  
  .main-footer .footer-subscribe .subscribe-form .form-group button{
    position: absolute;
    top: 9px;
    right: 0px;
    font-size: 14px;
    line-height: 24px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    background: transparent;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .main-footer .footer-subscribe .subscribe-form .form-group button i{
    position: relative;
    font-size: 30px;
    top: 5px;
    margin-right: 10px;
    font-weight: 400;
  }
  
  .main-footer .footer-subscribe .subscribe-form .form-group button:hover,
  .main-footer .footer-subscribe .subscribe-form .form-group input:focus + button{
  
  }
  
  .main-footer .footer-subscribe .subscribe-form .form-group input:focus{
  
  }
  
  .footer-bottom{
    position: relative;
    padding: 32px 0px;
  }
  
  .footer-bottom .copyright p{
    font-size: 17px;
    line-height: 28px;
    color: #ae979f;
    font-weight: 500;
  }
  
  .footer-bottom .copyright p a{
    color: #ae979f;
  }
  
  .footer-bottom .copyright p a:hover{
  
  }
  
  .footer-bottom .footer-nav li{
    position: relative;
    display: inline-block;
    margin-right: 15px;
  }
  
  .footer-bottom .footer-nav li:last-child{
    margin-right: 0px;
  }
  
  .footer-bottom .footer-nav li a{
    display: inline-block;
    font-size: 17px;
    line-height: 28px;
    color: #ae979f;
    font-weight: 500;
  }
  
  .footer-bottom .footer-nav li a:hover{
  
  }
  
  .main-footer .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: repeat-x;
    background-position: center;
    animation: slide 100s linear infinite;
    -webkit-animation: slide 100s linear infinite;
  }
  
  @keyframes slide{
    from { background-position: 0 0; }
      to { background-position: 1920px 0; }
  }
  
  
  
  /*** 
  
  ====================================================================
                          Home-Page-Two
  ====================================================================
  
  ***/
  
  
  /** header-style-two **/
  
  .main-header.style-two{
    box-shadow: none;
  }
  
  .main-header.style-two .header-lower{
    margin: 0px 50px;
  }
  
  .main-header.style-two .header-lower .outer-box{
    position: relative;
    background: #001b44;
    border-radius: 10px 10px 0px 0px;
  }
  
  .main-header.style-two .logo-box{
    background: transparent;
  }
  
  .main-header.style-two  .main-menu .navigation > li > a{
    color: #fff;
  }
  
  .main-header.style-two .header-top{
    border-bottom: none;
  }
  
  .main-header.style-two .menu-right-content .search-btn button{
    color: rgba(255,255,255,0.6);
  }
  
  .main-header.style-two .menu-right-content .theme-btn-one{
  
  }
  
  .main-header.style-two .sticky-header{
    background: #001b44;
  }
  
  
  /** banner-style-two **/
  
  .banner-section.style-two{
    margin: 0px 50px;
    padding-bottom: 130px;
    background: transparent;
  }
  
  .banner-section.style-two:before{
    position: absolute;
    content: '';
    background: #001b4421;
    width: calc(100% + 100px);
    left: -50px;
    top: 110px;
    right: 0px;
    height: 785px;
  }
  
  .banner-section.style-two .slide-item .pattern-layer .pattern-1{
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 727px;
    height: 323px;
    background-repeat: no-repeat;
    z-index: 1;
  }
  
  .banner-section.style-two .slide-item .pattern-layer .pattern-2{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 609px;
    height: 245px;
    background-repeat: no-repeat;
    z-index: 1;
  }
  
  .banner-section.style-two .banner-carousel{
    position: relative;
    padding: 0px 70px;
  }
  
  .banner-section.style-two .banner-carousel:before{
    position: absolute;
    content: '';
    background: #001b44;
    width: 100%;
    height: 560px;
    left: 0px;
    top: 0px;
    right: 0px;
    border-radius: 0px 0px 10px 10px;
  }
  
  .banner-section.style-two .banner-carousel .slide-item .image-layer{
    position:absolute;
    right:0;
    top: 0;
    left: 0;
    width:100%;
    height: 100%;
    border-radius: 10px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  
  .banner-section.style-two .banner-carousel .slide-item{
    position: relative;
    padding: 180px 0px 187px 0px;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .banner-section.style-two .banner-carousel .slide-item:before{
    position: absolute;
    content: '';
    background: #28161c;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0px;
    opacity: 0.7;
    z-index: 1;
  }
  
  .banner-section.style-two .content-box{
    position: relative;
    max-width: 670px;
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
  
  .banner-section.style-two .banner-carousel .content-box h1{
    color: #fff;
    margin-bottom: 36px;
  }
  
  .banner-carousel .btn-box .btn-one{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    background: #fff;
    color: #001b44;
    text-transform: uppercase;
    padding: 14px 48px;
    text-align: center;
    border-radius: 5px;
    z-index: 1;
  }
  
  .banner-carousel .btn-box .btn-one:hover{
    color: #fff;
  }
  
  .banner-carousel .btn-box .btn-one:hover:after{
    transform: scaleX(1);
    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  }
  
  .banner-carousel .btn-box .btn-one:after{
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 5px;
    transform: scaleX(0);
    transform-origin: 50% 100%;
    transition-property: transform;
    transition-duration: 0.5s;
    transition-timing-function: ease-out;
  }
  
  .banner-carousel .btn-box .btn-two{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    background: transparent;
    border: 1px solid #fff;
    color: #fff;
    text-transform: uppercase;
    padding: 13px 42px;
    text-align: center;
    border-radius: 5px;
    z-index: 1;
  }
  
  .banner-carousel .btn-box .btn-two:hover:after{
    transform: scaleX(1);
    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  }
  
  .banner-carousel .btn-box .btn-two:after{
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    border-radius: 5px;
    transform: scaleX(0);
    transform-origin: 50% 100%;
    transition-property: transform;
    transition-duration: 0.5s;
    transition-timing-function: ease-out;
  }
  
  .banner-carousel .btn-box .btn-two:hover{
    color: #001b44;
  }
  
  .banner-carousel .btn-box a{
    margin: 0px 8px;
  }
  
  .banner-section .owl-nav{
    position: absolute;
    right: 130px;
    bottom: 40px;
  }
  
  .banner-section .owl-nav .owl-prev,
  .banner-section .owl-nav .owl-next{
    position: relative;
    display: inline-block;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 14px;
    color: #001b44;
    background: #fff;
    font-weight: 700;
    text-align: center;
    border-radius: 50%;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .banner-section .owl-nav .owl-prev{
    margin-right: 15px;
  }
  
  .banner-section .owl-nav .owl-prev:hover,
  .banner-section .owl-nav .owl-next:hover{
    color: #fff;
  }
  
  .banner-section .mouse-btn-down{
    position: absolute;
    left: 50%;
    bottom: 105px;
    transform: translateX(-50%);
    z-index: 1;
  }
  
  .banner-section .mouse-btn-down .icon-box{
    position: relative;
    display: inline-block;
    width: 30px;
    height: 50px;
    background: #fff;
    border-radius: 20px;
    text-align: center;
    cursor: pointer;
    padding: 12px 0px;
  }
  
  .banner-section .mouse-btn-down .icon-box i{
    position: relative;
    display: block;
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    color: #001b44;
  }
  
  .banner-section .mouse-btn-down .icon-box:before{
    position: absolute;
    content: '';
    border: 1px solid rgba(0,0,0,0.1);
    width: 90px;
    height: 90px;
    left: -30px;
    top: -20px;
    border-radius: 50%;
  }
  
  .banner-section .mouse-btn-down .icon-box:after{
    position: absolute;
    content: '';
    border: 1px solid rgba(0,0,0,0.1);
    width: 110px;
    height: 110px;
    left: -40px;
    top: -30px;
    border-radius: 50%;
  }
  
  
  /** feature-section **/
  
  .feature-section{
    position: relative;
    padding: 0px 50px;
  }
  
  .feature-section .outer-container{
    position: relative;
    max-width: 1820px;
    width: 100%;
    margin: 0 auto;
  }
  
  .feature-section .inner-box .single-item{
    margin: 0px;
  }
  
  
  /** about-style-two **/
  
  .about-style-two{
    position: relative;
    padding: 95px 0px 130px 0px;
  }
  
  .about-style-two #image_block_1 .image-box{
    margin-top: 35px;
  }
  
  #image_block_1 .image-box{
    position: relative;
    display: block;
    margin-right: 30px;
    padding: 130px 70px 50px 0px;
  }
  
  #image_block_1 .image-box .image-1{
    position: relative;
    overflow: hidden;
    border-radius: 10px;
  }
  
  #image_block_1 .image-box .image-1:before{
    position: absolute;
    top: 0;
    left: -75%;
    display: block;
    content: '';
    width: 50%;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .3) 100%);
    transform: skewX(-25deg);
  }
  
  #image_block_1 .image-box:hover .image-1:before{
    animation: shine 1s;
  }
  
  #image_block_1 .image-box .image-1 img{
    width: 100%;
    border-radius: 10px;
  }
  
  #image_block_1 .image-box .image-2{
    position: absolute;
    left: -118px;
    bottom: 0px;
  }
  
  #image_block_1 .image-box .video-inner{
    position: absolute;
    top: 0px;
    right: 0px;
    max-width: 270px;
    width: 100%;
    border-radius: 10px;
    padding: 95px 0px;
    text-align: center;
    z-index: 1;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  #image_block_1 .image-box .video-inner .video-btn{
    position: relative;
    display: inline-block;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    background: #fff;
    border-radius: 50%;
    font-size: 26px;
    color: #001b44;
    z-index: 1;
  }
  
  #image_block_1 .image-box .video-inner .video-btn:after, 
  #image_block_1 .image-box .video-inner .video-btn:before {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: transparent;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-delay: .9s;
    content: "";
    position: absolute;
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.6);
    animation: ripple 3s infinite;
    transition: all .4s ease;
  }
  
  #image_block_1 .image-box .video-inner .video-btn:after {
    animation-delay: .6s;
  }
  @keyframes ripple {
    70% {
      box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
    }
  }
  
  #image_block_1 .image-box .video-inner .border{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    margin-top: -10px;
    margin-left: 10px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  
  #image_block_1 .image-box .pattern-layer{
    position: absolute;
    left: -120px;
    top: 0px;
    width: 323px;
    height: 323px;
    background-repeat: no-repeat;
  }
  
  
  /** service-style-two **/
  
  .service-style-two{
    position: relative;
  }
  
  .service-style-two .inner-container{
    position: relative;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
    border-radius: 10px;
  }
  
  .service-style-two .inner-container:before{
    position: absolute;
    content: '';
    background: #001b44;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    right: 0px;
    opacity: 0.95;
  }
  
  .service-style-two .inner-container .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .service-style-two .inner-container .single-item{
    position: relative;
    display: block;
    padding: 80px 50px 83px 50px;
    min-height: 780px;
  }
  
  .service-style-two .inner-container .single-item:before{
    position: absolute;
    content: '';
    background: rgb(255,255,255,0.1);
    width: 1px;
    height: 100%;
    top: 0px;
    right: -30px;
  }
  
  .service-style-two .inner-container .service-block:last-child .single-item:before{
    display: none;
  }
  
  .service-style-two .inner-container .single-item .icon-box{
    position: relative;
    display: block;
    text-align: center;
    margin-bottom: 33px;
  }
  
  .service-style-two .inner-container .single-item h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 32px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 24px;
  }
  
  .service-style-two .inner-container .single-item h3 a{
    color: #fff;
  }
  
  .service-style-two .inner-container .single-item h3 a:hover{
    
  }
  
  .service-style-two .inner-container .single-item p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    color: #ae979f;
    margin-bottom: 34px;
  }
  
  .service-style-two .inner-container .single-item .list li{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    color: #ae979f;
    margin-bottom: 8px;
  }
  
  .service-style-two .inner-container .single-item .list li:last-child{
    margin-bottom: 0px;
  }
  
  .service-style-two .inner-container .single-item .list li a{
    position: relative;
    display: inline-block;
    color: #ae979f;
  }
  
  .service-style-two .inner-container .single-item .list li a:hover{
    color: #fff;
  }
  
  .service-style-two .inner-container .single-item .list li a:before{
    position: absolute;
    content: "\\f062";
    top: 0px;
    right: -20px;
    font-family: 'Font Awesome 5 Free';
    font-size: 12px;
    color: #fff;
    font-weight: 700;
    opacity: 0;
    transform: rotate(90deg);
    transition: all 500ms ease;
  }
  
  .service-style-two .inner-container .single-item .list li a:hover:before{
    opacity: 1;
    transform: rotate(20deg);
  }
  
  .service-style-two .inner-container .single-item .list{
    margin-bottom: 33px;
  }
  
  .service-style-two .inner-container .single-item .link{
    margin-bottom: 64px;
  }
  
  .service-style-two .inner-container .single-item .link a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 24px;
    font-family: 'Nunito Sans', sans-serif;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .service-style-two .inner-container .single-item .link a i{
    position: absolute;
    left: 0px;
    top: 0px;
    font-size: 30px;
    font-weight: 400;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .service-style-two .inner-container .single-item .link a:hover{
    padding-left: 40px;
  }
  
  .service-style-two .inner-container .single-item .link a:hover i{
    opacity: 1;
  }
  
  .service-style-two .inner-container .single-item .text{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    color: #ae979f;
  }
  
  .service-style-two .inner-container .single-item .text a{
    color: #fff;
    border-bottom: 1px solid #fff;
    display: inline-block;
  }
  
  .service-style-two .inner-container .single-item .text a:hover{
  
  }
  
  .service-style-two .bg-layer{
    position: absolute;
    left: 0px;
    top: 390px;
    right: 0px;
    width: 100%;
    height: 1375px;
    background: #001b4421;
  }
  
  
  /** project-section **/
  
  .project-section{
    position: relative;
    padding: 95px 0px;
  }
  
  .project-section .sec-title .top-title:before, 
  .project-section .sec-title .top-title:after{
    background: #e2d7d0;
  }
  
  .project-section .sec-title .top-title:after{
    border-left: 2px solid #001b4421;
    border-bottom: 2px solid #001b4421;
  }
  
  .project-section .outer-container{
    position: relative;
    padding: 0px 30px;
  }
  
  .project-block-one .inner-box{
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: 10px;
  }
  
  .project-block-one .inner-box .image-box{
    position: relative;
    overflow: hidden;
    background: #001b44;
    border-radius: 10px;
  }
  
  .project-block-one .inner-box .image-box img{
    width: 100%;
    border-radius: 10px;
    transition: all 500ms ease;
  }
  
  .project-block-one .inner-box:hover .image-box img{
    opacity: 0.03;
  }
  
  .project-block-one .inner-box .content-box{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    padding: 15px 50px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .project-block-one .inner-box .content-box .view-btn{
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
  
  .project-block-one .inner-box .content-box .text span{
    position: relative;
    display: block;
    font-size: 14px;
    line-height: 24px;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 8px;
    top: -15px;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .project-block-one .inner-box:hover .content-box .text span,
  .project-block-one .inner-box:hover .content-box .text h3{
    top: 0px;
    opacity: 1;
  }
  
  .project-block-one .inner-box .content-box .text h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 32px;
    color: #fff;
    top: 15px;
    opacity: 0;
    font-weight: 700;
    transition: all 500ms ease;
  }
  
  .project-block-one .inner-box .content-box .text h3 a{
    display: inline-block;
    color: #fff;
  }
  
  .project-block-one .inner-box .content-box .text h3 a:hover{
  
  }
  
  .project-block-one .inner-box .content-box .view-btn a{
    position: relative;
    display: inline-block;
    font-size: 24px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 600;
    color: #fff;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-radius: 10px 0px 10px 0px;
    z-index: 1;
    opacity: 0;
  }
  
  .project-block-one .inner-box:hover .content-box .view-btn a{
    opacity: 1;
  }
  
  .project-block-one .inner-box .pattern-layer .pattern-1{
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 189px;
    height: 185px;
    background-repeat: no-repeat;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .project-block-one .inner-box .pattern-layer .pattern-2{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 159px;
    height: 174px;
    background-repeat: no-repeat;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .project-block-one .inner-box:hover .pattern-layer .pattern-1,
  .project-block-one .inner-box:hover .pattern-layer .pattern-2{
    opacity: 1;
  }
  
  .project-section .owl-nav{
    position: absolute;
    top: -80px;
    right: 345px;
  }
  
  .project-section .owl-nav .owl-prev,
  .project-section .owl-nav .owl-next{
    position: relative;
    display: inline-block;
    font-size: 30px;
    color: #001b44;
    font-weight: 400;
    margin: 0px;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .project-section .owl-nav .owl-prev{
    margin-right: 15px;
  }
  
  .project-section .owl-nav .owl-prev:hover,
  .project-section .owl-nav .owl-next:hover{
  
  }
  
  
  /** industries-style-two **/
  
  .industries-style-two{
    position: relative;
    padding-bottom: 130px;
  }
  
  .industries-style-two .sec-title .top-title:before, 
  .industries-style-two .sec-title .top-title:after{
    background: #e2d7d0;
  }
  
  .industries-style-two .sec-title .top-title:after{
    border-left: 2px solid #001b4421;
    border-bottom: 2px solid #001b4421;
  }
  
  .industries-style-two .tab-btn-one{
    margin-bottom: 80px;
  }
  
  .industries-style-two .tab-btn-one .tab-buttons{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  .industries-style-two .tab-btn-one .tab-buttons li{
    position: relative;
    display: block;
    float: left;
    width: 50%;
    padding: 24px 30px 26px 95px;
    cursor: pointer;
    border-right: 1px solid #eae0d9;
  }
  
  .industries-style-two .tab-btn-one .tab-buttons li:before{
    position: absolute;
    content: '';
    background: #eae0d9;
    width: 1px;
    height: 30px;
    top: 25px;
    right: 65px;
  }
  
  .industries-style-two .tab-btn-one .tab-buttons li:last-child{
    border-right: none;
  }
  
  .industries-style-two .tab-btn-one .tab-buttons li .icon-box{
    position: absolute;
    left: 30px;
    top: 19px;
  }
  
  .industries-style-two .tab-btn-one .tab-buttons li h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
  }
  
  .industries-style-two .tab-btn-one .tab-buttons li i{
    position: absolute;
    top: 27px;
    right: 30px;
    font-size: 20px;
    color: #b4a4a4;
    transition: all 500ms ease;
  }
  
  .industries-style-two .tab-btn-one .tab-buttons li.active-btn i{
    transform: rotate(180deg);
  }
  
  .industries-style-two .tabs-content-2{
    position: relative;
    display: block;
    margin-right: 30px;
  }
  
  .industries-style-two .tabs-content-2 .inner-box{
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: 15px;
  }
  
  .industries-style-two .tabs-content-2 .inner-box .image-box{
    position: relative;
    display: block;
    border-radius: 15px;
  }
  
  .industries-style-two .tabs-content-2 .inner-box .image-box:before {
    position: absolute;
    content: '';
    background: -webkit-linear-gradient(-90deg, rgba(70,43,52,0.0), rgba(70,43,52,1) 100%);
    width: 100%;
    height: 100%;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
  
  .industries-style-two .tabs-content-2 .inner-box .image-box img{
    width: 100%;
    border-radius: 15px;
  }
  
  .industries-style-two .tabs-content-2 .inner-box .content-box {
    position: absolute;
    left: 0px;
    bottom: 32px;
    padding: 0px 40px;
    width: 100%;
    z-index: 1;
    display: flex;
    align-items: center;
  }
  
  .industries-style-two .tabs-content-2 .inner-box .content-box .text h2 {
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 40px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 2px;
  }
  
  .industries-style-two .tabs-content-2 .inner-box .content-box .text span {
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    color: #fff;
    font-style: italic;
    font-weight: 500;
  }
  
  .industries-style-two .tabs-content-2 .inner-box .content-box .link {
    position: absolute;
    bottom: 2px;
    right: 40px;
  }
  
  .industries-style-two .tabs-content-2 .inner-box .content-box .link a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    color: #001b44;
    width: 62px;
    height: 62px;
    line-height: 62px;
    background: #fff;
    text-align: center;
    border-radius: 50%;
    z-index: 1;
  }
  
  .industries-style-two .tabs-content-2 .inner-box .content-box .link a:hover{
    color: #fff;
  }
  
  .industries-style-two .tab-btn-two li{
    position: relative;
    display: block;
    padding: 9px 0px 27px 70px;
    cursor: pointer;
    margin-bottom: 14px;
    min-height: 50px;
    transition: all 500ms ease;
  }
  
  .industries-style-two .tab-btn-two li:before{
    position: absolute;
    content: '';
    background: #eae0d9;
    width: 50px;
    height: 1px;
    left: 70px;
    bottom: 0px;
    transition: all 500ms ease;
  }
  
  .industries-style-two .tab-btn-two li.active-btn-2:before,
  .industries-style-two .tab-btn-two li:hover:before{
    width: calc(100% - 70px);
  }
  
  .industries-style-two .tab-btn-two li:last-child{
    margin-bottom: 0px;
  }
  
  .industries-style-two .tab-btn-two li .icon-box{
    position: absolute;
    left: 0px;
    top: 0px;
  }
  
  .industries-style-two .tab-btn-two li h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    color: #001b44;
    font-weight: 700;
    transition: all 500ms ease;
  }
  
  .industries-style-two .tab-btn-two li.active-btn h3,
  .industries-style-two .tab-btn-two li:hover h3{
  
  }
  
  
  /** chooseus-section **/
  
  .chooseus-section{
    position: relative;
    padding: 95px 0px 130px 0px;
  }
  
  .chooseus-section .top-title.light:before,
  .chooseus-section .top-title.light:after{
    background: #624b52;
  }
  
  .chooseus-section .top-title.light:after{
    border-bottom: 2px solid #001b44;
    border-left: 2px solid #001b44;
  }
  
  .chooseus-section .sec-title p{
    color: #ae979f;
  }
  
  .chooseus-block-one{
    position: relative;
  }
  
  .chooseus-block-one .inner-box{
    position: relative;
    display: block;
    background: #3f262f;
    padding: 50px 30px 42px 30px;
    border-radius: 10px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.1);
    z-index: 1;
  }
  
  .chooseus-block-one:before{
    position: absolute;
    display: block;
    content: '';
    background: rgba(255,255,255,0.05);
    width: 100%;
    height: 100%;
    left: 0px;
    top: 3px;
    border-radius: 10px;
  }
  
  .chooseus-block-one:after{
    position: absolute;
    content: '';
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .chooseus-block-one:hover:after{
    opacity: 1;
    left: -10px;
    top: -10px;
  }
  
  .chooseus-block-one .inner-box .icon-box{
    position: relative;
    display: block;
    margin-bottom: 24px;
  }
  
  .chooseus-block-one .inner-box h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 15px;
  }
  
  .chooseus-block-one .inner-box p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    color: rgba(255,255,255,0.6);
    margin-bottom: 24px;
  }
  
  .chooseus-block-one .inner-box a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    line-height: 24px;
    font-weight: 700;
    color: rgba(255,255,255,0.6);
    text-transform: uppercase;
  }
  
  .chooseus-block-one .inner-box a i{
    position: absolute;
    left: 0px;
    top: 0px;
    font-size: 30px;
    font-weight: 400;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .chooseus-block-one .inner-box a:hover{
    padding-left: 40px;
  }
  
  .chooseus-block-one .inner-box a:hover i{
    opacity: 1;
  }
  
  .chooseus-section .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-repeat: repeat-x;
    background-size: cover;
    background-position: center;
    animation: slide 100s linear infinite;
    -webkit-animation: slide 100s linear infinite;
  }
  
  
  /** pricing-section **/
  
  .pricing-section{
    position: relative;
    overflow: hidden;
    padding: 95px 0px 130px 0px;
  }
  
  .pricing-section .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .pricing-block-one .inner-box{
    position: relative;
    display: block;
    border: 1px solid #eae0d9;
    background: #fff;
    border-radius: 10px;
    padding: 40px 30px;
  }
  
  .pricing-block-one .inner-box .icon-box{
    position: relative;
    margin-bottom: 24px;
  }
  
  .pricing-block-one .inner-box h3{
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 36px;
    font-weight: 700;
    margin-bottom: 9px;
  }
  
  .pricing-block-one .inner-box .text{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    color: #002c5d;
    padding-bottom: 23px;
    margin-bottom: 38px;
  }
  
  .pricing-block-one .inner-box .text:before{
    position: absolute;
    content: '';
    width: 60px;
    height: 2px;
    left: 0px;
    bottom: 0px;
  }
  
  .pricing-block-one .inner-box h2{
    position: relative;
    display: block;
    font-size: 55px;
    line-height: 55px;
    font-weight: 700;
    margin-bottom: 14px;
    padding-left: 20px;
  }
  
  .pricing-block-one .inner-box h2 .text{
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    color: #a38f96;
    text-transform: uppercase;
    margin: 0px;
  }
  
  .pricing-block-one .inner-box h2 .text:before{
    display: none;
  }
  
  .pricing-block-one .inner-box h2 .symble{
    position: absolute;
    left: 0px;
    top: -8px;
    font-size: 30px;
  }
  
  .pricing-block-one .inner-box p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 32px;
  }
  
  .pricing-block-one .inner-box a{
    position: relative;
    display: block;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Nunito Sans', sans-serif;
    color: #fff;
    background: #001b44;
    text-transform: uppercase;
    padding: 14px 30px;
    text-align: center;
    border-radius: 5px;
  }
  
  .pricing-block-one .inner-box:hover a{
  
  }
  
  .pricing-block-one.popular .inner-box{
    background: #001b4421;
    border-color: #001b4421;
  }
  
  .pricing-block-one.popular .inner-box .popular-tag{
    position: absolute;
    top: 25px;
    right: -16px;
    font-size: 12px;
    line-height: 20px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 600;
    color: #fff;
    padding: 5.5px 22px;
    text-align: center;
    text-transform: uppercase;
    transform: rotate(-90deg);
  }
  
  .pricing-block-one.popular .inner-box .popular-tag:before{
    position: absolute;
    content: '';
    width: 14px;
    height: 16px;
    left: -13px;
    top: 0px;
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 100% 100%, 0% 0%);
  }
  
  .pricing-block-one.popular .inner-box .popular-tag:after{
    position: absolute;
    content: '';
    width: 14px;
    height: 16px;
    left: -13px;
    bottom: 0px;
    clip-path: polygon(0% 100%, 100% 0%, 100% 100%, 0% 100%, 0% 0%);
  }
  
  .pricing-block-one.popular .inner-box:before{
    position: absolute;
    content: '';
    width: 8px;
    height: 10px;
    top: -10px;
    right: 50px;
    clip-path: polygon(0% 100%, 100% 0%, 100% 100%, 0% 100%, 0% 0%);
  }
  
  .pricing-section .tabs-box{
    position: relative;
  }
  
  .pricing-section .tab-btn-box{
    position: absolute;
    top: -116px;
    right: 0px;
  }
  
  .pricing-section .tab-btn-box .tab-buttons{
    position: relative;
    display: inline-block;
  }
  
  .pricing-section .tab-btn-box .tab-buttons li{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Nunito Sans', sans-serif;
    text-transform: uppercase;
    border: 1px solid #001b4421;
    background: #001b4421;
    text-align: center;
    padding: 13px 15px;
    width: 110px;
    text-align: center;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .pricing-section .tab-btn-box .tab-buttons li:first-child{
    border-radius: 30px 0px 0px 30px;
  }
  
  .pricing-section .tab-btn-box .tab-buttons li:last-child{
    border-radius: 0px 30px 30px 0px;
  }
  
  .pricing-section .tab-btn-box .tab-buttons li.active-btn,
  .pricing-section .tab-btn-box .tab-buttons li:hover{
    background: transparent;
  }
  
  
  /** testimonial-style-two **/
  
  .testimonial-style-two{
    position: relative;
    padding: 130px 0px;
    background: #f1e7e1;
  }
  
  .testimonial-style-two .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .testimonial-style-two .testimonial-block-two{
    position: relative;
    margin: 0px 70px;
  }
  
  .testimonial-block-two .inner-box .icon-box{
    position: relative;
    display: inline-block;
    margin-bottom: 31px;
  }
  
  .testimonial-block-two .inner-box p{
    font-size: 22px;
    line-height: 36px;
    font-weight: 500;
    margin-bottom: 37px;
  }
  
  .testimonial-block-two .inner-box .rating{
    margin-bottom: 7px;
  }
  
  .testimonial-block-two .inner-box .rating li{
    position: relative;
    display: inline-block;
    font-size: 20px;
    margin: 0px 3px;
  }
  
  .testimonial-block-two .inner-box h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
  }
  
  .testimonial-block-two .inner-box h3 span{
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    color: #a38f96;
    text-transform: uppercase;
  }
  
  .testimonial-style-two .owl-theme .owl-dots .owl-dot span{
    position: relative;
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #d9cec7;
    margin: 0px 10px;
    cursor: pointer;
    border-radius: 50%;
    transition: all 500ms ease;
  }
  
  .testimonial-style-two .owl-theme .owl-dots .owl-dot span:before{
    position: absolute;
    content: '';
    width: 26px;
    height: 26px;
    border-radius: 50%;
    left: -10px;
    top: -10px;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .testimonial-style-two .owl-theme .owl-dots .owl-dot.active span:before{
    opacity: 1;
  }
  
  .testimonial-style-two .owl-theme .owl-dots .owl-dot.active span{
  
  }
  
  .testimonial-style-two .owl-theme .owl-dots{
    position: relative;
    display: block;
    margin-top: 36px;
  }
  
  .testimonial-style-two .thumb-box{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    max-width: 1920px;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
  
  .testimonial-style-two .thumb-box .user-thumb{
    position: absolute;
  }
  
  .testimonial-style-two .thumb-box .thumb-1{
    left: 195px;
    top: 100px;
  }
  
  .testimonial-style-two .thumb-box img{
    position: relative;
    border-radius: 50%;
    z-index: 1;
    animation: zoom-fade 5s infinite linear;
  }
  
  .testimonial-style-two .thumb-box .user-thumb .pattern-1{
    position: absolute;
    left: 0px;
    top: -35px;
    width: 105px;
    height: 105px;
    background-repeat: no-repeat;
  }
  
  .testimonial-style-two .thumb-box .user-thumb .pattern-2{
    position: absolute;
    left: -50px;
    bottom: -40px;
    width: 167px;
    height: 192px;
    background-repeat: no-repeat;
  }
  
  .testimonial-style-two .thumb-box .user-thumb .pattern-3{
    position: absolute;
    right: 0px;
    bottom: 0px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  
  .testimonial-style-two .thumb-box .user-thumb .pattern-4{
    position: absolute;
    right: 40px;
    top: -15px;
    width: 55px;
    height: 55px;
    background-repeat: no-repeat;
    z-index: 1;
  }
  
  .testimonial-style-two .thumb-box .thumb-2{
    left: 410px;
    bottom: 75px;
  }
  
  .testimonial-style-two .thumb-box .thumb-3{
    right: 95px;
    bottom: 120px;
  }
  
  .testimonial-style-two .thumb-box .thumb-4{
    top: 50px;
    right: 340px;
  }
  
  .testimonial-style-two .thumb-box .thumb-4 img{
    border-radius: 0px;
  }
  
  .news-section .owl-nav{
    position: absolute;
    top: -80px;
    right: 0px;
  }
  
  .news-section .owl-nav .owl-prev,
  .news-section .owl-nav .owl-next{
    position: relative;
    display: inline-block;
    font-size: 30px;
    color: #001b44;
    font-weight: 400;
    margin: 0px;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .news-section .owl-nav .owl-prev{
    margin-right: 15px;
  }
  
  .news-section .owl-nav .owl-prev:hover,
  .news-section .owl-nav .owl-next:hover{
  
  }
  
  
  /** clients-style-two **/
  
  .clients-style-two{
    position: relative;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding: 120px 0px;
  }
  
  .clients-style-two:before{
    position: absolute;
    content: '';
    background: -webkit-linear-gradient(-90deg, rgba(70,43,52,0.8)10%, rgba(255,255,255,1) 90%);
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    right: 0px;
  }
  
  .clients-style-two .title-inner{
    position: relative;
    display: block;
    max-width: 670px;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 130px;
  }
  
  .clients-style-two .title-inner h2{
    font-size: 48px;
    line-height: 58px;
    color: #fff;
    margin-bottom: 28px;
    font-weight: 800;
  }
  
  .clients-style-two .title-inner .btn-box a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    padding: 14px 35px;
    border-radius: 4px;
    text-align: center;
    width: 170px;
    margin: 0px 8px;
    text-transform: uppercase;
  }
  
  .clients-style-two .title-inner .btn-box a.btn-one{
    color: #fff;
  }
  
  .clients-style-two .title-inner .btn-box a.btn-one:hover{
    background: #fff;
  }
  
  .clients-style-two .title-inner .btn-box a.btn-two{
    color: #001b44;
    background: #fff;
  }
  
  .clients-style-two .title-inner .btn-box a.btn-two:hover{
    color: #fff;
  }
  
  .clients-style-two .clients-logo-box{
    position: relative;
    display: block;
  }
  
  .clients-style-two .clients-logo-box img{
    display: block;
    max-width: 100%;
    width: auto;
    margin: 0 auto;
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    transition: all 300ms ease;
  }
  
  .clients-style-two .clients-logo-box img:hover {
    filter: grayscale(0%);
    -webkit-filter: grayscale(0%);
    -moz-filter: grayscale(0%);
    -o-filter: grayscale(0%);
    -ms-filter: grayscale(0%);
  }
  
  
  /** contactinfo-section **/
  
  .contactinfo-section{
    position: relative;
    padding: 95px 0px 120px 0px;
  }
  
  .contactinfo-section .image-column{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 48%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .contactinfo-section .sec-title .top-title:before,
  .contactinfo-section .sec-title .top-title:after{
    background: #e2d7d0;
  }
  
  .contactinfo-section .sec-title .top-title:after{
    border-left: 2px solid #001b4421;
    border-bottom: 2px solid #001b4421;
  }
  
  #content_block_6 .content-box{
    position: relative;
    display: block;
  }
  
  #content_block_6 .content-box .info-list li{
    position: relative;
    display: block;
    padding-left: 82px;
    margin-bottom: 35px;
  }
  
  #content_block_6 .content-box .info-list li:last-child{
    margin-bottom: 0px;
  }
  
  #content_block_6 .content-box .info-list li .icon-box{
    position: absolute;
    left: 0px;
    top: 6px;
  }
  
  #content_block_6 .content-box .info-list li .inner{
    position: relative;
    padding-left: 32px;
  }
  
  #content_block_6 .content-box .info-list li .inner h4{
    display: block;
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  
  #content_block_6 .content-box .info-list li .inner p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
  }
  
  #content_block_6 .content-box .info-list li .inner p a{
    color: #002c5d;
  }
  
  #content_block_6 .content-box .info-list li .inner p a:hover{
  
  }
  
  #content_block_6 .content-box .info-list li .inner:before{
    position: absolute;
    content: '';
    background: #e2d7d0;
    width: 2px;
    height: 62px;
    left: 0px;
    top: 6px;
  }
  
  #content_block_6 .content-box .info-list li .inner:after{
    position: absolute;
    content: '';
    width: 2px;
    height: 20px;
    left: 0px;
    top: 6px;
    transition: all 500ms ease;
  }
  
  #content_block_6 .content-box .info-list li:hover .inner:after{
    height: 62px;
  }
  
  .contactinfo-section .map-inner{
    position: relative;
    display: block;
    border-radius: 50%;
    overflow: hidden;
  }
  
  .contactinfo-section .map-inner #contact-google-map{
    width: 470px;
    height: 470px;
    border-radius: 50%;
  }
  
  .contactinfo-section .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 52%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  
  /** footer-style-two **/
  
  .main-footer.style-two .footer-top{
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding: 104px 0px 106px 0px;
  }
  
  .main-footer.style-two .footer-top .about-widget{
    margin-right: 0px;
  }
  
  .main-footer.style-two .footer-top .about-widget .text p{
    line-height: 28px;
  }
  
  .main-footer.style-two .footer-top .about-widget .text{
    margin-bottom: 31px;
  }
  
  .main-footer .about-widget .subscribe-form .form-group{
    position: relative;
    margin: 0px;
  }
  
  .main-footer .about-widget .subscribe-form .form-group input[type='email']{
    position: relative;
    display: block;
    width: 100%;
    height: 52px;
    border: 1px solid #533c44;
    background: transparent;
    font-size: 17px;
    font-weight: 500;
    color: #ae979f;
    border-radius: 5px 5px 0px 0px;
    padding: 10px 20px;
    transition: all 500ms ease;
  }
  
  .main-footer .about-widget .subscribe-form .form-group input:focus{
  
  }
  
  .main-footer .about-widget .subscribe-form .form-group input::-webkit-input-placeholder{
    color:#ae979f;
  }
  
  .main-footer .about-widget .subscribe-form .form-group button{
    position: relative;
    display: block;
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    line-height: 24px;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    background: #533c44;
    padding: 9px 25px;
    border-radius: 0px 0px 5px 5px;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .main-footer .about-widget .subscribe-form .form-group button:hover{
  
  }
  
  .main-footer .about-widget .subscribe-form .form-group button i{
    position: relative;
    font-size: 30px;
    font-weight: 400;
    margin-right: 8px;
    top: 5px;
  }
  
  .nice-select:after{
    width: 8px;
    height: 8px;
    border-bottom: 2px solid #001b44;
    border-right: 2px solid #001b44;
    right: 20px;
  }
  
  .nice-select{
    position: relative;
    display: block;
    width: 100%;
    height: 55px;
    border: 1px solid #eae0d9 !important;
    border-radius: 5px;
    padding: 8px 20px;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
  }
  
  .main-footer .callback-widget .widget-content{
    position: relative;
    display: block;
    background: #fff;
    padding: 30px 30px;
    border-radius: 10px;
    margin-top: 7px;
    z-index: 1;
  }
  
  .main-footer .callback-widget .widget-content .callback-form{
    position: relative;
    margin: 0px 5px;
  }
  
  .main-footer .callback-widget .widget-content .form-group{
    position: relative;
    margin-bottom: 20px;
    padding: 0px 10px;
  }
  
  .main-footer .callback-widget .widget-content .form-group:last-child{
    margin-bottom: 0px;
  }
  
  .main-footer .callback-widget .widget-content .form-group input[type='text'],
  .main-footer .callback-widget .widget-content .form-group input[type='email']{
    position: relative;
    display: block;
    width: 100%;
    height: 55px;
    border: 1px solid #eae0d9;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
    transition: all 500ms ease;
  }
  
  .main-footer .callback-widget .widget-content .form-group input:focus{
  
  }
  
  .main-footer .callback-widget .widget-content .form-group button{
    display: block;
    width: 100%;
  }
  
  .main-footer .callback-widget .widget-content .form-group button:after{
    background: #001b44;
  }
  
  .main-footer .callback-widget .pattern-layer .pattern-1{
    position: absolute;
    right: -60px;
    bottom: -45px;
    width: 105px;
    height: 215px;
    background-repeat: no-repeat;
  }
  
  .main-footer .callback-widget .pattern-layer .pattern-2{
    position: absolute;
    background: #3f262f;
    width: 194px;
    height: 194px;
    border-radius: 50%;
    right: -160px;
    bottom: -60px;
    z-index: 1;
  }
  
  .main-footer .callback-widget .pattern-layer .pattern-3{
    position: absolute;
    width: 80px;
    height: 80px;
    right: -165px;
    bottom: -70px;
    border-radius: 50%;
  }
  
  .main-footer .callback-widget .pattern-layer .pattern-4{
    position: absolute;
    top: 120px;
    right: -115px;
    width: 55px;
    height: 55px;
    background-repeat: no-repeat;
    z-index: 1;
  }
  
  .main-footer.style-two .footer-bottom .copyright{
    position: relative;
    padding-left: 190px;
  }
  
  .main-footer.style-two .footer-bottom .copyright .footer-logo{
    position: absolute;
    left: 0px;
    top: 5px;
    z-index: 1;
  }
  
  .main-footer.style-two .footer-bottom .copyright .footer-logo:before{
    position: absolute;
    content: '';
    background: rgb(255,255,255,0.1);
    width: 1px;
    height: 45px;
    top: 0px;
    right: -21px;
  }
  
  .footer-bottom .social-links li{
    position: relative;
    display: inline-block;
    margin-right: 7px;
  }
  
  .footer-bottom .social-links li:last-child{
    margin-right: 0px;
  }
  
  .footer-bottom .social-links li a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    color: #ae979f;
    width: 45px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #3f262f;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 50%;
  }
  
  .footer-bottom .social-links li a:hover{
    color: #fff;
  }
  
  .main-footer.style-two .footer-bottom{
    padding: 35px 0px;
  }
  
  .footer-bottom .social-links{
    margin-top: 5px;
  }
  
  
  
  /*** 
  
  ====================================================================
                          Home-Page-Three
  ====================================================================
  
  ***/
  
  
  /** header-style-three **/
  
  .main-header.style-three{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    box-shadow: none;
  }
  
  .main-header.style-three  .main-menu .navigation > li > a{
    color: #fff;
  }
  
  .main-header.style-three  .main-menu .navigation > li.dropdown > a:before{
    color: #fff;
  }
  
  .main-header.style-three .sticky-header{
    background: #001b44;
  }
  
  .main-header.style-three .menu-right-content .search-btn button{
    color: #fff;
  }
  
  .main-header.style-three .menu-right-content .theme-btn-one{
    border: 1px solid #002c5d;
    background: transparent;
  }
  
  .main-header.style-three .outer-box{
    position: relative;
    min-height: 80px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }
  
  .main-header.style-three .header-lower .outer-box .menu-area{
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  
  .main-header.style-three .header-lower .outer-box .menu-right-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
  }
  
  .main-header.style-three .logo-box{
    float: none;
    margin: 0px;
    padding-top: 40px;
    background: transparent;
  }
  
  .main-header.style-three  .main-menu .navigation > li{
    padding-top: 50px;
  }
  
  .main-header.style-three .sticky-header .outer-box{
    display: block;
  }
  
  
  /** banner-style-three **/
  
  .banner-section.style-three{
    overflow: hidden;
  }
  
  .banner-section.style-three .slide-item{
    position: relative;
    padding: 330px 0px 250px 0px;
    overflow: hidden;
  }
  
  .banner-section.style-three .slide-item:before{
    position: absolute;
    content: '';
    background: #28161c;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    right: 0px;
    opacity: 0.6;
    z-index: 1;
  }
  
  .banner-section.style-three .banner-carousel .slide-item .image-layer{
    left: 0;
    right: 0;
  }
  
  .banner-section.style-three .banner-carousel .content-box{
    max-width: 650px;
    width: 100%;
  }
  
  .banner-section.style-three .banner-carousel .content-box h1{
    color: #fff;
    font-size: 90px;
    line-height: 90px;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 6px;
    transform: translateY(-100px);
  }
  
  .banner-section.style-three .banner-carousel .active .content-box h1{
    transform: translateY(0);
  }
  
  .banner-carousel .content-box h2{
    position: relative;
    display: block;
    font-size: 48px;
    line-height: 55px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 20px;
    opacity: 0;
    transform: translateX(100px);
    transition: all 1200ms ease;
  }
  
  .banner-carousel .active .content-box h2{
    opacity: 1;
    transform: translateX(0);
    transition-delay: 1200ms;
  }
  
  .banner-section.style-three .banner-carousel .content-box p{
    color: #fff;
    margin-bottom: 31px;
  }
  
  .banner-section.style-three .slide-item .pattern-layer .pattern-1{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 465px;
    height: 520px;
    background-repeat: no-repeat;
    z-index: 2;
  }
  
  .banner-section.style-three .slide-item .pattern-layer .pattern-2{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 459px;
    height: 522px;
    background-repeat: no-repeat;
    z-index: 1;
  }
  
  .banner-section.style-three .slide-item .pattern-layer .pattern-3{
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 294px;
    height: 295px;
    background-repeat: no-repeat;
    z-index: 1;
  }
  
  .banner-section.style-three .slide-item .pattern-layer .pattern-4{
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 695px;
    height: 691px;
    background-repeat: no-repeat;
    z-index: 1;
  }
  
  .banner-section.style-three .slide-item .pattern-layer .pattern-5{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 727px;
    height: 901px;
    background-repeat: no-repeat;
  }
  
  .banner-section.style-three .owl-nav{
    right: inherit;
    left: 335px;
    bottom: 70px;
  }
  
  .banner-section.style-three .social-box{
    position: absolute;
    left: -40px;
    top: 250px;
    z-index: 1;
    transform: rotate(-90deg);
  }
  
  .banner-section.style-three .social-box .social-links{
    position: relative;
  }
  
  .banner-section.style-three .social-box .social-links:before{
    position: absolute;
    content: '';
    width: 40px;
    height: 2px;
    left: -60px;
    top: 12px;
  }
  
  .banner-section.style-three .social-box .social-links li{
    position: relative;
    display: inline-block;
    font-size: 18px;
    font-family: 'Nunito Sans', sans-serif;
    color: #fff;
    font-weight: 700;
    margin-right: 20px;
  }
  
  .banner-section.style-three .social-box .social-links li:before{
    position: absolute;
    content: '';
    background: #fff;
    width: 6px;
    height: 1px;
    top: 13px;
    right: -14px;
  }
  
  .banner-section.style-three .social-box .social-links li:last-child:before,
  .banner-section.style-three .social-box .social-links li:first-child:before{
    display: none;
  }
  
  .banner-section.style-three .social-box .social-links li a{
    color: #fff;
  }
  
  .banner-section.style-three .social-box .social-links li:last-child{
    margin-right: 0px;
  }
  
  .banner-section.style-three .social-box .social-links li a:hover{
  
  }
  
  .banner-section.style-three .mail-box{
    position: absolute;
    left: 165px;
    top: 335px;
    z-index: 1;
    transform: rotate(-47deg);
  }
  
  .banner-section.style-three .mail-box a{
    position: relative;
    display: inline-block;
    font-size: 20px;
    line-height: 28px;
    font-family: 'Nunito Sans', sans-serif;
    color: #fff;
    font-weight: 700;
  }
  
  .banner-section.style-three .mail-box a:hover{
  
  }
  
  
  /** about-style-three **/
  
  .about-style-three{
    position: relative;
    padding: 95px 0px 130px 0px;
  }
  
  .about-style-three .image-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .about-style-three .sec-title .top-title:before,
  .about-style-three .sec-title .top-title:after{
    background: #e2d7d0;
  }
  
  .about-style-three .sec-title .top-title:after{
    border-left: 2px solid #001b4421;
    border-bottom: 2px solid #001b4421;
  }
  
  .about-style-three .image-box{
    position: relative;
    display: block;
    margin-left: -370px;
    margin-right: -60px;
  }
  
  .about-style-three .image-box img{
    width: 100%;
  }
  
  .about-style-three .sec-title{
    margin-bottom: 30px;
  }
  
  #content_block_1 .content-box .inner-box .list li h3{
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
  }
  
  .chooseus-section .title-inner .sec-title,
  .chooseus-section .title-inner .text{
    width: 50%;
  }
  
  .chooseus-section .title-inner .text{
    margin-top: 60px;
  }
  
  .chooseus-section .title-inner .text p{
    font-size: 17px;
    font-weight: 500;
  }
  
  .chooseus-section.alternet-2 .chooseus-block-one .inner-box{
    background: #fff;
    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.1);
  }
  
  .chooseus-section.alternet-2 .chooseus-block-one .inner-box h3{
    color: #001b44;
  }
  
  .chooseus-section.alternet-2 .chooseus-block-one .inner-box p{
    color: #002c5d;
    margin-bottom: 20px;
  }
  
  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a{
    color: #001b44;
    padding: 0px !important;
  }
  
  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a i{
    position: relative;
    margin-right: 8px;
    opacity: 1;
    top: 6px;
    color: #001b44;
  }
  
  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a:hover{
  
  }
  
  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a:hover i{
  
  }
  
  
  /** video-section **/
  
  .video-section{
    position: relative;
  }
  
  .video-section #image_block_1 .image-box .video-inner{
    position: relative;
    max-width: 100%;
    padding: 185px 0px 175px 0px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  
  .video-section #image_block_1 .image-box .video-inner .video-btn{
    width: 100px;
    height: 100px;
    line-height: 100px;
    font-size: 30px;
  }
  
  .video-section #image_block_1 .image-box .video-inner .border{
    width: 100px;
    height: 100px;
  }
  
  .video-section #image_block_1 .image-box{
    padding: 0px;
    margin: 0px;
  }
  
  .video-section .video-content{
    position: relative;
    margin-bottom: -330px;
    z-index: 1;
  }
  
  .video-section .video-content .pattern-layer .pattern-1{
    position: absolute;
    top: -60px;
    right: -55px;
    width: 105px;
    height: 215px;
    background-repeat: no-repeat;
  }
  
  .video-section .video-content .pattern-layer .pattern-2{
    position: absolute;
    top: 50px;
    right: -140px;
    width: 195px;
    height: 195px;
    border-radius: 50%
  }
  
  .video-section .video-content .pattern-layer .pattern-3{
    position: absolute;
    top: 170px;
    right: -150px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    animation: zoom-fade 5s infinite linear;
  }
  
  .service-section.alternet-2{
    padding-top: 445px;
  }
  
  .service-section .sec-title.light .top-title:before,
  .service-section .sec-title.light .top-title:after{
    background: #624b52;
  }
  
  .service-section .sec-title.light .top-title:after{
    border-left: 2px solid #001b44;
    border-bottom: 2px solid #001b44;
  }
  
  .service-section .sec-title.light p{
    color: #ae979f;
  }
  
  .service-section.alternet-2 .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  
  /** process-style-two **/
  
  .process-style-two{
    position: relative;
  }
  
  .process-style-two:before{
    position: absolute;
    content: '';
    background: #001b4421;
    width: 100%;
    height: 675px;
    left: 0px;
    bottom: 0px;
  }
  
  .process-style-two .inner-container{
    position: relative;
    border-radius: 10px 10px 0px 0px;
    background: #001b4421;
    padding: 95px 0px 122px 0px;
    overflow: hidden;
  }
  
  .process-style-two .sec-title .top-title:before,
  .process-style-two .sec-title .top-title:after{
    background: #e2d7d0;
  }
  
  .process-style-two .sec-title .top-title:after{
    border-left: 2px solid #001b4421;
    border-bottom: 2px solid #001b4421;
  }
  
  .process-style-two .single-item .inner-box{
    position: relative;
    display: block;
    padding-left: 50px;
  }
  
  .process-style-two .single-item .inner-box:before{
    position: absolute;
    content: '';
    background: #d9cec7;
    width: 1px;
    height: calc(100% + 377px);
    right: 0px;
    bottom: -122px;
  }
  
  .process-style-two .single-column:last-child .single-item .inner-box:before{
    height: calc(100% + 277px);
  }
  
  .process-style-two .single-column:first-child .single-item .inner-box:after{
    position: absolute;
    content: '';
    background: #d9cec7;
    width: 1px;
    height: calc(100% + 277px);
    left: 0px;
    bottom: -122px;
  }
  
  .process-style-two .single-item .inner-box span{
    position: relative;
    display: block;
    font-size: 14px;
    line-height: 24px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #a38f96;
    text-transform: uppercase;
    margin-bottom: 3px;
  }
  
  .process-style-two .single-item .inner-box h2{
    position: relative;
    display: block;
    font-size: 36px;
    line-height: 45px;
    font-weight: 700;
    margin-bottom: 49px;
  }
  
  .process-style-two .single-item .inner-box .icon-box{
    margin-bottom: 33px;
  }
  
  .process-style-two .single-item .inner-box h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
    margin-bottom: 14px;
  }
  
  .process-style-two .single-item .inner-box h3 a{
    display: inline-block;
    color: #001b44;
  }
  
  .process-style-two .single-item .inner-box h3 a:hover{
  
  }
  
  .process-style-two .single-item .inner-box p{
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  
  .process-style-two .single-item .inner-box .link a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    line-height: 24px;
    font-weight: 700;
    color: #001b44;
    text-transform: uppercase;
  }
  
  .process-style-two .single-item .inner-box .link a i{
    position: relative;
    font-size: 30px;
    top: 6px;
    margin-right: 8px;
    font-weight: 400;
  }
  
  .process-style-two .single-item .inner-box .link a:hover{
  
  }
  
  .process-style-two .sec-title{
    margin-bottom: 40px;
    z-index: 1;
  }
  
  
  .pricing-block-two .inner-box{
    position: relative;
    display: block;
    box-shadow: 0 0px 50px rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 10px;
    padding: 49px 30px 50px 40px;
  }
  
  .pricing-block-two .inner-box .icon-box{
    position: relative;
    margin-bottom: 17px;
  }
  
  .pricing-block-two .inner-box h3{
    position: relative;
    display: block;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    margin-bottom: 2px;
  }
  
  .pricing-block-two .inner-box .text{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    color: #002c5d;
  }
  
  .pricing-block-two .inner-box .text:before{
    position: absolute;
    content: '';
    width: 60px;
    height: 2px;
    left: 0px;
    bottom: 0px;
  }
  
  .pricing-block-two .inner-box h2{
    position: relative;
    display: block;
    font-size: 55px;
    line-height: 55px;
    font-weight: 700;
    margin-bottom: 31px;
    padding-left: 20px;
  }
  
  .pricing-block-two .inner-box h2 .text{
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    color: #a38f96;
    text-transform: uppercase;
    margin: 0px;
  }
  
  .pricing-block-two .inner-box h2 .text:before{
    display: none;
  }
  
  .pricing-block-two .inner-box h2 .symble{
    position: absolute;
    left: 0px;
    top: -8px;
    font-size: 30px;
  }
  
  .pricing-block-two .inner-box p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 32px;
  }
  
  .pricing-block-two .inner-box a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    font-family: 'Nunito Sans', sans-serif;
    color: #fff;
    background: #001b44;
    text-transform: uppercase;
    padding: 14px 58px;
    text-align: center;
    border-radius: 5px;
  }
  
  .pricing-block-two .inner-box:hover a{
  
  }
  
  .pricing-block-two .pricing-header{
    padding-bottom: 32px;
    border-bottom: 1px solid #eae0d9;
    margin-bottom: 33px;
  }
  
  .pricing-block-two .inner-box .list li{
    position: relative;
    display: block;
    font-size: 18px;
    line-height: 28px;
    font-family: 'Muli', sans-serif;
    color: #001b44;
    font-weight: 500;
    margin-bottom: 18px;
    padding-left: 34px;
  }
  
  .pricing-block-two .inner-box .list li:last-child{
    margin-bottom: 0px;
  }
  
  .pricing-block-two .inner-box .list{
    margin-bottom: 30px;
  }
  
  .pricing-block-two .inner-box .list li:before{
    position: absolute;
    content: "\\f11e";
    font-family: 'Flaticon';
    font-size: 18px;
    font-weight: 500;
    left: 0px;
    top: 0px;
  }
  
  
  /** team-style-two **/
  
  .team-style-two{
    position: relative;
    padding: 95px 0px 120px 0px;
  }
  
  .team-style-two .pattern-layer{
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
  }
  
  .team-style-two .sec-title .top-title:before,
  .team-style-two .sec-title .top-title:after{
    background: #624b52;
  }
  
  .team-style-two .sec-title .top-title:after{
    border-left: 2px solid #001b44;
    border-bottom: 2px solid #001b44;
  }
  
  .team-style-two .owl-dots{
    display: block;
    text-align: center;
    margin-top: 20px;
  }
  
  .project-style-two{
    position: relative;
    padding-bottom: 130px;
  }
  
  .project-style-two .project-block-one .inner-box:hover .image-box img{
    opacity: 0.15;
  }
  
  .project-style-two .more-text p{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
  }
  
  .project-style-two .more-text{
    position: relative;
    margin-top: 53px;
  }
  
  .project-style-two .more-text p a{
    display: inline-block;
    color: #001b44;
    line-height: 30px;
    border-bottom: 1px solid #001b44;
  }
  
  .project-style-two .more-text p a:hover{
  
  }
  
  
  /** testimonial-style-three **/
  
  .testimonial-style-three{
    position: relative;
    padding: 95px 0px 120px 0px;
  }
  
  .testimonial-style-three .sec-title{
    margin-bottom: 40px;
  }
  
  .testimonial-style-three .sec-title .top-title:before,
  .testimonial-style-three .sec-title .top-title:after{
    background: #e2d7d0;
  }
  
  .testimonial-style-three .sec-title .top-title:after{
    border-left: 2px solid #f1e7e1;
    border-bottom: 2px solid #f1e7e1;
  }
  
  .testimonial-style-three .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .testimonial-block-three{
    margin: 30px 0px 70px 0px;
  }
  
  .testimonial-block-three .inner-box{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 10px;
    padding: 40px 20px 42px 40px;
    margin-right: 10px;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);
  }
  
  .testimonial-block-three .inner-box .border-shap{
    position: absolute;
    left: 10px;
    top: -10px;
    width: 100%;
    height: 356px;
    background-repeat: no-repeat;
  }
  
  .testimonial-block-three .inner-box:before{
    position: absolute;
    content: '';
    background: #fff;
    width: 50px;
    height: 60px;
    left: 40px;
    bottom: -60px;
    clip-path: polygon(0% 0%, 100% 0%, 0% 100%, 0% 100%, 0% 0%);
  }
  
  .testimonial-block-three .inner-box .quote-box{
    position: absolute;
    right: 20px;
    top: -22px;
  }
  
  .testimonial-block-three .inner-box .author-box{
    position: relative;
    padding: 0px 0px 0px 80px;
    margin-bottom: 21px;
  }
  
  .testimonial-block-three .inner-box .author-box .author-thumb{
    position: absolute;
    left: 0px;
    top: -1px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  
  .testimonial-block-three .inner-box .author-box .author-thumb img{
    width: 100%;
    border-radius: 50%;
  }
  
  .testimonial-block-three .inner-box .author-box h3{
    font-size: 22px;
    line-height: 33px;
    font-weight: 700;
  }
  
  .testimonial-block-three .inner-box .author-box .designation{
    position: relative;
    display: inline-block;
    font-size: 12px;
    font-family: 'Muli', sans-serif;
    font-weight: 700;
    color: #a38f96;
    text-transform: uppercase;
  }
  
  .testimonial-block-three .inner-box .text p{
    font-size: 17px;
    font-weight: 500;
  }
  
  .news-section .sec-title .link{
    position: absolute;
    top: 86px;
    right: 0px;
    font-size: 14px;
    line-height: 24px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #001b44;
    text-transform: uppercase;
    z-index: 1;
  }
  
  .news-section .sec-title .link i{
    position: relative;
    font-size: 30px;
    font-weight: 400;
    margin-right: 8px;
    top: 6px;
  }
  
  .news-section .sec-title .link:hover{
  
  }
  
  .news-section.alternet-2{
    padding-bottom: 82px;
  }
  
  .clients-section.alternet-2 .clients-logo-box{
    background: #001b4421;
    border-right: 1px solid #d9cec7;
    margin-bottom: 0px;
    margin-top: 48px;
  }
  
  .clients-section.alternet-2 .clients-logo-box .logo-title{
    bottom: inherit;
    top: -43px;
    background: #fff;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);
  }
  
  .clients-section.alternet-2 .clients-logo-box:hover .logo-title{
    top: -28px;
  }
  
  .clients-section.alternet-2 .clients-logo-box .logo-title:before{
    background: #fff;
    top: 44px;
  }
  
  .clients-section.alternet-2 .clients-logo-box img{
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
  }
  
  .clients-section.alternet-2 .clients-logo-box:hover img{
    filter: grayscale(0%);
    -webkit-filter: grayscale(0%);
    -moz-filter: grayscale(0%);
    -o-filter: grayscale(0%);
    -ms-filter: grayscale(0%);
  }
  
  
  /** advice-section **/
  
  .advice-section{
    position: relative;
    padding: 50px 0px;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .advice-section:before{
    position: absolute;
    content: '';
    background: #3f262f;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    opacity: 0.95;
  }
  
  .advice-section .text h2{
    position: relative;
    font-size: 30px;
    line-height: 45px;
    color: #fff;
    font-weight: 700;
  }
  
  .advice-section .text h2 a{
    display: inline-block;
    line-height: 38px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
  }
  
  .advice-section .social-links li{
    position: relative;
    display: inline-block;
    margin-right: 7px;
  }
  
  .advice-section .social-links li:last-child{
    margin-right: 0px;
  }
  
  .advice-section .social-links li a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    color: #002c5d;
    background: #fff;
    width: 45px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border-radius: 50%;
  }
  
  .advice-section .social-links li a:hover{
    color: #fff;
  }
  
  
  /** footer-style-three **/
  
  .main-footer .logo-widget .footer-logo{
    margin-bottom: 33px;
  }
  
  .main-footer .logo-widget .text{
    margin-bottom: 32px;
  }
  
  .main-footer .logo-widget .text p{
    font-size: 17px;
    line-height: 28px;
    color: #ae979f;
    font-weight: 500;
  }
  
  .main-footer .logo-widget .upload-btn a{
    position: relative;
    display: inline-block;
    font-size: 17px;
    line-height: 28px;
    font-family: 'Muli', sans-serif;
    color: #fff;
    font-weight: 500;
    text-align: center;
    border-radius: 3px;
    padding: 13.5px 25px;
  }
  
  .main-footer .logo-widget .upload-btn a i{
    position: relative;
    font-size: 24px;
    margin-right: 10px;
    font-weight: 400;
    top: 2px;
  }
  
  .main-footer .logo-widget .upload-btn a:hover{
  
  }
  
  .main-footer .logo-widget{
    margin-top: 6px;
  }
  
  .footer-top .post-widget .post-inner .post{
    position: relative;
    display: block;
    padding-left: 100px;
    padding-bottom: 26px;
    margin-bottom: 28px;
    min-height: 108px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
  }
  
  .footer-top .post-widget .post-inner .post:last-child{
    border-bottom: none;
    margin-bottom: 0px;
  }
  
  .footer-top .post-widget .post-inner .post .image-box{
    position: absolute;
    left: 0px;
    top: 2px;
    width: 75px;
    height: 75px;
    border-radius: 10px;
  }
  
  .footer-top .post-widget .post-inner .post .image-box img{
    width: 100%;
    border-radius: 10px;
    transition: all 500ms ease;
  }
  
  .footer-top .post-widget .post-inner .post:hover .image-box img{
    opacity: 0.5;
  }
  
  .footer-top .post-widget .post-inner .post .post-date{
    position: relative;
    display: block;
    font-size: 13px;
    line-height: 20px;
    color: #ae979f;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 9px;
  }
  
  .footer-top .post-widget .post-inner .post h5{
    position: relative;
    display: block;
    font-size: 18px;
    line-height: 26px;
    color: #fff;
    font-weight: 700;
  }
  
  .footer-top .post-widget .post-inner .post h5 a{
    display: inline-block;
    color: #fff;
  }
  
  .footer-top .post-widget .post-inner .post h5 a:hover{
  
  }
  
  .footer-top .post-widget .widget-title{
    margin-bottom: 30px;
  }
  
  .main-footer.style-three .footer-top{
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding: 93px 0px 66px 0px;
  }
  
  
  
  /*** 
  
  ====================================================================
                          About-Page
  ====================================================================
  
  ***/
  
  
  /** page-title **/
  
  .page-title{
    position: relative;
    padding: 195px 0px 20px 0px;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .page-title:before{
    position: absolute;
    content: '';
    background: #352027;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    right: 0px;
    opacity: 0.8;
  }
  
  .page-title .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }
  
  .page-title .title-box{
    position: relative;
    display: block;
    margin-bottom: 152px;
  }
  
  .page-title .title-box h1{
    font-size: 60px;
    line-height: 65px;
    color: #fff;
    font-weight: 800;
    margin-bottom: 10px;
  }
  
  .page-title .title-box p{
    font-size: 22px;
    line-height: 30px;
    color: #fff;
    font-weight: 500;
  }
  
  .page-title .bread-crumb li{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 24px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    padding-right: 13px;
    margin-right: 5px;
  }
  
  .page-title .bread-crumb li:last-child{
    padding: 0px;
    margin: 0px;
  }
  
  .page-title .bread-crumb li a{
    color: #fff;
  }
  
  .page-title .bread-crumb li:before{
    position: absolute;
    content: '';
    background: #fff;
    width: 6px;
    height: 1px;
    right: 0px;
    bottom: 6px;
  }
  
  .page-title .bread-crumb li:last-child:before{
    display: none;
  }
  
  .page-title .bread-crumb li a:hover{
  
  }
  
  .about-style-two.about-page{
    padding-bottom: 80px;
  }
  
  .process-style-two.alternet-2:before{
    background: #001b44;
  }
  
  .process-style-two.alternet-2 .inner-container{
    background: #001b44;
  }
  
  .process-style-two.alternet-2 .sec-title .top-title:before, 
  .process-style-two.alternet-2 .sec-title .top-title:after {
    background: #624b52;
  }
  
  .process-style-two.alternet-2 .sec-title .top-title:after{
    border-left: 2px solid #001b44;
    border-bottom: 2px solid #001b44;
  }
  
  .process-style-two.alternet-2 .single-item .inner-box h3 a{
    color: #fff;
  }
  
  .process-style-two.alternet-2 .single-item .inner-box h3 a:hover{
  
  }
  
  .process-style-two.alternet-2 .single-item .inner-box p{
    color: rgba(255,255,255,0.6);
  }
  
  .process-style-two.alternet-2 .single-item .inner-box .link a{
    color: #fff;
  }
  
  .process-style-two.alternet-2 .single-item .inner-box .link a i{
    color: rgba(255,255,255,0.6);
    transition: all 500ms ease;
  }
  
  .process-style-two.alternet-2 .single-item .inner-box .link a:hover{
  
  }
  
  .process-style-two.alternet-2 .single-item .inner-box .link a:hover i{
    
  }
  
  .process-style-two.alternet-2 .single-item .inner-box:before,
  .process-style-two .single-column:first-child .single-item .inner-box:after{
    background: rgba(255,255,255,0.1);
  }
  
  .process-style-two.alternet-2 .inner-container .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  
  /** history-section **/
  
  .history-section{
    position: relative;
  }
  
  .history-section .sec-title{
    padding: 95px 0px 100px 0px;
    margin: 0px;
  }
  
  .history-section .inner-box{
    position: relative;
    padding: 130px 30px 130px 0px;
  }
  
  .history-section .inner-box .image-box{
    position: relative;
    display: block;
    border-radius: 10px;
    margin-bottom: 88px;
  }
  
  .history-section .inner-box .image-box img{
    width: 100%;
    border-radius: 10px;
  }
  
  .history-section .inner-box .content-box .year-box{
    position: relative;
    display: inline-block;
    width: 166px;
    height: 131px;
    line-height: 131px;
    text-align: center;
    margin-bottom: 36px;
  }
  
  .history-section .inner-box .content-box .year-box h3{
    font-size: 24px;
    font-weight: 700;
    line-height: 140px;
    z-index: 1;
  }
  
  .history-section .inner-box .content-box .year-box .pattern-1{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 166px;
    height: 131px;
    background-repeat: no-repeat;
  }
  
  .history-section .inner-box .content-box .year-box .pattern-2{
    position: absolute;
    left: 0px;
    top: 3px;
    width: 162px;
    height: 140px;
    background-repeat: no-repeat;
  }
  
  .history-section .inner-box .content-box .text h3{
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  
  .history-section .inner-box .content-box .text p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
  }
  
  .history-section .inner-box .content-box{
    position: relative;
    margin-bottom: 77px;
  }
  
  .mr-0{
    margin: 0px !important;
  }
  
  .history-section .inner-box:before{
    position: absolute;
    content: '';
    background: #eae0d9;
    width: 1px;
    height: 100%;
    top: 0px;
    right: 0px;
  }
  
  .history-section .column:nth-child(2) .inner-box:after{
    position: absolute;
    content: '';
    background: #eae0d9;
    width: 1px;
    height: 100%;
    top: 0px;
    left: -30px;
  }
  
  .history-section .column:last-child .inner-box:before{
    display: none;
  }
  
  .history-section .inner-box .dots-box{
    position: absolute;
    left: -37px;
    top: 0px;
    width: 15px;
    height: 15px;
    background: #fff;
    border: 1px solid #eae0d9;
    border-radius: 50%;
    z-index: 1;
  }
  
  .history-section .inner-box .dots-box:before{
    position: absolute;
    content: '';
    background: #eae0d9;
    width: 35px;
    height: 1px;
    left: -11px;
    top: 6px;
  }
  
  .history-section .inner-box .dots-box:after{
    position: absolute;
    content: '';
    background: #fff;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    left: 0px;
    top: 0px;
  }
  
  .history-section .inner-box .dots-box.active{
  
  }
  
  .history-section .inner-box .dots-box.active:before{
  
  }
  
  .history-section .inner-box .dots-box.active:after{
    border: 3px solid #fff;
  }
  
  .history-section .image-layer{
    position: absolute;
    left: 0px;
    top: 80px;
  }
  
  .main-footer .pattern-layer.no-anim{
    animation: none !important;
  }
  
  .team-style-three{
    padding: 95px 0px 120px 0px;
  }
  
  .team-style-three .team-block-one .inner-box .image-box{
    box-shadow: none;
    border-radius: 15px 15px 0px 0px;
  }
  
  .team-style-three .team-block-one .inner-box .image-box img{
    border-radius: 15px 15px 0px 0px;
  }
  
  .team-style-three .team-block-one .inner-box{
    box-shadow: 0 10px 20px 5px rgba(0, 0, 0, 0.1);
  }
  
  .team-style-three .team-block-one .inner-box .image-box .share-box p{
    border-bottom-right-radius: 0px;
  }
  
  .team-style-three .team-block-one .inner-box{
    border-radius: 15px;
    margin-bottom: 45px;
  }
  
  .team-style-three .team-block-one .inner-box .lower-content{
    padding: 24px 15px 21px 15px;
  }
  
  .team-style-three .owl-dots{
    position: relative;
    display: block;
    text-align: center;
  }
  
  .owl-dot-style-two .owl-dots .owl-dot span{
    position: relative;
    display: inline-block;
    width: 30px;
    height: 2px;
    background: #c2b3aa;
    margin: 0px 10px;
    cursor: pointer;
    z-index: 1;
    transition: all 500ms ease;
  }
  
  .owl-dot-style-two .owl-dots .owl-dot.active span,
  .owl-dot-style-two .owl-dots .owl-dot span:hover{
    height: 4px;
  }
  
  .team-style-four{
    position: relative;
    padding: 95px 0px 90px;
  }
  
  .team-style-four .sec-title .top-title:before,
  .team-style-four .sec-title .top-title:after{
    background: #e2d7d0;
  }
  
  .team-style-four .sec-title .top-title:after{
    border-left: 2px solid #001b4421;
    border-bottom: 2px solid #001b4421;
  }
  
  .team-style-four .team-block-one .inner-box{
    margin-bottom: 32px;
  }
  
  
  /*** 
  
  ====================================================================
                          Overview-Page
  ====================================================================
  
  ***/
  
  /** hiring-strategies **/
  
  .hiring-strategies{
    position: relative;
    padding: 95px 0px 90px 0px;
  }
  
  .hiring-strategies .inner-box .title-inner{
    position: relative;
    padding: 97px 50px 110px 100px;
    border-radius: 10px 10px 0px 0px;
    overflow: hidden;
  }
  
  .hiring-strategies .inner-box .title-inner .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .hiring-strategies .inner-box .title-inner h2{
    font-size: 60px;
    line-height: 72px;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 24px;
    max-width: 530px;
  }
  
  .hiring-strategies .inner-box .funfact-inner{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 0px 0px 10px 10px;
    box-shadow: 0 20px 15px 0px rgba(0, 0, 0, 0.1);
  }
  
  .hiring-strategies .inner-box .funfact-inner .counter-block{
    position: relative;
    display: block;
    padding: 54px 30px 52px 190px;
  }
  
  .hiring-strategies .inner-box .funfact-inner .counter-block:before{
    position: absolute;
    content: '';
    background: #eae0d9;
    width: 1px;
    height: 100%;
    top: 0px;
    right: -15px;
  }
  
  .hiring-strategies .inner-box .funfact-inner .counter-column:last-child .counter-block:before{
    display: none;
  }
  
  .hiring-strategies .inner-box .funfact-inner .counter-block .count-outer{
    position: absolute;
    left: 50px;
    top: 44px;
    display: inline-block;
    font-size: 60px;
    font-family: 'Nunito Sans', sans-serif;
    line-height: 70px;
    font-weight: 700;
  }
  
  .hiring-strategies .inner-box .funfact-inner .counter-block .count-outer .icon{
    position: relative;
    top: -7px;
    font-size: 34px;
    font-weight: 400;
  }
  
  .hiring-strategies .inner-box .funfact-inner .counter-block h6{
    display: block;
    font-size: 14px;
    line-height: 24px;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  
  /** solutions-problems **/
  
  .solutions-problems{
    position: relative;
    padding-bottom: 120px;
  }
  
  .solutions-problems .owl-dots{
    display: block;
    text-align: center;
  }
  
  .solutions-problems .upper-box{
    position: relative;
    margin-bottom: 80px;
  }
  
  .solutions-problems .upper-box .title-inner{
    position: relative;
    display: block;
    margin-right: 45px;
  }
  
  .solutions-problems .upper-box .title-inner h2{
    font-size: 44px;
    line-height: 54px;
    font-weight: 700;
    margin-bottom: 30px;
  }
  
  .solutions-problems .upper-box .title-inner p{
    font-size: 17px;
    font-weight: 500;
  }
  
  .solutions-problems .upper-box .inner-box .single-item .icon-box{
    position: relative;
    display: inline-block;
    margin-bottom: 24px;
  }
  
  .solutions-problems .upper-box .inner-box .single-item h3{
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  
  .solutions-problems .upper-box .inner-box .single-item p{
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 18px;
  }
  
  .solutions-problems .upper-box .inner-box .single-item a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    color: #001b44;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .solutions-problems .upper-box .inner-box .single-item a i{
    position: relative;
    font-size: 30px;
    top: 6px;
    margin-right: 10px;
    font-weight: 400;
  }
  
  .solutions-problems .upper-box .inner-box .single-item a:hover{
  
  }
  
  .solutions-problems .upper-box .inner-box{
    margin-top: 10px;
  }
  
  .solutions-problems .carousel-box{
    position: relative;
    margin-right: -30px;
  }
  
  .solutions-problems .carousel-box .single-item{
    position: relative;
    margin: 30px 0px;
    max-width: 600px;
    width: 100%;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 10px;
    margin-right: 30px;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .image-box{
    position: relative;
    max-width: 470px;
    width: 100%;
    border-radius: 15px 0px 0px 15px;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .image-box img{
    width: 100%;
    border-radius: 15px 0px 0px 15px;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .lower-content{
    position: relative;
    margin: 0px 100px 0px 40px;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .lower-content h3{
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100%;
    background: #001b44;
    padding: 25px 30px 25px 30px;
    border-top-left-radius: 10px;
    font-size: 22px;
    line-height: 32px;
    color: #fff;
    font-weight: 700;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content{
    position: absolute;
    overflow: hidden;
    top: 0px;
    right: 0px;
    width: 100px;
    height: 100%;
    box-shadow: 10px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 0px 15px 15px 0px;
    transition: all 500ms ease;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box:hover .side-content{
    box-shadow: none;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background: #fff;
    text-align: center;
    padding: 20px 15px 20px 15px;
    transition: all 900ms ease;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box:hover .side-content .content-box{
    opacity: 0;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box span{
    position: absolute;
    left: 0px;
    top: 30px;
    font-size: 35px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #001b4421;
    width: 100%;
    text-align: center;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box .icon-box{
    position: absolute;
    display: inline-block;
    left: 19px;
    bottom: 25px;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box:before{
    position: absolute;
    content: '';
    background: #eae0d9;
    width: 2px;
    height: 60px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    margin-top: -15px;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box:after{
    position: absolute;
    content: '';
    width: 2px;
    height: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    margin-top: 5px;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background: #001b4421;
    border-radius: 0px 15px 15px 0px;
    text-align: center;
    padding: 20px 15px 20px 15px;
    z-index: 1;
    left: -100px;
    transition: all 500ms ease;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box:hover .side-content .overlay-box{
    left: 0px;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box span{
    position: absolute;
    left: 0px;
    top: 30px;
    font-size: 35px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    width: 100%;
    text-align: center;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box a{
    position: absolute;
    display: inline-block;
    background: #fff;
    color: #001b44;
    width: 58px;
    height: 58px;
    line-height: 58px;
    text-align: center;
    border-radius: 50%;
    left: 20px;
    bottom: 25px;
    font-size: 14px;
    font-weight: 700;
    z-index: 1;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box a:hover{
    color: #fff;
  }
  
  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box:before{
    position: absolute;
    content: '';
    width: 2px;
    height: 60px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    margin-top: -15px;
  }
  
  
  /** growth-section **/
  
  .growth-section{
    position: relative;
    padding-top: 95px;
  }
  
  .growth-section:before{
    position: absolute;
    content: '';
    background: #001b44;
    width: 100%;
    height: 625px;
    left: 0px;
    top: 0px;
    right: 0px;
  }
  
  .growth-section .sec-title .top-title:before,
  .growth-section .sec-title .top-title:after{
    background: #533942;
  }
  
  .growth-section .sec-title .top-title:after{
    border-left: 2px solid #001b44;
    border-bottom: 2px solid #001b44;
  }
  
  .growth-section .image-box{
    position: relative;
    margin: 0px -85px;
    margin-bottom: -133px;
  }
  
  .growth-section .image-box .image{
    position: relative;
    display: block;
    border-radius: 10px;
    z-index: 1;
  }
  
  .growth-section .image-box .image img{
    width: 100%;
    border-radius: 10px;
  }
  
  .growth-section .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 579px;
    height: 575px;
    background-repeat: no-repeat;
  }
  
  .pricing-section.overview-page{
    padding-top: 250px;
    overflow: hidden;
  }
  
  .pb-0{
    padding-bottom: 0px;
  }
  
  .page-title .bg-shape{
    position: relative;
    display: block;
    width: 100%;
    height: 60px;
    background: #fff;
    margin-top: 20px;
    border-radius: 10px 10px 0px 0px;
  }
  
  
  /** placejob-section **/
  
  .placejob-section{
    position: relative;
    padding: 35px 0px 80px 0px;
  }
  
  .placejob-section .form-inner{
    position: relative;
    display: block;
    padding: 41px 30px 50px 30px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
    margin-bottom: 30px;
    border-radius: 5px;
  }
  
  .placejob-section .form-inner .title-inner{
    position: relative;
    padding-left: 77px;
    margin-bottom: 32px;
  }
  
  .placejob-section .form-inner .title-inner .icon-box{
    position: absolute;
    left: 0px;
    top: 7px;
  }
  
  .placejob-section .form-inner .title-inner h2{
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 42px;
    font-weight: 700;
  }
  
  .placejob-section .form-inner .title-inner p{
    font-size: 17px;
    font-weight: 500;
  }
  
  .placejob-section .form-inner .job-form .form-group{
    position: relative;
    margin-bottom: 20px;
  }
  
  .placejob-section .form-inner .job-form .form-group:last-child{
    margin-bottom: 0px;
  }
  
  .placejob-section .form-inner .job-form .form-group input[type='text'],
  .placejob-section .form-inner .job-form .form-group input[type='email'],
  .placejob-section .form-inner .job-form .form-group textarea{
    position: relative;
    display: block;
    width: 100%;
    height: 54px;
    border: 1px solid #eae0d9;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
    transition: all 500ms ease;
  }
  
  .placejob-section .form-inner .job-form .form-group textarea{
    height: 128px;
    resize: none;
  }
  
  .placejob-section .form-inner .job-form .form-group input:focus,
  .placejob-section .form-inner .job-form .form-group textarea:focus{
  
  }
  
  .placejob-section .form-inner .job-form .form-group .nice-select{
    height: 54px;
  }
  
  .placejob-section .form-inner .job-form .form-group .nice-select:after{
    border-bottom: 2px solid #b39ea5;
    border-right: 2px solid #b39ea5;
  }
  
  .placejob-section .form-inner .job-form .column .form-group .nice-select{
    margin-bottom: 20px;
  }
  
  .placejob-section .form-inner .job-form .column .form-group:last-child .nice-select{
    margin-bottom: 0px;
  }
  
  .placejob-section .form-inner .job-form .column:first-child .form-group .nice-select{
    z-index: 1;
  }
  
  .placejob-section .form-inner .job-form .form-group button{
    display: block;
    width: 100%;
    padding: 14px 44px;
  }
  
  
  
  /*** 
  
  ====================================================================
                          faq-Page
  ====================================================================
  
  ***/
  
  .faq-section{
    position: relative;
    padding: 95px 0px 130px 0px;
  }
  
  .faq-section .image-box{
    position: relative;
    display: block;
  }
  
  .faq-section .image-box img{
    width: 100%;
  }
  
  .accordion-box .block{
    position: relative;
    display: block;
    background: #fff;
    margin-bottom: 20px;
    transition: all 500ms ease;
  }
  
  .accordion-box .block:last-child{
    margin-bottom: 0px;
  }
  
  .accordion-box .block .acc-content{
    position:relative;
    display:none;
    margin: 20px 20px 0px 20px;
  }
  
  .accordion-box .block .acc-content.current{
    display:block;  
  }
  
  .accordion-box .block .acc-btn .icon-outer{
    position: absolute;
    width: 60px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #001b4421;
    top: 0px;
    right: 0px;
    text-align: center;
    cursor: pointer;
    transition: all 500ms ease;
    z-index: 1;
  }
  
  .accordion-box .block .acc-btn.active .icon-outer{
  
  }
  
  .accordion-box .block .acc-btn .icon-outer:after{
    position: absolute;
    content: '+';
    font-size: 24px;
    color: #001b44;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 600;
    width: 60px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0px;
    top: 0px;
  }
  
  .accordion-box .block .acc-btn.active .icon-outer:after{
    opacity: 0;
  }
  
  .accordion-box .block .acc-btn.active .icon-outer{
    color: #fff;
  }
  
  .accordion-box .block .acc-btn.active .icon-outer:before{
    position: relative;
    font-size: 10px;
    font-family: 'Flaticon';
    font-weight: 700;
    margin: 0px;
    content: "\\f123";
  }
  
  .accordion-box .block .acc-btn{
    position: relative;
    display: block;
    overflow: hidden;
    border: 1px solid #eae0d9;
    border-radius: 5px;
    background: #fff;
    padding: 16px 80px 14px 20px;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .accordion-box .block .acc-btn.active{
    background: #001b44;
  }
  
  .accordion-box .block .acc-btn h5{
    font-size: 18px;
    line-height: 28px;
    font-weight: 700;
    margin: 0px;
    transition: all 500ms ease;
  }
  
  .accordion-box .block .acc-btn.active h5{
    color: #fff;
  }
  
  .accordion-box .block .acc-content .text{
    position: relative;
    display: block;
    background: #fff;
    border: 1px solid #eae0d9;
    padding: 30px 30px 30px 30px;
    border-radius: 5px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  }
  
  .accordion-box .block .acc-content .text:before{
    position: absolute;
    content: '';
    background: #fff;
    width: 20px;
    height: 20px;
    left: 30px;
    top: -9px;
    transform: rotate(-45deg);
    box-shadow: 1px -1px 0px 0px #eae0d9;
    transition: all 500ms ease;
  }
  
  .accordion-box .block .acc-content .text p{
    font-size: 18px;
    font-weight: 500;
  }
  
  
  
  /*** 
  
  ====================================================================
                          Testimonials-Page
  ====================================================================
  
  ***/
  
  .clients-style-three{
    position: relative;
    padding: 140px 0px 110px 0px;
  }
  
  .clients-style-three #image_block_1 .image-box .video-inner{
    position: relative;
    max-width: 100%;
    padding: 210px 0px 190px 0px;
    margin-bottom: 10px;
  }
  
  .clients-style-three #image_block_1 .image-box{
    padding: 0px;
    margin: 0px;
  }
  
  .clients-style-three #image_block_1 .image-box .video-inner .video-btn{
    width: 100px;
    height: 100px;
    line-height: 100px;
    font-size: 36px;
  }
  
  .clients-style-three #image_block_1 .image-box .video-inner .border{
    width: 100px;
    height: 100px;
    margin-top: 0px;
  }
  
  .clients-style-three .clients-inner{
    position: relative;
    display: block;
    padding: 0px 100px;
  }
  
  .clients-style-three .clients-inner .clients-logo-box{
    display: block;
    max-width: 100%;
    width: auto;
    margin: 30px auto;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.1);
  }
  
  .clients-style-three .clients-inner .clients-logo-box img{
    display: block;
    max-width: 100%;
    width: auto;
    margin: 0 auto;
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    transition: all 500ms ease;
  }
  
  .clients-style-three .clients-inner .clients-logo-box:hover img{
    filter: grayscale(0%);
    -webkit-filter: grayscale(0%);
    -moz-filter: grayscale(0%);
    -o-filter: grayscale(0%);
    -ms-filter: grayscale(0%);
  }
  
  .clients-style-three .owl-nav .owl-prev,
  .clients-style-three .owl-nav .owl-next{
    position: absolute;
    display: inline-block;
    top: 60px;
    width: 70px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    border: 1px solid #eae0d9;
    border-radius: 50%;
    font-size: 30px;
    font-weight: 400;
    color: #001b44;
    background: #fff;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .clients-style-three .owl-nav .owl-prev{
    left: -100px;
  }
  
  .clients-style-three .owl-nav .owl-next{
    right: -100px;
  }
  
  .clients-style-three .owl-nav .owl-prev:hover,
  .clients-style-three .owl-nav .owl-next:hover{
    border-color: #fff;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);
  }
  
  
  .testimonial-page-section{
    position: relative;
    padding-bottom: 90px;
  }
  
  .testimonial-page-section .testimonial-block-three{
    margin: 0px 0px 110px 0px;
  }
  
  .testimonial-page-section .testimonial-block-three .inner-box{
    box-shadow: 0 10px 100px rgba(0, 0, 0, 0.1);
  }
  
  .testimonial-page-section .testimonial-block:nth-child(2) .testimonial-block-three .inner-box .border-shap{
    height: 384px;
  }
  
  .testimonial-page-section .testimonial-block:nth-child(3) .testimonial-block-three .inner-box .border-shap{
    height: 422px;
  }
  
  .testimonial-page-section .testimonial-block:nth-child(4) .testimonial-block-three .inner-box .border-shap{
    height: 422px;
  }
  
  .testimonial-page-section .testimonial-block:nth-child(6) .testimonial-block-three .inner-box .border-shap{
    height: 384px;
  }
  
  .testimonial-page-section .testimonial-block:nth-child(7) .testimonial-block-three .inner-box .border-shap{
    height: 384px;
  }
  
  .testimonial-page-section .testimonial-block:nth-child(8) .testimonial-block-three .inner-box .border-shap{
    height: 422px;
  }
  
  
  /*** 
  
  ====================================================================
                          Service-Page
  ====================================================================
  
  ***/
  
  .service-section.service-page{
    padding: 95px 0px 90px 0px;
  }
  
  .service-section.service-page .service-block-one{
    margin-top: 0px;
    margin-bottom: 30px;
  }
  
  .service-section.service-page .sec-title{
    margin-bottom: 50px;
  }
  
  
  /** hiring-section **/
  
  .hiring-section{
    position: relative;
  }
  
  .hiring-section .left-column,
  .hiring-section .right-column{
    width: 50%;
  }
  
  .hiring-section .left-column{
    background: #001b44;
  }
  
  .hiring-section .right-column{
    background: #3e242d;
  }
  
  .hiring-section .left-column .inner-box{
    position: relative;
    display: block;
    text-align: left;
    max-width: 500px;
    padding: 120px 50px 130px 0px;
  }
  
  .hiring-section .right-column .inner-box{
    position: relative;
    display: block;
    text-align: left;
    max-width: 550px;
    padding: 120px 0px 130px 100px;
  }
  
  .hiring-section .inner-box h2{
    position: relative;
    display: block;
    font-size: 44px;
    line-height: 55px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 19px;
  }
  
  .hiring-section .inner-box p{
    font-size: 17px;
    font-weight: 500;
    color: rgba(255,255,255,0.6);
    margin-bottom: 42px;
  }
  
  .hiring-section .inner-box a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #001b44;
    border-radius: 4px;
    text-align: center;
    background: #fff;
    padding: 15px 44px;
    text-transform: uppercase;
    z-index: 1;
  }
  
  .hiring-section .inner-box a:hover{
    color: #fff;
  }
  
  .hiring-section .inner-box a:hover:after{
    transform: scaleX(1);
    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  }
  
  .hiring-section .inner-box a:after{
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 4px;
    transform: scaleX(0);
    transform-origin: 50% 100%;
    transition-property: transform;
    transition-duration: 0.5s;
    transition-timing-function: ease-out;
  }
  
  .hiring-section .inner-box .icon-box{
    position: absolute;
    right: 70px;
    bottom: 70px;
    font-size: 130px;
    line-height: 100px;
    color: rgba(255,255,255,0.1);
  }
  
  .hiring-section .image-layer .image-1{
    position: absolute;
    left: 0px;
    top: 0px;
  }
  
  .hiring-section .image-layer .image-2{
    position: absolute;
    right: 0px;
    top: 0px;
  }
  
  
  /** contact-section **/
  
  .contact-section{
    position: relative;
    padding: 95px 0px 130px 0px
  }
  
  .contact-section .form-inner{
    position: relative;
    display: block;
    background: #fff;
    padding: 50px 50px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
  }
  
  .default-form .form-group{
    position: relative;
    margin-bottom: 20px;
  }
  
  .default-form .form-group:last-child{
    margin-bottom: 0px;
  }
  
  .default-form .form-group input[type='text'], 
  .default-form .form-group input[type='email'], 
  .default-form .form-group textarea {
    position: relative;
    display: block;
    width: 100%;
    height: 56px;
    border: 1px solid #eae0d9;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
    transition: all 500ms ease;
  }
  
  .default-form .form-group input:focus,
  .default-form .form-group textarea:focus{
  
  }
  
  .default-form .form-group textarea{
    height: 120px;
    resize: none;
  }
  
  .default-form .form-group button{
    display: block;
    width: 100%;
  }
  
  .default-form .form-group .nice-select:after {
    border-bottom: 2px solid #002c5d;
    border-right: 2px solid #002c5d;
  }
  
  .contact-section .form-inner .pattern-layer{
    position: absolute;
    right: -130px;
    bottom: -130px;
    width: 380px;
    height: 340px;
    background-repeat: no-repeat;
    z-index: -1;
  }
  
  
  /** service-details **/
  
  .service-details{
    position: relative;
    padding: 95px 0px 130px 0px;
  }
  
  .service-details-content .content-one .image-box{
    position: relative;
    display: block;
    border-radius: 10px;
    margin-bottom: 43px;
  }
  
  .service-details-content .content-one .image-box img{
    width: 100%;
    border-radius: 10px;
  }
  
  .service-details-content p{
    font-size: 17px;
    font-weight: 500;
  }
  
  .service-details-content .content-one .text p{
    margin-bottom: 20px;
  }
  
  .service-details-content .content-one .text p:last-child{
    margin-bottom: 0px;
  }
  
  .service-details-content .content-one .sec-title{
    margin-bottom: 37px;
  }
  
  .service-details-content .content-one{
    margin-bottom: 42px;
  }
  
  .service-details-content .content-two .inner-box{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
    margin-bottom: 73px;
  }
  
  .service-details-content .content-two .inner-box .single-column{
    float: left;
    position: relative;
    display: block;
    width: 33.333%;
    padding: 36px 40px 26px 30px;
    border-right: 1px solid #eae0d9;
  }
  
  .service-details-content .content-two .inner-box .single-column:last-child{
    border: none;
  }
  
  .service-details-content .content-two .inner-box .single-column .content-box h5{
    position: relative;
    display: block;
    font-size: 20px;
    font-weight: 700;
    color: #a38f96;
    margin-bottom: 17px;
  }
  
  .service-details-content .content-two .inner-box .single-column .content-box h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
    margin-bottom: 64px;
  }
  
  .service-details-content .content-two .inner-box .single-column .content-box .link a{
    position: relative;
    display: inline-block;
    font-size: 30px;
    font-weight: 400;
    color: #001b44;
  }
  
  .service-details-content .content-two .inner-box .single-column .content-box .icon-box{
    position: absolute;
    right: 30px;
    bottom: 30px;
    font-size: 85px;
    line-height: 85px;
    color: #001b4421;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box{
    position: absolute;
    left: 0px;
    top: 30px;
    background: #001b44;
    width: 100%;
    padding: 33px 40px 32px 30px;
    border-radius: 10px 0px 10px 10px;
    visibility: hidden;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .service-details-content .content-two .inner-box .single-column:nth-child(2) .overlay-box{
    border-radius: 0px 0px 10px 10px;
  }
  
  .service-details-content .content-two .inner-box .single-column:last-child .overlay-box{
    border-radius: 0px 10px 10px 10px;
  }
  
  .service-details-content .content-two .inner-box .single-column:last-child .overlay-box .icon-box{
    border-top-right-radius: 10px;
  }
  
  .service-details-content .content-two .inner-box .single-column:hover .overlay-box{
    visibility: visible;
    opacity: 1;
    top: 0px;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box .icon-box{
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 40px;
    color: #fff;
    width: 70px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    border-bottom-left-radius: 35px;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box h5{
    position: relative;
    display: block;
    font-size: 20px;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 12px;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box .list li{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    color: #ae979f;
    margin-bottom: 8px;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box .list li:last-child{
    margin-bottom: 0px;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box .list{
    margin-bottom: 15px;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box .link a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    line-height: 24px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box .link a i{
    position: relative;
    font-size: 30px;
    font-weight: 400;
    top: 6px;
    margin-right: 8px;
  }
  
  .service-details-content .content-two .inner-box .single-column .overlay-box .link a:hover{
  
  }
  
  .service-details-content .content-three .upper-box{
    margin-bottom: 42px;
  }
  
  .service-details-content .content-three .upper-box h3{
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 22px;
  }
  
  .service-details-content .content-three .tab-btns li{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
    padding: 40px 30px 30px 30px;
  }
  
  .service-details-content .content-three .tab-btns li.active-btn:before{
    position: absolute;
    content: '';
    background: #001b44;
    width: 30px;
    height: 30px;
    top: 50%;
    margin-top: -15px;
    right: -10px;
    transform: rotate(-45deg);
  }
  
  .service-details-content .content-three .tab-btns li.active-btn{
    background: #001b44;
  }
  
  .service-details-content .content-three .tab-btns li:last-child{
    margin-bottom: 0px;
  }
  
  .service-details-content .content-three .tab-btns li .icon-box{
    position: relative;
    font-size: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    color: #ddd2d2;
    transition: all 500ms ease;
  }
  
  .service-details-content .content-three .tab-btns li.active-btn .icon-box{
  
  }
  
  .service-details-content .content-three .tab-btns li h6{
    position: relative;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    text-transform: uppercase;
    transition: all 500ms ease;
  }
  
  .service-details-content .content-three .tab-btns li.active-btn h6{
    color: #fff;
  }
  
  .service-details-content .content-three .tabs-content .inner-box{
    position: relative;
    display: block;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .service-details-content .content-three .tabs-content .inner-box .image-box{
    position: relative;
    display: block;
  }
  
  .service-details-content .content-three .tabs-content .inner-box .image-box img{
    width: 100%;
    border-radius: 10px;
  }
  
  .service-details-content .content-three .tabs-content .inner-box .text{
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: calc(100% - 30px);
    border-top-right-radius: 10px;
    background: #001b44;
    padding: 34px 30px 32px 30px;
  }
  
  .service-details-content .content-three .tabs-content .inner-box .text h3{
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 15px;
  }
  
  .service-details-content .content-three .tabs-content .inner-box .text a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    line-height: 24px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
  }
  
  .service-details-content .content-three .tabs-content .inner-box .text a i{
    position: relative;
    font-size: 30px;
    font-weight: 400;
    top: 6px;
    margin-right: 8px;
  }
  
  .service-details-content .content-three .tabs-content .inner-box .text a:hover{
  
  }
  
  .service-details-content .content-three .tabs-content .inner-box .text p{
    color: #ae979f;
    margin-bottom: 19px;
  }
  
  .service-details-content .content-three{
    margin-bottom: 73px;
  }
  
  .service-details-content .content-four .upper-box{
    margin-bottom: 32px;
  }
  
  .service-details-content .content-four .upper-box h3{
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 22px;
  }
  
  .service-details-content .content-four .inner-box .list-item li{
    position: relative;
    display: block;
    padding: 20px 50px 22px 80px;
    background: #001b4421;
    border-radius: 10px;
    margin-bottom: 20px;
    transition: all 500ms ease;
  }
  
  .service-details-content .content-four .inner-box .list-item li:hover{
    background: #001b44;
  }
  
  .service-details-content .content-four .inner-box .list-item li:last-child{
    margin-bottom: 0px;
  }
  
  .service-details-content .content-four .inner-box .list-item li .icon-box{
    position: absolute;
    left: 17px;
    top: 20px;
    font-size: 30px;
    line-height: 30px;
  }
  
  .service-details-content .content-four .inner-box .list-item li .icon-box:before{
    position: absolute;
    content: '';
    background: #d9cec7;
    width: 1px;
    height: 32px;
    top: -1px;
    right: -12px;
    transition: all 500ms ease;
  }
  
  .service-details-content .content-four .inner-box .list-item li:hover .icon-box:before{
    background: #6b555d;
  }
  
  .service-details-content .content-four .inner-box .list-item li h5{
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
    transition: all 500ms ease;
  }
  
  .service-details-content .content-four .inner-box .list-item li:hover h5{
    color: #fff;
  }
  
  .service-details-content .content-four .inner-box .list-item li .more-content{
    position: absolute;
    top: 21px;
    right: 20px;
  }
  
  .service-details-content .content-four .inner-box .list-item li .more-content .menu-icon i{
    position: relative;
    display: inline-block;
    font-size: 16px;
    width: 8px;
    color: #b4a4a4;
    transition: all 500ms ease;
  }
  
  .service-details-content .content-four .inner-box .list-item li:hover .more-content .menu-icon i{
    
  }
  
  .service-details-content .content-four .inner-box .list-item li .more-content .text{
    position: absolute;
    right: -10px;
    top: 47px;
    width: 270px;
    background: #fff;
    padding: 23px 30px 22px 30px;
    z-index: 1;
    border-radius: 5px;
    visibility: hidden;
    opacity: 0;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    transition: all 500ms ease;
  }
  
  .service-details-content .content-four .inner-box .list-item li:hover .more-content .text{
    visibility: visible;
    opacity: 1;
    top: 37px;
  }
  
  .service-details-content .content-four .inner-box .list-item li .more-content .text:before{
    position: absolute;
    content: '';
    background: #fff;
    width: 15px;
    height: 15px;
    top: -5px;
    right: 8px;
    transform: rotate(-45deg);
  }
  
  .service-details-content .content-four{
    margin-bottom: 73px;
  }
  
  .service-details-content .content-five .upper-box{
    margin-bottom: 29px;
  }
  
  .service-details-content .content-five .upper-box h3 {
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 40px;
    font-weight: 700;
  }
  
  .project-block-two .inner-box{
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: 10px;
  }
  
  .project-block-two .inner-box .image-box{
    position: relative;
    display: block;
    border-radius: 10px;
  }
  
  .project-block-two .inner-box .image-box img{
    width: 100%;
    border-radius: 10px;
  }
  
  .project-block-two .inner-box .content-box .text{
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: calc(100% - 60px);
    padding: 26px 40px 21px 30px;
    border-top-right-radius: 10px;
    background: #001b44;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .project-block-two .inner-box:hover .content-box .text{
    opacity: 1;
  }
  
  .project-block-two .inner-box .content-box .link{
    position: absolute;
    right: 0px;
    bottom: 0px;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .project-block-two .inner-box:hover .content-box .link{
    opacity: 1;
  }
  
  .project-block-two .inner-box .content-box .link a{
    position: relative;
    display: inline-block;
    width: 60px;
    height: 60px;
    line-height: 60px;
    font-size: 14px;
    color: #fff;
    font-weight: 700;
    text-align: center;
  }
  
  .project-block-two .inner-box .content-box .text span{
    position: relative;
    display: block;
    font-size: 12px;
    line-height: 20px;
    font-weight: 700;
    color: #ae979f;
    text-transform: uppercase;
    margin-bottom: 9px;
  }
  
  .project-block-two .inner-box .content-box .text h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
    color: #fff;
  }
  
  .project-block-two .inner-box .content-box .text h3 a{
    display: inline-block;
    color: #fff;
  }
  
  .project-block-two .inner-box .content-box .text h3 a:hover{
  
  }
  
  .service-details-content .content-five .owl-nav {
    position: absolute;
    top: -60px;
    right: 0px;
  }
  
  .service-details-content .content-five .owl-nav .owl-prev, 
  .service-details-content .content-five .owl-nav .owl-next {
    position: relative;
    display: inline-block;
    font-size: 30px;
    color: #001b44;
    font-weight: 400;
    margin: 0px;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .service-details-content .content-five .owl-nav .owl-prev:hover, 
  .service-details-content .content-five .owl-nav .owl-next:hover{
  
  }
  
  .service-details-content .content-five .owl-nav .owl-prev{
    margin-right: 20px;
  }
  
  .service-sidebar .categories-widget{
    position: relative;
    display: block;
    background: #001b4421;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 50px;
  }
  
  .service-sidebar .categories-widget .categories-list li a{
    position: relative;
    display: block;
    font-size: 20px;
    line-height: 28px;
    font-family: 'Nunito Sans', sans-serif;
    color: #001b44;
    font-weight: 700;
    padding: 24px 30px 22px 30px;
    border-bottom: 1px solid #fff;
  }
  
  .service-sidebar .categories-widget .categories-list li a.active,
  .service-sidebar .categories-widget .categories-list li a:hover{
    background: #001b44;
    color: #fff;
  }
  
  .service-sidebar .categories-widget .categories-list li:last-child a{
    border-bottom: none;
  }
  
  .service-sidebar .categories-widget .categories-list li a:before{
    position: absolute;
    content: '';
    border: 2px solid #cfc2ba;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    top: 28px;
    right: 30px;
    transition: all 500ms ease;
  }
  
  .service-sidebar .categories-widget .categories-list li a.active:before,
  .service-sidebar .categories-widget .categories-list li a:hover:before{
  
  }
  
  .service-sidebar .categories-widget .categories-list li a:after{
    position: absolute;
    content: '';
    top: 33px;
    right: 35px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    transform: scale(0,0);
    transition: all 500ms ease;
  }
  
  .service-sidebar .categories-widget .categories-list li a.active:after,
  .service-sidebar .categories-widget .categories-list li a:hover:after{
    transform: scale(1,1);
  }
  
  .service-sidebar{
    position: relative;
    display: block;
    margin-left: 30px;
  }
  
  .service-sidebar .recruitment-widget .widget-content{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
  
  .service-sidebar .recruitment-widget .widget-content .text{
    position: relative;
    background: #001b44;
    padding: 43px 130px 42px 30px;
    min-height: 181px;
  }
  
  .service-sidebar .recruitment-widget .widget-content .text h3{
    position: relative;
    font-size: 24px;
    line-height: 32px;
    color: #fff;
    font-weight: 700;
  }
  
  .service-sidebar .recruitment-widget .widget-content .text .image-box{
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
  
  .service-sidebar .recruitment-widget .widget-content .text .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 177px;
    height: 175px;
    background-repeat: no-repeat;
  }
  
  .service-sidebar .recruitment-widget .widget-content .link{
    position: relative;
    padding: 12px 30px 16px 30px;
  }
  
  .service-sidebar .recruitment-widget .widget-content .link a{
    display: inline-block;
    font-size: 14px;
    line-height: 24px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    color: #001b44;
  }
  
  .service-sidebar .recruitment-widget .widget-content .link a i{
    position: relative;
    top: 6px;
    font-size: 30px;
    font-weight: 400;
    margin-right: 8px;
  }
  
  .service-sidebar .recruitment-widget .widget-content .link a:hover{
  
  }
  
  .service-sidebar .recruitment-widget{
    margin-bottom: 50px;
  }
  
  .service-sidebar .subscribe-widget{
    position: relative;
    display: block;
    background: #fff;
    padding: 43px 30px 50px 30px;
    border-radius: 10px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
  }
  
  .service-sidebar .subscribe-widget h3{
    position: relative;
    display: block;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    margin-bottom: 26px;
  }
  
  .service-sidebar .subscribe-widget .subscribe-form label{
    position: relative;
    display: block;
    font-size: 18px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #001b44;
    margin-bottom: 13px;
  }
  
  .service-sidebar .subscribe-widget .subscribe-form .form-group input[type='text'],
  .service-sidebar .subscribe-widget .subscribe-form .form-group input[type='email']{
    position: relative;
    display: block;
    width: 100%;
    height: 54px;
    background: #001b4421;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
  }
  
  .service-sidebar .subscribe-widget .subscribe-form .form-group{
    margin-bottom: 24px;
    position: relative;
  }
  
  .service-sidebar .subscribe-widget .subscribe-form .form-group:last-child{
    margin-bottom: 0px;
  }
  
  .service-sidebar .subscribe-widget .subscribe-form .select-box{
    height: 54px;
  }
  
  .service-sidebar .subscribe-widget .subscribe-form .nice-select{
    border: none !important;
    background: #001b4421;
    height: 54px;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
  }
  
  .service-sidebar .subscribe-widget .subscribe-form .nice-select:after{
    border-bottom: 2px solid #7e6970;
    border-right: 2px solid #7e6970;
  }
  
  .service-sidebar .subscribe-widget .subscribe-form button{
    display: block;
    width: 100%;
  }
  
  
  
  /*** 
  
  ====================================================================
                          Job-Page
  ====================================================================
  
  ***/
  
  .findjob-section{
    position: relative;
    padding: 95px 0px 120px 0px;
  }
  
  .findjob-section .search-inner .form-group{
    position: relative;
    margin: 0px;
  }
  
  .findjob-section .search-inner .form-group input[type='search'],
  .findjob-section .search-inner .form-group input[type='text'],
  .findjob-section .search-inner .form-group input[type='email']{
    position: relative;
    display: block;
    width: 100%;
    height: 70px;
    background: #fff;
    border: 1px solid #eae0d9;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 17px;
    color: #002c5d;
    font-weight: 500;
    padding-left: 50px;
    transition: all 500ms ease;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  .findjob-section .search-inner .form-group i{
    position: absolute;
    left: 20px;
    top: 21px;
    font-size: 16px;
    color: #baabab;
    z-index: 1;
  }
  
  .findjob-section .search-inner .form-group .select-box{
    height: 70px;
  }
  
  .findjob-section .search-inner .form-group .nice-select{
    height: 70px;
    padding-left: 50px;
    font-size: 17px;
    color: #002c5d;
    font-weight: 500;
    background: #fff;
    border: 1px solid #eae0d9;
    line-height: 52px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
  
  .findjob-section .search-inner .form-group .nice-select:after{
    border-bottom: 2px solid #ae979f;
    border-right: 2px solid #ae979f;
  }
  
  .findjob-section .search-inner .form-group.message-btn{
    position: relative;
    display: block;
    margin-top: 30px;
  }
  
  .findjob-section .search-inner .form-group.message-btn button{
    display: block;
    width: 100%;
    padding: 22px 44px;
  }
  
  .findjob-section .search-inner{
    margin-bottom: 60px;
  }
  
  .single-job-post{
    position: relative;
    display: block;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
  
  .single-job-post .job-inner{
    border: 1px solid #eae0d9;
    border-top: none;
    padding: 22px 30px;
  }
  
  .single-job-post .job-header{
    position: relative;
    display: block;
    background: #001b4421;
    padding: 20px 30px;
    transition: all 500ms ease;
  }
  
  .single-job-post:hover .job-header{
    background: #001b44;
  }
  
  .single-job-post .job-header .info li{
    position: relative;
    display: inline-block;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
    transition: all 500ms ease;
  }
  
  .single-job-post .job-header .info li i{
    color: #472c35;
    margin-right: 8px;
    font-weight: 600;
    font-size: 16px;
    transition: all 500ms ease;
  }
  
  .single-job-post:hover .job-header .info li i{
    color: rgba(255,255,255,0.5);
  }
  
  .single-job-post:hover .job-header .info li{
    color: rgba(255,255,255,0.5);
  }
  
  .single-job-post .job-header .info li a{
    display: inline-block;
    font-size: 14px;
    line-height: 20px;
    margin-right: 10px;
    color: #002c5d;
    font-weight: 700;
    text-transform: uppercase;
    background: #fff;
    padding: 4px 6px;
    text-align: center;
    border-radius: 5px;
    border: 1px solid rgba(255,255,255,0.2);
  }
  
  .single-job-post:hover .job-header .info li a{
    color: rgba(255,255,255,0.5);
    background: #3f262f;
  }
  
  .single-job-post .job-header .number p{
    font-size: 17px;
    font-weight: 500;
  }
  
  .single-job-post .job-title{
    position: relative;
    padding: 0px 0px 0px 80px;
  }
  
  .single-job-post .job-title .company-logo{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border: 1px solid #eae0d9;
    border-radius: 5px;
  }
  
  .single-job-post .job-title{
    position: relative;
    float: left;
    width: 45%;
  }
  
  .single-job-post .job-title:before{
    position: absolute;
    content: '';
    background: #eae0d9;
    width: 1px;
    height: 53px;
    top: 5px;
    right: 30px;
  }
  
  .single-job-post .job-inner .job-title h3{
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
    margin-bottom: 4px;
  }
  
  .single-job-post .job-inner p{
    position: relative;
    font-size: 17px;
    line-height: 28px;
    color: #002c5d;
    font-weight: 500;
  }
  
  .single-job-post .job-inner .job-title p i{
    font-size: 16px;
    font-weight: 600;
    color: #baabab;
    margin-right: 10px;
  }
  
  .single-job-post .job-inner .salary-box{
    position: relative;
    float: left;
    width: 27%;
    margin-top: 7px;
  }
  
  .single-job-post .job-inner .salary-box:before{
    position: absolute;
    content: '';
    background: #eae0d9;
    width: 1px;
    height: 53px;
    top: -2px;
    right: 30px;
  }
  
  .single-job-post .job-inner .experience-box{
    position: relative;
    float: left;
    width: 15%;
    margin-top: 7px;
  }
  
  .single-job-post .job-inner .apply-btn{
    position: relative;
    float: left;
    width: 13%;
    text-align: right;
    margin-top: 5px;
  }
  
  .single-job-post .job-inner span{
    position: relative;
    display: block;
    font-size: 12px;
    line-height: 20px;
    font-weight: 700;
    color: #a38f96;
    margin-bottom: 4px;
    text-transform: uppercase;
  }
  
  .single-job-post .job-inner .apply-btn a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 20px;
    font-family: 'Nunito Sans', sans-serif;
    color: #001b44;
    font-weight: 700;
    text-transform: uppercase;
    border: 1px solid #eae0d9;
    border-radius: 5px;
    padding: 15.5px 47.5px;
    z-index: 1;
  }
  
  .single-job-post:hover .job-inner .apply-btn a{
    color: #fff;
  }
  
  .single-job-post{
    margin-bottom: 40px;
  }
  
  .findjob-section .post-jobs .single-job-post:last-child{
    margin-bottom: 0px;
  }
  
  
  /** job-details **/
  
  .job-details{
    position: relative;
    padding: 130px 0px;
  }
  
  .job-details-content .upper-box{
    position: relative;
    display: block;
    background: #efe5df;
    border-radius: 10px;
    padding: 40px 40px;
    margin-bottom: 53px;
  }
  
  .job-details-content .upper-box .inner-box{
    position: relative;
    padding-left: 130px;
    padding-right: 80px;
  }
  
  .job-details-content .upper-box .inner-box .company-logo{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 110px;
    height: 110px;
    line-height: 110px;
    background: #fff;
    border-radius: 5px;
    text-align: center;
  }
  
  .job-details-content .upper-box .inner-box .inner span{
    position: relative;
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    color: #002c5d;
    text-transform: uppercase;
    font-weight: 700;
    background: #fff;
    padding: 6px 13px 4px 13px;
    border-radius: 5px;
    margin-bottom: 15px;
  }
  
  .job-details-content .upper-box .inner-box .inner h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
    margin-bottom: 4px;
  }
  
  .job-details-content .upper-box .inner-box .inner p{
    font-size: 17px;
    font-weight: 500;
  }
  
  .job-details-content .upper-box .inner-box .inner p i{
    font-size: 16px;
    font-weight: 600;
    margin-right: 8px;
    color: #b9a9a9;
  }
  
  .job-details-content .upper-box .inner-box .info{
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
  }
  
  .job-details-content .upper-box .inner-box .info li{
    position: relative;
    display: block;
    margin-bottom: 10px;
  }
  
  .job-details-content .upper-box .inner-box .info li:last-child{
    margin-bottom: 0px;
  }
  
  .job-details-content .upper-box .inner-box .info li span{
    position: absolute;
    top: -40px;
    right: 0px;
    font-size: 12px;
    line-height: 40px;
    font-family: 'Nunito Sans', sans-serif;
    color: #001b44;
    font-weight: 700;
    text-transform: uppercase;
    background: #fff;
    border: 1px solid #e7ddd7;
    text-align: center;
    width: 120px;
    height: 40px;
    border-radius: 5px;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    transition: all 500ms ease;
  }
  
  .job-details-content .upper-box .inner-box .info li:hover span{
    top: -50px;
    opacity: 1;
    visibility: visible;
  }
  
  .job-details-content .upper-box .inner-box .info li span:before{
    position: absolute;
    content: '';
    background: #fff;
    width: 10px;
    height: 10px;
    right: 18px;
    bottom: -5px;
    transform: rotate(-45deg);
  }
  
  .job-details-content .upper-box .inner-box .info li a{
    position: relative;
    display: inline-block;
    font-size: 20px;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 50%;
    background: #fff;
    color: #b4a4a4;
    font-weight: 600;
    z-index: 1;
  }
  
  .job-details-content .upper-box .inner-box .info li a:hover{
    background: #001b44;
  }
  
  .job-details-content h2{
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 22px;
  }
  
  .job-details-content .text p{
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  
  .job-details-content .text h3{
    position: relative;
    display: block;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    margin-bottom: 24px;
    padding-top: 16px;
  }
  
  .job-details-content .text .list li{
    position: relative;
    display: block;
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 10px;
    padding-left: 30px;
  }
  
  .job-details-content .text .list li:last-child{
    margin-bottom: 0px;
  }
  
  .job-details-content .text .list li span{
    position: relative;
    display: inline-block;
    width: 130px;
    text-align: left;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    color: #a38f96;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .job-details-content .text .list{
    margin-bottom: 21px;
  }
  
  .job-details-content .text .list li:before{
    position: absolute;
    content: '>';
    font-size: 20px;
    line-height: 26px;
    font-family: 'Muli', sans-serif;
    font-weight: 700;
    left: 0px;
    top: 1px;
  }
  
  .job-details-content .text{
    border-bottom: 1px solid #eae0d9;
    margin-bottom: 40px;
    padding-bottom: 29px;
  }
  
  .job-details-content .social-box .social-links li{
    position: relative;
    display: inline-block;
    float: left;
    width: 25%;
  }
  
  .job-details-content .social-box .social-links li a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    color: #fff;
    text-transform: uppercase;
    text-align: center;
    width: 170px;
    height: 54px;
    line-height: 54px;
    border-radius: 5px;
    font-weight: 700;
  }
  
  .job-details-content .social-box .social-links li a i{
    margin-right: 10px;
    font-weight: 400;
  }
  
  .job-details-content .social-box .social-links li:first-child a{
  
  }
  
  .job-details-content .social-box .social-links li:nth-child(2) a{
    
  }
  
  .job-details-content .social-box .social-links li:nth-child(3) a{
    
  }
  
  .job-details-content .social-box .social-links li:last-child a{
  
  }
  
  .job-details-content .social-box .social-links{
    margin-right: -25px;
  }
  
  .job-details-content .social-box{
    margin-bottom: 92px;
  }
  
  .job-details .related-job h2{
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 29px;
  }
  
  .job-details .related-job .single-job-post:last-child{
    margin-bottom: 0px;
  }
  
  .job-sidebar .apply-btn{
    position: relative;
    display: block;
    margin-bottom: 40px;
  }
  
  .job-sidebar .apply-btn .theme-btn-one{
    display: block;
    width: 100%;
  }
  
  .job-sidebar{
    position: relative;
    display: block;
    margin-left: 30px;
  }
  
  .job-sidebar .job-discription{
    position: relative;
    display: block;
    background: #fff;
    padding: 24px 30px 11px 30px;
    border: 1px solid #eae0d9;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
  
  .job-sidebar .job-discription .list li{
    position: relative;
    display: block;
    border-bottom: 1px solid #eae0d9;
    margin-bottom: 16px;
    padding-bottom: 12px;
  }
  
  .job-sidebar .job-discription .list li:last-child{
    margin-bottom: 0px;
    border-bottom: none;
  }
  
  .job-sidebar .job-discription .list li span{
    position: relative;
    display: block;
    font-size: 12px;
    line-height: 20px;
    font-weight: 700;
    color: #a38f96;
    text-transform: uppercase;
    margin-bottom: 4px;
  }
  
  .job-sidebar .job-discription .list li p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
  }
  
  .job-sidebar .job-discription .list li p a{
    color: #002c5d;
  }
  
  .job-sidebar .job-discription .list li p a:hover{
  
  }
  
  .job-sidebar .job-discription{
    margin-bottom: 40px;
  }
  
  .job-sidebar .support-widget .widget-content{
    position: relative;
    display: block;
    background: #001b44;
    padding: 40px 30px;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .job-sidebar .support-widget .widget-content .image-box{
    position: relative;
    display: inline-block;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    margin-bottom: 24px;
  }
  
  .job-sidebar .support-widget .widget-content .image-box img{
    width: 100%;
    border-radius: 50%;
  }
  
  .job-sidebar .support-widget .widget-content h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    color: #fff;
    font-weight: 700;
  }
  
  .job-sidebar .support-widget .widget-content .designation{
    position: relative;
    display: block;
    font-size: 17px;
    font-weight: 500;
    color: rgba(255,255,255,0.5);
    margin-bottom: 15px;
  }
  
  .job-sidebar .support-widget .widget-content .support-info li{
    position: relative;
    display: block;
    font-size: 17px;
    font-weight: 500;
    color: #fff;
  }
  
  .job-sidebar .support-widget .widget-content .support-info li a{
    color: rgba(255,255,255,0.5);
  }
  
  .job-sidebar .support-widget .widget-content .support-info li a:hover{
  
  }
  
  .job-sidebar .support-widget .widget-content .support-info{
    margin-bottom: 22px;
  }
  
  .job-sidebar .support-widget .widget-content .social-links li{
    position: relative;
    display: inline-block;
    margin: 0px 3px;
  }
  
  .job-sidebar .support-widget .widget-content .social-links li a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    color: #001b44;
    background: #fff;
    width: 42px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border-radius: 50%;
  }
  
  .job-sidebar .support-widget .widget-content .social-links li a:hover{
  
  }
  
  .job-sidebar .support-widget .widget-content .pattern-layer .pattern-1{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 214px;
    height: 149px;
    background-repeat: no-repeat;
  }
  
  .job-sidebar .support-widget .widget-content .pattern-layer .pattern-2{
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 209px;
    height: 241px;
    background-repeat: no-repeat;
  }
  
  .placejob-section .form-inner .job-form .form-group i{
    position: absolute;
    left: 35px;
    top: 12px;
    font-size: 24px;
    z-index: 1;
  }
  
  .applynow-section .form-inner .pualification-form .form-group:last-child input[type='text']{
    padding-left: 55px;
  }
  
  .applynow-section .apply-form .form-group{
    position: relative;
    margin-bottom: 30px;
  }
  
  .applynow-section .apply-form .form-group:last-child{
    margin-bottom: 0px;
  }
  
  .applynow-section .apply-form .form-group input[type='text'],
  .applynow-section .apply-form .form-group textarea{
    position: relative;
    display: block;
    width: 100%;
    height: 60px;
    background: #fff;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
    border-radius: 5px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
  }
  
  .applynow-section .apply-form .form-group textarea{
    height: 140px;
    resize: none;
  }
  
  .applynow-section .apply-form .form-group .select-box{
    height: 60px;
  }
  
  .applynow-section .apply-form .form-group .nice-select{
    border: none !important;
    height: 60px;
    background: #fff;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
    border-radius: 5px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
  }
  
  .applynow-section .apply-form .form-group .nice-select:after{
    border-bottom: 2px solid #ae979f;
    border-right: 2px solid #ae979f;
  }
  
  .applynow-section .apply-form .form-group button{
    display: block;
    width: 100%;
  }
  
  
  /** growth-style-two **/
  
  .growth-style-two{
    position: relative;
    padding: 95px 0px 125px 0px;
  }
  
  .growth-style-two .sec-title .top-title:before,
  .growth-style-two .sec-title .top-title:after{
    background: #e2d7d0;
  }
  
  .growth-style-two .sec-title .top-title:after{
    border-left: 2px solid #001b4421;
    border-bottom: 2px solid #001b4421;
  }
  
  .growth-style-two .sec-title{
    margin-bottom: 29px;
  }
  
  .growth-style-two #content_block_1 .content-box .inner-box p{
    margin-bottom: 15px;
  }
  
  .growth-style-two .image-column{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 50%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .growth-style-two .inner-column .text{
    position: relative;
    display: block;
    margin-left: 100px;
    margin-right: 0px;
  }
  
  .growth-style-two .inner-column .text h2{
    position: relative;
    display: block;
    font-size: 60px;
    line-height: 72px;
    color: #fff;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 17px;
  }
  
  .growth-style-two .inner-column .text p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    color: #ae979f;
    margin-bottom: 32px;
  }
  
  .growth-style-two .inner-column .text .theme-btn-two{
    padding: 15px 43px;
  }
  
  
  /** advantages-section **/
  
  .advantages-section{
    position: relative;
    padding: 95px 0px 120px 0px;
  }
  
  .advantages-section .single-item .inner-box .icon-box{
    position: relative;
    margin-bottom: 23px;
  }
  
  .advantages-section .single-item .inner-box h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
    margin-bottom: 14px;
  }
  
  .advantages-section .single-item .inner-box p{
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 18px;
  }
  
  .advantages-section .single-item .inner-box a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #001b44;
    text-transform: uppercase;
  }
  
  .advantages-section .owl-dots{
    display: block;
    text-align: center;
    margin-top: 36px;
  }
  
  .advantages-section .single-item .inner-box a i{
    position: relative;
    font-size: 30px;
    font-weight: 400;
    margin-right: 10px;
    top: 6px;
  }
  
  .advantages-section .single-item .inner-box a:hover{
  
  }
  
  .advantages-section .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
  
  .pricing-section.overview-page-2 .sec-title .top-title:before,
  .pricing-section.overview-page-2 .sec-title .top-title:after{
    background: #fff;
  }
  
  .pricing-section.overview-page-2 .sec-title .top-title:after{
    border-left: 2px solid #001b4421;
    border-bottom: 2px solid #001b4421;
  }
  
  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box{
    background: #001b44;
  }
  
  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box h3{
    color: #fff;
  }
  
  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box .text{
    color: #001b4421;
  }
  
  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box p{
    color: #001b4421;
  }
  
  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box a{
  
  }
  
  
  /*** 
  
  ====================================================================
                          Blog-Page
  ====================================================================
  
  ***/
  
  .sidebar-page-container{
    position: relative;
    padding: 130px 0px;
  }
  
  .sidebar-page-container .news-block-one .inner-box{
    margin-bottom: 30px;
  }
  
  .sidebar-page-container .more-btn a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #001b44;
    border-radius: 4px;
    text-align: center;
    padding: 14px 42px;
    text-transform: uppercase;
    z-index: 1;
  }
  
  .sidebar-page-container .more-btn a:hover{
    color: #fff;
  }
  
  .sidebar-page-container .more-btn{
    position: relative;
    margin-top: 30px;
  }
  
  .blog-sidebar .search-widget .search-form .form-group{
    position: relative;
    margin: 0px;
  }
  
  .blog-sidebar .search-widget .search-form .form-group input[type='search']{
    position: relative;
    display: block;
    width: 100%;
    height: 58px;
    background: #001b4421;
    border-radius: 5px;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
    padding: 10px 50px 10px 20px;
  }
  
  .blog-sidebar .search-widget .search-form .form-group button{
    position: absolute;
    top: 7px;
    right: 8px;
    width: 44px;
    height: 44px;
    line-height: 44px;
    background: #001b44;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    border-radius: 5px;
    transition: all 500ms ease;
  }
  
  .blog-sidebar .search-widget .search-form .form-group input:focus + button,
  .blog-sidebar .search-widget .search-form .form-group button:hover{
  
  }
  
  .blog-sidebar .search-widget{
    margin-bottom: 50px;
  }
  
  .blog-sidebar .sidebar-widget{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
    margin-bottom: 50px;
  }
  
  .blog-sidebar .sidebar-widget .widget-title{
    position: relative;
    display: block;
    padding: 18px 30px 17px 65px;
    border-bottom: 1px solid #eae0d9;
  }
  
  .blog-sidebar .sidebar-widget .widget-title:before{
    position: absolute;
    content: '';
    width: 30px;
    height: 3px;
    left: 30px;
    bottom: -2px;
  }
  
  .blog-sidebar .sidebar-widget .widget-title h3{
    position: relative;
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
  }
  
  .blog-sidebar .sidebar-widget .widget-title i{
    position: absolute;
    left: 30px;
    top: 25px;
    font-size: 20px;
    line-height: 20px;
  }
  
  .blog-sidebar .sidebar-widget .widget-content{
    position: relative;
    padding: 34px 30px 31px 30px;
  }
  
  .blog-sidebar .categories-widget .widget-content .list li{
    position: relative;
    display: block;
    margin-bottom: 16px;
  }
  
  .blog-sidebar .categories-widget .widget-content .list li:last-child{
    margin-bottom: 0px;
  }
  
  .blog-sidebar .categories-widget .widget-content .list li a{
    position: relative;
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    font-family: 'Muli', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    color: #001b44;
  }
  
  .blog-sidebar .categories-widget .widget-content .list li a:before{
    position: absolute;
    content: '';
    width: 3px;
    height: 30px;
    left: -30px;
    top: -7px;
    transform: scale(0,0);
    transition: all 500ms ease;
  }
  
  .blog-sidebar .categories-widget .widget-content .list li a:hover:before{
    transform: scale(1,1);
  }
  
  .blog-sidebar .categories-widget .widget-content .list li a:hover{
  
  }
  
  .blog-sidebar .categories-widget .widget-content .list li a span{
    position: absolute;
    display: inline-block;
    top: -6px;
    right: -18px;
    color: #a38f96;
    transition: all 500ms ease;
  }
  
  .blog-sidebar .categories-widget .widget-content .list li a:hover span{
  
  }
  
  .blog-sidebar .post-widget .widget-content .post{
    position: relative;
    display: block;
    padding-left: 100px;
    padding-bottom: 26px;
    margin-bottom: 29px;
    min-height: 107px;
    border-bottom: 1px solid #eae0d9;
  }
  
  .blog-sidebar .post-widget .widget-content .post:last-child{
    margin-bottom: 0px;
    border-bottom: none;
  }
  
  .blog-sidebar .post-widget .widget-content .post .post-thumb{
    position: absolute;
    left: 0px;
    top: 1px;
    width: 75px;
    height: 75px;
    border-radius: 10px;
    overflow: hidden;
    z-index: 1;
  }
  
  .blog-sidebar .post-widget .widget-content .post .post-thumb img{
    width: 100%;
    border-radius: 10px;
    transition: all 500ms ease;
  }
  
  .blog-sidebar .post-widget .widget-content .post:hover .post-thumb img{
    opacity: 0.2;
  }
  
  .blog-sidebar .post-widget .widget-content .post .post-thumb:before{
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    opacity: 0;
    z-index: -1;
    transition: all 500ms ease;
  }
  
  .blog-sidebar .post-widget .widget-content .post:hover .post-thumb:before{
    opacity: 1;
  }
  
  .blog-sidebar .post-widget .widget-content .post .post-date{
    position: relative;
    display: block;
    font-size: 12px;
    line-height: 20px;
    color: #a38f96;
    text-transform: uppercase;
    margin-bottom: 8px;
  }
  
  .blog-sidebar .post-widget .widget-content .post h5{
    position: relative;
    display: block;
    font-size: 18px;
    line-height: 26px;
    font-weight: 700;
  }
  
  .blog-sidebar .post-widget .widget-content .post h5 a{
    display: inline-block;
    color: #001b44;
  }
  
  .blog-sidebar .post-widget .widget-content .post h5 a:hover{
  
  }
  
  .blog-sidebar .post-widget .widget-content {
    padding: 40px 30px 9px 30px;
  }
  
  .blog-sidebar .sidebar-tags .tags-list li{
    position: relative;
    display: inline-block;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  
  .blog-sidebar .sidebar-tags .tags-list li a{
    position: relative;
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    font-family: 'Muli', sans-serif;
    color: #a38f96;
    text-transform: uppercase;
    padding: 10px 8px 8px 8px;
    text-align: center;
    font-weight: 700;
    border: 1px solid #eae0d9;
    border-radius: 5px;
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.08);
  }
  
  .blog-sidebar .sidebar-tags .tags-list li a:hover{
    background: #001b44;
    border-color: #001b44;
    color: #fff;
  }
  
  .blog-sidebar .sidebar-tags .widget-content {
    padding: 41px 30px 30px 30px;
  }
  
  .blog-sidebar .gallery-widget .image-list{
    position: relative;
    margin: 0px -2.5px;
  }
  
  .blog-sidebar .gallery-widget .image-list li{
    position: relative;
    float: left;
    width: 100px;
    height: 100px;
    margin: 0px 2.5px;
    margin-bottom: 5px;
  }
  
  .blog-sidebar .gallery-widget .image-list li .image-box{
    position: relative;
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 5px;
    overflow: hidden;
    z-index: 1;
  }
  
  .blog-sidebar .gallery-widget .image-list li .image-box img{
    width: 100%;
    border-radius: 5px;
    transition: all 500ms ease;
  }
  
  .blog-sidebar .gallery-widget .image-list li .image-box:hover img{
    opacity: 0.2;
  }
  
  .blog-sidebar .gallery-widget .image-list li .image-box:before{
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    opacity: 0;
    z-index: -1;
    transition: all 500ms ease;
  }
  
  .blog-sidebar .gallery-widget .image-list li .image-box:hover:before{
    opacity: 1;
  }
  
  .blog-sidebar .gallery-widget .widget-content {
    padding: 41px 30px 35px 30px;
  }
  
  .blog-sidebar .sidebar-resource .inner-box{
    position: relative;
    display: block;
    overflow: hidden;
    background: #001b4421;
    border-radius: 10px;
    padding: 60px 50px;
  }
  
  .blog-sidebar .sidebar-resource .inner-box .iocn-box{
    position: relative;
    margin-bottom: 23px;
  }
  
  .blog-sidebar .sidebar-resource .inner-box h3{
    position: relative;
    display: block;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    margin-bottom: 27px;
  }
  
  .blog-sidebar .sidebar-resource .inner-box a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 20px;
    font-family: 'Nunito Sans', sans-serif;
    color: #001b44;
    font-weight: 700;
    text-transform: uppercase;
    background: #fff;
    border-radius: 5px;
    padding: 18px 65px 16px 20px;
  }
  
  .blog-sidebar .sidebar-resource .inner-box a i{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 46px;
    height: 100%;
    line-height: 100%;
    text-align: center;
    font-size: 24px;
    border-left: 2px solid #ded4ce;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .blog-sidebar .sidebar-resource .inner-box a:hover{
  
  }
  
  .blog-sidebar .sidebar-resource .inner-box .pattern-layer .pattern-1{
    position: absolute;
    top: 0px;
    right: 0px;
    width: 198px;
    height: 119px;
    background-repeat: no-repeat;
  }
  
  .blog-sidebar .sidebar-resource .inner-box .pattern-layer .pattern-2{
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 219px;
    height: 225px;
    background-repeat: no-repeat;
  }
  
  .news-block-one .inner-box .lower-content .inner h2{
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 38px;
    color: #fff;
    font-weight: 700;
    margin-bottom: 18px;
  }
  
  .news-block-one .inner-box .lower-content .inner h2 a{
    display: inline-block;
    color: #fff;
  }
  
  .news-block-one .inner-box .lower-content .inner h2 a:hover{
  
  }
  
  .news-block-one .inner-box .lower-content .inner p{
    font-size: 17px;
    font-weight: 500;
    color: rgba(255,255,255,0.5);
    margin-bottom: 25px;
  }
  
  .sidebar-page-container.blog-list .news-block-one .inner-box .lower-content .inner .post-info li:first-child{
    padding-left: 50px;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .post-info li img{
    position: absolute;
    left: 0px;
    top: -3px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner{
    padding: 33px 30px 47px 40px;
    margin-top: -190px;
    border-radius: 0px 10px 10px 10px;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .category{
    margin-bottom: 16px;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box{
    position: absolute;
    right: 40px;
    bottom: 40px;
    margin-left: 15px;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box:before{
    position: absolute;
    left: 0px;
    top: -17px;
    content: '';
    width: 100%;
    height: 17px;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .share-link{
    position: relative;
    display: inline-block;
    font-size: 16px;
    color: rgba(255,255,255,0.6);
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 50%
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .share-link:hover{
    color: #fff;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links{
    position: absolute;
    right: 0px;
    bottom: 47px;
    min-width: 115px;
    background: #fff;
    border-radius: 5px;
    opacity: 0;
    visibility: hidden;
    transition: all 500ms ease;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box:hover .social-links{
    opacity: 1;
    visibility: visible;
    bottom: 57px;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links:before{
    position: absolute;
    content: '';
    background: #fff;
    width: 10px;
    height: 10px;
    bottom: -5px;
    right: 14px;
    transform: rotate(-45deg);
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li{
    position: relative;
    display: inline-block;
    float: left;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li a{
    position: relative;
    display: inline-block;
    font-size: 16px;
    color: #001b44;
    width: 35px;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li a:before{
    position: absolute;
    content: '';
    background: #d9cec7;
    width: 1px;
    height: 20px;
    top: 10px;
    right: 0px;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li:last-child a:before{
    display: none;
  }
  
  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li a:hover{
  
  }
  
  .blog-list .news-block-one .inner-box{
    margin-bottom: 80px;
  
  }
  
  .blog-list .news-block-one .inner-box .owl-nav{
    position: absolute;
    right: 40px;
    bottom: 210px;
  }
  
  .blog-list .news-block-one .inner-box .owl-nav .owl-prev,
  .blog-list .news-block-one .inner-box .owl-nav .owl-next{
    position: relative;
    display: inline-block;
    font-size: 10px;
    font-weight: 700;
    color: #001b44;
    background: #fff;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 50%;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .blog-list .news-block-one .inner-box .owl-nav .owl-prev{
    margin-right: 5px;
  }
  
  .blog-list .news-block-one .inner-box .owl-nav .owl-prev:hover,
  .blog-list .news-block-one .inner-box .owl-nav .owl-next:hover{
    color: #fff;
  }
  
  .page-title .news-block-one .inner-box{
    margin-bottom: -20px;
    max-width: 770px;
    margin-top: 90px;
  }
  
  .page-title .news-block-one .inner-box .lower-content .inner{
    border-radius: 10px 10px 0px 0px;
    margin-top: 0px;
    padding-bottom: 47px;
  }
  
  .page-title .news-block-one .inner-box .lower-content .inner .post-info li:first-child {
    padding-left: 50px;
  }
  
  .page-title .news-block-one .inner-box .lower-content .inner .post-info li img {
    position: absolute;
    left: 0px;
    top: -3px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  
  .page-title .news-block-one .inner-box .post-date {
    position: absolute;
    right: 20px;
    top: -30px;
    width: 70px;
    height: 70px;
    line-height: 22px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
  }
  
  .page-title .news-block-one .inner-box .lower-content{
    padding-right: 0px;
  }
  
  .page-title .news-block-one .inner-box .lower-content .inner h2{
    margin-bottom: 25px;
  }
  
  .blog-details-content .inner-box .post-time{
    position: relative;
    margin-bottom: 33px;
  }
  
  .blog-details-content .inner-box .post-time h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
  }
  
  .blog-details-content .inner-box .post-time h3 i{
    position: relative;
    font-size: 18px;
    margin-right: 10px;
  }
  
  .blog-details-content .inner-box .image-box{
    position: relative;
    display: block;
    margin-bottom: 43px;
    border-radius: 10px;
  }
  
  .blog-details-content .inner-box .image-box img{
    width: 100%;
    border-radius: 10px;
  }
  
  .blog-details-content .inner-box .text p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  
  .blog-details-content .inner-box .text h2{
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 22px;
    padding-top: 15px;
  }
  
  .blog-details-content .inner-box .text h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 10px;
    padding-left: 50px;
    padding-top: 9px;
  }
  
  .blog-details-content .inner-box .text h3:before{
    position: absolute;
    content: '';
    width: 40px;
    height: 2px;
    left: 0px;
    top: 14px;
  }
  
  .blog-details-content .inner-box .text .list li{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    padding-left: 32px;
    margin-bottom: 10px;
  }
  
  .blog-details-content .inner-box .text .list{
    position: relative;
    padding-top: 5px;
  }
  
  .blog-details-content .inner-box .text .list li:last-child{
    margin-bottom: 0px;
  }
  
  .blog-details-content .inner-box .text .list li:before{
    position: absolute;
    content: '*';
    font-size: 30px;
    font-weight: 700;
    font-family: 'Muli', sans-serif;
    left: 0px;
    top: 7px;
  }
  
  .blog-details-content .inner-box .two-column{
    position: relative;
    padding: 43px 0px;
  }
  
  .blog-details-content .inner-box .two-column .content-box{
    position: relative;
    display: block;
    padding: 80px 50px 70px 40px;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .blog-details-content .inner-box .two-column .content-box:before{
    position: absolute;
    content: '';
    background: #001b44;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    right: 0px;
    opacity: 0.9;
  }
  
  .blog-details-content .inner-box .two-column .content-box .inner{
    position: relative;
    z-index: 1;
  }
  
  .blog-details-content .inner-box .two-column .content-box .icon-box{
    position: relative;
    margin-bottom: 30px;
  }
  
  .blog-details-content .inner-box .two-column .content-box p{
    position: relative;
    font-size: 20px;
    line-height: 32px;
    color: #fff;
    margin-bottom: 25px;
  }
  
  .blog-details-content .inner-box .two-column .content-box h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    color: #fff;
    font-weight: 700;
  }
  
  .blog-details-content .inner-box .two-column .image-box{
    position: relative;
    display: block;
    border-radius: 10px;
    margin-bottom: 0px;
  }
  
  .blog-details-content .inner-box .two-column .image-box img{
    width: 100%;
    border-radius: 10px;
  }
  
  .blog-details-content .inner-box .two-column .content-box .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  
  .blog-details-content .inner-box{
    margin-bottom: 72px;
  }
  
  .blog-details-content .post-share-option .social-box .social-links li{
    position: relative;
    display: inline-block;
    float: left;
    width: 25%;
  }
  
  .blog-details-content .post-share-option .social-box .social-links li a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: 'Nunito Sans', sans-serif;
    color: #fff;
    text-transform: uppercase;
    text-align: center;
    width: 170px;
    height: 54px;
    line-height: 54px;
    border-radius: 5px;
    font-weight: 700;
  }
  
  .blog-details-content .post-share-option .social-box .social-links li a i{
    margin-right: 10px;
    font-weight: 400;
  }
  
  .blog-details-content .post-share-option .social-box .social-links li:first-child a{
  
  }
  
  .blog-details-content .post-share-option .social-box .social-links li:nth-child(2) a{
    
  }
  
  .blog-details-content .post-share-option .social-box .social-links li:nth-child(3) a{
    
  }
  
  .blog-details-content .post-share-option .social-box .social-links li:last-child a{
  
  }
  
  .blog-details-content .post-share-option .social-box .social-links{
    margin-right: -25px;
  }
  
  .blog-details-content .post-share-option .tag-list li{
    position: relative;
    display: inline-block;
    margin: 0px 2px;
  }
  
  .blog-details-content .post-share-option .tag-list li a{
    position: relative;
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    font-family: 'Muli', sans-serif;
    color: #a38f96;
    text-transform: uppercase;
    padding: 10px 8px 8px 8px;
    text-align: center;
    font-weight: 700;
    border: 1px solid #eae0d9;
    border-radius: 5px;
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.08);
  }
  
  .blog-details-content .post-share-option .tag-list li a:hover{
    color: #fff;
    background: #001b44;
    border-color: #001b44;
  }
  
  .blog-details-content .post-share-option .tag-list{
    margin-bottom: 50px;
  }
  
  .blog-details-content .post-share-option{
    position: relative;
    display: block;
    padding: 60px 0px 50px 0px;
    border-top: 1px solid #eae0d9;
  }
  
  .blog-details-content .post-share-option:before{
    position: absolute;
    content: '';
    background: #fff;
    width: 110px;
    height: 3px;
    left: 50%;
    transform: translateX(-50%);
    top: -1px;
  }
  
  .blog-details-content .post-share-option .icon-box{
    position: absolute;
    left: 50%;
    top: -31px;
    transform: translateX(-50%);
    width: 60px;
    height: 60px;
    line-height: 60px;
    background: #fff;
    font-size: 24px;
    color: #001b44;
    text-align: center;
    border-radius: 50%;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
  }
  
  .blog-details-content .author-box{
    position: relative;
    display: block;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 19px 30px rgba(0, 0, 0, 0.08);
    padding: 40px 80px 50px 80px;
    margin-bottom: 50px;
  }
  
  .blog-details-content .author-box:before{
    position: absolute;
    content: '';
    background: #001b4421;
    width: 100%;
    height: 90px;
    left: 0px;
    top: 0px;
  }
  
  .blog-details-content .author-box .inner .image-box{
    position: relative;
    display: inline-block;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-bottom: 24px;
  }
  
  .blog-details-content .author-box .inner .image-box img{
    width: 100%;
    border-radius: 50%;
  }
  
  .blog-details-content .author-box .inner h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 5px;
  }
  
  .blog-details-content .author-box .inner span{
    position: relative;
    display: block;
    font-size: 17px;
    font-weight: 500;
    color: #a38f96;
    margin-bottom: 15px;
  }
  
  .blog-details-content .author-box .inner span a{
    display: inline-block;
    color: #a38f96;
  }
  
  .blog-details-content .author-box .inner span a:hover{
  
  }
  
  .blog-details-content .author-box .inner p{
    font-size: 17px;
    font-weight: 500;
    margin-bottom: 22px;
  }
  
  .blog-details-content .author-box .social-links li{
    position: relative;
    display: inline-block;
    margin: 0px 3px;
  }
  
  .blog-details-content .author-box .social-links li a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    color: #001b44;
    width: 42px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border: 1px solid #eae1da;
    border-radius: 50%;
  }
  
  .blog-details-content .author-box .social-links li a:hover{
    background: #eae1da;
  }
  
  .blog-details-content .author-box .icon-layer{
    position: absolute;
    left: 35px;
    top: 10px;
    width: 210px;
    height: 169px;
    background-repeat: no-repeat;
  }
  
  .blog-details-content .author-box .signature{
    position: absolute;
    top: 40px;
    right: 40px;
  }
  
  .blog-details-content .nav-btn-box .left-btn,
  .blog-details-content .nav-btn-box .right-btn{
    position: relative;
    display: block;
    background: #eae0d9;
    border-radius: 5px;
  }
  
  .blog-details-content .nav-btn-box .left-btn{
    padding: 21px 50px 23px 65px;
    margin-left: 35px;
  }
  
  .blog-details-content .nav-btn-box .right-btn{
    padding: 21px 65px 23px 50px;
    margin-right: 35px;
    text-align: right;
  }
  
  .blog-details-content .nav-btn-box .left-btn .image-box{
    position: absolute;
    left: -35px;
    top: 30px;
    width: 70px;
    height: 70px;
    border-radius: 5px;
  }
  
  .blog-details-content .nav-btn-box .right-btn .image-box{
    position: absolute;
    right: -35px;
    top: 30px;
    width: 70px;
    height: 70px;
    border-radius: 5px;
  }
  
  .blog-details-content .nav-btn-box .image-box img{
    width: 100%;
    border-radius: 5px;
  }
  
  .blog-details-content .nav-btn-box .inner a{
    position: relative;
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    font-family: 'Muli', sans-serif;
    color: #a38f96;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 9px;
  }
  
  .blog-details-content .nav-btn-box .left-btn:hover .inner a{
    padding-left: 25px;
  }
  
  .blog-details-content .nav-btn-box .right-btn:hover .inner a{
    padding-right: 25px;
  }
  
  .blog-details-content .nav-btn-box .left-btn .inner a i{
    left: 0px;
  }
  
  .blog-details-content .nav-btn-box .right-btn .inner a i{
    right: 0px;
  }
  
  .blog-details-content .nav-btn-box .inner a i{
    position: absolute;
    top: -1px;
    display: inline-block;
    font-size: 16px;
    opacity: 0;
    transition: all 500ms ease;
  }
  
  .blog-details-content .nav-btn-box .left-btn:hover .inner a i,
  .blog-details-content .nav-btn-box .right-btn:hover .inner a i{
    opacity: 1;
  }
  
  .blog-details-content .nav-btn-box .inner h5{
    position: relative;
    display: block;
    font-size: 18px;
    line-height: 26px;
    font-weight: 700;
  }
  
  .blog-details-content .nav-btn-box{
    position: relative;
    margin-bottom: 90px;
  }
  
  .group-title{
    position: relative;
    display: block;
    margin-bottom: 24px;
  }
  
  .group-title h2{
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 38px;
    font-weight: 700;
    margin: 0px;
  }
  
  .blog-details-content .comment-box .comment{
    position: relative;
    display: block;
    border-bottom: 1px solid #eae1da;
    margin-bottom: 34px;
    padding: 0px 0px 32px 110px;
    min-height: 174px;
  }
  
  .blog-details-content .comment-box .comment.reply-comment{
    margin-left: 40px;
  }
  
  .blog-details-content .comment-box .comment:last-child{
    margin-bottom: 0px;
    border-bottom: none;
  }
  
  .blog-details-content .comment-box .comment .thumb-box{
    position: absolute;
    left: 0px;
    top: 6px;
    width: 80px;
    height: 80px;
    border-radius: 5px;
  }
  
  .blog-details-content .comment-box .comment .thumb-box img{
    width: 100%;
    border-radius: 5px;
  }
  
  .blog-details-content .comment-box .comment .comment-inner .comment-info{
    position: relative;
    margin-bottom: 14px;
  }
  
  .blog-details-content .comment-box .comment .comment-inner .comment-info h3{
    position: relative;
    display: block;
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
  }
  
  .blog-details-content .comment-box .comment .comment-inner .comment-info .comment-time{
    position: absolute;
    top: 2px;
    right: 0px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    text-transform: uppercase;
    color: #a38f96;
    border-bottom: 1px solid #a38f96;
  }
  
  .blog-details-content .comment-box .comment .comment-inner p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 13px;
  }
  
  .blog-details-content .comment-box .comment .comment-inner .reply-btn{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 20px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .blog-details-content .comment-box .comment .comment-inner .reply-btn i{
    position: relative;
    display: inline-block;
    font-size: 20px;
    font-weight: 400;
    margin-right: 10px;
    top: 2px;
  }
  
  .blog-details-content .comment-box .comment .comment-inner .reply-btn:hover{
    color: #001b44;
  }
  
  .blog-details-content .comments-form-area{
    position: relative;
    display: block;
    background: #fff;
    padding: 44px 50px 50px 50px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
  }
  
  .blog-details-content .comments-form-area .comment-form .form-group{
    position: relative;
    margin-bottom: 20px;
  }
  
  .blog-details-content .comments-form-area .comment-form .form-group:last-child{
    margin-bottom: 0px;
  }
  
  .blog-details-content .comments-form-area .comment-form .form-group input[type='text'],
  .blog-details-content .comments-form-area .comment-form .form-group input[type='email'],
  .blog-details-content .comments-form-area .comment-form .form-group textarea{
    position: relative;
    display: block;
    width: 100%;
    height: 56px;
    border: 1px solid #eae0d9;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: 500;
    color: #002c5d;
    transition: all 500ms ease;
  }
  
  .blog-details-content .comments-form-area .comment-form .form-group textarea{
    resize: none;
    height: 120px;
  }
  
  .blog-details-content .comments-form-area .comment-form .message-btn button{
    display: block;
    width: 100%;
  }
  
  .blog-details-content .comments-form-area .comment-form .form-group input:focus,
  .blog-details-content .comments-form-area .comment-form .form-group textarea:focus{
  
  }
  
  .blog-details-content .comments-form-area .group-title h2{
    margin-bottom: 8px;
  }
  
  .blog-details-content .comments-form-area .group-title p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
  }
  
  .blog-details-content .comments-form-area .group-title{
    margin-bottom: 32px;
  }
  
  
  
  /*** 
  
  ====================================================================
                          Portfolio-Page
  ====================================================================
  
  ***/
  
  .protfolio-page{
    position: relative;
    padding: 130px 0px;
  }
  
  .protfolio-page .project-block-two .inner-box{
    margin-bottom: 30px;
  }
  
  .protfolio-page .more-btn{
    position: relative;
    margin-top: 30px;
  }
  
  .protfolio-page .more-btn a{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 26px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #001b44;
    border-radius: 4px;
    text-align: center;
    padding: 14px 42px;
    text-transform: uppercase;
    z-index: 1;
  }
  
  .protfolio-page .more-btn a:hover{
    color: #fff;
  }
  
  .protfolio-page .filters{
    position: relative;
    display: block;
    text-align: center;
    margin-bottom: 60px;
  }
  
  .protfolio-page .filters .filter-tabs{
    position: relative;
    display: inline-block;
    border: 1px solid #eae0d9;
    border-radius: 5px;
    padding: 10px 0px;
  }
  
  .protfolio-page .filters .filter-tabs:before{
    position: absolute;
    content: '';
    width: 3px;
    height: 12px;
    left: -2px;
    top: 19px;
  }
  
  .protfolio-page .filters .filter-tabs li{
    position: relative;
    display: inline-block;
    font-size: 14px;
    line-height: 24px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    color: #001b44;
    text-transform: uppercase;
    margin: 0px 17px;
    cursor: pointer;
    transition: all 500ms ease;
  }
  
  .protfolio-page .filters .filter-tabs li:before{
    position: absolute;
    content: '';
    background: #d9cec7;
    width: 3px;
    height: 6px;
    top: 8px;
    right: -21px;
    transition: all 500ms ease;
  }
  
  .protfolio-page .filters .filter-tabs li:last-child:before{
    display: none;
  }
  
  .protfolio-page .filters .filter-tabs li.active:before,
  .protfolio-page .filters .filter-tabs li:hover:before{
    height: 12px;
    top: 7px;
  }
  
  .protfolio-page .filters .filter-tabs li.active,
  .protfolio-page .filters .filter-tabs li:hover{
  
  }
  
  .protfolio-page .pagination-wrapper{
    margin-top: 30px;
  }
  
  .protfolio-page .project-block-one .inner-box{
    margin-bottom: 30px;
  }
  
  .protfolio-page .project-block-one .inner-box:hover .image-box img {
    opacity: 0.2;
  }
  
  .protfolio-page .project-block-one .inner-box .content-box{
    padding: 15px 30px;
  }
  
  .protfolio-page .outer-container{
    position: relative;
    padding: 0px 30px;
  }
  
  .portfolio-wide-2 .masonry-item{
    float: left;
    width: 20%;
    padding: 0px 15px;
  }
  
  .portfolio-wide-2 .sortable-masonry{
    margin: 0px -15px;
  }
  
  
  /*** 
  
  ====================================================================
                          Error-Page
  ====================================================================
  
  ***/
  
  .error-section{
    position: relative;
    padding: 130px 0px;
  }
  
  .error-section .error-content .image-box{
    position: relative;
    display: block;
    margin-bottom: 36px;
  }
  
  .error-section .error-content .image-box img{
    width: 100%;
  }
  
  .error-section .error-content h2{
    position: relative;
    display: block;
    font-size: 48px;
    line-height: 60px;
    font-weight: 700;
    margin-bottom: 8px;
  }
  
  .error-section .error-content p{
    font-size: 20px;
    line-height: 30px;
    font-weight: 400;
    margin-bottom: 32px;
  }
  
  .error-section .error-content .theme-btn-two{
    padding: 15px 32px;
  }
  
  
  /*** 
  
  ====================================================================
                          Contact-Page
  ====================================================================
  
  ***/
  
  .contact-section .form-inner {
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
  }
  
  .contact-page-section .form-inner{
    position: relative;
    display: block;
    background: #fff;
    padding: 50px 50px;
    padding-top: 43px;
    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
    margin-top: 31px;
  }
  
  .contact-page-section .form-inner h2{
    position: relative;
    display: block;
    font-size: 30px;
    line-height: 40px;
    font-weight: 700;
    margin-bottom: 29px;
  }
  
  .contact-page-section #content_block_6 .content-box .sec-title p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    margin-top: 10px;
  }
  
  .contact-page-section #content_block_6 .content-box .sec-title p span{
    font-weight: 700;
    color: #001b44;
  }
  
  .contact-page-section #content_block_6 .content-box .sec-title{
    margin-bottom: 36px;
  }
  
  
  /** locations-section **/
  
  .locations-section{
    position: relative;
    padding: 130px 0px;
  }
  
  .locations-section .single-item .inner-box{
    position: relative;
    display: block;
    background: #fff;
    padding: 34px 40px 37px 40px;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.06);
  }
  
  .locations-section .single-item .inner-box .upper-box{
    position: relative;
    margin-bottom: 18px;
  }
  
  .locations-section .single-item .inner-box .upper-box h3{
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  
  .locations-section .single-item .inner-box .upper-box p{
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
  }
  
  .locations-section .single-item .inner-box .info-list li{
    position: relative;
    display: block;
    padding-left: 70px;
    margin-bottom: 14px;
  }
  
  .locations-section .single-item .inner-box .info-list li:last-child{
    margin-bottom: 0px;
  }
  
  .locations-section .single-item .inner-box .info-list li i{
    position: absolute;
    left: 0px;
    top: 4px;
    font-size: 18px;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #001b4421;
    border-radius: 50%;
    transition: all 500ms ease;
  }
  
  .locations-section .single-item .inner-box .info-list li:hover i{
    background: #001b44;
  }
  
  .locations-section .single-item .inner-box .info-list li p{
    position: relative;
    display: block;
    font-size: 17px;
    line-height: 28px;
    color: #001b44;
    font-weight: 700;
    margin-bottom: 0px;
  }
  
  .locations-section .single-item .inner-box .info-list li a{
    position: relative;
    display: inline-block;
    font-size: 17px;
    line-height: 28px;
    font-weight: 500;
    color: #002c5d;
  }
  
  .locations-section .single-item .inner-box .info-list li a:hover{
  
  }
  
  .locations-section .pattern-layer{
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-repeat: repeat-x;
    animation: slide 100s linear infinite;
    -webkit-animation: slide 100s linear infinite;
  }
  a {
     -webkit-text-decoration: auto !important;
             text-decoration: auto !important;
}


.progress-wrap {
  position: fixed;
  right: 50px;
  bottom: 111px;
  height: 46px;
  width: 46px;
  cursor: pointer;
  display: block;
  border-radius: 50px;
   z-index: 10000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(15px);
  transition: all 200ms linear;
}
.progress-wrap.active-progress {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.progress-wrap svg.progress-circle path {
  stroke: #001b44;
  stroke-width: 4;
  box-sizing: border-box;
  transition: all 200ms linear;
}
.progress-wrap svg path {
  fill: none;
}
 
#top_scroll{
  top: 34px;
  position: relative;
}

 
#scroll_svg:hover path, .progress-wrap.active-progress:hover path, .progress-wrap.active-progress:hover #top_scroll{
  stroke: #ff5956 !important;
  color: #ff5956;
  top: 26px;
  position: relative;
}

.preloader-close:hover {
  background: white;
  color: black;
}


ul {
  padding-left: 0 !important;
}



  /*--------------------------------------------------------------
  # Custom Cursor
  --------------------------------------------------------------*/
  .custom-cursor__cursor {
    width: 25px;
    height: 25px;
    border-radius: 100%;
    border: 1px solid #002c5d !important;
    transition: all 200ms ease-out;
    position: fixed;
    pointer-events: none;
    left: 0;
    top: 0;
    transform: translate(calc(-50% + 5px), -50%);
    z-index: 999991;
  }
  .custom-cursor__cursor-two {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background-color:#ff5956 !important;
    opacity: 0.3;
    position: fixed;
    transform: translate(-50%, -50%);
    pointer-events: none;
    transition: width 0.3s, height 0.3s, opacity 0.3s;
    z-index: 999991;
  }
  .custom-cursor__hover {
    background-color: #002c5d !important;
    opacity: 0.4;
  }
  .custom-cursor__innerhover {
    width: 25px;
    height: 25px;
    opacity: 0.4;
  }

  nav .collapse:nth-of-type(2) {
    display: none !important;
}

@media only screen and (max-width: 991px) {
  .col-sm-12-f {
    width: 50% !important;
}
  footer img {
    width: 15% !important;
}
  .main-header .main-menu {
      max-width: 920px;
      margin: 0 auto;
      float: none;
      display: none;
      margin: 0 !important;
  }
}

@media  (min-width: 1501px) and  (max-width: 1154px) {
  .main-menu .navigation > li {
    margin: 0 !important; 
  }
}
@media  (min-width: 992px) and  (max-width: 1700px) {

.industries-section .tabs-content .inner-box .content-box{
  width: 95% !important;
}
}
@media  (min-width: 992px) and  (max-width: 1500px) {

  .industries-section .tabs-content .inner-box .content-box{
    width: 80% !important;
  }
  }
.btn.btn-primary{
  --bs-btn-border-color :none !important
}

`, "",{"version":3,"sources":["webpack://./src/CustomCSS/css/style.css"],"names":[],"mappings":";AACA,iBAAiB;;AAEjB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8CAuC8C;;;;AAI9C;;;;;;IAMI;CACH;IACG,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;EACd;;;EAGA;;;;;;MAMI;;;EAGJ;KACG,cAAc;IACf,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,qBAAqB;IACrB,2BAA2B;IAC3B,8BAA8B;IAC9B,mCAAmC;EACrC;;IAEE;IACA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;;EAGA;IACE,+BAA+B;IAC/B,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,aAAa;IACb,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,0BAA0B;EAC5B;;EAEA,cAAc;;EAEd;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,4BAA4B;IAC5B,0DAA0D;EAC5D;;EAEA;IACE,eAAe;IACf,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gBAAgB;EAClB;;EAEA;;EAEA;;EAEA;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;;EAGA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,uCAAuC;IACvC,wBAAwB;IACxB,wBAAwB;EAC1B;;EAEA,aAAa;;EAEb;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IAEE,oBAAoB;IAEpB,gEAAgE;EAClE;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAElB,oBAAoB;IAEpB,0BAA0B;IAE1B,8BAA8B;IAE9B,yBAAyB;IAEzB,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IAEE,oBAAoB;IAEpB,gEAAgE;EAClE;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAE9B,oBAAoB;IAEpB,0BAA0B;IAE1B,8BAA8B;IAE9B,yBAAyB;IAEzB,oCAAoC;EACtC;;;EAGA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,6BAA6B;EAC/B;;;EAGA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;EAEA;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;;;EAIA;;;;;;KAMG;;;EAGH,kBAAkB;;EAElB;IACE,iBAAiB;IACjB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,UAAU;IACV,2CAA2C;IAC3C,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;IACR,OAAO;IACP,0CAA0C;IAC1C,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,SAAS;IACT,kBAAkB;IAGlB,8BAA8B;IAE9B,0BAA0B;IAG1B,6BAA6B;IAE7B,yBAAyB;IAGzB,qCAAqC;IAErC,iCAAiC;IAGjC,gCAAgC;IAEhC,4BAA4B;EAC9B;;EAEA,iBAAiB;;EAEjB;IACE,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,aAAa;KACZ,mBAAmB;IACpB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IAGE,aAAa;IACb,eAAe;IAGf,mBAAmB;IAGnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;GACjB;;EAED;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;;EAEA;;EAEA,mBAAmB;;EAEnB;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf;;EAEF;IACE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;;EAElB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,4BAA4B;IAC5B,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,UAAU;IAGV,2BAA2B;IAG3B,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,mBAAmB;IAGnB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,8CAA8C;EAChD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,yBAAyB;AAC7B;;;EAGE,gBAAgB;;GAEf;IACC,WAAW;IACX,wBAAwB;EAC1B;;GAEC;IACC,UAAU;EACZ;;GAEC;IACC,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAKhB,yBAAyB;EAC3B;;GAEC;IACC,2BAA2B;EAC7B;;GAEC;IACC,2BAA2B;EAC7B;;GAEC;IACC,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,sCAAsC;IACtC,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IAKzB,yBAAyB;EAC3B;;GAEC;IACC,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,QAAQ;IACR,UAAU;IACV,kCAAkC;IAClC,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,0BAA0B;EAC5B;;GAEC;;IAEC,uBAAuB;EACzB;;GAEC;IACC,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;GAEC;IACC,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,WAAW;EACb;;GAEC;;;EAGD;;GAEC;;;EAGD;;GAEC;;IAEC,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;IAKhC,2BAA2B;IAG3B,qBAAqB;IAKrB,yBAAyB;EAC3B;;GAEC;IACC,SAAS;IACT,SAAS;EACX;;GAEC;IACC,iBAAiB;IACjB,UAAU;IACV,iBAAiB;EACnB;;GAEC;IACC,kBAAkB;EACpB;;GAEC;;IAEC,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,cAAc;IACd,yBAAyB;IACzB,4BAA4B;IAC5B,8CAA8C;IAC9C,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;EAC9B;;GAEC;IACC,WAAW;EACb;;GAEC;IACC,kBAAkB;IAClB,WAAW;EACb;;GAEC;IACC,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,kCAAkC;IAClC,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,wBAAwB;IACxB,0BAA0B;EAC5B;;GAEC;IACC,SAAS;IACT,UAAU;EACZ;;GAEC;;IAEC,mBAAmB;EACrB;;GAEC;;EAED;;GAEC;IACC,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;GAEC;IACC,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IAKnB,2BAA2B;EAC7B;;GAEC;IACC,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,WAAW;IACX,QAAQ;EACV;;GAEC;IACC,SAAS;IACT,SAAS;EACX;;GAEC;IACC,iBAAiB;IACjB,UAAU;IACV,iBAAiB;EACnB;;GAEC;IACC,kBAAkB;EACpB;;GAEC;IACC,kBAAkB;EACpB;;GAEC;IACC,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,cAAc;IACd,yBAAyB;IACzB,4BAA4B;IAC5B,8CAA8C;IAC9C,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;EAC9B;;GAEC;IACC,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,kCAAkC;IAClC,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,wBAAwB;IACxB,0BAA0B;EAC5B;;GAEC;IACC,SAAS;IACT,UAAU;EACZ;;GAEC;IACC,mBAAmB;EACrB;;GAEC;IACC,WAAW;IACX,kBAAkB;EACpB;;GAEC;IACC,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,SAAS;EACX;;GAEC;;IAEC,kBAAkB;IAClB,SAAS;IAKT,wBAAwB;IACxB,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;EAC9B;;GAEC;IACC,kBAAkB;IAClB,SAAS;IAKT,wBAAwB;IACxB,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;EAC9B;;GAEC;IACC,iBAAiB;IACjB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,aAAa;IACb,SAAS;IACT,0BAA0B;EAC5B;;GAEC;;;EAGD;;GAEC;IACC,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IAKzB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA,qBAAqB;;GAEpB;IACC,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,SAAS;EACX;;GAEC;IACC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;;EAGA,kBAAkB;;EAElB;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,aAAa;EACf;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,MAAM;IACN,WAAW;IACX,YAAY;IACZ,UAAU;IAGV,2BAA2B;IAC3B,0BAA0B;IAC1B,+BAA+B;IAC/B,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;IAKnB,wBAAwB;IAGxB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAGlB,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,mBAAmB;IAKnB,wBAAwB;IAGxB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,WAAW;IAKX,wBAAwB;EAC1B;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IAGE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,4CAA4C;EAC9C;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IAKzB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,MAAM;IACN,KAAK;IACL,QAAQ;IACR,0BAA0B;IAK1B,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,OAAO;IACP,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,iCAAiC;IACjC,cAAc;IACd,iBAAiB;IAKjB,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,cAAc;IAGd,uBAAuB;EACzB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;IAKb,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;EACpB;;;EAGA,0BAA0B;;;EAG1B;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;IACE,cAAc;IACd,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,8BAA8B;IAG9B,0BAA0B;IAC1B,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IAGE,wBAAwB;IACxB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,OAAO;IACP,SAAS;IACT,UAAU;IACV,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,SAAS;IACT,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;IAGV,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,UAAU;IAGV,0BAA0B;IAC1B,gCAAgC;IAChC,qCAAqC;IACrC,wCAAwC;IACxC,oCAAoC;IACpC,mCAAmC;EACrC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,OAAO;IACP,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,2BAA2B;IAC3B,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IAKjB,wBAAwB;EAC1B;;EAEA;;EAEA;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oCAAoC;IACpC,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA,qBAAqB;;EAErB;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,OAAO;IACP,SAAS;IACT,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,KAAK;IACL,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IAGtB,kBAAkB;IAKlB,6BAA6B;EAC/B;;EAEA;IAGE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,OAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IAKV,6BAA6B;IAK7B,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IAKV,wBAAwB;IAKxB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IAKV,4BAA4B;IAK5B,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IAKV,wBAAwB;IAKxB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IAKV,6BAA6B;IAK7B,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IAKV,wBAAwB;IAKxB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IAKV,4BAA4B;IAK5B,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IAKV,wBAAwB;IAKxB,wBAAwB;EAC1B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;;;EAIA,sBAAsB;;EAEtB;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,6CAA6C;IAC7C,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,cAAc;IAKd,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,UAAU;EACZ;;;EAGA,sBAAsB;;EAEtB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;IAC1B,+BAA+B;IAC/B,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;IAC1B,+BAA+B;IAC/B,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,qBAAqB;IACrB,4BAA4B;IAC5B,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,SAAS;IACT;;EAEF;IACE,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;EACd;EACA;;KAEG,gBAAgB;KAChB,yCAAyC;EAC5C;;EAEA;;MAEI,mBAAmB;MACnB,yCAAyC;GAC5C;EACD;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,cAAc;IACd,0BAA0B;EAC5B;;;EAGA;IACE,oCAAoC;EACtC;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;EACrB;;;EAGA,oBAAoB;;EAEpB;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,cAAc;IACd,WAAW;IACX,UAAU;IACV,YAAY;IAGZ,8FAA8F;IAG9F,wBAAwB;EAC1B;;EAEA;IAEE,mBAAmB;EACrB;;EAQA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,oCAAoC;IACpC,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,aAAa;IACb,2DAA2D;EAC7D;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;IACX,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;IACX,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;IAClC,WAAW;IACX,aAAa;EACf;;;EAGA,sBAAsB;;EAEtB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,WAAW;IACX,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,0BAA0B;EAC5B;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAElB,uCAAuC;EACzC;;;EAGA,6BAA6B;;EAE7B;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;IACR,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,UAAU;IACV,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;;EAGA,yBAAyB;;EAEzB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,8EAA8E;IAC9E,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,iCAAiC;IACjC,yBAAyB;IACzB,SAAO;IACP,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,iCAAiC;IACjC,WAAW;IACX,WAAW;IACX,UAAU;IACV,WAAW;IACX,0BAA0B;EAC5B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;;;EAGA;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,cAAc;IACd,4BAA4B;EAC9B;;;EAGA,sBAAsB;;EAEtB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kDAAkD;IAClD,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,oDAAoD;IACpD,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,UAAU;IACV,4BAA4B;IAC5B,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,QAAQ;IACR,+BAA+B;IAC/B,WAAW;IACX,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;EACE,YAAY;AACd;AACA;AACA,WAAW;AACX;;EAEE;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,4BAA4B;EAC9B;;;EAGA,mBAAmB;;EAEnB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,SAAS;IACT,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,UAAU;IACV,iBAAiB;IAKjB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,cAAc;IACd,cAAc;IACd,sCAAsC;IACtC,gBAAgB;IAChB,SAAS;IAKT,yBAAyB;EAC3B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,8CAA8C;IAC9C,eAAe;IACf,iBAAiB;IACjB,2CAA2C;IAC3C,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gCAAgC;IAChC,UAAU;IACV,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,UAAU;IACV,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;;EAGA,mBAAmB;;EAEnB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,cAAc;IACd,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,mBAAmB;IAEnB,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IAEE,sBAAsB;EACxB;EAeA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;IACA;MACE,WAAW;MACX,YAAY;MACZ,UAAU;IACZ;EACF;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;IAC5B,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,iCAAiC;IACjC,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,iCAAiC;IACjC,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;;EAGA,0BAA0B;;EAE1B;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,2DAA2D;EAC7D;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA,qBAAqB;;EAErB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;;EAGA,kBAAkB;;EAElB;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;;EAGA;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,6CAA6C;EAC/C;;EAEA;IACE,OAAO,wBAAwB,EAAE;MAC/B,KAAK,6BAA6B,EAAE;EACxC;;;;EASA;;;;;;KAMG;;;EAGH,uBAAuB;;EAEvB;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;EACrB;;;EAGA,uBAAuB;;EAEvB;IACE,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;IACX,UAAU;IACV,UAAU;IACV,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,SAAS;IACT,QAAQ;IACR,UAAU;IACV,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,OAAO;IACP,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IAEE,oBAAoB;IAEpB,gEAAgE;EAClE;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAElB,oBAAoB;IAEpB,0BAA0B;IAE1B,8BAA8B;IAE9B,yBAAyB;IAEzB,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IAEE,oBAAoB;IAEpB,gEAAgE;EAClE;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAElB,oBAAoB;IAEpB,0BAA0B;IAE1B,8BAA8B;IAE9B,yBAAyB;IAEzB,oCAAoC;EACtC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;EACd;;EAEA;;IAEE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,iCAAiC;IACjC,YAAY;IACZ,aAAa;IACb,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;;EAGA,sBAAsB;;EAEtB;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;;EAGA,sBAAsB;;EAEtB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,cAAc;IACd,WAAW;IACX,UAAU;IACV,YAAY;IAGZ,8FAA8F;IAG9F,wBAAwB;EAC1B;;EAEA;IAEE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAET,gCAAgC;IAEhC,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAElB,4CAA4C;IAE5C,6BAA6B;IAE7B,wBAAwB;EAC1B;;EAEA;IAEE,oBAAoB;EACtB;EAYA;IACE;MAEU,6CAA6C;IACvD;IACA;MAEU,0CAA0C;IACpD;EACF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,+BAA+B;IAC/B,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;;EAGA,wBAAwB;;EAExB;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,UAAU;IACV,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;;EAEA;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,wBAAwB;IACxB,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,WAAW;IACX,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,cAAc;IACd,qBAAqB;EACvB;;;EAGA,sBAAsB;;EAEtB;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,0BAA0B;EAC5B;;EAEA;;IAEE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,UAAU;IACV,0BAA0B;EAC5B;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;EAGA;;;EAGA,2BAA2B;;EAE3B;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,UAAU;IACV,4BAA4B;IAC5B,eAAe;IACf,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,sFAAsF;IACtF,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,UAAU;IACV,WAAW;IACX,0BAA0B;EAC5B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;;;EAGA;;;EAGA,uBAAuB;;EAEvB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,8BAA8B;EAChC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,yCAAyC;IACzC,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;IAC3B,qCAAqC;IACrC,6CAA6C;EAC/C;;;EAGA,sBAAsB;;EAEtB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;EAEA;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,+DAA+D;EACjE;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,WAAW;IACX,WAAW;IACX,+DAA+D;EACjE;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,UAAU;IACV,WAAW;IACX,+DAA+D;EACjE;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,yBAAyB;IACzB,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,uBAAuB;EACzB;;;EAGA,4BAA4B;;EAE5B;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IAEV,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;EAGA;;;EAGA,wBAAwB;;EAExB;IACE,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,2FAA2F;IAC3F,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAK3B,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;EAC3B;;;EAGA,0BAA0B;;EAE1B;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;;EAGA,uBAAuB;;EAEvB;IACE,8CAA8C;IAC9C,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gCAAgC;IAChC,+BAA+B;IAC/B,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gCAAgC;IAChC,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;;;EAIA;;;;;;KAMG;;;EAGH,yBAAyB;;EAEzB;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IAGE,aAAa;IACb,eAAe;IAGf,mBAAmB;IAGnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;;EAGA,yBAAyB;;EAEzB;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAKlB,6BAA6B;EAC/B;;EAEA;IAKE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IAKV,4BAA4B;IAK5B,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IAKV,wBAAwB;IAKxB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,WAAW;IACX,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,WAAW;IACX,gBAAgB;EAClB;;EAEA;;EAEA;;;EAGA,wBAAwB;;EAExB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,cAAc;EAChB;;EAEA;;EAEA;;EAEA;;EAEA;;;EAGA,oBAAoB;;EAEpB;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,YAAY;IACZ,aAAa;IACb;EACF;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAElB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;;EAGA,wBAAwB;;EAExB;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,0BAA0B;IAC1B,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,0BAA0B;IAC1B,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;;EAGA;IACE,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;EAEA;;EAEA;IACE,oBAAoB;IACpB,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,QAAQ;EACV;;;EAGA,qBAAqB;;EAErB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;;EAEA;;;EAGA,8BAA8B;;EAE9B;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,2DAA2D;EAC7D;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;;EAEA;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;EAC3B;;;EAGA,qBAAqB;;EAErB;IACE,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,8CAA8C;EAChD;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;;EAGA,yBAAyB;;EAEzB;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;;EAEA;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,8CAA8C;EAChD;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8CAA8C;IAC9C,0BAA0B;EAC5B;;;;EAIA;;;;;;KAMG;;;EAGH,iBAAiB;;EAEjB;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;;EAEA;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,WAAW;EACb;;EAEA;;EAEA;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;EAC7B;;;EAGA,sBAAsB;;EAEtB;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;EACV;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;;;;;;KAMG;;EAEH,wBAAwB;;EAExB;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,8CAA8C;EAChD;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;EAC3B;;;EAGA,yBAAyB;;EAEzB;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;EAEA;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,4BAA4B;IAC5B,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,4CAA4C;IAC5C,gCAAgC;IAChC,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,gCAAgC;IAChC,kBAAkB;IAClB,4BAA4B;IAC5B,UAAU;IACV,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,+BAA+B;IAC/B,iBAAiB;EACnB;;;EAGA,qBAAqB;;EAErB;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,SAAS;IACT,QAAQ;IACR,UAAU;EACZ;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;EAClC;;;EAGA,uBAAuB;;EAEvB;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;;;EAGA;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;;;;EAIA;;;;;;KAMG;;EAEH;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,sCAAsC;IACtC,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;IAC5B,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,oCAAoC;IACpC,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;;;EAIA;;;;;;KAMG;;EAEH;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAK3B,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;;IAEE,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;IAClB,yCAAyC;EAC3C;;;EAGA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;;EAGA;;;;;;KAMG;;EAEH;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA,qBAAqB;;EAErB;IACE,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IAEE,oBAAoB;IAEpB,gEAAgE;EAClE;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAElB,oBAAoB;IAEpB,0BAA0B;IAE1B,8BAA8B;IAE9B,yBAAyB;IAEzB,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;EACV;;;EAGA,sBAAsB;;EAEtB;IACE,kBAAkB;IAClB;EACF;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;;;EAGA;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,WAAW;EACb;;;EAGA,sBAAsB;;EAEtB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,4BAA4B;IAC5B,iCAAiC;IACjC,kBAAkB;IAClB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;;EAEA;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,cAAc;IACd,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,0CAA0C;IAC1C,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,4BAA4B;IAC5B,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,0BAA0B;EAC5B;;EAEA;;;EAGA;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;;IAEE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,0BAA0B;EAC5B;;EAEA;;;EAGA;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;;;EAIA;;;;;;KAMG;;EAEH;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;;;IAGE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,0CAA0C;EAC5C;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;;EAGA,kBAAkB;;EAElB;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;IAChB,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;;EAGA,uBAAuB;;EAEvB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;;EAGA,yBAAyB;;EAEzB;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;EAEA;;;EAGA;;;;;;KAMG;;EAEH;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;;;EAGA;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;IACX,SAAS;IACT,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,YAAY;IACZ,cAAc;IACd,0BAA0B;EAC5B;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;;EAEA;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;IACvC;EACF;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;;EAErB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;EACf;;EAEA;;IAEE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,SAAS;IACT,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;IACtC,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;IAC7C,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;;IAEE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,0BAA0B;EAC5B;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;;;EAGA;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;;;EAIA;;;;;;KAMG;;EAEH;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,UAAU;IACV,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,QAAQ;EACV;;EAEA;;;EAGA;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;;EAGA;;;;;;KAMG;;EAEH;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;;EAGA;;;;;;KAMG;;EAEH;IACE,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,0CAA0C;IAC1C,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA,wBAAwB;;EAExB;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;EAEA;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,qCAAqC;IACrC,6CAA6C;EAC/C;EACA;KACG,wCAAgC;aAAhC,gCAAgC;AACrC;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,mBAAmB;GAClB,cAAc;EACf,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EAEtB,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;;AAGA;EACE,0BAA0B;EAC1B,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;;AAGA;EACE,0BAA0B;AAC5B;;;;EAIE;;iEAE+D;EAC/D;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IAEpC,8BAA8B;IAC9B,eAAe;IACf,oBAAoB;IACpB,OAAO;IACP,MAAM;IAEN,4CAA4C;IAC5C,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mCAAmC;IACnC,YAAY;IACZ,eAAe;IAEf,gCAAgC;IAChC,oBAAoB;IAEpB,iDAAiD;IACjD,eAAe;EACjB;EACA;IACE,oCAAoC;IACpC,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;AAC5B;;AAEA;EACE;IACE,qBAAqB;AACzB;EACE;IACE,qBAAqB;AACzB;EACE;MACI,gBAAgB;MAChB,cAAc;MACd,WAAW;MACX,aAAa;MACb,oBAAoB;EACxB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;;AAEA;EACE,qBAAqB;AACvB;AACA;AACA;;EAEE;IACE,qBAAqB;EACvB;EACA;AACF;EACE;AACF","sourcesContent":[" \n/* Css For OCDS */\n\n/************ TABLE OF CONTENTS ***************\n1. Fonts\n2. Reset\n3. Global\n4. Main Header/style-one/style-two\n5. Main Slider/style-one/style-two\n6. Intro Section\n7. Welcome Section\n9. Cta Section\n8. Research Fields\n10. Testimonial Section\n11. Researches Section\n12. Team Section\n14. Video\n15. Fact Counter\n16. News Section\n19. Clients Section\n20. Main Footer\n21. Footer Bottom\n22. Research Style Two\n23. Innovative Solution\n24. Discover Section\n25. Testimonial Section\n26. Chooseus Section\n27. News Style Two\n28. Page Title\n29. Research Page Section\n30. Research Details\n31. Professor Page Section\n32. Professor Details\n33. About Section\n34. Error Section\n35. Blog Page Section\n36. Blog Details\n37. Blog Sidebar\n38. Contact Section\n39. Google Map\n\n\n**********************************************/\n\n\n\n/*** \n\n====================================================================\n  Reset\n====================================================================\n\n ***/\n * {\n    margin:0px;\n    padding:0px;\n    border:none;\n    outline:none;\n  }\n  \n  \n  /*** \n  \n  ====================================================================\n    Global Settings\n  ====================================================================\n  \n   ***/\n  \n  \n  body {\n     font-size:15px;\n    color:#002c5d;\n    line-height:28px;\n    font-weight:400;\n    background:#ffffff;\n    font-family: 'Muli', sans-serif;\n    background-size:cover;\n    background-repeat:no-repeat;\n    background-position:center top;\n    -webkit-font-smoothing: antialiased;\n  }\n  \n    @media (min-width:1200px) {\n    .container {\n      max-width: 1170px;\n      padding: 0px 15px;\n    }\n  }\n  \n  .container-fluid{\n    padding: 0px;\n  }\n  \n  .large-container{\n    position:static;\n    max-width:1480px;\n    padding:0px 15px;\n    margin:0 auto;\n  }\n  \n  .auto-container{\n    position:static;\n    max-width:1200px;\n    padding:0px 15px;\n    margin:0 auto;\n  }\n  \n  .small-container{\n    max-width:680px;\n    margin:0 auto;\n  }\n  \n  .boxed_wrapper{\n    position: relative;\n    margin: 0 auto;\n    overflow: hidden;\n    width: 100%;\n    min-width: 300px;\n  }\n  \n  \n  a{\n    text-decoration:none !important;\n    transition:all 500ms ease;\n    -moz-transition:all 500ms ease;\n    -webkit-transition:all 500ms ease;\n    -ms-transition:all 500ms ease;\n    -o-transition:all 500ms ease;\n  }\n  \n  a:hover{\n    text-decoration:none;\n    outline:none;\n  }\n  \n  input,button,select,textarea{\n    font-family: 'Muli', sans-serif;\n    font-weight: 400;\n    font-size: 15px;\n    color: #555;\n  }\n  \n  ul,li{\n    list-style:none;\n    padding:0px;\n    margin:0px; \n  }\n  \n  input{\n    transition: all 500ms ease;\n  }\n  \n  button:focus,\n  input:focus,\n  textarea:focus{\n    outline: none;\n    box-shadow: none;\n    transition: all 500ms ease;\n  }\n  \n  p{\n    position: relative;\n    font-size: 15px;\n    line-height: 28px;\n    font-family: 'Muli', sans-serif;\n    font-weight: 400;\n    color: #002c5d;\n    margin: 0px;\n    transition: all 500ms ease;\n  }\n  \n  h1,h2,h3,h4,h5,h6{\n    position:relative;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 400;\n    color: #001b44;\n    margin: 0px;\n    transition: all 500ms ease;\n  }\n  \n  /* Preloader */\n  \n  .preloader {\n    position: fixed;\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    z-index: 999;\n    background-position: center center;\n    background-repeat: no-repeat;\n    /* background-image: url(../images/icons/preloader.png); */\n  }\n  \n  .preloader-close{\n    position: fixed;\n    z-index: 999999;\n    color: #fff;\n    padding: 10px 20px;\n    cursor: pointer;\n    right: 0;\n    bottom: 0;\n    font-weight: 600;\n  }\n  \n  .preloader.style-two .preloader-close{\n  \n  }\n  \n  .loader-wrap {\n    position: fixed;\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    z-index: 999999;\n  }\n  \n  .loader-wrap .layer-one {\n    position: absolute;\n    left: 0%;\n    top: 0;\n    width: 33.3333%;\n    height: 100%;\n    overflow: hidden;\n  }\n  \n  .loader-wrap .layer-two {\n    position: absolute;\n    left: 33.3333%;\n    top: 0;\n    width: 33.3333%;\n    height: 100%;\n    overflow: hidden;\n  }\n  \n  .loader-wrap .layer-three {\n    position: absolute;\n    left: 66.6666%;\n    top: 0;\n    width: 33.3333%;\n    height: 100%;\n    overflow: hidden;\n  }\n  \n  .loader-wrap .layer .overlay {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: #002c5d;\n  }\n  \n  \n  .centred{\n    text-align: center;\n  }\n  \n  .pull-left{\n    float: left;\n  }\n  \n  .pull-right{\n    float: right;\n  }\n  \n  \n  figure{\n    margin: 0px;\n  }\n  \n  img {\n    display: inline-block;\n    max-width: 100%;\n    height: auto;\n    transition-delay: .1s;\n    transition-timing-function: ease-in-out;\n    transition-duration: .7s;\n    transition-property: all;\n  }\n  \n  /** button **/\n  \n  .theme-btn-one, .theme-btn-one.nav-link{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #fff !important;\n    border-radius: 4px;\n    text-align: center;\n    background: #001b44;\n    padding: 15px 44px;\n    text-transform: uppercase;\n    z-index: 1;\n  }\n  \n  .theme-btn-one:hover:after{\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n    -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n  }\n  \n  .theme-btn-one:after{\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 4px;\n    -webkit-transform: scaleX(0);\n    transform: scaleX(0);\n    -webkit-transform-origin: 50% 100%;\n    transform-origin: 50% 100%;\n    -webkit-transition-property: transform;\n    transition-property: transform;\n    -webkit-transition-duration: 0.5s;\n    transition-duration: 0.5s;\n    -webkit-transition-timing-function: ease-out;\n    transition-timing-function: ease-out;\n  }\n  \n  .theme-btn-two,  #Button_react{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #fff !important;\n    border-radius: 4px;\n    text-align: center;\n    padding: 10px 29px;\n    text-transform: uppercase;\n    z-index: 1;\n  }\n  \n  .theme-btn-two:hover:after,  #Button_react:hover:after{\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n    -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n  }\n  \n  .theme-btn-two:after, #Button_react:after{\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 4px;\n    background: #001b44 !important; \n    -webkit-transform: scaleX(0);\n    transform: scaleX(0);\n    -webkit-transform-origin: 50% 100%;\n    transform-origin: 50% 100%;\n    -webkit-transition-property: transform;\n    transition-property: transform;\n    -webkit-transition-duration: 0.5s;\n    transition-duration: 0.5s;\n    -webkit-transition-timing-function: ease-out;\n    transition-timing-function: ease-out;\n  }\n  \n  \n  .pagination{\n    position: relative;\n    display: block;\n  }\n  \n  .pagination li{\n    display: inline-block;\n    margin-right: 7px;\n  }\n  \n  .pagination li:last-child{\n    margin-right: 0px;\n  }\n  \n  .pagination li a{\n    position: relative;\n    display: inline-block;\n    font-size: 20px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    height: 50px;\n    width: 50px;\n    line-height: 50px;\n    text-align: center;\n    color: #001b44;\n    background: transparent;\n    border-radius: 5px;\n    border: 1px solid #eae0d9;\n    z-index: 1;\n    transition: all 500ms ease;\n  }\n  \n  .pagination li a i{\n    font-size: 14px;\n  }\n  \n  .pagination li a:hover,\n  .pagination li a.active{\n    color: #fff;\n  }\n  \n  .sec-pad{\n    padding: 95px 0px 130px 0px !important;\n  }\n  \n  .sec-pad-2{\n    padding: 130px 0px !important;\n  }\n  \n  \n  .scroll-top{\n    width: 50px;\n    height: 120px;\n    position: fixed;\n    display: inline-block;\n    bottom: 10%;\n    right: 40px;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Nunito Sans', sans-serif;\n    z-index: 99;\n    color: #ffffff;\n    background: #3e252d;\n    border-radius: 5px;\n    text-align: center;\n    cursor: pointer;\n    text-transform: uppercase;\n    z-index: 1;\n    transition: 1s ease;\n  }\n  \n  .scroll-top i{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    font-weight: 400;\n    margin-bottom: 10px;\n  }\n  \n  .scroll-top:hover{\n    \n  }\n  \n  .scroll-top.open {\n    bottom: 40px;\n  }\n  \n  .sec-title{\n    position: relative;\n    display: block;\n    margin-bottom: 50px;\n  }\n  \n  .sec-title .top-title{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Muli', sans-serif;\n    font-weight: 700;\n    text-transform: uppercase;\n    margin-bottom: 12px;\n    padding-top: 28px;\n    z-index: 1;\n  }\n  \n  .sec-title .top-title:before{\n    position: absolute;\n    content: '';\n    background: #001b4421;\n    width: 50px;\n    height: 50px;\n    border-radius: 5px;\n    left: -25px;\n    top: 8px;\n    z-index: -1;\n  }\n  \n  .sec-title .top-title:after{\n    position: absolute;\n    content: '';\n    background: #001b4421;\n    border-left: 2px solid #fff;\n    border-bottom: 2px solid #fff;\n    width: 24px;\n    height: 24px;\n    border-radius: 3px;\n    left: 9px;\n    top: 0px;\n    z-index: -1;\n  }\n  \n  .sec-title h2{\n    position: relative;\n    display: block;\n    font-size: 44px;\n    line-height: 54px;\n    font-weight: 700;\n  }\n  \n  .sec-title.light h2{\n    color: #fff;\n  }\n  \n  .sec-title p{\n    font-size: 18px;\n    line-height: 26px;\n    margin-top: 16px;\n  }\n  \n  \n  \n  /*** \n  \n  ====================================================================\n                          Home-Page-One\n  ====================================================================\n  \n  ***/\n  \n  \n  /** main-header **/\n  \n  .main-header{\n    position:relative;\n    left:0px;\n    top:0px;\n    z-index:999;\n    width:100%;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n    transition:all 500ms ease;\n    -moz-transition:all 500ms ease;\n    -webkit-transition:all 500ms ease;\n    -ms-transition:all 500ms ease;\n    -o-transition:all 500ms ease;\n  }\n  \n  .sticky-header{\n    position:fixed;\n    opacity:0;\n    visibility:hidden;\n    background: #fff;\n    left:0px;\n    top:0px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n    width:100%;\n    z-index:0;\n    transition:all 500ms ease;\n    -moz-transition:all 500ms ease;\n    -webkit-transition:all 500ms ease;\n    -ms-transition:all 500ms ease;\n    -o-transition:all 500ms ease;\n  }\n  \n  .fixed-header .sticky-header{\n    z-index:999;\n    opacity:1;\n    visibility:visible;\n    -ms-animation-name: fadeInDown;\n    -moz-animation-name: fadeInDown;\n    -op-animation-name: fadeInDown;\n    -webkit-animation-name: fadeInDown;\n    animation-name: fadeInDown;\n    -ms-animation-duration: 500ms;\n    -moz-animation-duration: 500ms;\n    -op-animation-duration: 500ms;\n    -webkit-animation-duration: 500ms;\n    animation-duration: 500ms;\n    -ms-animation-timing-function: linear;\n    -moz-animation-timing-function: linear;\n    -op-animation-timing-function: linear;\n    -webkit-animation-timing-function: linear;\n    animation-timing-function: linear;\n    -ms-animation-iteration-count: 1;\n    -moz-animation-iteration-count: 1;\n    -op-animation-iteration-count: 1;\n    -webkit-animation-iteration-count: 1;\n    animation-iteration-count: 1;\n  }\n  \n  /** header-top **/\n  \n  .main-header .header-top{\n    position: relative;\n    width: 100%;\n    padding: 0px 50px;\n    border-bottom: 1px solid #eae0d9;\n  }\n  \n  .main-header .header-top .top-inner{\n    position: relative;\n    display: flex;\n     align-items: center;\n    justify-content: space-between;\n  }\n  \n  .main-header .header-top .left-info{\n    position: relative;\n    padding:  0;\n    margin-bottom: 0 !important;\n  }\n  \n  .main-header .header-top .location-box{\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    padding: 11px 30px 11px 30px;\n    border-left: 1px solid #eae0d9;\n    border-right: 1px solid #eae0d9;\n  }\n  \n  .main-header .header-top .right-info{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    flex-wrap: wrap;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    padding: 11px 0px;\n  }\n  \n  .main-header .header-top .left-info li{\n    position: relative;\n    display: inline-block;\n    font-size: 15px;\n    line-height: 20px;\n    color: #002c5d;\n    font-weight: 600;\n    margin-right: 30px;\n    padding-left: 25px;\n  }\n  \n  .main-header .header-top .left-info li:last-child{\n    margin-right: 0px;\n  }\n  \n  .main-header .header-top .left-info li p{\n    font-size: 15px;\n    line-height: 20px;\n    color: #002c5d;\n    font-weight: 600;\n  }\n  \n  .main-header .header-top .left-info li p a{\n    color: #002c5d;\n  }\n  \n  .main-header .header-top .left-info li p a:hover{\n  \n  }\n  \n  .main-header .header-top .left-info li i{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    font-size: 18px;\n    font-weight: 400;\n  }\n  \n  .main-header .header-top .left-info li p span{\n    font-weight: 700;\n    color: #001b44;\n    text-transform: uppercase;\n  }\n  \n  .main-header .header-top .location-box .location-carousel{\n    position: relative;\n    display: block;\n    max-width: 560px;\n    width: 100%;\n    padding-right: 110px;\n  }\n  \n  .main-header .header-top .location-box .location-carousel p{\n    font-size: 15px;\n    font-weight: 600;\n  }\n  \n  .main-header .header-top .location-box .location-carousel p span{\n    font-weight: 700;\n   }\n  \n  .main-header .header-top .location-box .location-carousel .owl-nav{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n  }\n  \n  .main-header .header-top .location-box .location-carousel .owl-nav .owl-prev,\n  .main-header .header-top .location-box .location-carousel .owl-nav .owl-next{\n    position: relative;\n    display: inline-block;\n    width: 24px;\n    height: 24px;\n    line-height: 24px;\n    background: #001b4421;\n    text-align: center;\n    border-radius: 5px;\n    font-size: 10px;\n    color: #001b44;\n    cursor: pointer;\n    z-index: 1;\n    margin: 0px 2.5px;\n    transition: all 500ms ease;\n  }\n  \n  .main-header .header-top .location-box .location-carousel .owl-nav .owl-prev:hover,\n  .main-header .header-top .location-box .location-carousel .owl-nav .owl-next:hover{\n    color: #fff;\n  }\n  \n  .main-header .header-top .location-box .apply-btn{\n    position: relative;\n    padding-left: 30px;\n  }\n  \n  .main-header .header-top .location-box .apply-btn a{\n    position: relative;\n    display: inline-block;\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  .main-header .header-top .location-box .apply-btn a i{\n    font-size: 14px;\n    margin-left: 8px;\n  }\n  \n  .main-header .header-top .location-box .apply-btn a:hover{\n    color: #001b44;\n  }\n  \n  .main-header .header-top .right-info .list{\n    margin-right: 30px;\n  }\n  \n  .main-header .header-top .right-info .list li{\n    position: relative;\n    display: inline-block;\n    font-size: 15px;\n    font-weight: 600;\n    margin-right: 15px;\n  }\n  \n  .main-header .header-top .right-info .list li:last-child{\n    margin-right: 0px !important;\n  }\n  \n  .main-header .header-top .right-info .list li a{\n    color: #002c5d;\n  }\n  \n  .main-header .header-top .right-info .list li a:hover{\n  \n  }\n  \n  .main-header .header-top .right-info .social-links li{\n    position: relative;\n    display: inline-block;\n    font-size: 15px;\n    margin-right: 13px;\n  }\n  \n  .main-header .header-top .right-info .social-links li:last-child{\n    margin-right: 0px;\n  }\n  \n  .main-header .header-top .right-info .social-links li a{\n    color: #001b44;\n  }\n  \n  .main-header .header-top .right-info .social-links li a:hover{\n  \n  }\n  \n  /** header-lower **/\n  \n  .main-header .header-lower{\n    position: relative;\n  }\n  \n  .main-header  .main-menu  {\n    float: left;\n  }\n  \n  .main-header .logo-box{\n    position: relative;\n    float: left;\n    background: #002c5d;\n    padding: 6px ;\n    margin: 0 10px ;\n    }\n\n  #img_nav{ \n    background: #002c5d;\n    padding: 6px;\n    margin: 0 10px  ;\n\n  }\n  \n  .main-header .menu-right-content{\n    margin-top: 20px;\n    /* padding-right: 50px; */\n  }\n  \n  .main-header .menu-right-content li{\n    position: relative;\n    display: inline-block;\n  }\n  \n  .main-header .menu-right-content .search-btn button{\n    position: relative;\n    display: inline-block;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 26px;\n    top: 2px;\n    color: #000;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .main-header .menu-right-content .search-btn button:hover{\n  \n  }\n  \n  .main-header .language{\n    position:relative;\n    display: inline-block;\n    /* margin: 0px 15px 0px 35px; */\n  }\n  \n  .main-header .language .lang-btn{\n    position:relative;\n    display: inline-block;\n    background: #001b4421;\n    padding: 12px 15px 13px 14px;\n    border-radius: 4px;\n    height: 52px;\n    cursor: pointer;\n  }\n  \n  .main-header .language .lang-btn .icon{\n    position: relative;\n    display: inline-block;\n    font-size: 18px;\n    color: #001b44;\n    margin-right: 5px;\n  }\n  \n  .main-header .language .lang-btn .txt{\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 13px;\n    font-weight: 700;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #001b44;\n  }\n  \n  .main-header .language .lang-btn .arrow{\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    padding-left: 4px;\n    font-size: 14px;\n    color: #001b44;\n  }\n  \n  .main-header .language .lang-dropdown{\n    position: absolute;\n    left: 0;\n    top: 100%;\n    width: 150px;\n    background: #001b44;\n    padding: 5px 0px;\n    opacity: 0;\n    visibility: hidden;\n    z-index: 1;\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n    transform: translateY(20px);\n    -webkit-transition: all 300ms linear;\n    -ms-transition: all 300ms linear;\n    transition: all 300ms linear;\n  }\n  \n  .main-header .language:hover .lang-dropdown{\n    opacity: 1;\n    visibility: visible;\n    -webkit-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n  \n  .main-header .language .lang-dropdown li{\n    position: relative;\n    display: block;\n    border-bottom: 1px solid rgba(255,255,255,0.2);\n  }\n  \n  .main-header .language .lang-dropdown li:last-child{\n    border: none;\n  }\n  \n  .main-header .language .lang-dropdown li a{\n    position: relative;\n    display: block;\n    padding: 5px 15px;\n    font-size: 14px;\n    line-height: 24px;\n    color: #fff;\n    text-align: left;\n  }\n  .navigation.clearfix li a:hover {\n    color: #ff5956 !important;\n}\n  \n  \n  /** main-menu **/\n  \n   .main-menu .navbar-collapse{\n    padding:0px;\n    display:block !important;\n  }\n  \n   .main-menu .navigation{\n    margin:0px;\n  }\n  \n   .main-menu .navigation > li{\n    position:inherit;\n    float:left;\n    z-index:2;\n    padding:36px 0px 33px 0px;\n    margin: 0px 18px;\n    -webkit-transition:all 300ms ease;\n    -moz-transition:all 300ms ease;\n    -ms-transition:all 300ms ease;\n    -o-transition:all 300ms ease;\n    transition:all 300ms ease;\n  }\n  \n   .main-menu .navigation > li:last-child{\n    margin-right:0px !important;\n  }\n  \n   .main-menu .navigation > li:first-child{\n    margin-left: 0px !important;\n  }\n  \n   .main-menu .navigation > li > a, .nav_ocd{\n    position:relative;\n    display:block;\n    text-align:center;\n    font-size:14px;\n    line-height:30px;\n    font-weight:700;\n    opacity:1;\n    font-family: 'Nunito Sans', sans-serif;\n    color:#001b44;\n    z-index:1;\n    padding-right: 17px;\n    text-transform: uppercase;\n    -webkit-transition:all 500ms ease;\n    -moz-transition:all 500ms ease;\n    -ms-transition:all 500ms ease;\n    -o-transition:all 500ms ease;\n    transition:all 500ms ease;\n  }\n  \n   .main-menu .navigation > li.dropdown > a:before{\n    position: absolute;\n    display: inline-block;\n    content: \"\\f062\";\n    top: 0px;\n    right: 0px;\n    font-family: 'Font Awesome 5 Free';\n    font-size: 12px;\n    color: #bdadad;\n    font-weight: 700;\n    transform: rotate(20deg);\n    transition: all 500ms ease;\n  }\n  \n   .main-menu .navigation > li.dropdown.current > a:before,\n   .main-menu .navigation > li.dropdown:hover > a:before{\n    transform: rotate(0deg);\n  }\n  \n   .main-menu .navigation > li > a span{\n    position: absolute;\n    top: -15px;\n    right: -15px;\n    font-size: 11px;\n    color: #fff;\n    font-weight: 500;\n    width: 37px;\n    height: 16px;\n    line-height: 16px;\n    text-align: center;\n    border-radius: 20px;\n  }\n  \n   .main-menu .navigation > li > a span:before{\n    position: absolute;\n    content: '';\n    width: 8px;\n    height: 8px;\n    left: 15px;\n    bottom: -3px;\n    transform: rotate(-45deg);\n    z-index: -1;\n  }\n  \n   .main-menu .navigation > li.dropdown.current > a:before,\n   .main-menu .navigation > li.dropdown:hover > a:before{\n  \n  }\n  \n   .main-menu .navigation > li.current > a,\n   .main-menu .navigation > li:hover > a{\n    \n  }\n  \n   .main-menu .navigation > li > ul,\n   .main-menu .navigation > li > .megamenu{\n    position:absolute;\n    left: inherit;\n    top:100%;\n    width:250px;\n    z-index:100;\n    display:none;\n    opacity: 0;\n    visibility: hidden;\n    padding: 10px 0px;\n    background-color: #001b44;\n    border-radius: 0px 0px 10px 10px;\n    -moz-transform: translateY(30px);\n    -webkit-transform: translateY(30px);\n    -ms-transform: translateY(30px);\n    -o-transform: translateY(30px);\n    transform: translateY(30px);\n    -webkit-transform-origin: top;\n    -ms-transform-origin: top;\n    transform-origin: top;\n    -webkit-transition:all 500ms ease;\n    -moz-transition:all 500ms ease;\n    -ms-transition:all 500ms ease;\n    -o-transition:all 500ms ease;\n    transition:all 500ms ease;\n  }\n  \n   .main-menu .navigation > li > ul.from-right{\n    left:auto;\n    right:0px;  \n  }\n  \n   .main-menu .navigation > li > ul > li{\n    position:relative;\n    width:100%;\n    padding: 0px 30px;\n  }\n  \n   .main-menu .navigation > li > ul > li:last-child{\n    border-bottom:none; \n  }\n  \n   .main-menu .navigation > li > ul > li > a,\n   .main-menu .navigation > li > .megamenu li > a{\n    position:relative;\n    display:block;\n    padding:14px 0px 13px 0px;\n    line-height:24px;\n    font-weight:600;\n    font-family: 'Nunito Sans', sans-serif;\n    font-size:15px;\n    text-transform:capitalize;\n    color: rgba(255,255,255,0.5);\n    border-bottom: 1px solid rgba(255,255,255,0.2);\n    text-align: left;\n    transition:all 500ms ease;\n    -moz-transition:all 500ms ease;\n    -webkit-transition:all 500ms ease;\n    -ms-transition:all 500ms ease;\n    -o-transition:all 500ms ease;\n  }\n  \n   .main-menu .navigation > li > .megamenu li > a:hover{\n    color: #fff;\n  }\n  \n   .main-menu .navigation > li > ul > li > a:hover{\n    padding-left: 18px;\n    color: #fff;\n  }\n  \n   .main-menu .navigation > li > ul > li > a:before{\n    position: absolute;\n    display: inline-block;\n    content: \"\\f062\";\n    top: 15px;\n    left: 0px;\n    font-family: 'Font Awesome 5 Free';\n    font-size: 12px;\n    color: #fff;\n    font-weight: 700;\n    opacity: 0;\n    transform: rotate(20deg);\n    transition: all 500ms ease;\n  }\n  \n   .main-menu .navigation > li > ul > li > a:hover:before{\n    top: 11px;\n    opacity: 1;\n  }\n  \n   .main-menu .navigation > li > ul > li:last-child > a,\n   .main-menu .navigation > li > .megamenu li:last-child > a{\n    border-bottom: none;\n  }\n  \n   .main-menu .navigation > li > .megamenu li > a:hover{\n  \n  }\n  \n   .main-menu .navigation > li > ul > li.dropdown > a:after{\n    font-family: 'Font Awesome 5 Free';\n    content: \"\\f105\";\n    position:absolute;\n    right:20px;\n    top:14px;\n    display:block;\n    line-height:24px;\n    font-size:16px;\n    font-weight:800;\n    text-align:center;\n    z-index:5;  \n  }\n  \n   .main-menu .navigation > li > ul > li > ul{\n    position:absolute;\n    left: 100%;\n    top:-2px;\n    width:250px;\n    margin-left: 10px;\n    z-index:100;\n    display:none;\n    padding: 10px 0px;\n    background-color: #001b44;\n    border-radius: 10px;\n    -moz-transform: translateY(30px);\n    -webkit-transform: translateY(30px);\n    -ms-transform: translateY(30px);\n    -o-transform: translateY(30px);\n    transform: translateY(30px);\n  }\n  \n   .main-menu .navigation > li > ul > li > ul:before{\n    position: absolute;\n    content: '';\n    width: 10px;\n    height: 100%;\n    left: -10px;\n    top: 0px;\n  }\n  \n   .main-menu .navigation > li > ul > li > ul.from-right{\n    left:auto;\n    right:0px;  \n  }\n  \n   .main-menu .navigation > li > ul > li > ul > li{\n    position:relative;\n    width:100%;\n    padding: 0px 30px;\n  }\n  \n   .main-menu .navigation > li > ul > li > ul > li:last-child{\n    border-bottom:none; \n  }\n  \n   .main-menu .navigation > li > ul > li > ul > li:last-child{\n    border-bottom:none; \n  }\n  \n   .main-menu .navigation > li > ul > li > ul > li > a{\n    position:relative;\n    display:block;\n    padding:14px 0px 13px 0px;\n    line-height:24px;\n    font-weight:600;\n    font-family: 'Nunito Sans', sans-serif;\n    font-size:15px;\n    text-transform:capitalize;\n    color: rgba(255,255,255,0.5);\n    border-bottom: 1px solid rgba(255,255,255,0.2);\n    text-align: left;\n    transition:all 500ms ease;\n    -moz-transition:all 500ms ease;\n    -webkit-transition:all 500ms ease;\n    -ms-transition:all 500ms ease;\n    -o-transition:all 500ms ease;\n  }\n  \n   .main-menu .navigation > li > ul > li > ul > li > a:before{\n    position: absolute;\n    display: inline-block;\n    content: \"\\f062\";\n    top: 15px;\n    left: 0px;\n    font-family: 'Font Awesome 5 Free';\n    font-size: 12px;\n    color: #fff;\n    font-weight: 700;\n    opacity: 0;\n    transform: rotate(20deg);\n    transition: all 500ms ease;\n  }\n  \n   .main-menu .navigation > li > ul > li > ul > li > a:hover:before{\n    top: 11px;\n    opacity: 1;\n  }\n  \n   .main-menu .navigation > li > ul > li > ul > li:last-child > a{\n    border-bottom: none;\n  }\n  \n   .main-menu .navigation > li > ul > li > ul > li > a:hover{\n    color: #fff;\n    padding-left: 18px;\n  }\n  \n   .main-menu .navigation > li > ul > li > ul > li.dropdown > a:after{\n    font-family: 'Font Awesome 5 Free';\n    content: \"\\f105\";\n    position:absolute;\n    right:20px;\n    top:12px;\n    display:block;\n    line-height:24px;\n    font-size:16px;\n    font-weight:900;\n    z-index:5;  \n  }\n  \n   .main-menu .navigation > li.dropdown:hover > ul,\n   .main-menu .navigation > li.dropdown:hover > .megamenu{\n    visibility:visible;\n    opacity:1;\n    -moz-transform: translateY(0);\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    transition:all 500ms ease;\n    -moz-transition:all 500ms ease;\n    -webkit-transition:all 500ms ease;\n    -ms-transition:all 500ms ease;\n    -o-transition:all 500ms ease;\n  }\n  \n   .main-menu .navigation li > ul > li.dropdown:hover > ul{\n    visibility:visible;\n    opacity:1;\n    -moz-transform: translateY(0);\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    transition:all 300ms ease;\n    -moz-transition:all 300ms ease;\n    -webkit-transition:all 500ms ease;\n    -ms-transition:all 300ms ease;\n    -o-transition:all 300ms ease; \n  }\n  \n   .main-menu .navigation li.dropdown .dropdown-btn{\n    position:absolute;\n    right:-32px;\n    top:66px;\n    width:34px;\n    height:30px;\n    text-align:center;\n    font-size:18px;\n    line-height:26px;\n    color:#3b3b3b;\n    cursor:pointer;\n    display: none;\n    z-index:5;\n    transition: all 500ms ease;\n  }\n  \n   .main-menu .navigation li.current.dropdown .dropdown-btn,\n   .main-menu .navigation li:hover .dropdown-btn{\n    \n  }\n  \n   .main-menu .navigation li.dropdown ul li.dropdown .dropdown-btn{\n    display: none;\n  }\n  \n  .menu-area .mobile-nav-toggler {\n    position: relative;\n    float: right;\n    font-size: 40px;\n    line-height: 50px;\n    cursor: pointer;\n    color: #3786ff;\n    display: none;\n  }\n  \n  .menu-area .mobile-nav-toggler .icon-bar{\n    position: relative;\n    height: 2px;\n    width: 30px;\n    display: block;\n    margin-bottom: 5px;\n    background-color: #ffffff;\n    -webkit-transition: all 300ms ease;\n    -moz-transition: all 300ms ease;\n    -ms-transition: all 300ms ease;\n    -o-transition: all 300ms ease;\n    transition: all 300ms ease;\n  }\n  \n  .menu-area .mobile-nav-toggler .icon-bar:last-child{\n    margin-bottom: 0px;\n  }\n  \n  /** megamenu-style **/\n  \n   .main-menu .navigation > li.dropdown > .megamenu{\n    position: absolute;\n    width: 100%;\n    padding: 30px 50px;\n    left: 0px;\n  }\n  \n   .main-menu .navigation li.dropdown .megamenu li h4{\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 600;\n    padding: 3px 0px;\n    color: #fff;\n  }\n  \n  \n  /** mobile-menu **/\n  \n  .nav-outer .mobile-nav-toggler{\n    position: relative;\n    float: right;\n    font-size: 40px;\n    line-height: 50px;\n    cursor: pointer;\n    color:#3786ff;\n    display: none;\n  }\n  \n  .mobile-menu{\n    position: fixed;\n    right: 0;\n    top: 0;\n    width: 300px;\n    padding-right:30px;\n    max-width:100%;\n    height: 100%;\n    opacity: 0;\n    visibility: hidden;\n    z-index: 999999;\n  }\n  \n  .mobile-menu .navbar-collapse{\n    display:block !important; \n  }\n  \n  .mobile-menu .nav-logo{\n    position:relative;\n    padding:3px 109px 0px;\n    text-align:left;  \n  }\n  \n  .mobile-menu-visible{\n    overflow: hidden;\n  }\n  \n  .mobile-menu-visible .mobile-menu{\n    opacity: 1;\n    visibility: visible;\n  }\n  \n  .mobile-menu .menu-backdrop{\n    position: fixed;\n    right: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    -webkit-transform: translateX(101%);\n    -ms-transform: translateX(101%);\n    transform: translateX(101%);\n    transition: all 900ms ease;\n    -moz-transition: all 900ms ease;\n    -webkit-transition: all 900ms ease;\n    -ms-transition: all 900ms ease;\n    -o-transition: all 900ms ease;\n  }\n  \n  .mobile-menu-visible .mobile-menu .menu-backdrop{\n    opacity: 0.70;\n    visibility: visible;\n    -webkit-transition:all 0.7s ease;\n    -moz-transition:all 0.7s ease;\n    -ms-transition:all 0.7s ease;\n    -o-transition:all 0.7s ease;\n    transition:all 0.7s ease;\n    -webkit-transform: translateX(0%);\n    -ms-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n  \n  .mobile-menu .menu-box{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    max-height: 100%;\n    overflow-y: auto;\n    background: #002c5d;\n    padding: 0px 0px;\n    z-index: 5;\n    opacity: 0;\n    visibility: hidden;\n    border-radius: 0px;\n    -webkit-transform: translateX(101%);\n    -ms-transform: translateX(101%);\n    transform: translateX(101%);\n  }\n  \n  .mobile-menu-visible .mobile-menu .menu-box{\n    opacity: 1;\n    visibility: visible;\n    -webkit-transition:all 0.7s ease;\n    -moz-transition:all 0.7s ease;\n    -ms-transition:all 0.7s ease;\n    -o-transition:all 0.7s ease;\n    transition:all 0.7s ease;\n    -webkit-transform: translateX(0%);\n    -ms-transform: translateX(0%);\n    transform: translateX(0%);\n  }\n  \n  .mobile-menu .close-btn{\n    position: absolute;\n    right: 15px;\n    top: 15px;\n    width: 30px;\n    height: 30px;\n    line-height: 28px;\n    border: 2px solid #fff;\n    border-radius: 50%;\n    text-align: center;\n    font-size: 15px;\n    color: #ffffff;\n    cursor: pointer;\n    z-index: 10;\n    -webkit-transition:all 0.9s ease;\n    -moz-transition:all 0.9s ease;\n    -ms-transition:all 0.9s ease;\n    -o-transition:all 0.9s ease;\n    transition:all 0.9s ease;\n  }\n  \n  .mobile-menu-visible .mobile-menu .close-btn{\n    -webkit-transform:rotate(360deg);\n    -ms-transform:rotate(360deg);\n    transform:rotate(360deg);\n  }\n  \n  .mobile-menu .close-btn:hover{\n    -webkit-transform:rotate(90deg);\n    -ms-transform:rotate(90deg);\n    transform:rotate(90deg);\n  }\n  \n  .mobile-menu .navigation{\n    position: relative;\n    display: block;\n    width: 100%;\n    float: none;\n  }\n  \n  .mobile-menu .navigation li{\n    position: relative;\n    display: block;\n    border-top: 1px solid rgba(255,255,255,0.10);\n  }\n  \n  .mobile-menu .navigation:last-child{\n    border-bottom: 1px solid rgba(255,255,255,0.10);\n  }\n  \n  .mobile-menu .navigation li > ul > li:first-child{\n    border-top: 1px solid rgba(255,255,255,0.10);\n  }\n  \n  .mobile-menu .navigation li > a{\n    position: relative;\n    display: block;\n    line-height: 24px;\n    padding: 10px 25px;\n    font-size: 15px;\n    font-weight: 500;\n    color: #ffffff;\n    text-transform: uppercase;\n    -webkit-transition: all 500ms ease;\n    -moz-transition: all 500ms ease;\n    -ms-transition: all 500ms ease;\n    -o-transition: all 500ms ease;\n    transition: all 500ms ease; \n  }\n  \n  .mobile-menu .navigation li ul li > a{\n    font-size: 16px;\n    margin-left: 20px;\n    text-transform: capitalize;\n  }\n  \n  .mobile-menu .navigation li > a:before{\n    content:'';\n    position:absolute;\n    left:0;\n    top:0;\n    height:0;\n    border-left:5px solid #fff;\n    -webkit-transition: all 500ms ease;\n    -moz-transition: all 500ms ease;\n    -ms-transition: all 500ms ease;\n    -o-transition: all 500ms ease;\n    transition: all 500ms ease; \n  }\n  \n  .mobile-menu .navigation li.current > a:before{\n    height:100%;\n  }\n  \n  .mobile-menu .navigation li.dropdown .dropdown-btn{\n    position:absolute;\n    right:6px;\n    top:6px;\n    width:32px;\n    height:32px;\n    text-align:center;\n    font-size:16px;\n    line-height:32px;\n    color:#ffffff;\n    background:rgba(255,255,255,0.10);\n    cursor:pointer;\n    border-radius:2px;\n    -webkit-transition: all 500ms ease;\n    -moz-transition: all 500ms ease;\n    -ms-transition: all 500ms ease;\n    -o-transition: all 500ms ease;\n    transition: all 500ms ease; \n    z-index:5;\n  }\n  \n  .mobile-menu .navigation li.dropdown .dropdown-btn.open{\n    background:#fff; \n    color: #3b3b3b;\n    -webkit-transform:rotate(90deg);\n    -ms-transform:rotate(90deg);\n    transform:rotate(90deg);  \n  }\n  \n  .mobile-menu .navigation li > ul,\n  .mobile-menu .navigation li > ul > li > ul,\n  .mobile-menu .navigation > li.dropdown > .megamenu{\n    display: none;\n  }\n  \n  .mobile-menu .social-links{\n    position:relative;\n    padding:30px 25px;\n  }\n  \n  .mobile-menu .social-links li{\n    position:relative;\n    display:inline-block;\n    margin:0px 10px 10px;\n  }\n  \n  .mobile-menu .social-links li a{\n    position:relative;\n    line-height:32px;\n    font-size:16px;\n    color:#ffffff;\n    -webkit-transition: all 500ms ease;\n    -moz-transition: all 500ms ease;\n    -ms-transition: all 500ms ease;\n    -o-transition: all 500ms ease;\n    transition: all 500ms ease; \n  }\n  \n  .mobile-menu .social-links li a:hover{\n    \n  }\n  \n  div#mCSB_1_container{\n    top: 0px !important;\n  }\n  \n  .mobile-menu .contact-info {\n    position: relative;\n    padding: 80px 30px 20px 30px;\n  }\n  \n  .mobile-menu .contact-info h4 {\n    position: relative;\n    font-size: 20px;\n    color: #ffffff;\n    font-weight: 700;\n    margin-bottom: 20px;\n  }\n  \n  .mobile-menu .contact-info ul li {\n    position: relative;\n    display: block;\n    font-size: 15px;\n    color: rgba(255,255,255,0.80);\n    margin-bottom: 3px;\n  }\n  \n  .mobile-menu .contact-info ul li a{\n    color: rgba(255,255,255,0.80);\n  }\n  \n  .mobile-menu .contact-info ul li a:hover{\n    \n  }\n  \n  .mobile-menu .contact-info ul li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  \n  /** search pop-up style **/\n  \n  \n  .main-header .search-btn .search-toggler{\n    position: relative;\n    font-size: 22px;\n    color: #222;\n    font-weight: 400;\n    background: transparent;\n    cursor: pointer;\n    display: inline-block;\n    transition: all 500ms ease;\n  }\n  \n  .main-header .search-btn .search-toggler{\n    \n  }\n  \n  .search-popup{\n    position:fixed;\n    left:0;\n    top:0px;\n    width:100%;\n    height:100%;\n    z-index:99999;\n    visibility:hidden;\n    opacity:0;\n    overflow:auto;\n    background: rgba(0, 0, 0, 0.9);\n    -webkit-transform:translateY(101%);\n    -ms-transform:translateY(101%);\n    transform:translateY(101%);\n    transition:all 700ms ease;\n    -moz-transition:all 700ms ease;\n    -webkit-transition:all 700ms ease;\n    -ms-transition:all 700ms ease;\n    -o-transition:all 700ms ease;\n  }\n  \n  .search-popup.popup-visible{\n    -webkit-transform:translateY(0%);\n    -ms-transform:translateY(0%);\n    transform:translateY(0%);\n    visibility:visible;\n    opacity:1;\n  }\n  \n  .search-popup .overlay-layer{\n    position:absolute;\n    left:0px;\n    top:0px;\n    right:0px;\n    bottom:0px;\n    display:block;\n  }\n  \n  .search-popup .close-search{\n    position:absolute;\n    right:25px;\n    top:25px;\n    width: 30px;\n    height: 30px;\n    line-height: 26px;\n    text-align: center;\n    border: 2px solid #fff;\n    border-radius: 50%;\n    font-size:10px;\n    font-weight: 700;\n    color:#ffffff;\n    cursor:pointer;\n    z-index:5;\n    transition: all 500ms ease;\n  }\n  \n  .search-popup .close-search:hover{\n  \n  }\n  \n  .search-popup .search-form{\n    position: relative;\n    padding: 0px 15px 0px;\n    max-width: 1024px;\n    margin: 0 auto;\n    margin-top: 150px;\n    margin-bottom: 100px;\n    opacity: 0;\n    -webkit-transform: translateY(50px);\n    -ms-transform: translateY(50px);\n    transform: translateY(50px);\n    z-index: 10;\n  }\n  \n  .search-popup.popup-visible .search-form {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    transform: translateY(0px);\n    transition: all 500ms ease 500ms;\n    -moz-transition: all 900ms ease 500ms;\n    -webkit-transition: all 900ms ease 500ms;\n    -ms-transition: all 900ms ease 500ms;\n    -o-transition: all 900ms ease 500ms;\n  }\n  \n  .search-popup .search-form .form-group{\n    margin-bottom: 30px;\n  }\n  \n  .search-popup .search-form fieldset{\n    position:relative;\n    border-radius:12px;\n  }\n  \n  .search-popup .search-form fieldset input[type=\"search\"]{\n    position:relative;\n    height:70px;\n    padding:20px 250px 20px 30px;\n    background:#ffffff;\n    line-height:30px;\n    font-size:24px;\n    color:#233145;\n    border-radius:7px;\n    box-shadow: none;\n    outline: none;\n    border: none;\n  }\n  \n  .search-popup .search-form fieldset input[type=\"submit\"]{\n    position:absolute;\n    display:block;\n    right:0px;\n    top:0px;\n    text-align:center;\n    width:220px;\n    height:70px;\n    padding:20px 10px 20px 10px;\n    color:#ffffff !important;\n    line-height:30px;\n    font-size:20px;\n    cursor:pointer;\n    text-transform:uppercase;\n    border-radius:0px 7px 7px 0px;\n  }\n  \n  .search-popup .search-form fieldset input[type=\"submit\"]:hover{\n    transform: translateY(0px);\n  }\n  \n  .search-popup h3{\n    text-transform:uppercase;\n    font-size:20px;\n    font-weight:600;\n    color:#ffffff;\n    margin-bottom:20px;\n    letter-spacing:1px;\n    text-align:center;  \n  }\n  \n  .search-popup .recent-searches{\n    font-size:16px;\n    color:#ffffff;\n    text-align:center;\n  }\n  \n  .search-popup .recent-searches li{\n    display:inline-block;\n    margin:0px 10px 10px 0px; \n  }\n  \n  .search-popup .recent-searches li a{\n    display:block;\n    line-height:24px;\n    border:1px solid #ffffff;\n    padding:7px 15px;\n    color:#ffffff;\n    border-radius:3px;\n    -webkit-transition:all 0.5s ease;\n    -moz-transition:all 0.5s ease;\n    -ms-transition:all 0.5s ease;\n    -o-transition:all 0.5s ease;\n    transition:all 0.5s ease;\n  }\n  \n  .search-popup .recent-searches li a:hover{\n    \n  }\n  #logo_nav{\n    padding: 5px !important;\n  }\n  .sticky-header .logo-box{\n    padding: 0 24px 14px 0    !important;\n    float: left !important;\n  }\n  \n  .sticky-header  .main-menu .navigation > li{\n    padding: 24px 0px 21px 0px !important;\n  }\n  \n  .sticky-header .menu-right-content{\n    margin-top: 9px !important;\n  }\n  \n  \n  /** banner-section **/\n  \n  .banner-section{\n    position: relative;\n    background: #001b4421;\n  }\n  \n  .banner-carousel{\n    position: relative;\n  }\n  \n  .banner-section.style-one .banner-carousel .slide-item{\n    position: relative;\n    overflow: hidden;;\n  }\n  \n  .banner-section.style-one .banner-carousel .slide-item{\n    padding: 171px 0px 180px 0px;\n    min-height: 877px;\n  }\n  \n  .banner-carousel .slide-item.style-two .content-box{\n    padding-left: 60px;\n  }\n  \n  .banner-section.style-one .banner-carousel .slide-item .image-layer{\n    position:absolute;\n    right:0;\n    width:43%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n  }\n  \n  .banner-section .banner-carousel .slide-item .image-layer{\n    position:absolute;\n    top:0;\n    height:100%;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    -webkit-transform:scale(1);\n    -ms-transform:scale(1);\n    transform:scale(1);\n    -webkit-transition: all 6000ms linear;\n    -moz-transition: all 6000ms linear;\n    -ms-transition: all 6000ms linear;\n    -o-transition: all 6000ms linear;\n    transition: all 6000ms linear;\n  }\n  \n  .banner-section .banner-carousel .active .slide-item .image-layer{\n    -webkit-transform:scale(1.15);\n    -ms-transform:scale(1.15);\n    transform:scale(1.15);\n  }\n  \n  .banner-section.style-one .banner-carousel .slide-item.style-two .image-layer{\n    right: inherit;\n    left: 0;\n  }\n  \n  .banner-carousel .content-box{\n    position: relative;\n    display: block;\n    z-index:5;\n    width: 100%;\n  }\n  \n  .banner-carousel .content-box span{\n    position: relative;\n    display: inline-block;\n    font-size: 15px;\n    line-height: 20px;\n    font-weight: 700;\n    margin-bottom: 13px;\n    text-transform: uppercase;\n    opacity: 0;\n    -webkit-transform: translateY(-100px);\n    -moz-transform: translateY(-100px);\n    -ms-transform: translateY(-100px);\n    -o-transform: translateY(-100px);\n    transform: translateY(-100px);\n    -webkit-transition: all 700ms ease;\n    -moz-transition: all 700ms ease;\n    -ms-transition: all 700ms ease;\n    -o-transition: all 700ms ease;\n    transition: all 700ms ease;\n  }\n  \n  .banner-carousel .active .content-box span{\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    -webkit-transition-delay: 700ms;\n    -moz-transition-delay: 700ms;\n    -ms-transition-delay: 700ms;\n    -o-transition-delay: 700ms;\n    transition-delay: 700ms;\n  }\n  \n  .banner-carousel .content-box h1{\n    position: relative;\n    display: block;\n    font-size: 60px;\n    line-height: 68px;\n    font-weight: 800;\n    margin-bottom: 23px;\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n    -moz-transform: translateX(100px);\n    -ms-transform: translateX(100px);\n    -o-transform: translateX(100px);\n    transform: translateX(100px);\n    -webkit-transition: all 1000ms ease;\n    -moz-transition: all 1000ms ease;\n    -ms-transition: all 1000ms ease;\n    -o-transition: all 1000ms ease;\n    transition: all 1000ms ease;\n  }\n  \n  .banner-carousel .active .content-box h1{\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n    -webkit-transition-delay: 1000ms;\n    -moz-transition-delay: 1000ms;\n    -ms-transition-delay: 1000ms;\n    -o-transition-delay: 1000ms;\n    transition-delay: 1000ms;\n  }\n  \n  .banner-carousel .content-box p{\n    position: relative;\n    display: block;\n    color: #002c5d;\n    font-size: 18px;\n    line-height: 30px;\n    font-weight: 500;\n    margin-bottom: 41px;\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n    -moz-transform: translateX(-100px);\n    -ms-transform: translateX(-100px);\n    -o-transform: translateX(-100px);\n    transform: translateX(-100px);\n    -webkit-transition: all 1300ms ease;\n    -moz-transition: all 1300ms ease;\n    -ms-transition: all 1300ms ease;\n    -o-transition: all 1300ms ease;\n    transition: all 1300ms ease;\n  }\n  \n  .banner-carousel .active .content-box p{\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n    -webkit-transition-delay: 1300ms;\n    -moz-transition-delay: 1300ms;\n    -ms-transition-delay: 1300ms;\n    -o-transition-delay: 1300ms;\n    transition-delay: 1300ms;\n  }\n  \n  .banner-carousel .content-box .btn-box{\n    position: relative;\n    opacity: 0;\n    -webkit-transform: translateY(100px);\n    -moz-transform: translateY(100px);\n    -ms-transform: translateY(100px);\n    -o-transform: translateY(100px);\n    transform: translateY(100px);\n    -webkit-transition: all 1600ms ease;\n    -moz-transition: all 1600ms ease;\n    -ms-transition: all 1600ms ease;\n    -o-transition: all 1600ms ease;\n    transition: all 1600ms ease;\n  }\n  \n  .banner-carousel .active .content-box .btn-box{\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n    -webkit-transition-delay: 1600ms;\n    -moz-transition-delay: 1600ms;\n    -ms-transition-delay: 1600ms;\n    -o-transition-delay: 1600ms;\n    transition-delay: 1600ms;\n  }\n  \n  .owl-dots-none .owl-dots,\n  .owl-nav-none .owl-nav{\n    display: none !important;\n  }\n  \n  .banner-carousel .slide-item.style-one .content-box .pattern-layer .pattern-1{\n    position: absolute;\n    left: -130px;\n    top: -80px;\n    width: 300px;\n    height: 300px;\n    background: #e5dbd5;\n    border-radius: 50%;\n  }\n  \n  .banner-carousel .slide-item.style-one .pattern-layer .pattern-1{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 57%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n  \n  .banner-carousel .slide-item.style-one .pattern-layer .pattern-2{\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    width: 43%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n  \n  .banner-carousel .slide-item.style-two .pattern-layer .pattern-1{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 43%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n  \n  .banner-carousel .slide-item.style-two .pattern-layer .pattern-2{\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    width: 57%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n  \n  .bg-color-1{\n    background: #001b44;\n  }\n  \n  \n  \n  /** clients-section **/\n  \n  .clients-section{\n    position: relative;\n  }\n  \n  .clients-section .clients-logo-box{\n    position: relative;\n    display: block;\n    background: #001b44;\n    padding: 50px 0px;\n    border-right: 1px solid rgba(255,255,255,0.2);\n    margin-bottom: 28px;\n  }\n  \n  .clients-section .clients-logo-box img{\n    display: block;\n    max-width: 100%;\n    width: auto;\n    margin: 0 auto;\n    -webkit-transition: all 300ms ease;\n    -moz-transition: all 300ms ease;\n    -ms-transition: all 300ms ease;\n    -o-transition: all 300ms ease;\n    transition: all 300ms ease;\n  }\n  \n  .clients-section .clients-logo-box .logo-title{\n    position: absolute;\n    left: 40px;\n    bottom: -38px;\n    width: calc(100% - 80px);\n    background: #001b4421;\n    text-align: center;\n    border-radius: 5px;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 500ms ease;\n  }\n  \n  .clients-section .clients-logo-box:hover .logo-title{\n    bottom: -28px;\n    opacity: 1;\n    visibility: visible;\n  }\n  \n  .clients-section .clients-logo-box .logo-title:before{\n    position: absolute;\n    content: '';\n    background: #001b4421;\n    width: 20px;\n    height: 20px;\n    left: 50%;\n    margin-left: -13px;\n    top: -8px;\n    transform: rotate(45deg);\n  }\n  \n  .clients-section .clients-logo-box .logo-title a{\n    position: relative;\n    display: block;\n    padding: 15px 20px 11px 20px;\n    font-size: 16px;\n    line-height: 30px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 600;\n    color: #001b44;\n    z-index: 1;\n  }\n  \n  \n  /** welcome-section **/\n  \n  .welcome-section{\n    position: relative;\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .welcome-section .image-box{\n    position: relative;\n    display: block;\n    margin-top: 6px;\n  }\n  \n  .welcome-section .image-box img{\n    width: 100%;\n  }\n  \n  .tabs-box .tab{\n    position:relative;\n    display:none;\n    transition: all 900ms ease;\n    -moz-transition: all 900ms ease;\n    -webkit-transition: all 900ms ease;\n    -ms-transition: all 900ms ease;\n    -o-transition: all 900ms ease;\n  }\n  \n  .tabs-box .tab.active-tab{\n    display:block;  \n  }\n  \n  .tabs-box .tab{\n    transform:scale(0.9,0.9) translateY(0px);\n  }\n  \n  .tabs-box .tab.active-tab{\n    transform:scale(1) translateY(0px);\n  }\n  \n  .tabs-box-2 .tab-2{\n    position:relative;\n    display:none;\n    transition: all 900ms ease;\n    -moz-transition: all 900ms ease;\n    -webkit-transition: all 900ms ease;\n    -ms-transition: all 900ms ease;\n    -o-transition: all 900ms ease;\n  }\n  \n  .tabs-box-2 .tab-2.active-tab-2{\n    display:block;  \n  }\n  \n  .tabs-box-2 .tab-2{\n    transform:scale(0.9,0.9) translateY(0px);\n  }\n  \n  .tabs-box-2 .tab-2.active-tab-2{\n    transform:scale(1) translateY(0px);\n  }\n  \n  #content_block_1 .content-box{\n    position: relative;\n    display: block;\n  }\n  \n  #content_block_1 .content-box .tab-btn-box{\n    position: relative;\n    margin-bottom: 43px;\n  }\n  \n  #content_block_1 .content-box .tab-btns li{\n    position: relative;\n    display: inline-block;\n    float: left;\n    background: #001b4421;\n    padding: 25px 70px 25px 70px;\n    border-radius: 5px;\n    width: 270px;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  #content_block_1 .content-box .tab-btns li:after{\n    position: absolute;\n    content: '';\n    background: #d9cec7;\n    width: 1px;\n    height: 30px;\n    right: 50px;\n    top: 14px;\n    }\n  \n  #content_block_1 .content-box .tab-btns li:hover{\n    background: #002c5d;\n    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);\n    color: white;\n  }\n  #content_block_1 .content-box .tab-btns li.active-btn\n {\n     background: #fff; \n     box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  #content_block_1 .content-box .tab-btns li.active-btn:hover\n  {\n      background: #002c5d; \n      box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);\n   }\n  #content_block_1 .content-box .tab-btns li:last-child{\n    float: right;\n  }\n  \n  #content_block_1 .content-box .tab-btns li i.employ-icon{\n    position: absolute;\n    left: 20px;\n    top: 20px;\n    font-size: 30px;\n    color: #001b44;\n    transition: all 500ms ease;\n  }\n  \n  #content_block_1 .content-box .tab-btns li h5{\n    font-size: 18px;\n    line-height: 25px;\n    font-weight: 600;\n  }\n  \n  #content_block_1 .content-box .tab-btns li i.arrow-icon{\n    position: absolute;\n    top: 12px;\n    right: 17px;\n    font-size: 20px;\n    color: #b4a4a4;\n    transition: all 500ms ease;\n  }\n  \n \n  #content_block_1 .content-box .tab-btns li.active-btn i.bi{\n    transform: rotate(180deg) !important;\n  }\n  \n  #content_block_1 .content-box .inner-box h5{\n    font-size: 18px;\n    line-height: 28px;\n    margin-bottom: 14px;\n    font-weight: 600;\n  }\n  \n  #content_block_1 .content-box .inner-box h2{\n    font-size: 36px;\n    line-height: 44px;\n    font-weight: 700;\n    margin-bottom: 22px;\n  }\n  \n  #content_block_1 .content-box .inner-box p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    margin-bottom: 38px;\n  }\n  \n  #content_block_1 .content-box .inner-box .list li{\n    position: relative;\n    display: inline-block;\n    float: left;\n    width: 50%;\n    padding: 0px 0px 0px 85px;\n  }\n  \n  #content_block_1 .content-box .inner-box .list li .icon-box{\n    position: absolute;\n    left: 0px;\n    top: -6px;\n  }\n  \n  #content_block_1 .content-box .inner-box .list li h4{\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 700;\n  }\n  \n  #content_block_1 .content-box .inner-box .list{\n    margin-bottom: 41px;\n  }\n  \n  #content_block_1 .content-box .inner-box .link a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #001b44;\n    text-transform: uppercase;\n  }\n  \n  #content_block_1 .content-box .inner-box .link a i{\n    position: relative;\n    font-size: 30px;\n    margin-right: 8px;\n    font-weight: 400;\n    top: 6px;\n  }\n  \n  #content_block_1 .content-box .tabs-content .inner-box .link a:hover{\n  \n  }\n  \n  .welcome-section .sec-title{\n    margin-bottom: 53px;\n  }\n  \n  \n  /** about-section **/\n  \n  .about-section{\n    position: relative;\n  }\n  \n  .about-section .inner-container{\n    position: relative;\n    display: block;\n    background: #fff;\n    overflow: hidden;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n  }\n  \n  .about-section #content_block_2 .content-box{\n    margin-right: 30px;\n  }\n  \n  #content_block_2 .content-box{\n    position: relative;\n    display: block;\n    overflow: hidden;\n  }\n  \n  #content_block_2 .content-box .image-box{\n    position: relative;\n    display: block;\n    overflow: hidden;\n  }\n  \n  #content_block_2 .content-box .image-box img{\n    width: 100%;\n  }\n  \n  #content_block_2 .content-box .inner-box{\n    position: relative;\n    background: #001b44;\n    padding: 67px 30px;\n  }\n  \n  #content_block_2 .content-box .image-box:before{\n    position: absolute;\n    top: 0;\n    left: -75%;\n    display: block;\n    content: '';\n    width: 50%;\n    height: 100%;\n    background: -o-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .3) 100%);\n    background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), to(rgba(255, 255, 255, .3)));\n    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .3) 100%);\n    -webkit-transform: skewX(-25deg);\n    -ms-transform: skewX(-25deg);\n    transform: skewX(-25deg);\n  }\n  \n  #content_block_2 .content-box:hover .image-box:before{\n    -webkit-animation: shine 1s;\n    animation: shine 1s;\n  }\n  \n  @-webkit-keyframes shine {\n    100% {\n      left: 125%;\n    }\n  }\n  \n  @keyframes shine {\n    100% {\n      left: 125%;\n    }\n  }\n  \n  #content_block_2 .content-box .inner-box .icon-box{\n    position: relative;\n    display: inline-block;\n    margin-bottom: 23px;\n  }\n  \n  #content_block_2 .content-box .inner-box h3{\n    display: block;\n    font-size: 24px;\n    line-height: 32px;\n    color: #fff;\n    font-weight: 700;\n    margin-bottom: 27px;\n  }\n  \n  #content_block_2 .content-box .inner-box a, #Button_react{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #fff;\n    font-weight: 700;\n    border-radius: 5px;\n    text-transform: uppercase;\n    padding: 15px 65px 13px 20px;\n  }\n  \n  #content_block_2 .content-box .inner-box a i, #Button_react i{\n    position: absolute;\n    top: 14px;\n    right: 11px;\n    font-size: 24px;\n    font-weight: 400;\n  }\n  \n  #content_block_2 .content-box .inner-box a:before, #Button_react:before{\n    position: absolute;\n    content: '';\n    background: #001b44;\n    width: 2px;\n    height: 100%;\n    right: 46px;\n    top: 0px;\n  }\n  \n  .about-section #content_block_3 .content-box{\n    position: relative;\n    padding: 95px 60px 100px 0px;\n  }\n  \n  #content_block_3 .content-box .text p{\n    font-size: 17px;\n  }\n  \n  #content_block_3 .content-box .text{\n    margin-bottom: 30px;\n  }\n  \n  #content_block_3 .content-box .link a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #001b44;\n    text-transform: uppercase;\n  }\n  \n  #content_block_3 .content-box .link a i{\n    position: relative;\n    font-size: 30px;\n    margin-right: 8px;\n    font-weight: 400;\n    top: 6px;\n  }\n  \n  #content_block_3 .content-box .link a:hover{\n  \n  }\n  \n  #content_block_3 .content-box .link{\n    position: relative;\n    margin-bottom: 41px;\n  }\n  \n  #content_block_3 .content-box .author-text{\n    position: relative;\n    display: block;\n    background: #001b4421;\n    padding: 41px 28px 0 69px;\n    border-radius: 100px 100px 100px 0px;\n    margin-bottom: 20px;\n    min-height: 130px;\n  }\n  \n  #content_block_3 .content-box .author-text:before{\n    position: absolute;\n    content: '';\n    background: #001b4421;\n    width: 40px;\n    height: 40px;\n    left: 0px;\n    bottom: -40px;\n    clip-path: polygon(0% 0%, 100% 0%, 0% 100%, 0% 100%, 0% 0%);\n  }\n  \n  #content_block_3 .content-box .author-text h3{\n    position: relative;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n  }\n  \n  #content_block_3 .content-box .author-text h3:before{\n    position: absolute;\n    content: '';\n    width: 3px;\n    height: 70px;\n    left: -42px;\n    top: -2px;\n  }\n  \n  #content_block_3 .content-box .author-text h3:after{\n    position: absolute;\n    content: '';\n    width: 3px;\n    height: 35px;\n    left: -33px;\n    top: -2px;\n  }\n  \n  #content_block_3 .content-box .author-info{\n    position: relative;\n    display: block;\n    padding: 3px 0px 10px 100px;\n  }\n  \n  #content_block_3 .content-box .author-info .author-thumb{\n    position: absolute;\n    left: 20px;\n    top: 0px;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n  }\n  \n  #content_block_3 .content-box .author-info .author-thumb img{\n    width: 100%;\n    border-radius: 50%;\n  }\n  \n  #content_block_3 .content-box .author-info h4{\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 700;\n  }\n  \n  #content_block_3 .content-box .author-info .designation{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    color: #002c5d;\n  }\n  \n  #content_block_3 .content-box .author-info .signature{\n    position: absolute;\n    top: 0px;\n    right: 50px;\n  }\n  \n  #content_block_3 .content-box .sec-title{\n    margin-bottom: 30px;\n  }\n  \n  .about-section .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 423px;\n    right: 0px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: bottom center;\n    width: 100%;\n    height: 380px;\n  }\n  \n  \n  /** service-section **/\n  \n  .service-section{\n    position: relative;\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .service-block-one{\n    margin-top: 20px;\n  }\n  \n  .service-block-one .inner-box{\n    position: relative;\n    display: block;\n    text-align: center;\n  }\n  \n  .service-block-one .inner-box .image-box{\n    position: relative;\n    display: block;\n    overflow: hidden;\n    border-radius: 10px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .service-block-one .inner-box .image-box img{\n    width: 100%;\n    border-radius: 10px;\n    transition: all 500ms ease;\n  }\n  \n  .service-block-one .inner-box:hover .image-box img{\n    transform: scale(1.1);\n  }\n  \n  .service-block-one .inner-box .lower-content{\n    position: relative;\n    padding: 0px 70px;\n  }\n  \n  .service-block-one .inner-box .lower-content .content-box{\n    position: relative;\n    margin-top: -117px;\n    transition: all 500ms ease;\n  }\n  \n  .service-block-one .inner-box:hover .lower-content .content-box{\n    opacity: 0;\n  }\n  \n  .service-block-one .inner-box .lower-content .content-box .inner{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 10px;\n    padding: 67px 15px 22px 15px;\n    margin-bottom: 21px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .service-block-one .inner-box .lower-content .content-box .inner .icon-box{\n    position: relative;\n    display: inline-block;\n    margin-bottom: 12px;\n  }\n  \n  .service-block-one .inner-box .lower-content .content-box .inner h4{\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n  }\n  \n  .service-block-one .inner-box .lower-content .content-box .link a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #001b44;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  .service-block-one .inner-box .lower-content .overlay-content{\n    position: absolute;\n    left: 30px;\n    top: 30px;\n    background: #001b44;\n    border-radius: 10px;\n    width: calc(100% - 60px);\n    overflow: hidden;\n    visibility: hidden;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .service-block-one .inner-box:hover .lower-content .overlay-content{\n    top: 0px;\n    opacity: 1;\n    visibility: visible;\n  }\n  \n  .service-block-one .inner-box .lower-content .overlay-content p{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    color: rgba(255, 255, 255, 0.744);\n    font-weight: 500;\n    padding: 30px 15px 32px 15px;\n    text-align: justify;\n  }\n  \n  .service-block-one .inner-box .lower-content .overlay-content a{\n    position: relative;\n    display: block;\n    padding: 6px 15px 13px 15px;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #fff;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  .service-block-one .inner-box .lower-content .overlay-content a i{\n    position: relative;\n    font-size: 30px;\n    margin-right: 8px;\n    font-weight: 400;\n    top: 6px;\n  }\n  \n  .service-section .pattern-layer{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    right: 0px;\n    width: 100%;\n    height: 580px;\n    background-size: cover;\n    background-repeat: no-repeat;\n  }\n  \n  .service-section .sec-title{\n    margin-bottom: 33px;\n  }\n  \n  .service-section .owl-dots{\n    position: relative;\n    display: block;\n    text-align: center;\n    margin-top: 40px;\n  }\n  \n  .owl-dot-style-one .owl-dots .owl-dot span{\n    position: relative;\n    display: inline-block;\n    width: 3px;\n    height: 10px;\n    background: #c2b3aa;\n    margin: 0px 5px;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .owl-dot-style-one .owl-dots .owl-dot.active span,\n  .owl-dot-style-one .owl-dots .owl-dot span:hover{\n    height: 20px;\n  }\n  \n  .service-section .anim-icon{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    max-width: 1200px;\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n  }\n  \n  .service-section .anim-icon .icon-1{\n    position: absolute;\n    left: -25px;\n    top: 45px;\n    width: 170px;\n    height: 250px;\n    background-repeat: no-repeat;\n  }\n  \n  .service-section .anim-icon .icon-2{\n    position: absolute;\n    top: 140px;\n    right: 130px;\n    background: #001b4421;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    -webkit-animation: zoom-fade 5s infinite linear;\n    animation: zoom-fade 5s infinite linear;\n  }\n  \n  \n  /** recruitment-technology **/\n  \n  .recruitment-technology{\n    position: relative;\n    padding: 0;\n  }\n  \n  .recruitment-technology .image-box{\n    position: relative;\n    display: block;\n    margin-right: -100px;\n  }\n  \n  .recruitment-technology .image-box img{\n    max-width: none;\n    float: right;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item{\n    position: relative;\n    display: block;\n    background: #fff;\n    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);\n    margin-bottom: 30px;\n    padding: 27px 30px 33px 30px;\n    border-radius: 10px;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item:last-child{\n    margin-bottom: 0px;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner{\n    position: relative;\n    padding-left: 100px;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner .icon-box{\n    position: absolute;\n    left: 0px;\n    top: 3px;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    padding-left: 82px;\n    margin-bottom: 8px;\n    transition: all 500ms ease;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner h3 a{\n    display: inline-block;\n    color: #001b44;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner h3 a:hover{\n  \n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner h3 a i{\n    position: relative;\n    font-size: 30px;\n    margin-left: 8px;\n    font-weight: 400;\n    top: 5px;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item:hover .inner h3 a i{\n    opacity: 1;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner h3 span{\n    position: absolute;\n    left: 0px;\n    top: 6px;\n    font-size: 20px;\n    transition: all 500ms ease;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item:hover .inner h3 span{\n    opacity: 0;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item:hover .inner h3{\n    padding-left: 0px;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item .inner h3:before{\n    position: absolute;\n    content: '';\n    width: 40px;\n    height: 2px;\n    left: 32px;\n    top: 19px;\n    transition: all 500ms ease;\n  }\n  \n  #content_block_4 .content-box .inner-box .single-item:hover .inner h3:before{\n    opacity: 0;\n  }\n  \n  #content_block_4 .content-box .sec-title{\n    margin-bottom: 43px;\n  }\n  \n  \n  /** industries-section **/\n  \n  .industries-section{\n    position: relative;\n    overflow: hidden;\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .industries-section .sec-title .top-title:before{\n    background: #624b52;\n  }\n  \n  .industries-section .sec-title .top-title:after{\n    background: #624b52;\n    border-left: 2px solid #001b44;\n    border-bottom: 2px solid #001b44;\n  }\n  \n  .industries-section .sec-title{\n    margin-bottom: 37px;\n  }\n  \n  .industries-section .tabs-content{\n    position: relative;\n    display: block;\n    margin: 35px -375px 0px 30px;\n  }\n  \n  .industries-section .tabs-content .image-box{\n    position: relative;\n    display: block;\n    border-radius: 10px;\n  }\n  \n  .industries-section .tabs-content .image-box:before{\n    position: absolute;\n    content: '';\n    background: -webkit-linear-gradient(-90deg, rgba(255, 0, 85, 0), #00183b 100%);\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n  }\n  \n  .industries-section .tabs-content .image-box img{\n    width: 100%;\n    border-radius: 10px;\n  }\n  \n  .industries-section .tabs-content .inner-box{\n    position: relative;\n  }\n  \n  .industries-section .tabs-content .inner-box .content-box{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    padding: 0px 70px;\n    width: 100%;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n  }\n  \n  .industries-section .tabs-content .inner-box .content-box .text h2{\n    position: relative;\n    display: block;\n    font-size: 36px;\n    line-height: 45px;\n    color: #fff;\n    font-weight: 700;\n    margin-bottom: 2px;\n  }\n  \n  .industries-section .tabs-content .inner-box .content-box .text span{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    color: #fff;\n    font-style: italic;\n    font-weight: 500;\n  }\n  \n  .industries-section .tabs-content .inner-box .content-box .link{\n    position: relative;\n    float: right;\n    margin-left: 60px;\n  }\n  \n  .industries-section .tabs-content .inner-box .content-box .link a{\n    position: relative;\n    display: inline-block;\n    font-size: 38px;\n    font-weight: 700;\n    color: #001b44;\n    width: 62px;\n    height: 62px;\n    line-height: 62px;\n    background: #fff;\n    text-align: center;\n    border-radius: 50%;\n    z-index: 1;\n  }\n  \n  .industries-section .tabs-content .inner-box .content-box .link a:hover{\n    color: #fff;\n  }\n  \n  .industries-section .tabs-content .inner-box .content-box .text{\n    position: relative;\n    display: inline-block;\n    margin-right: 60px;\n  }\n  \n  .industries-section .tabs-content .inner-box .content-box .line {\n    position: relative;\n    display: block;\n    height: 1px;\n    background: rgba(255,255,255,0.2);\n    width: calc(100% - 120px);\n    flex: 1;\n    top: 3px;\n  }\n  \n  .industries-section .tab-btns li{\n    position: relative;\n    display: block;\n    padding: 9px 0px 27px 70px;\n    cursor: pointer;\n    margin-bottom: 14px;\n    min-height: 50px;\n    transition: all 500ms ease;\n  }\n  \n  .industries-section .tab-btns li:before{\n    position: absolute;\n    content: '';\n    background: rgba(255,255,255,0.2);\n    width: 50px;\n    height: 1px;\n    left: 70px;\n    bottom: 0px;\n    transition: all 500ms ease;\n  }\n  \n  .industries-section .tab-btns li.active-btn:before,\n  .industries-section .tab-btns li:hover:before{\n    width: calc(100% - 70px);\n  }\n  \n  .industries-section .tab-btns li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .industries-section .tab-btns li .icon-box{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n  }\n  \n  .industries-section .tab-btns li h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    color: #fff;\n    font-weight: 700;\n    transition: all 500ms ease;\n  }\n  \n  .industries-section .tab-btns li.active-btn h3,\n  .industries-section .tab-btns li:hover h3{\n  \n  }\n  \n  .industries-section .pattern-layer{\n    position: absolute;\n    left: 10px;\n    top: -175px;\n    width: 1060px;\n    height: 1170px;\n    background-repeat: no-repeat;\n  }\n  \n  \n  /** process-section **/\n  \n  .process-section{\n    position: relative;\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .process-section .sec-title{\n    margin-bottom: 75px;\n  }\n  \n  .process-block-one .inner-box{\n    position: relative;\n    display: block;\n  }\n  \n  .process-block-one .inner-box:before{\n    position: absolute;\n    content: '';\n    /* background: url(../images/icons/arrow-1.png); */\n    width: 58px;\n    height: 70px;\n    top: 30px;\n    right: -45px;\n    background-repeat: no-repeat;\n  }\n  \n  .process-block:last-child .process-block-one .inner-box:before{\n    display: none;\n  }\n  \n  .process-block-one .inner-box .icon-box{\n    position: relative;\n    display: inline-block;\n    width: 146px;\n    height: 128px;\n    text-align: center;\n    line-height: 128px;\n    margin-bottom: 43px;\n    z-index: 1;\n  }\n  \n  .process-block-one .inner-box .icon-box:before{\n    position: absolute;\n    content: '';\n    /* background: url(../images/icons/icon-bg-1.png); */\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    background-repeat: no-repeat;\n    z-index: -1;\n  }\n  \n  .process-block-one .inner-box .icon-box:after{\n    position: absolute;\n    content: '';\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%);\n    z-index: -2;\n    box-shadow: 5px 5px 100px 30px black;\n  }\n  \n  .process-block-one .inner-box .icon-box span{\n    position: absolute;\n    top: -20px;\n    right: -30px;\n    width: 60px;\n    height: 60px;\n    line-height: 60px;\n    background: #fff;\n    font-size: 20px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    text-align: center;\n    border-radius: 50%;\n    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .process-block-one .inner-box .lower-content h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    margin-bottom: 10px;\n  }\n  \n  .process-block-one .inner-box .lower-content p{\n    font-size: 17px;\n    font-weight: 500;\n    margin-bottom: 13px;\n  }\n  \n  .process-block-one .inner-box .lower-content a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 24px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  .col-lg-4.col-md-6.col-sm-12.process-block:hover .process-block-one .inner-box .lower-content a {\n    color: #ff5956;\n  }\n  .single-award-block .inner-box:hover    {\n    background: #001b44;\n    color: white;\n    cursor: pointer;\n}\n \n.single-award-block:hover ul li p {\n  color: white;\n}\n.single-award-block:hover img {\ncolor: red ;  \n}\n  \n  .process-block-one .inner-box .icon-box .anim-icon .icon-1{\n    position: absolute;\n    left: -12px;\n    top: -20px;\n    width: 176px;\n    height: 158px;\n    background-repeat: no-repeat;\n    z-index: -2;\n  }\n  \n  .process-block-one .inner-box .icon-box .anim-icon .icon-2{\n    position: absolute;\n    left: -3px;\n    top: 10px;\n    width: 10px;\n    height: 11px;\n    background-repeat: no-repeat;\n  }\n  \n  .process-block-one .inner-box .icon-box .anim-icon .icon-3{\n    position: absolute;\n    right: -3px;\n    bottom: 10px;\n    width: 10px;\n    height: 11px;\n    background-repeat: no-repeat;\n  }\n  \n  \n  /** team-section **/\n  \n  .team-section{\n    position: relative;\n    padding: 95px 0px 100px 0px;\n  }\n  \n  .team-section .sec-title .top-title:before,\n  .team-section .sec-title .top-title:after{\n    background: #e2d7d0;\n  }\n  \n  .team-section .sec-title .top-title:after{\n    border-left: 2px solid #001b4421;\n    border-bottom: 2px solid #001b4421;\n  }\n  \n  .team-section .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 820px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background: bottom center;\n  }\n  \n  .progress-box .bar{\n    position:relative;\n    width:100%;\n    height:2px;\n    background:#d9cec7;\n    border-radius:0px;\n    margin-bottom:12px;\n  }\n  \n  .progress-box .bar:before{\n    position: absolute;\n    content: '';\n    width: 2px;\n    height: 14px;\n    left: 0px;\n    top: -6px;\n  }\n  \n  .progress-box .bar-inner{\n    position:relative;\n    display:block;\n    width:0px;\n    height:2px;\n    border-radius:3px;\n    -webkit-transition:all 1500ms ease;\n    -ms-transition:all 1500ms ease;\n    -o-transition:all 1500ms ease;\n    -moz-transition:all 1500ms ease;\n    transition:all 1500ms ease; \n  }\n  \n  .progress-box .bar-inner:before{\n    position: absolute;\n    content: '';\n    width: 2px;\n    height: 30px;\n    top: 0px;\n    right: 0px;\n  }\n  \n  .progress-box .count-text{\n    position:absolute;\n    top: 11px;\n    right: 11px;\n    font-size:16px;\n    color: #001b44;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    opacity:0;\n    -webkit-transition:all 500ms ease;\n    -ms-transition:all 500ms ease;\n    -o-transition:all 500ms ease;\n    -moz-transition:all 500ms ease;\n    transition:all 500ms ease;  \n  }\n  \n  .progress-box .bar-inner.counted .count-text{\n    opacity:1;  \n  }\n  \n  #content_block_5 .content-box .text{\n    margin-bottom: 48px;\n  }\n  \n  #content_block_5 .content-box .text p{\n    font-size: 17px;\n    font-weight: 500;\n  }\n  \n  .progress-box h6{\n    position: relative;\n    display: block;\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  .progress-box{\n    position: relative;\n    margin-bottom: 33px;\n  }\n  \n  #content_block_5 .content-box .link a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 24px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #001b44;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  #content_block_5 .content-box .link a i{\n    position: relative;\n    font-size: 30px;\n    margin-right: 8px;\n    font-weight: 400;\n    top: 6px;\n  }\n  \n  #content_block_5 .content-box .link a:hover{\n  \n  }\n  \n  .team-block-one .inner-box{\n    position: relative;\n    display: block;\n    margin-bottom: 22px;\n  }\n  \n  .team-block-one .inner-box .image-box{\n    position: relative;\n    display: block;\n    overflow: hidden;\n    border-radius: 20px;\n    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .team-block-one .inner-box .image-box:before{\n    position: absolute;\n    content: '';\n    background: #001b44;\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 0px;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .team-block-one .inner-box:hover .image-box:before{\n    opacity: 1;\n  }\n  \n  .team-block-one .inner-box .image-box img{\n    width: 100%;\n    border-radius: 20px;\n    transition: all 500ms ease;\n  }\n  \n  .team-block-one .inner-box:hover .image-box img{\n    opacity: 0.2;\n  }\n  \n  .team-block-one .inner-box .image-box .singature{\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%) rotate(-30deg);\n    font-size: 44px;\n    line-height: 50px;\n    font-family: 'Mrs Saint Delafield', cursive;\n    color: #fff;\n    font-weight: 400;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .team-block-one .inner-box:hover .image-box .singature{\n    opacity: 1;\n  }\n  \n  .team-block-one .inner-box .image-box .share-box{\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n    width: 96px;\n  }\n  \n  .team-block-one .inner-box .image-box .share-box p{\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n    background: #001b4421;\n    color: #001b44;\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 400;\n    text-transform: uppercase;\n    padding: 6px 10px;\n    text-align: center;\n    width: 100%;\n    cursor: pointer;\n    border-radius: 15px 0px 15px 0px;\n  }\n  \n  .team-block-one .inner-box .image-box .share-box p i{\n    margin-right: 8px;\n  }\n  \n  .team-block-one .inner-box .image-box .share-box .social-links{\n    position: absolute;\n    right: -144px;\n    bottom: 0px;\n    background: #001b4421;\n    text-align: center;\n    z-index: 1;\n    width: 144px;\n    border-radius: 15px 0px 15px 0px;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 500ms ease;\n  }\n  \n  .team-block-one .inner-box .image-box .share-box:hover .social-links{\n    right: 0px;\n    opacity: 1;\n    visibility: visible;\n  }\n  \n  .team-block-one .inner-box .image-box .share-box .social-links li{\n    position: relative;\n    display: inline-block;\n    float: left;\n    width: 25%;\n    border-right: 1px solid #d9cec7;\n  }\n  \n  .team-block-one .inner-box .image-box .share-box .social-links li:last-child{\n    border-right: none;\n  }\n  \n  .team-block-one .inner-box .image-box .share-box .social-links li a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    color: #001b44;\n    width: 100%;\n    height: 36px;\n    line-height: 36px;\n    text-align: center;\n  }\n  \n  .team-block-one .inner-box .image-box .share-box .social-links li a:hover{\n  \n  }\n  \n  .team-block-one .inner-box .lower-content{\n    position: relative;\n    display: block;\n    padding-top: 14px;\n    text-align: center;\n  }\n  \n  .team-block-one .inner-box .lower-content h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    margin-bottom: 0px;\n  }\n  \n  .team-block-one .inner-box .lower-content h3 a{\n    display: inline-block;\n    color: #001b44;\n  }\n  \n  .team-block-one .inner-box .lower-content h3 a:hover{\n  \n  }\n  \n  .team-block-one .inner-box .lower-content .designation{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    font-weight: 500;\n    margin: 0px;\n  }\n  \n  .team-section .inner-column{\n    padding-top: 35px;\n  }\n  \n  \n  /** news-section **/\n  \n  .news-section{\n    position: relative;\n    padding: 95px 0px 130px 0px;\n  }\n  \n  .news-block-one .inner-box{\n    position: relative;\n    display: block;\n  }\n  \n  .news-block-one .inner-box .image-box{\n    position: relative;\n    display: block;\n    overflow: hidden;\n    border-radius: 10px;\n  }\n  \n  .news-block-one .inner-box .image-box img{\n    width: 100%;\n    border-radius: 10px;\n    transition: all 500ms ease;\n  }\n  \n  .news-block-one .inner-box:hover .image-box img{\n    transform: scale(1.05);\n  }\n  \n  .news-block-one .inner-box .image-box:before{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    z-index: 1;\n    display: block;\n    content: '';\n    width: 0;\n    height: 0;\n    background: rgba(255,255,255,.2);\n    border-radius: 100%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    opacity: 0;\n  }\n  \n  .news-block-one .inner-box:hover .image-box::before{\n    -webkit-animation: circle .75s;\n    animation: circle .75s;\n  }\n  \n  @-webkit-keyframes circle {\n    0% {\n      opacity: 1;\n    }\n    40% {\n      opacity: 1;\n    }\n    100% {\n      width: 200%;\n      height: 200%;\n      opacity: 0;\n    }\n  }\n  @keyframes circle {\n    0% {\n      opacity: 1;\n    }\n    40% {\n      opacity: 1;\n    }\n    100% {\n      width: 200%;\n      height: 200%;\n      opacity: 0;\n    }\n  }\n  \n  .news-block-one .inner-box .image-box .post-date{\n    position: absolute;\n    right: 0px;\n    top: 30px;\n    width: 70px;\n    height: 70px;\n    line-height: 22px;\n    text-align: center;\n    font-size: 16px;\n    color: #fff;\n    font-weight: 700;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px 0px 0px 5px;\n  }\n  \n  .news-block-one .inner-box .lower-content{\n    position: relative;\n    padding-right: 30px;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner{\n    position: relative;\n    margin-top: -137px;\n    background: #001b44;\n    padding: 33px 30px 32px 30px;\n    border-radius: 0px 10px 0px 10px;\n    z-index: 2;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .category p{\n    position: relative;\n    display: inline-block;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #fff;\n    line-height: 12px;\n    border-bottom: 1px solid #d1cdcf;\n    margin: 0px;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .category i{\n    position: relative;\n    font-size: 20px;\n    margin-right: 8px;\n    top: 3px;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .category{\n    margin-bottom: 15px;\n    position: relative;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 32px;\n    color: #fff;\n    font-weight: 700;\n    margin-bottom: 14px;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner h3 a{\n    display: inline-block;\n    color: #fff;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner h3 a:hover{\n  \n  }\n  \n  .news-block-one .inner-box .lower-content .inner .post-info li{\n    position: relative;\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    padding-right: 12px;\n    margin-right: 11px;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .post-info li:last-child{\n    padding: 0px;\n    margin: 0px;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .post-info li a{\n    color: #fff;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .post-info li i{\n    margin-right: 10px;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .post-info li a:hover{\n  \n  }\n  \n  .news-block-one .inner-box .lower-content .inner .post-info li:before{\n    position: absolute;\n    content: '';\n    background: rgba(255,255,255,0.3);\n    top: 7px;\n    right: 0px;\n    height: 14px;\n    width: 1px;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .post-info li:after{\n    position: absolute;\n    content: '';\n    background: rgba(255,255,255,0.3);\n    top: 7px;\n    right: -3px;\n    height: 14px;\n    width: 1px;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner .post-info li:last-child:before,\n  .news-block-one .inner-box .lower-content .inner .post-info li:last-child:after{\n    display: none;\n  }\n  \n  .bg-color-2{\n    background: #001b4421;\n  }\n  \n  \n  /** testimonial-section **/\n  \n  .testimonial-section{\n    position: relative;\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .testimonial-section .sec-title .top-title:after {\n    border-left: 2px solid #001b4421;\n    border-bottom: 2px solid #001b4421;\n  }\n  \n  .testimonial-section .sec-title .top-title:before,\n  .testimonial-section .sec-title .top-title:after {\n    background: #e2d7d0;\n  }\n  \n  .testimonial-block-one{\n    margin: 30px 0px 70px 0px;\n  }\n  \n  .testimonial-block-one .inner-box{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 10px;\n    padding: 37px 40px 42px 50px;\n    margin-right: 10px;\n    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .testimonial-block-one .inner-box .border-shap{\n    position: absolute;\n    left: 10px;\n    top: -10px;\n    width: 100%;\n    height: 328px;\n    background-repeat: no-repeat;\n  }\n  \n  .testimonial-block-one .inner-box:before{\n    position: absolute;\n    content: '';\n    background: #fff;\n    width: 40px;\n    height: 61px;\n    left: 40px;\n    bottom: -60px;\n    clip-path: polygon(0% 0%, 100% 0%, 0% 100%, 0% 100%, 0% 0%);\n  }\n  \n  .testimonial-block-one .inner-box .quote-box{\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    width: 60px;\n    height: 60px;\n    line-height: 60px;\n    text-align: center;\n    background: #001b44;\n    border-radius: 0px 10px 0px 30px;\n  }\n  \n  .testimonial-block-one .inner-box .quote-box img{\n    position: relative;\n    display: inline-block;\n  }\n  \n  .testimonial-block-one .inner-box .author-box{\n    position: relative;\n    padding: 0px 0px 0px 80px;\n    margin-bottom: 19px;\n  }\n  \n  .testimonial-block-one .inner-box .author-box .author-thumb{\n    position: absolute;\n    left: 0px;\n    top: 3px;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n  }\n  \n  .testimonial-block-one .inner-box .author-box .author-thumb img{\n    width: 100%;\n    border-radius: 50%;\n  }\n  \n  .testimonial-block-one .inner-box .author-box .rating li{\n    position: relative;\n    display: inline-block;\n    font-size: 15px;\n    margin-right: 6px;\n  }\n  \n  .testimonial-block-one .inner-box .author-box .rating li:last-child{\n    margin-right: 0px;\n  }\n  \n  .testimonial-block-one .inner-box .author-box .rating{\n    position: relative;\n    margin-bottom: 7px;\n  }\n  \n  .testimonial-block-one .inner-box .author-box h3{\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n  }\n  \n  .testimonial-block-one .inner-box .author-box h3 span{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Muli', sans-serif;\n    font-weight: 700;\n    color: #a38f96;\n    text-transform: uppercase;\n  }\n  \n  .testimonial-block-one .inner-box .text p{\n    font-size: 17px;\n    font-weight: 500;\n  }\n  \n  .testimonial-section .sec-title{\n    margin-bottom: 27px;\n  }\n  \n  \n  /** awards-section **/\n  \n  .awards-section{\n    position: relative;\n    padding: 95px 0px 130px 0px;\n  }\n  \n  .awards-section .image-box img{\n    width: 100%;\n  }\n  \n  .single-award-block .inner-box{\n    position: relative;\n    display: block;\n    border: 1px solid #eae0d9;\n    background: #fff;\n    padding: 23px 30px 22px 30px;\n    border-radius: 10px;\n    margin-bottom: 30px;\n  }\n  \n  .single-award-block .inner-box .upper-box{\n    position: relative;\n    padding: 0px 0px 16px 75px;\n    border-bottom: 1px solid #eae0d9;\n    margin-bottom: 22px;\n    min-height: 77px;\n  }\n  \n  .single-award-block .inner-box .upper-box .icon-box{\n    position: absolute;\n    left: 0px;\n    top: 6px;\n  }\n  \n  .single-award-block .inner-box .upper-box h3{\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n  }\n  \n  .single-award-block .inner-box .lower-box li{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    font-weight: 500;\n    margin-bottom: 4px;\n  }\n  \n  .single-award-block .inner-box .lower-box li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .single-award-block .inner-box .lower-box li span{\n    position: relative;\n    display: inline-block;\n    width: 90px;\n  }\n  \n  .awards-section .sec-title{\n    margin-bottom: 55px;\n  }\n  \n  .awards-section .inner-block .single-award-block:last-child .inner-box{\n    margin-bottom: 0px;\n  }\n  \n  .awards-section .pattern-layer{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  \n  /** main-footer **/\n  \n  .main-footer{\n    position: relative;\n  }\n  \n  .footer-top{\n    position: relative;\n    padding: 124px 0px 80px 0px;\n  }\n  \n  .footer-top .footer-widget .widget-title{\n    position: relative;\n    display: block;\n    margin-bottom: 25px;\n  }\n  \n  .footer-top .footer-widget .widget-title h3{\n    position: relative;\n    font-size: 22px;\n    line-height: 30px;\n    color: #fff;\n    font-weight: 700;\n  }\n  \n  .footer-top .about-widget .text p{\n    font-size: 17px;\n    line-height: 28px;\n    color: #ae979f;\n    font-weight: 500;\n    margin-bottom: 15px;\n  }\n  \n  .footer-top .about-widget .text p:last-child{\n    line-height: 30px;\n    margin: 0px;\n  }\n  \n  .footer-top .about-widget .text{\n    margin-bottom: 24px;\n  }\n  \n  .footer-top .about-widget .text p i{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    transform: rotate(20deg);\n  }\n  \n  .footer-top .about-widget{\n    margin-right: 50px;\n  }\n  \n  .footer-top .about-widget .social-links li{\n    position: relative;\n    display: inline-block;\n    margin-right: 15px;\n  }\n  \n  .footer-top .about-widget .social-links li:last-child{\n    margin-right: 0px;\n  }\n  \n  .footer-top .about-widget .social-links li h5{\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: 700;\n    color: #fff;\n  }\n  \n  .footer-top .about-widget .social-links li a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    color: #fff;\n  }\n  \n  .footer-top .links-widget .links-list li{\n    position: relative;\n    display: block;\n    width: 50%;\n    float: left;\n    margin-bottom: 15px;\n  }\n  \n  .footer-top .links-widget .links-list li a{\n    position: relative;\n    display: inline-block;\n    font-size: 17px;\n    line-height: 28px;\n    color: #ae979f;\n    font-weight: 500;\n  }\n  \n  .footer-top .links-widget .links-list li a:hover{\n  \n  }\n  \n  .footer-top .contact-widget .info-box li{\n    position: relative;\n    display: block;\n  }\n  \n  .footer-top .contact-widget .info-box li a{\n    position: relative;\n    display: inline-block;\n    font-size: 17px;\n    line-height: 28px;\n    color: #ae979f;\n    font-weight: 500;\n  }\n  \n  .footer-top .contact-widget .info-box li a:hover{\n  \n  }\n  \n  .footer-top .contact-widget .single-info-box{\n    position: relative;\n    display: block;\n    margin-bottom: 36px;\n  }\n  \n  .footer-top .contact-widget .single-info-box:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .main-footer .footer-subscribe{\n    position: relative;\n    display: block;\n  }\n  \n  .main-footer .footer-subscribe .text{\n    margin-bottom: 15px;\n  }\n  \n  .main-footer .footer-subscribe h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    color: #fff;\n    font-weight: 700;\n  }\n  \n  .main-footer .footer-subscribe .subscribe-form .form-group{\n    position: relative;\n    margin: 0px;\n  }\n  \n  .main-footer .footer-subscribe .subscribe-form .form-group input[type='email']{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 54px;\n    border-bottom: 1px solid rgba(255,255,255,0.1);\n    padding: 10px 0px;\n    padding-right: 160px;\n    font-size: 17px;\n    color: #ae979f;\n    font-weight: 500;\n    background: transparent;\n    transition: all 500ms ease;\n  }\n  \n  .main-footer .footer-subscribe .subscribe-form .form-group input::-webkit-input-placeholder{\n    color:#ae979f;\n  }\n  \n  .main-footer .footer-subscribe .subscribe-form .form-group button{\n    position: absolute;\n    top: 9px;\n    right: 0px;\n    font-size: 14px;\n    line-height: 24px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #fff;\n    text-transform: uppercase;\n    background: transparent;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .main-footer .footer-subscribe .subscribe-form .form-group button i{\n    position: relative;\n    font-size: 30px;\n    top: 5px;\n    margin-right: 10px;\n    font-weight: 400;\n  }\n  \n  .main-footer .footer-subscribe .subscribe-form .form-group button:hover,\n  .main-footer .footer-subscribe .subscribe-form .form-group input:focus + button{\n  \n  }\n  \n  .main-footer .footer-subscribe .subscribe-form .form-group input:focus{\n  \n  }\n  \n  .footer-bottom{\n    position: relative;\n    padding: 32px 0px;\n  }\n  \n  .footer-bottom .copyright p{\n    font-size: 17px;\n    line-height: 28px;\n    color: #ae979f;\n    font-weight: 500;\n  }\n  \n  .footer-bottom .copyright p a{\n    color: #ae979f;\n  }\n  \n  .footer-bottom .copyright p a:hover{\n  \n  }\n  \n  .footer-bottom .footer-nav li{\n    position: relative;\n    display: inline-block;\n    margin-right: 15px;\n  }\n  \n  .footer-bottom .footer-nav li:last-child{\n    margin-right: 0px;\n  }\n  \n  .footer-bottom .footer-nav li a{\n    display: inline-block;\n    font-size: 17px;\n    line-height: 28px;\n    color: #ae979f;\n    font-weight: 500;\n  }\n  \n  .footer-bottom .footer-nav li a:hover{\n  \n  }\n  \n  .main-footer .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: repeat-x;\n    background-position: center;\n    animation: slide 100s linear infinite;\n    -webkit-animation: slide 100s linear infinite;\n  }\n  \n  @keyframes slide{\n    from { background-position: 0 0; }\n      to { background-position: 1920px 0; }\n  }\n  \n  @-webkit-keyframes slide{\n    from { background-position: 0 0; }\n      to { background-position: 1920px 0; }\n  }\n  \n  \n  \n  /*** \n  \n  ====================================================================\n                          Home-Page-Two\n  ====================================================================\n  \n  ***/\n  \n  \n  /** header-style-two **/\n  \n  .main-header.style-two{\n    box-shadow: none;\n  }\n  \n  .main-header.style-two .header-lower{\n    margin: 0px 50px;\n  }\n  \n  .main-header.style-two .header-lower .outer-box{\n    position: relative;\n    background: #001b44;\n    border-radius: 10px 10px 0px 0px;\n  }\n  \n  .main-header.style-two .logo-box{\n    background: transparent;\n  }\n  \n  .main-header.style-two  .main-menu .navigation > li > a{\n    color: #fff;\n  }\n  \n  .main-header.style-two .header-top{\n    border-bottom: none;\n  }\n  \n  .main-header.style-two .menu-right-content .search-btn button{\n    color: rgba(255,255,255,0.6);\n  }\n  \n  .main-header.style-two .menu-right-content .theme-btn-one{\n  \n  }\n  \n  .main-header.style-two .sticky-header{\n    background: #001b44;\n  }\n  \n  \n  /** banner-style-two **/\n  \n  .banner-section.style-two{\n    margin: 0px 50px;\n    padding-bottom: 130px;\n    background: transparent;\n  }\n  \n  .banner-section.style-two:before{\n    position: absolute;\n    content: '';\n    background: #001b4421;\n    width: calc(100% + 100px);\n    left: -50px;\n    top: 110px;\n    right: 0px;\n    height: 785px;\n  }\n  \n  .banner-section.style-two .slide-item .pattern-layer .pattern-1{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    width: 727px;\n    height: 323px;\n    background-repeat: no-repeat;\n    z-index: 1;\n  }\n  \n  .banner-section.style-two .slide-item .pattern-layer .pattern-2{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 609px;\n    height: 245px;\n    background-repeat: no-repeat;\n    z-index: 1;\n  }\n  \n  .banner-section.style-two .banner-carousel{\n    position: relative;\n    padding: 0px 70px;\n  }\n  \n  .banner-section.style-two .banner-carousel:before{\n    position: absolute;\n    content: '';\n    background: #001b44;\n    width: 100%;\n    height: 560px;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    border-radius: 0px 0px 10px 10px;\n  }\n  \n  .banner-section.style-two .banner-carousel .slide-item .image-layer{\n    position:absolute;\n    right:0;\n    top: 0;\n    left: 0;\n    width:100%;\n    height: 100%;\n    border-radius: 10px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n  }\n  \n  .banner-section.style-two .banner-carousel .slide-item{\n    position: relative;\n    padding: 180px 0px 187px 0px;\n    border-radius: 10px;\n    overflow: hidden;\n  }\n  \n  .banner-section.style-two .banner-carousel .slide-item:before{\n    position: absolute;\n    content: '';\n    background: #28161c;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    right: 0px;\n    opacity: 0.7;\n    z-index: 1;\n  }\n  \n  .banner-section.style-two .content-box{\n    position: relative;\n    max-width: 670px;\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  .banner-section.style-two .banner-carousel .content-box h1{\n    color: #fff;\n    margin-bottom: 36px;\n  }\n  \n  .banner-carousel .btn-box .btn-one{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    background: #fff;\n    color: #001b44;\n    text-transform: uppercase;\n    padding: 14px 48px;\n    text-align: center;\n    border-radius: 5px;\n    z-index: 1;\n  }\n  \n  .banner-carousel .btn-box .btn-one:hover{\n    color: #fff;\n  }\n  \n  .banner-carousel .btn-box .btn-one:hover:after{\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n    -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n  }\n  \n  .banner-carousel .btn-box .btn-one:after{\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 5px;\n    -webkit-transform: scaleX(0);\n    transform: scaleX(0);\n    -webkit-transform-origin: 50% 100%;\n    transform-origin: 50% 100%;\n    -webkit-transition-property: transform;\n    transition-property: transform;\n    -webkit-transition-duration: 0.5s;\n    transition-duration: 0.5s;\n    -webkit-transition-timing-function: ease-out;\n    transition-timing-function: ease-out;\n  }\n  \n  .banner-carousel .btn-box .btn-two{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    background: transparent;\n    border: 1px solid #fff;\n    color: #fff;\n    text-transform: uppercase;\n    padding: 13px 42px;\n    text-align: center;\n    border-radius: 5px;\n    z-index: 1;\n  }\n  \n  .banner-carousel .btn-box .btn-two:hover:after{\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n    -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n  }\n  \n  .banner-carousel .btn-box .btn-two:after{\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #fff;\n    border-radius: 5px;\n    -webkit-transform: scaleX(0);\n    transform: scaleX(0);\n    -webkit-transform-origin: 50% 100%;\n    transform-origin: 50% 100%;\n    -webkit-transition-property: transform;\n    transition-property: transform;\n    -webkit-transition-duration: 0.5s;\n    transition-duration: 0.5s;\n    -webkit-transition-timing-function: ease-out;\n    transition-timing-function: ease-out;\n  }\n  \n  .banner-carousel .btn-box .btn-two:hover{\n    color: #001b44;\n  }\n  \n  .banner-carousel .btn-box a{\n    margin: 0px 8px;\n  }\n  \n  .banner-section .owl-nav{\n    position: absolute;\n    right: 130px;\n    bottom: 40px;\n  }\n  \n  .banner-section .owl-nav .owl-prev,\n  .banner-section .owl-nav .owl-next{\n    position: relative;\n    display: inline-block;\n    width: 60px;\n    height: 60px;\n    line-height: 60px;\n    text-align: center;\n    font-size: 14px;\n    color: #001b44;\n    background: #fff;\n    font-weight: 700;\n    text-align: center;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .banner-section .owl-nav .owl-prev{\n    margin-right: 15px;\n  }\n  \n  .banner-section .owl-nav .owl-prev:hover,\n  .banner-section .owl-nav .owl-next:hover{\n    color: #fff;\n  }\n  \n  .banner-section .mouse-btn-down{\n    position: absolute;\n    left: 50%;\n    bottom: 105px;\n    transform: translateX(-50%);\n    z-index: 1;\n  }\n  \n  .banner-section .mouse-btn-down .icon-box{\n    position: relative;\n    display: inline-block;\n    width: 30px;\n    height: 50px;\n    background: #fff;\n    border-radius: 20px;\n    text-align: center;\n    cursor: pointer;\n    padding: 12px 0px;\n  }\n  \n  .banner-section .mouse-btn-down .icon-box i{\n    position: relative;\n    display: block;\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 400;\n    color: #001b44;\n  }\n  \n  .banner-section .mouse-btn-down .icon-box:before{\n    position: absolute;\n    content: '';\n    border: 1px solid rgba(0,0,0,0.1);\n    width: 90px;\n    height: 90px;\n    left: -30px;\n    top: -20px;\n    border-radius: 50%;\n  }\n  \n  .banner-section .mouse-btn-down .icon-box:after{\n    position: absolute;\n    content: '';\n    border: 1px solid rgba(0,0,0,0.1);\n    width: 110px;\n    height: 110px;\n    left: -40px;\n    top: -30px;\n    border-radius: 50%;\n  }\n  \n  \n  /** feature-section **/\n  \n  .feature-section{\n    position: relative;\n    padding: 0px 50px;\n  }\n  \n  .feature-section .outer-container{\n    position: relative;\n    max-width: 1820px;\n    width: 100%;\n    margin: 0 auto;\n  }\n  \n  .feature-section .inner-box .single-item{\n    margin: 0px;\n  }\n  \n  \n  /** about-style-two **/\n  \n  .about-style-two{\n    position: relative;\n    padding: 95px 0px 130px 0px;\n  }\n  \n  .about-style-two #image_block_1 .image-box{\n    margin-top: 35px;\n  }\n  \n  #image_block_1 .image-box{\n    position: relative;\n    display: block;\n    margin-right: 30px;\n    padding: 130px 70px 50px 0px;\n  }\n  \n  #image_block_1 .image-box .image-1{\n    position: relative;\n    overflow: hidden;\n    border-radius: 10px;\n  }\n  \n  #image_block_1 .image-box .image-1:before{\n    position: absolute;\n    top: 0;\n    left: -75%;\n    display: block;\n    content: '';\n    width: 50%;\n    height: 100%;\n    background: -o-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .3) 100%);\n    background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), to(rgba(255, 255, 255, .3)));\n    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, .3) 100%);\n    -webkit-transform: skewX(-25deg);\n    -ms-transform: skewX(-25deg);\n    transform: skewX(-25deg);\n  }\n  \n  #image_block_1 .image-box:hover .image-1:before{\n    -webkit-animation: shine 1s;\n    animation: shine 1s;\n  }\n  \n  #image_block_1 .image-box .image-1 img{\n    width: 100%;\n    border-radius: 10px;\n  }\n  \n  #image_block_1 .image-box .image-2{\n    position: absolute;\n    left: -118px;\n    bottom: 0px;\n  }\n  \n  #image_block_1 .image-box .video-inner{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    max-width: 270px;\n    width: 100%;\n    border-radius: 10px;\n    padding: 95px 0px;\n    text-align: center;\n    z-index: 1;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  #image_block_1 .image-box .video-inner .video-btn{\n    position: relative;\n    display: inline-block;\n    width: 80px;\n    height: 80px;\n    line-height: 80px;\n    text-align: center;\n    background: #fff;\n    border-radius: 50%;\n    font-size: 26px;\n    color: #001b44;\n    z-index: 1;\n  }\n  \n  #image_block_1 .image-box .video-inner .video-btn:after, \n  #image_block_1 .image-box .video-inner .video-btn:before {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: transparent;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    -webkit-animation-delay: .9s;\n    animation-delay: .9s;\n    content: \"\";\n    position: absolute;\n    -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.6);\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.6);\n    -webkit-animation: ripple 3s infinite;\n    animation: ripple 3s infinite;\n    -webkit-transition: all .4s ease;\n    transition: all .4s ease;\n  }\n  \n  #image_block_1 .image-box .video-inner .video-btn:after {\n    -webkit-animation-delay: .6s;\n    animation-delay: .6s;\n  }\n  \n  @-webkit-keyframes ripple {\n    70% {\n      -webkit-box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n              box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n    }\n    100% {\n      -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n              box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n    }\n  }\n  @keyframes ripple {\n    70% {\n      -webkit-box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n              box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);\n    }\n    100% {\n      -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n              box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n    }\n  }\n  \n  #image_block_1 .image-box .video-inner .border{\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%);\n    margin-top: -10px;\n    margin-left: 10px;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n  }\n  \n  #image_block_1 .image-box .pattern-layer{\n    position: absolute;\n    left: -120px;\n    top: 0px;\n    width: 323px;\n    height: 323px;\n    background-repeat: no-repeat;\n  }\n  \n  \n  /** service-style-two **/\n  \n  .service-style-two{\n    position: relative;\n  }\n  \n  .service-style-two .inner-container{\n    position: relative;\n    width: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    overflow: hidden;\n    border-radius: 10px;\n  }\n  \n  .service-style-two .inner-container:before{\n    position: absolute;\n    content: '';\n    background: #001b44;\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    opacity: 0.95;\n  }\n  \n  .service-style-two .inner-container .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .service-style-two .inner-container .single-item{\n    position: relative;\n    display: block;\n    padding: 80px 50px 83px 50px;\n    min-height: 780px;\n  }\n  \n  .service-style-two .inner-container .single-item:before{\n    position: absolute;\n    content: '';\n    background: rgb(255,255,255,0.1);\n    width: 1px;\n    height: 100%;\n    top: 0px;\n    right: -30px;\n  }\n  \n  .service-style-two .inner-container .service-block:last-child .single-item:before{\n    display: none;\n  }\n  \n  .service-style-two .inner-container .single-item .icon-box{\n    position: relative;\n    display: block;\n    text-align: center;\n    margin-bottom: 33px;\n  }\n  \n  .service-style-two .inner-container .single-item h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 32px;\n    color: #fff;\n    font-weight: 700;\n    margin-bottom: 24px;\n  }\n  \n  .service-style-two .inner-container .single-item h3 a{\n    color: #fff;\n  }\n  \n  .service-style-two .inner-container .single-item h3 a:hover{\n    \n  }\n  \n  .service-style-two .inner-container .single-item p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    color: #ae979f;\n    margin-bottom: 34px;\n  }\n  \n  .service-style-two .inner-container .single-item .list li{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    color: #ae979f;\n    margin-bottom: 8px;\n  }\n  \n  .service-style-two .inner-container .single-item .list li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .service-style-two .inner-container .single-item .list li a{\n    position: relative;\n    display: inline-block;\n    color: #ae979f;\n  }\n  \n  .service-style-two .inner-container .single-item .list li a:hover{\n    color: #fff;\n  }\n  \n  .service-style-two .inner-container .single-item .list li a:before{\n    position: absolute;\n    content: \"\\f062\";\n    top: 0px;\n    right: -20px;\n    font-family: 'Font Awesome 5 Free';\n    font-size: 12px;\n    color: #fff;\n    font-weight: 700;\n    opacity: 0;\n    transform: rotate(90deg);\n    transition: all 500ms ease;\n  }\n  \n  .service-style-two .inner-container .single-item .list li a:hover:before{\n    opacity: 1;\n    transform: rotate(20deg);\n  }\n  \n  .service-style-two .inner-container .single-item .list{\n    margin-bottom: 33px;\n  }\n  \n  .service-style-two .inner-container .single-item .link{\n    margin-bottom: 64px;\n  }\n  \n  .service-style-two .inner-container .single-item .link a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 24px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #fff;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  .service-style-two .inner-container .single-item .link a i{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    font-size: 30px;\n    font-weight: 400;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .service-style-two .inner-container .single-item .link a:hover{\n    padding-left: 40px;\n  }\n  \n  .service-style-two .inner-container .single-item .link a:hover i{\n    opacity: 1;\n  }\n  \n  .service-style-two .inner-container .single-item .text{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    color: #ae979f;\n  }\n  \n  .service-style-two .inner-container .single-item .text a{\n    color: #fff;\n    border-bottom: 1px solid #fff;\n    display: inline-block;\n  }\n  \n  .service-style-two .inner-container .single-item .text a:hover{\n  \n  }\n  \n  .service-style-two .bg-layer{\n    position: absolute;\n    left: 0px;\n    top: 390px;\n    right: 0px;\n    width: 100%;\n    height: 1375px;\n    background: #001b4421;\n  }\n  \n  \n  /** project-section **/\n  \n  .project-section{\n    position: relative;\n    padding: 95px 0px;\n  }\n  \n  .project-section .sec-title .top-title:before, \n  .project-section .sec-title .top-title:after{\n    background: #e2d7d0;\n  }\n  \n  .project-section .sec-title .top-title:after{\n    border-left: 2px solid #001b4421;\n    border-bottom: 2px solid #001b4421;\n  }\n  \n  .project-section .outer-container{\n    position: relative;\n    padding: 0px 30px;\n  }\n  \n  .project-block-one .inner-box{\n    position: relative;\n    display: block;\n    overflow: hidden;\n    border-radius: 10px;\n  }\n  \n  .project-block-one .inner-box .image-box{\n    position: relative;\n    overflow: hidden;\n    background: #001b44;\n    border-radius: 10px;\n  }\n  \n  .project-block-one .inner-box .image-box img{\n    width: 100%;\n    border-radius: 10px;\n    transition: all 500ms ease;\n  }\n  \n  .project-block-one .inner-box:hover .image-box img{\n    opacity: 0.03;\n  }\n  \n  .project-block-one .inner-box .content-box{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    padding: 15px 50px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .project-block-one .inner-box .content-box .view-btn{\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n  }\n  \n  .project-block-one .inner-box .content-box .text span{\n    position: relative;\n    display: block;\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 700;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n    top: -15px;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .project-block-one .inner-box:hover .content-box .text span,\n  .project-block-one .inner-box:hover .content-box .text h3{\n    top: 0px;\n    opacity: 1;\n  }\n  \n  .project-block-one .inner-box .content-box .text h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 32px;\n    color: #fff;\n    top: 15px;\n    opacity: 0;\n    font-weight: 700;\n    transition: all 500ms ease;\n  }\n  \n  .project-block-one .inner-box .content-box .text h3 a{\n    display: inline-block;\n    color: #fff;\n  }\n  \n  .project-block-one .inner-box .content-box .text h3 a:hover{\n  \n  }\n  \n  .project-block-one .inner-box .content-box .view-btn a{\n    position: relative;\n    display: inline-block;\n    font-size: 24px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 600;\n    color: #fff;\n    width: 60px;\n    height: 60px;\n    line-height: 60px;\n    text-align: center;\n    border-radius: 10px 0px 10px 0px;\n    z-index: 1;\n    opacity: 0;\n  }\n  \n  .project-block-one .inner-box:hover .content-box .view-btn a{\n    opacity: 1;\n  }\n  \n  .project-block-one .inner-box .pattern-layer .pattern-1{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    width: 189px;\n    height: 185px;\n    background-repeat: no-repeat;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .project-block-one .inner-box .pattern-layer .pattern-2{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 159px;\n    height: 174px;\n    background-repeat: no-repeat;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .project-block-one .inner-box:hover .pattern-layer .pattern-1,\n  .project-block-one .inner-box:hover .pattern-layer .pattern-2{\n    opacity: 1;\n  }\n  \n  .project-section .owl-nav{\n    position: absolute;\n    top: -80px;\n    right: 345px;\n  }\n  \n  .project-section .owl-nav .owl-prev,\n  .project-section .owl-nav .owl-next{\n    position: relative;\n    display: inline-block;\n    font-size: 30px;\n    color: #001b44;\n    font-weight: 400;\n    margin: 0px;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .project-section .owl-nav .owl-prev{\n    margin-right: 15px;\n  }\n  \n  .project-section .owl-nav .owl-prev:hover,\n  .project-section .owl-nav .owl-next:hover{\n  \n  }\n  \n  \n  /** industries-style-two **/\n  \n  .industries-style-two{\n    position: relative;\n    padding-bottom: 130px;\n  }\n  \n  .industries-style-two .sec-title .top-title:before, \n  .industries-style-two .sec-title .top-title:after{\n    background: #e2d7d0;\n  }\n  \n  .industries-style-two .sec-title .top-title:after{\n    border-left: 2px solid #001b4421;\n    border-bottom: 2px solid #001b4421;\n  }\n  \n  .industries-style-two .tab-btn-one{\n    margin-bottom: 80px;\n  }\n  \n  .industries-style-two .tab-btn-one .tab-buttons{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .industries-style-two .tab-btn-one .tab-buttons li{\n    position: relative;\n    display: block;\n    float: left;\n    width: 50%;\n    padding: 24px 30px 26px 95px;\n    cursor: pointer;\n    border-right: 1px solid #eae0d9;\n  }\n  \n  .industries-style-two .tab-btn-one .tab-buttons li:before{\n    position: absolute;\n    content: '';\n    background: #eae0d9;\n    width: 1px;\n    height: 30px;\n    top: 25px;\n    right: 65px;\n  }\n  \n  .industries-style-two .tab-btn-one .tab-buttons li:last-child{\n    border-right: none;\n  }\n  \n  .industries-style-two .tab-btn-one .tab-buttons li .icon-box{\n    position: absolute;\n    left: 30px;\n    top: 19px;\n  }\n  \n  .industries-style-two .tab-btn-one .tab-buttons li h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n  }\n  \n  .industries-style-two .tab-btn-one .tab-buttons li i{\n    position: absolute;\n    top: 27px;\n    right: 30px;\n    font-size: 20px;\n    color: #b4a4a4;\n    transition: all 500ms ease;\n  }\n  \n  .industries-style-two .tab-btn-one .tab-buttons li.active-btn i{\n    transform: rotate(180deg);\n  }\n  \n  .industries-style-two .tabs-content-2{\n    position: relative;\n    display: block;\n    margin-right: 30px;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box{\n    position: relative;\n    display: block;\n    overflow: hidden;\n    border-radius: 15px;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box .image-box{\n    position: relative;\n    display: block;\n    border-radius: 15px;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box .image-box:before {\n    position: absolute;\n    content: '';\n    background: -webkit-linear-gradient(-90deg, rgba(70,43,52,0.0), rgba(70,43,52,1) 100%);\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box .image-box img{\n    width: 100%;\n    border-radius: 15px;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box .content-box {\n    position: absolute;\n    left: 0px;\n    bottom: 32px;\n    padding: 0px 40px;\n    width: 100%;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box .content-box .text h2 {\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 40px;\n    color: #fff;\n    font-weight: 700;\n    margin-bottom: 2px;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box .content-box .text span {\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    color: #fff;\n    font-style: italic;\n    font-weight: 500;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box .content-box .link {\n    position: absolute;\n    bottom: 2px;\n    right: 40px;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box .content-box .link a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 700;\n    color: #001b44;\n    width: 62px;\n    height: 62px;\n    line-height: 62px;\n    background: #fff;\n    text-align: center;\n    border-radius: 50%;\n    z-index: 1;\n  }\n  \n  .industries-style-two .tabs-content-2 .inner-box .content-box .link a:hover{\n    color: #fff;\n  }\n  \n  .industries-style-two .tab-btn-two li{\n    position: relative;\n    display: block;\n    padding: 9px 0px 27px 70px;\n    cursor: pointer;\n    margin-bottom: 14px;\n    min-height: 50px;\n    transition: all 500ms ease;\n  }\n  \n  .industries-style-two .tab-btn-two li:before{\n    position: absolute;\n    content: '';\n    background: #eae0d9;\n    width: 50px;\n    height: 1px;\n    left: 70px;\n    bottom: 0px;\n    transition: all 500ms ease;\n  }\n  \n  .industries-style-two .tab-btn-two li.active-btn-2:before,\n  .industries-style-two .tab-btn-two li:hover:before{\n    width: calc(100% - 70px);\n  }\n  \n  .industries-style-two .tab-btn-two li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .industries-style-two .tab-btn-two li .icon-box{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n  }\n  \n  .industries-style-two .tab-btn-two li h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    color: #001b44;\n    font-weight: 700;\n    transition: all 500ms ease;\n  }\n  \n  .industries-style-two .tab-btn-two li.active-btn h3,\n  .industries-style-two .tab-btn-two li:hover h3{\n  \n  }\n  \n  \n  /** chooseus-section **/\n  \n  .chooseus-section{\n    position: relative;\n    padding: 95px 0px 130px 0px;\n  }\n  \n  .chooseus-section .top-title.light:before,\n  .chooseus-section .top-title.light:after{\n    background: #624b52;\n  }\n  \n  .chooseus-section .top-title.light:after{\n    border-bottom: 2px solid #001b44;\n    border-left: 2px solid #001b44;\n  }\n  \n  .chooseus-section .sec-title p{\n    color: #ae979f;\n  }\n  \n  .chooseus-block-one{\n    position: relative;\n  }\n  \n  .chooseus-block-one .inner-box{\n    position: relative;\n    display: block;\n    background: #3f262f;\n    padding: 50px 30px 42px 30px;\n    border-radius: 10px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.1);\n    z-index: 1;\n  }\n  \n  .chooseus-block-one:before{\n    position: absolute;\n    display: block;\n    content: '';\n    background: rgba(255,255,255,0.05);\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 3px;\n    border-radius: 10px;\n  }\n  \n  .chooseus-block-one:after{\n    position: absolute;\n    content: '';\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .chooseus-block-one:hover:after{\n    opacity: 1;\n    left: -10px;\n    top: -10px;\n  }\n  \n  .chooseus-block-one .inner-box .icon-box{\n    position: relative;\n    display: block;\n    margin-bottom: 24px;\n  }\n  \n  .chooseus-block-one .inner-box h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    color: #fff;\n    margin-bottom: 15px;\n  }\n  \n  .chooseus-block-one .inner-box p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    color: rgba(255,255,255,0.6);\n    margin-bottom: 24px;\n  }\n  \n  .chooseus-block-one .inner-box a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    line-height: 24px;\n    font-weight: 700;\n    color: rgba(255,255,255,0.6);\n    text-transform: uppercase;\n  }\n  \n  .chooseus-block-one .inner-box a i{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    font-size: 30px;\n    font-weight: 400;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .chooseus-block-one .inner-box a:hover{\n    padding-left: 40px;\n  }\n  \n  .chooseus-block-one .inner-box a:hover i{\n    opacity: 1;\n  }\n  \n  .chooseus-section .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-repeat: repeat-x;\n    background-size: cover;\n    background-position: center;\n    animation: slide 100s linear infinite;\n    -webkit-animation: slide 100s linear infinite;\n  }\n  \n  \n  /** pricing-section **/\n  \n  .pricing-section{\n    position: relative;\n    overflow: hidden;\n    padding: 95px 0px 130px 0px;\n  }\n  \n  .pricing-section .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .pricing-block-one .inner-box{\n    position: relative;\n    display: block;\n    border: 1px solid #eae0d9;\n    background: #fff;\n    border-radius: 10px;\n    padding: 40px 30px;\n  }\n  \n  .pricing-block-one .inner-box .icon-box{\n    position: relative;\n    margin-bottom: 24px;\n  }\n  \n  .pricing-block-one .inner-box h3{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 36px;\n    font-weight: 700;\n    margin-bottom: 9px;\n  }\n  \n  .pricing-block-one .inner-box .text{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    color: #002c5d;\n    padding-bottom: 23px;\n    margin-bottom: 38px;\n  }\n  \n  .pricing-block-one .inner-box .text:before{\n    position: absolute;\n    content: '';\n    width: 60px;\n    height: 2px;\n    left: 0px;\n    bottom: 0px;\n  }\n  \n  .pricing-block-one .inner-box h2{\n    position: relative;\n    display: block;\n    font-size: 55px;\n    line-height: 55px;\n    font-weight: 700;\n    margin-bottom: 14px;\n    padding-left: 20px;\n  }\n  \n  .pricing-block-one .inner-box h2 .text{\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 700;\n    color: #a38f96;\n    text-transform: uppercase;\n    margin: 0px;\n  }\n  \n  .pricing-block-one .inner-box h2 .text:before{\n    display: none;\n  }\n  \n  .pricing-block-one .inner-box h2 .symble{\n    position: absolute;\n    left: 0px;\n    top: -8px;\n    font-size: 30px;\n  }\n  \n  .pricing-block-one .inner-box p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    margin-bottom: 32px;\n  }\n  \n  .pricing-block-one .inner-box a{\n    position: relative;\n    display: block;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #fff;\n    background: #001b44;\n    text-transform: uppercase;\n    padding: 14px 30px;\n    text-align: center;\n    border-radius: 5px;\n  }\n  \n  .pricing-block-one .inner-box:hover a{\n  \n  }\n  \n  .pricing-block-one.popular .inner-box{\n    background: #001b4421;\n    border-color: #001b4421;\n  }\n  \n  .pricing-block-one.popular .inner-box .popular-tag{\n    position: absolute;\n    top: 25px;\n    right: -16px;\n    font-size: 12px;\n    line-height: 20px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 600;\n    color: #fff;\n    padding: 5.5px 22px;\n    text-align: center;\n    text-transform: uppercase;\n    transform: rotate(-90deg);\n  }\n  \n  .pricing-block-one.popular .inner-box .popular-tag:before{\n    position: absolute;\n    content: '';\n    width: 14px;\n    height: 16px;\n    left: -13px;\n    top: 0px;\n    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 100% 100%, 0% 0%);\n  }\n  \n  .pricing-block-one.popular .inner-box .popular-tag:after{\n    position: absolute;\n    content: '';\n    width: 14px;\n    height: 16px;\n    left: -13px;\n    bottom: 0px;\n    clip-path: polygon(0% 100%, 100% 0%, 100% 100%, 0% 100%, 0% 0%);\n  }\n  \n  .pricing-block-one.popular .inner-box:before{\n    position: absolute;\n    content: '';\n    width: 8px;\n    height: 10px;\n    top: -10px;\n    right: 50px;\n    clip-path: polygon(0% 100%, 100% 0%, 100% 100%, 0% 100%, 0% 0%);\n  }\n  \n  .pricing-section .tabs-box{\n    position: relative;\n  }\n  \n  .pricing-section .tab-btn-box{\n    position: absolute;\n    top: -116px;\n    right: 0px;\n  }\n  \n  .pricing-section .tab-btn-box .tab-buttons{\n    position: relative;\n    display: inline-block;\n  }\n  \n  .pricing-section .tab-btn-box .tab-buttons li{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Nunito Sans', sans-serif;\n    text-transform: uppercase;\n    border: 1px solid #001b4421;\n    background: #001b4421;\n    text-align: center;\n    padding: 13px 15px;\n    width: 110px;\n    text-align: center;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .pricing-section .tab-btn-box .tab-buttons li:first-child{\n    border-radius: 30px 0px 0px 30px;\n  }\n  \n  .pricing-section .tab-btn-box .tab-buttons li:last-child{\n    border-radius: 0px 30px 30px 0px;\n  }\n  \n  .pricing-section .tab-btn-box .tab-buttons li.active-btn,\n  .pricing-section .tab-btn-box .tab-buttons li:hover{\n    background: transparent;\n  }\n  \n  \n  /** testimonial-style-two **/\n  \n  .testimonial-style-two{\n    position: relative;\n    padding: 130px 0px;\n    background: #f1e7e1;\n  }\n  \n  .testimonial-style-two .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .testimonial-style-two .testimonial-block-two{\n    position: relative;\n    margin: 0px 70px;\n  }\n  \n  .testimonial-block-two .inner-box .icon-box{\n    position: relative;\n    display: inline-block;\n    margin-bottom: 31px;\n  }\n  \n  .testimonial-block-two .inner-box p{\n    font-size: 22px;\n    line-height: 36px;\n    font-weight: 500;\n    margin-bottom: 37px;\n  }\n  \n  .testimonial-block-two .inner-box .rating{\n    margin-bottom: 7px;\n  }\n  \n  .testimonial-block-two .inner-box .rating li{\n    position: relative;\n    display: inline-block;\n    font-size: 20px;\n    margin: 0px 3px;\n  }\n  \n  .testimonial-block-two .inner-box h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n  }\n  \n  .testimonial-block-two .inner-box h3 span{\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 700;\n    color: #a38f96;\n    text-transform: uppercase;\n  }\n  \n  .testimonial-style-two .owl-theme .owl-dots .owl-dot span{\n    position: relative;\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    background: #d9cec7;\n    margin: 0px 10px;\n    cursor: pointer;\n    border-radius: 50%;\n    transition: all 500ms ease;\n  }\n  \n  .testimonial-style-two .owl-theme .owl-dots .owl-dot span:before{\n    position: absolute;\n    content: '';\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    left: -10px;\n    top: -10px;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .testimonial-style-two .owl-theme .owl-dots .owl-dot.active span:before{\n    opacity: 1;\n  }\n  \n  .testimonial-style-two .owl-theme .owl-dots .owl-dot.active span{\n  \n  }\n  \n  .testimonial-style-two .owl-theme .owl-dots{\n    position: relative;\n    display: block;\n    margin-top: 36px;\n  }\n  \n  .testimonial-style-two .thumb-box{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    max-width: 1920px;\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n  }\n  \n  .testimonial-style-two .thumb-box .user-thumb{\n    position: absolute;\n  }\n  \n  .testimonial-style-two .thumb-box .thumb-1{\n    left: 195px;\n    top: 100px;\n  }\n  \n  .testimonial-style-two .thumb-box img{\n    position: relative;\n    border-radius: 50%;\n    z-index: 1;\n    -webkit-animation: zoom-fade 5s infinite linear;\n    animation: zoom-fade 5s infinite linear;\n  }\n  \n  .testimonial-style-two .thumb-box .user-thumb .pattern-1{\n    position: absolute;\n    left: 0px;\n    top: -35px;\n    width: 105px;\n    height: 105px;\n    background-repeat: no-repeat;\n  }\n  \n  .testimonial-style-two .thumb-box .user-thumb .pattern-2{\n    position: absolute;\n    left: -50px;\n    bottom: -40px;\n    width: 167px;\n    height: 192px;\n    background-repeat: no-repeat;\n  }\n  \n  .testimonial-style-two .thumb-box .user-thumb .pattern-3{\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n  }\n  \n  .testimonial-style-two .thumb-box .user-thumb .pattern-4{\n    position: absolute;\n    right: 40px;\n    top: -15px;\n    width: 55px;\n    height: 55px;\n    background-repeat: no-repeat;\n    z-index: 1;\n  }\n  \n  .testimonial-style-two .thumb-box .thumb-2{\n    left: 410px;\n    bottom: 75px;\n  }\n  \n  .testimonial-style-two .thumb-box .thumb-3{\n    right: 95px;\n    bottom: 120px;\n  }\n  \n  .testimonial-style-two .thumb-box .thumb-4{\n    top: 50px;\n    right: 340px;\n  }\n  \n  .testimonial-style-two .thumb-box .thumb-4 img{\n    border-radius: 0px;\n  }\n  \n  .news-section .owl-nav{\n    position: absolute;\n    top: -80px;\n    right: 0px;\n  }\n  \n  .news-section .owl-nav .owl-prev,\n  .news-section .owl-nav .owl-next{\n    position: relative;\n    display: inline-block;\n    font-size: 30px;\n    color: #001b44;\n    font-weight: 400;\n    margin: 0px;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .news-section .owl-nav .owl-prev{\n    margin-right: 15px;\n  }\n  \n  .news-section .owl-nav .owl-prev:hover,\n  .news-section .owl-nav .owl-next:hover{\n  \n  }\n  \n  \n  /** clients-style-two **/\n  \n  .clients-style-two{\n    position: relative;\n    width: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    padding: 120px 0px;\n  }\n  \n  .clients-style-two:before{\n    position: absolute;\n    content: '';\n    background: -webkit-linear-gradient(-90deg, rgba(70,43,52,0.8)10%, rgba(255,255,255,1) 90%);\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n  }\n  \n  .clients-style-two .title-inner{\n    position: relative;\n    display: block;\n    max-width: 670px;\n    width: 100%;\n    margin: 0 auto;\n    margin-bottom: 130px;\n  }\n  \n  .clients-style-two .title-inner h2{\n    font-size: 48px;\n    line-height: 58px;\n    color: #fff;\n    margin-bottom: 28px;\n    font-weight: 800;\n  }\n  \n  .clients-style-two .title-inner .btn-box a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    padding: 14px 35px;\n    border-radius: 4px;\n    text-align: center;\n    width: 170px;\n    margin: 0px 8px;\n    text-transform: uppercase;\n  }\n  \n  .clients-style-two .title-inner .btn-box a.btn-one{\n    color: #fff;\n  }\n  \n  .clients-style-two .title-inner .btn-box a.btn-one:hover{\n    background: #fff;\n  }\n  \n  .clients-style-two .title-inner .btn-box a.btn-two{\n    color: #001b44;\n    background: #fff;\n  }\n  \n  .clients-style-two .title-inner .btn-box a.btn-two:hover{\n    color: #fff;\n  }\n  \n  .clients-style-two .clients-logo-box{\n    position: relative;\n    display: block;\n  }\n  \n  .clients-style-two .clients-logo-box img{\n    display: block;\n    max-width: 100%;\n    width: auto;\n    margin: 0 auto;\n    filter: grayscale(100%);\n    -webkit-filter: grayscale(100%);\n    -moz-filter: grayscale(100%);\n    -o-filter: grayscale(100%);\n    -ms-filter: grayscale(100%);\n    -webkit-transition: all 300ms ease;\n    -moz-transition: all 300ms ease;\n    -ms-transition: all 300ms ease;\n    -o-transition: all 300ms ease;\n    transition: all 300ms ease;\n  }\n  \n  .clients-style-two .clients-logo-box img:hover {\n    filter: grayscale(0%);\n    -webkit-filter: grayscale(0%);\n    -moz-filter: grayscale(0%);\n    -o-filter: grayscale(0%);\n    -ms-filter: grayscale(0%);\n  }\n  \n  \n  /** contactinfo-section **/\n  \n  .contactinfo-section{\n    position: relative;\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .contactinfo-section .image-column{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 48%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .contactinfo-section .sec-title .top-title:before,\n  .contactinfo-section .sec-title .top-title:after{\n    background: #e2d7d0;\n  }\n  \n  .contactinfo-section .sec-title .top-title:after{\n    border-left: 2px solid #001b4421;\n    border-bottom: 2px solid #001b4421;\n  }\n  \n  #content_block_6 .content-box{\n    position: relative;\n    display: block;\n  }\n  \n  #content_block_6 .content-box .info-list li{\n    position: relative;\n    display: block;\n    padding-left: 82px;\n    margin-bottom: 35px;\n  }\n  \n  #content_block_6 .content-box .info-list li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  #content_block_6 .content-box .info-list li .icon-box{\n    position: absolute;\n    left: 0px;\n    top: 6px;\n  }\n  \n  #content_block_6 .content-box .info-list li .inner{\n    position: relative;\n    padding-left: 32px;\n  }\n  \n  #content_block_6 .content-box .info-list li .inner h4{\n    display: block;\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 700;\n    margin-bottom: 15px;\n  }\n  \n  #content_block_6 .content-box .info-list li .inner p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n  }\n  \n  #content_block_6 .content-box .info-list li .inner p a{\n    color: #002c5d;\n  }\n  \n  #content_block_6 .content-box .info-list li .inner p a:hover{\n  \n  }\n  \n  #content_block_6 .content-box .info-list li .inner:before{\n    position: absolute;\n    content: '';\n    background: #e2d7d0;\n    width: 2px;\n    height: 62px;\n    left: 0px;\n    top: 6px;\n  }\n  \n  #content_block_6 .content-box .info-list li .inner:after{\n    position: absolute;\n    content: '';\n    width: 2px;\n    height: 20px;\n    left: 0px;\n    top: 6px;\n    transition: all 500ms ease;\n  }\n  \n  #content_block_6 .content-box .info-list li:hover .inner:after{\n    height: 62px;\n  }\n  \n  .contactinfo-section .map-inner{\n    position: relative;\n    display: block;\n    border-radius: 50%;\n    overflow: hidden;\n  }\n  \n  .contactinfo-section .map-inner #contact-google-map{\n    width: 470px;\n    height: 470px;\n    border-radius: 50%;\n  }\n  \n  .contactinfo-section .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 52%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  \n  /** footer-style-two **/\n  \n  .main-footer.style-two .footer-top{\n    border-bottom: 1px solid rgba(255,255,255,0.1);\n    padding: 104px 0px 106px 0px;\n  }\n  \n  .main-footer.style-two .footer-top .about-widget{\n    margin-right: 0px;\n  }\n  \n  .main-footer.style-two .footer-top .about-widget .text p{\n    line-height: 28px;\n  }\n  \n  .main-footer.style-two .footer-top .about-widget .text{\n    margin-bottom: 31px;\n  }\n  \n  .main-footer .about-widget .subscribe-form .form-group{\n    position: relative;\n    margin: 0px;\n  }\n  \n  .main-footer .about-widget .subscribe-form .form-group input[type='email']{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 52px;\n    border: 1px solid #533c44;\n    background: transparent;\n    font-size: 17px;\n    font-weight: 500;\n    color: #ae979f;\n    border-radius: 5px 5px 0px 0px;\n    padding: 10px 20px;\n    transition: all 500ms ease;\n  }\n  \n  .main-footer .about-widget .subscribe-form .form-group input:focus{\n  \n  }\n  \n  .main-footer .about-widget .subscribe-form .form-group input::-webkit-input-placeholder{\n    color:#ae979f;\n  }\n  \n  .main-footer .about-widget .subscribe-form .form-group button{\n    position: relative;\n    display: block;\n    width: 100%;\n    text-align: center;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    line-height: 24px;\n    color: #fff;\n    font-weight: 700;\n    text-transform: uppercase;\n    background: #533c44;\n    padding: 9px 25px;\n    border-radius: 0px 0px 5px 5px;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .main-footer .about-widget .subscribe-form .form-group button:hover{\n  \n  }\n  \n  .main-footer .about-widget .subscribe-form .form-group button i{\n    position: relative;\n    font-size: 30px;\n    font-weight: 400;\n    margin-right: 8px;\n    top: 5px;\n  }\n  \n  .nice-select:after{\n    width: 8px;\n    height: 8px;\n    border-bottom: 2px solid #001b44;\n    border-right: 2px solid #001b44;\n    right: 20px;\n  }\n  \n  .nice-select{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 55px;\n    border: 1px solid #eae0d9 !important;\n    border-radius: 5px;\n    padding: 8px 20px;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n  }\n  \n  .main-footer .callback-widget .widget-content{\n    position: relative;\n    display: block;\n    background: #fff;\n    padding: 30px 30px;\n    border-radius: 10px;\n    margin-top: 7px;\n    z-index: 1;\n  }\n  \n  .main-footer .callback-widget .widget-content .callback-form{\n    position: relative;\n    margin: 0px 5px;\n  }\n  \n  .main-footer .callback-widget .widget-content .form-group{\n    position: relative;\n    margin-bottom: 20px;\n    padding: 0px 10px;\n  }\n  \n  .main-footer .callback-widget .widget-content .form-group:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .main-footer .callback-widget .widget-content .form-group input[type='text'],\n  .main-footer .callback-widget .widget-content .form-group input[type='email']{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 55px;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n    padding: 10px 20px;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n    transition: all 500ms ease;\n  }\n  \n  .main-footer .callback-widget .widget-content .form-group input:focus{\n  \n  }\n  \n  .main-footer .callback-widget .widget-content .form-group button{\n    display: block;\n    width: 100%;\n  }\n  \n  .main-footer .callback-widget .widget-content .form-group button:after{\n    background: #001b44;\n  }\n  \n  .main-footer .callback-widget .pattern-layer .pattern-1{\n    position: absolute;\n    right: -60px;\n    bottom: -45px;\n    width: 105px;\n    height: 215px;\n    background-repeat: no-repeat;\n  }\n  \n  .main-footer .callback-widget .pattern-layer .pattern-2{\n    position: absolute;\n    background: #3f262f;\n    width: 194px;\n    height: 194px;\n    border-radius: 50%;\n    right: -160px;\n    bottom: -60px;\n    z-index: 1;\n  }\n  \n  .main-footer .callback-widget .pattern-layer .pattern-3{\n    position: absolute;\n    width: 80px;\n    height: 80px;\n    right: -165px;\n    bottom: -70px;\n    border-radius: 50%;\n  }\n  \n  .main-footer .callback-widget .pattern-layer .pattern-4{\n    position: absolute;\n    top: 120px;\n    right: -115px;\n    width: 55px;\n    height: 55px;\n    background-repeat: no-repeat;\n    z-index: 1;\n  }\n  \n  .main-footer.style-two .footer-bottom .copyright{\n    position: relative;\n    padding-left: 190px;\n  }\n  \n  .main-footer.style-two .footer-bottom .copyright .footer-logo{\n    position: absolute;\n    left: 0px;\n    top: 5px;\n    z-index: 1;\n  }\n  \n  .main-footer.style-two .footer-bottom .copyright .footer-logo:before{\n    position: absolute;\n    content: '';\n    background: rgb(255,255,255,0.1);\n    width: 1px;\n    height: 45px;\n    top: 0px;\n    right: -21px;\n  }\n  \n  .footer-bottom .social-links li{\n    position: relative;\n    display: inline-block;\n    margin-right: 7px;\n  }\n  \n  .footer-bottom .social-links li:last-child{\n    margin-right: 0px;\n  }\n  \n  .footer-bottom .social-links li a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    color: #ae979f;\n    width: 45px;\n    height: 45px;\n    line-height: 45px;\n    text-align: center;\n    background: #3f262f;\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 50%;\n  }\n  \n  .footer-bottom .social-links li a:hover{\n    color: #fff;\n  }\n  \n  .main-footer.style-two .footer-bottom{\n    padding: 35px 0px;\n  }\n  \n  .footer-bottom .social-links{\n    margin-top: 5px;\n  }\n  \n  \n  \n  /*** \n  \n  ====================================================================\n                          Home-Page-Three\n  ====================================================================\n  \n  ***/\n  \n  \n  /** header-style-three **/\n  \n  .main-header.style-three{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    box-shadow: none;\n  }\n  \n  .main-header.style-three  .main-menu .navigation > li > a{\n    color: #fff;\n  }\n  \n  .main-header.style-three  .main-menu .navigation > li.dropdown > a:before{\n    color: #fff;\n  }\n  \n  .main-header.style-three .sticky-header{\n    background: #001b44;\n  }\n  \n  .main-header.style-three .menu-right-content .search-btn button{\n    color: #fff;\n  }\n  \n  .main-header.style-three .menu-right-content .theme-btn-one{\n    border: 1px solid #002c5d;\n    background: transparent;\n  }\n  \n  .main-header.style-three .outer-box{\n    position: relative;\n    min-height: 80px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n  \n  .main-header.style-three .header-lower .outer-box .menu-area{\n    z-index: 1;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n  }\n  \n  .main-header.style-three .header-lower .outer-box .menu-right-content {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    flex-wrap: wrap;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    margin-top: 12px;\n  }\n  \n  .main-header.style-three .logo-box{\n    float: none;\n    margin: 0px;\n    padding-top: 40px;\n    background: transparent;\n  }\n  \n  .main-header.style-three  .main-menu .navigation > li{\n    padding-top: 50px;\n  }\n  \n  .main-header.style-three .sticky-header .outer-box{\n    display: block;\n  }\n  \n  \n  /** banner-style-three **/\n  \n  .banner-section.style-three{\n    overflow: hidden;\n  }\n  \n  .banner-section.style-three .slide-item{\n    position: relative;\n    padding: 330px 0px 250px 0px;\n    overflow: hidden;\n  }\n  \n  .banner-section.style-three .slide-item:before{\n    position: absolute;\n    content: '';\n    background: #28161c;\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    opacity: 0.6;\n    z-index: 1;\n  }\n  \n  .banner-section.style-three .banner-carousel .slide-item .image-layer{\n    left: 0;\n    right: 0;\n  }\n  \n  .banner-section.style-three .banner-carousel .content-box{\n    max-width: 650px;\n    width: 100%;\n  }\n  \n  .banner-section.style-three .banner-carousel .content-box h1{\n    color: #fff;\n    font-size: 90px;\n    line-height: 90px;\n    font-weight: 800;\n    text-transform: uppercase;\n    margin-bottom: 6px;\n    -webkit-transform: translateY(-100px);\n    -moz-transform: translateY(-100px);\n    -ms-transform: translateY(-100px);\n    -o-transform: translateY(-100px);\n    transform: translateY(-100px);\n  }\n  \n  .banner-section.style-three .banner-carousel .active .content-box h1{\n    -webkit-transform: translateY(0);\n    -moz-transform: translateY(0);\n    -ms-transform: translateY(0);\n    -o-transform: translateY(0);\n    transform: translateY(0);\n  }\n  \n  .banner-carousel .content-box h2{\n    position: relative;\n    display: block;\n    font-size: 48px;\n    line-height: 55px;\n    color: #fff;\n    font-weight: 700;\n    margin-bottom: 20px;\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n    -moz-transform: translateX(100px);\n    -ms-transform: translateX(100px);\n    -o-transform: translateX(100px);\n    transform: translateX(100px);\n    -webkit-transition: all 1200ms ease;\n    -moz-transition: all 1200ms ease;\n    -ms-transition: all 1200ms ease;\n    -o-transition: all 1200ms ease;\n    transition: all 1200ms ease;\n  }\n  \n  .banner-carousel .active .content-box h2{\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n    -webkit-transition-delay: 1200ms;\n    -moz-transition-delay: 1200ms;\n    -ms-transition-delay: 1200ms;\n    -o-transition-delay: 1200ms;\n    transition-delay: 1200ms;\n  }\n  \n  .banner-section.style-three .banner-carousel .content-box p{\n    color: #fff;\n    margin-bottom: 31px;\n  }\n  \n  .banner-section.style-three .slide-item .pattern-layer .pattern-1{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 465px;\n    height: 520px;\n    background-repeat: no-repeat;\n    z-index: 2;\n  }\n  \n  .banner-section.style-three .slide-item .pattern-layer .pattern-2{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 459px;\n    height: 522px;\n    background-repeat: no-repeat;\n    z-index: 1;\n  }\n  \n  .banner-section.style-three .slide-item .pattern-layer .pattern-3{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    width: 294px;\n    height: 295px;\n    background-repeat: no-repeat;\n    z-index: 1;\n  }\n  \n  .banner-section.style-three .slide-item .pattern-layer .pattern-4{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    width: 695px;\n    height: 691px;\n    background-repeat: no-repeat;\n    z-index: 1;\n  }\n  \n  .banner-section.style-three .slide-item .pattern-layer .pattern-5{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 727px;\n    height: 901px;\n    background-repeat: no-repeat;\n  }\n  \n  .banner-section.style-three .owl-nav{\n    right: inherit;\n    left: 335px;\n    bottom: 70px;\n  }\n  \n  .banner-section.style-three .social-box{\n    position: absolute;\n    left: -40px;\n    top: 250px;\n    z-index: 1;\n    transform: rotate(-90deg);\n  }\n  \n  .banner-section.style-three .social-box .social-links{\n    position: relative;\n  }\n  \n  .banner-section.style-three .social-box .social-links:before{\n    position: absolute;\n    content: '';\n    width: 40px;\n    height: 2px;\n    left: -60px;\n    top: 12px;\n  }\n  \n  .banner-section.style-three .social-box .social-links li{\n    position: relative;\n    display: inline-block;\n    font-size: 18px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #fff;\n    font-weight: 700;\n    margin-right: 20px;\n  }\n  \n  .banner-section.style-three .social-box .social-links li:before{\n    position: absolute;\n    content: '';\n    background: #fff;\n    width: 6px;\n    height: 1px;\n    top: 13px;\n    right: -14px;\n  }\n  \n  .banner-section.style-three .social-box .social-links li:last-child:before,\n  .banner-section.style-three .social-box .social-links li:first-child:before{\n    display: none;\n  }\n  \n  .banner-section.style-three .social-box .social-links li a{\n    color: #fff;\n  }\n  \n  .banner-section.style-three .social-box .social-links li:last-child{\n    margin-right: 0px;\n  }\n  \n  .banner-section.style-three .social-box .social-links li a:hover{\n  \n  }\n  \n  .banner-section.style-three .mail-box{\n    position: absolute;\n    left: 165px;\n    top: 335px;\n    z-index: 1;\n    transform: rotate(-47deg);\n  }\n  \n  .banner-section.style-three .mail-box a{\n    position: relative;\n    display: inline-block;\n    font-size: 20px;\n    line-height: 28px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #fff;\n    font-weight: 700;\n  }\n  \n  .banner-section.style-three .mail-box a:hover{\n  \n  }\n  \n  \n  /** about-style-three **/\n  \n  .about-style-three{\n    position: relative;\n    padding: 95px 0px 130px 0px;\n  }\n  \n  .about-style-three .image-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .about-style-three .sec-title .top-title:before,\n  .about-style-three .sec-title .top-title:after{\n    background: #e2d7d0;\n  }\n  \n  .about-style-three .sec-title .top-title:after{\n    border-left: 2px solid #001b4421;\n    border-bottom: 2px solid #001b4421;\n  }\n  \n  .about-style-three .image-box{\n    position: relative;\n    display: block;\n    margin-left: -370px;\n    margin-right: -60px;\n  }\n  \n  .about-style-three .image-box img{\n    width: 100%;\n  }\n  \n  .about-style-three .sec-title{\n    margin-bottom: 30px;\n  }\n  \n  #content_block_1 .content-box .inner-box .list li h3{\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n  }\n  \n  .chooseus-section .title-inner .sec-title,\n  .chooseus-section .title-inner .text{\n    width: 50%;\n  }\n  \n  .chooseus-section .title-inner .text{\n    margin-top: 60px;\n  }\n  \n  .chooseus-section .title-inner .text p{\n    font-size: 17px;\n    font-weight: 500;\n  }\n  \n  .chooseus-section.alternet-2 .chooseus-block-one .inner-box{\n    background: #fff;\n    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.1);\n  }\n  \n  .chooseus-section.alternet-2 .chooseus-block-one .inner-box h3{\n    color: #001b44;\n  }\n  \n  .chooseus-section.alternet-2 .chooseus-block-one .inner-box p{\n    color: #002c5d;\n    margin-bottom: 20px;\n  }\n  \n  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a{\n    color: #001b44;\n    padding: 0px !important;\n  }\n  \n  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a i{\n    position: relative;\n    margin-right: 8px;\n    opacity: 1;\n    top: 6px;\n    color: #001b44;\n  }\n  \n  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a:hover{\n  \n  }\n  \n  .chooseus-section.alternet-2 .chooseus-block-one .inner-box a:hover i{\n  \n  }\n  \n  \n  /** video-section **/\n  \n  .video-section{\n    position: relative;\n  }\n  \n  .video-section #image_block_1 .image-box .video-inner{\n    position: relative;\n    max-width: 100%;\n    padding: 185px 0px 175px 0px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n  }\n  \n  .video-section #image_block_1 .image-box .video-inner .video-btn{\n    width: 100px;\n    height: 100px;\n    line-height: 100px;\n    font-size: 30px;\n  }\n  \n  .video-section #image_block_1 .image-box .video-inner .border{\n    width: 100px;\n    height: 100px;\n  }\n  \n  .video-section #image_block_1 .image-box{\n    padding: 0px;\n    margin: 0px;\n  }\n  \n  .video-section .video-content{\n    position: relative;\n    margin-bottom: -330px;\n    z-index: 1;\n  }\n  \n  .video-section .video-content .pattern-layer .pattern-1{\n    position: absolute;\n    top: -60px;\n    right: -55px;\n    width: 105px;\n    height: 215px;\n    background-repeat: no-repeat;\n  }\n  \n  .video-section .video-content .pattern-layer .pattern-2{\n    position: absolute;\n    top: 50px;\n    right: -140px;\n    width: 195px;\n    height: 195px;\n    border-radius: 50%\n  }\n  \n  .video-section .video-content .pattern-layer .pattern-3{\n    position: absolute;\n    top: 170px;\n    right: -150px;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    -webkit-animation: zoom-fade 5s infinite linear;\n    animation: zoom-fade 5s infinite linear;\n  }\n  \n  .service-section.alternet-2{\n    padding-top: 445px;\n  }\n  \n  .service-section .sec-title.light .top-title:before,\n  .service-section .sec-title.light .top-title:after{\n    background: #624b52;\n  }\n  \n  .service-section .sec-title.light .top-title:after{\n    border-left: 2px solid #001b44;\n    border-bottom: 2px solid #001b44;\n  }\n  \n  .service-section .sec-title.light p{\n    color: #ae979f;\n  }\n  \n  .service-section.alternet-2 .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  \n  /** process-style-two **/\n  \n  .process-style-two{\n    position: relative;\n  }\n  \n  .process-style-two:before{\n    position: absolute;\n    content: '';\n    background: #001b4421;\n    width: 100%;\n    height: 675px;\n    left: 0px;\n    bottom: 0px;\n  }\n  \n  .process-style-two .inner-container{\n    position: relative;\n    border-radius: 10px 10px 0px 0px;\n    background: #001b4421;\n    padding: 95px 0px 122px 0px;\n    overflow: hidden;\n  }\n  \n  .process-style-two .sec-title .top-title:before,\n  .process-style-two .sec-title .top-title:after{\n    background: #e2d7d0;\n  }\n  \n  .process-style-two .sec-title .top-title:after{\n    border-left: 2px solid #001b4421;\n    border-bottom: 2px solid #001b4421;\n  }\n  \n  .process-style-two .single-item .inner-box{\n    position: relative;\n    display: block;\n    padding-left: 50px;\n  }\n  \n  .process-style-two .single-item .inner-box:before{\n    position: absolute;\n    content: '';\n    background: #d9cec7;\n    width: 1px;\n    height: calc(100% + 377px);\n    right: 0px;\n    bottom: -122px;\n  }\n  \n  .process-style-two .single-column:last-child .single-item .inner-box:before{\n    height: calc(100% + 277px);\n  }\n  \n  .process-style-two .single-column:first-child .single-item .inner-box:after{\n    position: absolute;\n    content: '';\n    background: #d9cec7;\n    width: 1px;\n    height: calc(100% + 277px);\n    left: 0px;\n    bottom: -122px;\n  }\n  \n  .process-style-two .single-item .inner-box span{\n    position: relative;\n    display: block;\n    font-size: 14px;\n    line-height: 24px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #a38f96;\n    text-transform: uppercase;\n    margin-bottom: 3px;\n  }\n  \n  .process-style-two .single-item .inner-box h2{\n    position: relative;\n    display: block;\n    font-size: 36px;\n    line-height: 45px;\n    font-weight: 700;\n    margin-bottom: 49px;\n  }\n  \n  .process-style-two .single-item .inner-box .icon-box{\n    margin-bottom: 33px;\n  }\n  \n  .process-style-two .single-item .inner-box h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 700;\n    margin-bottom: 14px;\n  }\n  \n  .process-style-two .single-item .inner-box h3 a{\n    display: inline-block;\n    color: #001b44;\n  }\n  \n  .process-style-two .single-item .inner-box h3 a:hover{\n  \n  }\n  \n  .process-style-two .single-item .inner-box p{\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 20px;\n  }\n  \n  .process-style-two .single-item .inner-box .link a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    line-height: 24px;\n    font-weight: 700;\n    color: #001b44;\n    text-transform: uppercase;\n  }\n  \n  .process-style-two .single-item .inner-box .link a i{\n    position: relative;\n    font-size: 30px;\n    top: 6px;\n    margin-right: 8px;\n    font-weight: 400;\n  }\n  \n  .process-style-two .single-item .inner-box .link a:hover{\n  \n  }\n  \n  .process-style-two .sec-title{\n    margin-bottom: 40px;\n    z-index: 1;\n  }\n  \n  \n  .pricing-block-two .inner-box{\n    position: relative;\n    display: block;\n    box-shadow: 0 0px 50px rgba(0, 0, 0, 0.1);\n    background: #fff;\n    border-radius: 10px;\n    padding: 49px 30px 50px 40px;\n  }\n  \n  .pricing-block-two .inner-box .icon-box{\n    position: relative;\n    margin-bottom: 17px;\n  }\n  \n  .pricing-block-two .inner-box h3{\n    position: relative;\n    display: block;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n    margin-bottom: 2px;\n  }\n  \n  .pricing-block-two .inner-box .text{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    color: #002c5d;\n  }\n  \n  .pricing-block-two .inner-box .text:before{\n    position: absolute;\n    content: '';\n    width: 60px;\n    height: 2px;\n    left: 0px;\n    bottom: 0px;\n  }\n  \n  .pricing-block-two .inner-box h2{\n    position: relative;\n    display: block;\n    font-size: 55px;\n    line-height: 55px;\n    font-weight: 700;\n    margin-bottom: 31px;\n    padding-left: 20px;\n  }\n  \n  .pricing-block-two .inner-box h2 .text{\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 700;\n    color: #a38f96;\n    text-transform: uppercase;\n    margin: 0px;\n  }\n  \n  .pricing-block-two .inner-box h2 .text:before{\n    display: none;\n  }\n  \n  .pricing-block-two .inner-box h2 .symble{\n    position: absolute;\n    left: 0px;\n    top: -8px;\n    font-size: 30px;\n  }\n  \n  .pricing-block-two .inner-box p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    margin-bottom: 32px;\n  }\n  \n  .pricing-block-two .inner-box a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #fff;\n    background: #001b44;\n    text-transform: uppercase;\n    padding: 14px 58px;\n    text-align: center;\n    border-radius: 5px;\n  }\n  \n  .pricing-block-two .inner-box:hover a{\n  \n  }\n  \n  .pricing-block-two .pricing-header{\n    padding-bottom: 32px;\n    border-bottom: 1px solid #eae0d9;\n    margin-bottom: 33px;\n  }\n  \n  .pricing-block-two .inner-box .list li{\n    position: relative;\n    display: block;\n    font-size: 18px;\n    line-height: 28px;\n    font-family: 'Muli', sans-serif;\n    color: #001b44;\n    font-weight: 500;\n    margin-bottom: 18px;\n    padding-left: 34px;\n  }\n  \n  .pricing-block-two .inner-box .list li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .pricing-block-two .inner-box .list{\n    margin-bottom: 30px;\n  }\n  \n  .pricing-block-two .inner-box .list li:before{\n    position: absolute;\n    content: \"\\f11e\";\n    font-family: 'Flaticon';\n    font-size: 18px;\n    font-weight: 500;\n    left: 0px;\n    top: 0px;\n  }\n  \n  \n  /** team-style-two **/\n  \n  .team-style-two{\n    position: relative;\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .team-style-two .pattern-layer{\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: top center;\n  }\n  \n  .team-style-two .sec-title .top-title:before,\n  .team-style-two .sec-title .top-title:after{\n    background: #624b52;\n  }\n  \n  .team-style-two .sec-title .top-title:after{\n    border-left: 2px solid #001b44;\n    border-bottom: 2px solid #001b44;\n  }\n  \n  .team-style-two .owl-dots{\n    display: block;\n    text-align: center;\n    margin-top: 20px;\n  }\n  \n  .project-style-two{\n    position: relative;\n    padding-bottom: 130px;\n  }\n  \n  .project-style-two .project-block-one .inner-box:hover .image-box img{\n    opacity: 0.15;\n  }\n  \n  .project-style-two .more-text p{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n  }\n  \n  .project-style-two .more-text{\n    position: relative;\n    margin-top: 53px;\n  }\n  \n  .project-style-two .more-text p a{\n    display: inline-block;\n    color: #001b44;\n    line-height: 30px;\n    border-bottom: 1px solid #001b44;\n  }\n  \n  .project-style-two .more-text p a:hover{\n  \n  }\n  \n  \n  /** testimonial-style-three **/\n  \n  .testimonial-style-three{\n    position: relative;\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .testimonial-style-three .sec-title{\n    margin-bottom: 40px;\n  }\n  \n  .testimonial-style-three .sec-title .top-title:before,\n  .testimonial-style-three .sec-title .top-title:after{\n    background: #e2d7d0;\n  }\n  \n  .testimonial-style-three .sec-title .top-title:after{\n    border-left: 2px solid #f1e7e1;\n    border-bottom: 2px solid #f1e7e1;\n  }\n  \n  .testimonial-style-three .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .testimonial-block-three{\n    margin: 30px 0px 70px 0px;\n  }\n  \n  .testimonial-block-three .inner-box{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 10px;\n    padding: 40px 20px 42px 40px;\n    margin-right: 10px;\n    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .testimonial-block-three .inner-box .border-shap{\n    position: absolute;\n    left: 10px;\n    top: -10px;\n    width: 100%;\n    height: 356px;\n    background-repeat: no-repeat;\n  }\n  \n  .testimonial-block-three .inner-box:before{\n    position: absolute;\n    content: '';\n    background: #fff;\n    width: 50px;\n    height: 60px;\n    left: 40px;\n    bottom: -60px;\n    clip-path: polygon(0% 0%, 100% 0%, 0% 100%, 0% 100%, 0% 0%);\n  }\n  \n  .testimonial-block-three .inner-box .quote-box{\n    position: absolute;\n    right: 20px;\n    top: -22px;\n  }\n  \n  .testimonial-block-three .inner-box .author-box{\n    position: relative;\n    padding: 0px 0px 0px 80px;\n    margin-bottom: 21px;\n  }\n  \n  .testimonial-block-three .inner-box .author-box .author-thumb{\n    position: absolute;\n    left: 0px;\n    top: -1px;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n  }\n  \n  .testimonial-block-three .inner-box .author-box .author-thumb img{\n    width: 100%;\n    border-radius: 50%;\n  }\n  \n  .testimonial-block-three .inner-box .author-box h3{\n    font-size: 22px;\n    line-height: 33px;\n    font-weight: 700;\n  }\n  \n  .testimonial-block-three .inner-box .author-box .designation{\n    position: relative;\n    display: inline-block;\n    font-size: 12px;\n    font-family: 'Muli', sans-serif;\n    font-weight: 700;\n    color: #a38f96;\n    text-transform: uppercase;\n  }\n  \n  .testimonial-block-three .inner-box .text p{\n    font-size: 17px;\n    font-weight: 500;\n  }\n  \n  .news-section .sec-title .link{\n    position: absolute;\n    top: 86px;\n    right: 0px;\n    font-size: 14px;\n    line-height: 24px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #001b44;\n    text-transform: uppercase;\n    z-index: 1;\n  }\n  \n  .news-section .sec-title .link i{\n    position: relative;\n    font-size: 30px;\n    font-weight: 400;\n    margin-right: 8px;\n    top: 6px;\n  }\n  \n  .news-section .sec-title .link:hover{\n  \n  }\n  \n  .news-section.alternet-2{\n    padding-bottom: 82px;\n  }\n  \n  .clients-section.alternet-2 .clients-logo-box{\n    background: #001b4421;\n    border-right: 1px solid #d9cec7;\n    margin-bottom: 0px;\n    margin-top: 48px;\n  }\n  \n  .clients-section.alternet-2 .clients-logo-box .logo-title{\n    bottom: inherit;\n    top: -43px;\n    background: #fff;\n    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .clients-section.alternet-2 .clients-logo-box:hover .logo-title{\n    top: -28px;\n  }\n  \n  .clients-section.alternet-2 .clients-logo-box .logo-title:before{\n    background: #fff;\n    top: 44px;\n  }\n  \n  .clients-section.alternet-2 .clients-logo-box img{\n    filter: grayscale(100%);\n    -webkit-filter: grayscale(100%);\n    -moz-filter: grayscale(100%);\n    -o-filter: grayscale(100%);\n    -ms-filter: grayscale(100%);\n  }\n  \n  .clients-section.alternet-2 .clients-logo-box:hover img{\n    filter: grayscale(0%);\n    -webkit-filter: grayscale(0%);\n    -moz-filter: grayscale(0%);\n    -o-filter: grayscale(0%);\n    -ms-filter: grayscale(0%);\n  }\n  \n  \n  /** advice-section **/\n  \n  .advice-section{\n    position: relative;\n    padding: 50px 0px;\n    width: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .advice-section:before{\n    position: absolute;\n    content: '';\n    background: #3f262f;\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 0px;\n    opacity: 0.95;\n  }\n  \n  .advice-section .text h2{\n    position: relative;\n    font-size: 30px;\n    line-height: 45px;\n    color: #fff;\n    font-weight: 700;\n  }\n  \n  .advice-section .text h2 a{\n    display: inline-block;\n    line-height: 38px;\n    border-bottom: 1px solid rgba(255,255,255,0.1);\n  }\n  \n  .advice-section .social-links li{\n    position: relative;\n    display: inline-block;\n    margin-right: 7px;\n  }\n  \n  .advice-section .social-links li:last-child{\n    margin-right: 0px;\n  }\n  \n  .advice-section .social-links li a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    color: #002c5d;\n    background: #fff;\n    width: 45px;\n    height: 45px;\n    line-height: 45px;\n    text-align: center;\n    border-radius: 50%;\n  }\n  \n  .advice-section .social-links li a:hover{\n    color: #fff;\n  }\n  \n  \n  /** footer-style-three **/\n  \n  .main-footer .logo-widget .footer-logo{\n    margin-bottom: 33px;\n  }\n  \n  .main-footer .logo-widget .text{\n    margin-bottom: 32px;\n  }\n  \n  .main-footer .logo-widget .text p{\n    font-size: 17px;\n    line-height: 28px;\n    color: #ae979f;\n    font-weight: 500;\n  }\n  \n  .main-footer .logo-widget .upload-btn a{\n    position: relative;\n    display: inline-block;\n    font-size: 17px;\n    line-height: 28px;\n    font-family: 'Muli', sans-serif;\n    color: #fff;\n    font-weight: 500;\n    text-align: center;\n    border-radius: 3px;\n    padding: 13.5px 25px;\n  }\n  \n  .main-footer .logo-widget .upload-btn a i{\n    position: relative;\n    font-size: 24px;\n    margin-right: 10px;\n    font-weight: 400;\n    top: 2px;\n  }\n  \n  .main-footer .logo-widget .upload-btn a:hover{\n  \n  }\n  \n  .main-footer .logo-widget{\n    margin-top: 6px;\n  }\n  \n  .footer-top .post-widget .post-inner .post{\n    position: relative;\n    display: block;\n    padding-left: 100px;\n    padding-bottom: 26px;\n    margin-bottom: 28px;\n    min-height: 108px;\n    border-bottom: 1px solid rgba(255,255,255,0.1);\n  }\n  \n  .footer-top .post-widget .post-inner .post:last-child{\n    border-bottom: none;\n    margin-bottom: 0px;\n  }\n  \n  .footer-top .post-widget .post-inner .post .image-box{\n    position: absolute;\n    left: 0px;\n    top: 2px;\n    width: 75px;\n    height: 75px;\n    border-radius: 10px;\n  }\n  \n  .footer-top .post-widget .post-inner .post .image-box img{\n    width: 100%;\n    border-radius: 10px;\n    transition: all 500ms ease;\n  }\n  \n  .footer-top .post-widget .post-inner .post:hover .image-box img{\n    opacity: 0.5;\n  }\n  \n  .footer-top .post-widget .post-inner .post .post-date{\n    position: relative;\n    display: block;\n    font-size: 13px;\n    line-height: 20px;\n    color: #ae979f;\n    font-weight: 700;\n    text-transform: uppercase;\n    margin-bottom: 9px;\n  }\n  \n  .footer-top .post-widget .post-inner .post h5{\n    position: relative;\n    display: block;\n    font-size: 18px;\n    line-height: 26px;\n    color: #fff;\n    font-weight: 700;\n  }\n  \n  .footer-top .post-widget .post-inner .post h5 a{\n    display: inline-block;\n    color: #fff;\n  }\n  \n  .footer-top .post-widget .post-inner .post h5 a:hover{\n  \n  }\n  \n  .footer-top .post-widget .widget-title{\n    margin-bottom: 30px;\n  }\n  \n  .main-footer.style-three .footer-top{\n    border-bottom: 1px solid rgba(255,255,255,0.1);\n    padding: 93px 0px 66px 0px;\n  }\n  \n  \n  \n  /*** \n  \n  ====================================================================\n                          About-Page\n  ====================================================================\n  \n  ***/\n  \n  \n  /** page-title **/\n  \n  .page-title{\n    position: relative;\n    padding: 195px 0px 20px 0px;\n    width: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .page-title:before{\n    position: absolute;\n    content: '';\n    background: #352027;\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    opacity: 0.8;\n  }\n  \n  .page-title .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n  }\n  \n  .page-title .title-box{\n    position: relative;\n    display: block;\n    margin-bottom: 152px;\n  }\n  \n  .page-title .title-box h1{\n    font-size: 60px;\n    line-height: 65px;\n    color: #fff;\n    font-weight: 800;\n    margin-bottom: 10px;\n  }\n  \n  .page-title .title-box p{\n    font-size: 22px;\n    line-height: 30px;\n    color: #fff;\n    font-weight: 500;\n  }\n  \n  .page-title .bread-crumb li{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 700;\n    color: #fff;\n    text-transform: uppercase;\n    padding-right: 13px;\n    margin-right: 5px;\n  }\n  \n  .page-title .bread-crumb li:last-child{\n    padding: 0px;\n    margin: 0px;\n  }\n  \n  .page-title .bread-crumb li a{\n    color: #fff;\n  }\n  \n  .page-title .bread-crumb li:before{\n    position: absolute;\n    content: '';\n    background: #fff;\n    width: 6px;\n    height: 1px;\n    right: 0px;\n    bottom: 6px;\n  }\n  \n  .page-title .bread-crumb li:last-child:before{\n    display: none;\n  }\n  \n  .page-title .bread-crumb li a:hover{\n  \n  }\n  \n  .about-style-two.about-page{\n    padding-bottom: 80px;\n  }\n  \n  .process-style-two.alternet-2:before{\n    background: #001b44;\n  }\n  \n  .process-style-two.alternet-2 .inner-container{\n    background: #001b44;\n  }\n  \n  .process-style-two.alternet-2 .sec-title .top-title:before, \n  .process-style-two.alternet-2 .sec-title .top-title:after {\n    background: #624b52;\n  }\n  \n  .process-style-two.alternet-2 .sec-title .top-title:after{\n    border-left: 2px solid #001b44;\n    border-bottom: 2px solid #001b44;\n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box h3 a{\n    color: #fff;\n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box h3 a:hover{\n  \n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box p{\n    color: rgba(255,255,255,0.6);\n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box .link a{\n    color: #fff;\n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box .link a i{\n    color: rgba(255,255,255,0.6);\n    transition: all 500ms ease;\n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box .link a:hover{\n  \n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box .link a:hover i{\n    \n  }\n  \n  .process-style-two.alternet-2 .single-item .inner-box:before,\n  .process-style-two .single-column:first-child .single-item .inner-box:after{\n    background: rgba(255,255,255,0.1);\n  }\n  \n  .process-style-two.alternet-2 .inner-container .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  \n  /** history-section **/\n  \n  .history-section{\n    position: relative;\n  }\n  \n  .history-section .sec-title{\n    padding: 95px 0px 100px 0px;\n    margin: 0px;\n  }\n  \n  .history-section .inner-box{\n    position: relative;\n    padding: 130px 30px 130px 0px;\n  }\n  \n  .history-section .inner-box .image-box{\n    position: relative;\n    display: block;\n    border-radius: 10px;\n    margin-bottom: 88px;\n  }\n  \n  .history-section .inner-box .image-box img{\n    width: 100%;\n    border-radius: 10px;\n  }\n  \n  .history-section .inner-box .content-box .year-box{\n    position: relative;\n    display: inline-block;\n    width: 166px;\n    height: 131px;\n    line-height: 131px;\n    text-align: center;\n    margin-bottom: 36px;\n  }\n  \n  .history-section .inner-box .content-box .year-box h3{\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 140px;\n    z-index: 1;\n  }\n  \n  .history-section .inner-box .content-box .year-box .pattern-1{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 166px;\n    height: 131px;\n    background-repeat: no-repeat;\n  }\n  \n  .history-section .inner-box .content-box .year-box .pattern-2{\n    position: absolute;\n    left: 0px;\n    top: 3px;\n    width: 162px;\n    height: 140px;\n    background-repeat: no-repeat;\n  }\n  \n  .history-section .inner-box .content-box .text h3{\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    margin-bottom: 15px;\n  }\n  \n  .history-section .inner-box .content-box .text p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n  }\n  \n  .history-section .inner-box .content-box{\n    position: relative;\n    margin-bottom: 77px;\n  }\n  \n  .mr-0{\n    margin: 0px !important;\n  }\n  \n  .history-section .inner-box:before{\n    position: absolute;\n    content: '';\n    background: #eae0d9;\n    width: 1px;\n    height: 100%;\n    top: 0px;\n    right: 0px;\n  }\n  \n  .history-section .column:nth-child(2) .inner-box:after{\n    position: absolute;\n    content: '';\n    background: #eae0d9;\n    width: 1px;\n    height: 100%;\n    top: 0px;\n    left: -30px;\n  }\n  \n  .history-section .column:last-child .inner-box:before{\n    display: none;\n  }\n  \n  .history-section .inner-box .dots-box{\n    position: absolute;\n    left: -37px;\n    top: 0px;\n    width: 15px;\n    height: 15px;\n    background: #fff;\n    border: 1px solid #eae0d9;\n    border-radius: 50%;\n    z-index: 1;\n  }\n  \n  .history-section .inner-box .dots-box:before{\n    position: absolute;\n    content: '';\n    background: #eae0d9;\n    width: 35px;\n    height: 1px;\n    left: -11px;\n    top: 6px;\n  }\n  \n  .history-section .inner-box .dots-box:after{\n    position: absolute;\n    content: '';\n    background: #fff;\n    width: 13px;\n    height: 13px;\n    border-radius: 50%;\n    left: 0px;\n    top: 0px;\n  }\n  \n  .history-section .inner-box .dots-box.active{\n  \n  }\n  \n  .history-section .inner-box .dots-box.active:before{\n  \n  }\n  \n  .history-section .inner-box .dots-box.active:after{\n    border: 3px solid #fff;\n  }\n  \n  .history-section .image-layer{\n    position: absolute;\n    left: 0px;\n    top: 80px;\n  }\n  \n  .main-footer .pattern-layer.no-anim{\n    animation: none !important;\n  }\n  \n  .team-style-three{\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .team-style-three .team-block-one .inner-box .image-box{\n    box-shadow: none;\n    border-radius: 15px 15px 0px 0px;\n  }\n  \n  .team-style-three .team-block-one .inner-box .image-box img{\n    border-radius: 15px 15px 0px 0px;\n  }\n  \n  .team-style-three .team-block-one .inner-box{\n    box-shadow: 0 10px 20px 5px rgba(0, 0, 0, 0.1);\n  }\n  \n  .team-style-three .team-block-one .inner-box .image-box .share-box p{\n    border-bottom-right-radius: 0px;\n  }\n  \n  .team-style-three .team-block-one .inner-box{\n    border-radius: 15px;\n    margin-bottom: 45px;\n  }\n  \n  .team-style-three .team-block-one .inner-box .lower-content{\n    padding: 24px 15px 21px 15px;\n  }\n  \n  .team-style-three .owl-dots{\n    position: relative;\n    display: block;\n    text-align: center;\n  }\n  \n  .owl-dot-style-two .owl-dots .owl-dot span{\n    position: relative;\n    display: inline-block;\n    width: 30px;\n    height: 2px;\n    background: #c2b3aa;\n    margin: 0px 10px;\n    cursor: pointer;\n    z-index: 1;\n    transition: all 500ms ease;\n  }\n  \n  .owl-dot-style-two .owl-dots .owl-dot.active span,\n  .owl-dot-style-two .owl-dots .owl-dot span:hover{\n    height: 4px;\n  }\n  \n  .team-style-four{\n    position: relative;\n    padding: 95px 0px 90px;\n  }\n  \n  .team-style-four .sec-title .top-title:before,\n  .team-style-four .sec-title .top-title:after{\n    background: #e2d7d0;\n  }\n  \n  .team-style-four .sec-title .top-title:after{\n    border-left: 2px solid #001b4421;\n    border-bottom: 2px solid #001b4421;\n  }\n  \n  .team-style-four .team-block-one .inner-box{\n    margin-bottom: 32px;\n  }\n  \n  \n  /*** \n  \n  ====================================================================\n                          Overview-Page\n  ====================================================================\n  \n  ***/\n  \n  /** hiring-strategies **/\n  \n  .hiring-strategies{\n    position: relative;\n    padding: 95px 0px 90px 0px;\n  }\n  \n  .hiring-strategies .inner-box .title-inner{\n    position: relative;\n    padding: 97px 50px 110px 100px;\n    border-radius: 10px 10px 0px 0px;\n    overflow: hidden;\n  }\n  \n  .hiring-strategies .inner-box .title-inner .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .hiring-strategies .inner-box .title-inner h2{\n    font-size: 60px;\n    line-height: 72px;\n    font-weight: 800;\n    text-transform: uppercase;\n    margin-bottom: 24px;\n    max-width: 530px;\n  }\n  \n  .hiring-strategies .inner-box .funfact-inner{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 0px 0px 10px 10px;\n    box-shadow: 0 20px 15px 0px rgba(0, 0, 0, 0.1);\n  }\n  \n  .hiring-strategies .inner-box .funfact-inner .counter-block{\n    position: relative;\n    display: block;\n    padding: 54px 30px 52px 190px;\n  }\n  \n  .hiring-strategies .inner-box .funfact-inner .counter-block:before{\n    position: absolute;\n    content: '';\n    background: #eae0d9;\n    width: 1px;\n    height: 100%;\n    top: 0px;\n    right: -15px;\n  }\n  \n  .hiring-strategies .inner-box .funfact-inner .counter-column:last-child .counter-block:before{\n    display: none;\n  }\n  \n  .hiring-strategies .inner-box .funfact-inner .counter-block .count-outer{\n    position: absolute;\n    left: 50px;\n    top: 44px;\n    display: inline-block;\n    font-size: 60px;\n    font-family: 'Nunito Sans', sans-serif;\n    line-height: 70px;\n    font-weight: 700;\n  }\n  \n  .hiring-strategies .inner-box .funfact-inner .counter-block .count-outer .icon{\n    position: relative;\n    top: -7px;\n    font-size: 34px;\n    font-weight: 400;\n  }\n  \n  .hiring-strategies .inner-box .funfact-inner .counter-block h6{\n    display: block;\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  \n  /** solutions-problems **/\n  \n  .solutions-problems{\n    position: relative;\n    padding-bottom: 120px;\n  }\n  \n  .solutions-problems .owl-dots{\n    display: block;\n    text-align: center;\n  }\n  \n  .solutions-problems .upper-box{\n    position: relative;\n    margin-bottom: 80px;\n  }\n  \n  .solutions-problems .upper-box .title-inner{\n    position: relative;\n    display: block;\n    margin-right: 45px;\n  }\n  \n  .solutions-problems .upper-box .title-inner h2{\n    font-size: 44px;\n    line-height: 54px;\n    font-weight: 700;\n    margin-bottom: 30px;\n  }\n  \n  .solutions-problems .upper-box .title-inner p{\n    font-size: 17px;\n    font-weight: 500;\n  }\n  \n  .solutions-problems .upper-box .inner-box .single-item .icon-box{\n    position: relative;\n    display: inline-block;\n    margin-bottom: 24px;\n  }\n  \n  .solutions-problems .upper-box .inner-box .single-item h3{\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    margin-bottom: 15px;\n  }\n  \n  .solutions-problems .upper-box .inner-box .single-item p{\n    font-size: 17px;\n    font-weight: 500;\n    margin-bottom: 18px;\n  }\n  \n  .solutions-problems .upper-box .inner-box .single-item a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #001b44;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  .solutions-problems .upper-box .inner-box .single-item a i{\n    position: relative;\n    font-size: 30px;\n    top: 6px;\n    margin-right: 10px;\n    font-weight: 400;\n  }\n  \n  .solutions-problems .upper-box .inner-box .single-item a:hover{\n  \n  }\n  \n  .solutions-problems .upper-box .inner-box{\n    margin-top: 10px;\n  }\n  \n  .solutions-problems .carousel-box{\n    position: relative;\n    margin-right: -30px;\n  }\n  \n  .solutions-problems .carousel-box .single-item{\n    position: relative;\n    margin: 30px 0px;\n    max-width: 600px;\n    width: 100%;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 10px;\n    margin-right: 30px;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .image-box{\n    position: relative;\n    max-width: 470px;\n    width: 100%;\n    border-radius: 15px 0px 0px 15px;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .image-box img{\n    width: 100%;\n    border-radius: 15px 0px 0px 15px;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .lower-content{\n    position: relative;\n    margin: 0px 100px 0px 40px;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .lower-content h3{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    width: 100%;\n    background: #001b44;\n    padding: 25px 30px 25px 30px;\n    border-top-left-radius: 10px;\n    font-size: 22px;\n    line-height: 32px;\n    color: #fff;\n    font-weight: 700;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content{\n    position: absolute;\n    overflow: hidden;\n    top: 0px;\n    right: 0px;\n    width: 100px;\n    height: 100%;\n    box-shadow: 10px 0px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 0px 15px 15px 0px;\n    transition: all 500ms ease;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box:hover .side-content{\n    box-shadow: none;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    text-align: center;\n    padding: 20px 15px 20px 15px;\n    transition: all 900ms ease;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box:hover .side-content .content-box{\n    opacity: 0;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box span{\n    position: absolute;\n    left: 0px;\n    top: 30px;\n    font-size: 35px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #001b4421;\n    width: 100%;\n    text-align: center;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box .icon-box{\n    position: absolute;\n    display: inline-block;\n    left: 19px;\n    bottom: 25px;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box:before{\n    position: absolute;\n    content: '';\n    background: #eae0d9;\n    width: 2px;\n    height: 60px;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%);\n    margin-top: -15px;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .content-box:after{\n    position: absolute;\n    content: '';\n    width: 2px;\n    height: 20px;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%);\n    margin-top: 5px;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background: #001b4421;\n    border-radius: 0px 15px 15px 0px;\n    text-align: center;\n    padding: 20px 15px 20px 15px;\n    z-index: 1;\n    left: -100px;\n    transition: all 500ms ease;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box:hover .side-content .overlay-box{\n    left: 0px;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box span{\n    position: absolute;\n    left: 0px;\n    top: 30px;\n    font-size: 35px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    width: 100%;\n    text-align: center;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box a{\n    position: absolute;\n    display: inline-block;\n    background: #fff;\n    color: #001b44;\n    width: 58px;\n    height: 58px;\n    line-height: 58px;\n    text-align: center;\n    border-radius: 50%;\n    left: 20px;\n    bottom: 25px;\n    font-size: 14px;\n    font-weight: 700;\n    z-index: 1;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box a:hover{\n    color: #fff;\n  }\n  \n  .solutions-problems .carousel-box .single-item .inner-box .side-content .overlay-box:before{\n    position: absolute;\n    content: '';\n    width: 2px;\n    height: 60px;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%);\n    margin-top: -15px;\n  }\n  \n  \n  /** growth-section **/\n  \n  .growth-section{\n    position: relative;\n    padding-top: 95px;\n  }\n  \n  .growth-section:before{\n    position: absolute;\n    content: '';\n    background: #001b44;\n    width: 100%;\n    height: 625px;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n  }\n  \n  .growth-section .sec-title .top-title:before,\n  .growth-section .sec-title .top-title:after{\n    background: #533942;\n  }\n  \n  .growth-section .sec-title .top-title:after{\n    border-left: 2px solid #001b44;\n    border-bottom: 2px solid #001b44;\n  }\n  \n  .growth-section .image-box{\n    position: relative;\n    margin: 0px -85px;\n    margin-bottom: -133px;\n  }\n  \n  .growth-section .image-box .image{\n    position: relative;\n    display: block;\n    border-radius: 10px;\n    z-index: 1;\n  }\n  \n  .growth-section .image-box .image img{\n    width: 100%;\n    border-radius: 10px;\n  }\n  \n  .growth-section .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 579px;\n    height: 575px;\n    background-repeat: no-repeat;\n  }\n  \n  .pricing-section.overview-page{\n    padding-top: 250px;\n    overflow: hidden;\n  }\n  \n  .pb-0{\n    padding-bottom: 0px;\n  }\n  \n  .page-title .bg-shape{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 60px;\n    background: #fff;\n    margin-top: 20px;\n    border-radius: 10px 10px 0px 0px;\n  }\n  \n  \n  /** placejob-section **/\n  \n  .placejob-section{\n    position: relative;\n    padding: 35px 0px 80px 0px;\n  }\n  \n  .placejob-section .form-inner{\n    position: relative;\n    display: block;\n    padding: 41px 30px 50px 30px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n    margin-bottom: 30px;\n    border-radius: 5px;\n  }\n  \n  .placejob-section .form-inner .title-inner{\n    position: relative;\n    padding-left: 77px;\n    margin-bottom: 32px;\n  }\n  \n  .placejob-section .form-inner .title-inner .icon-box{\n    position: absolute;\n    left: 0px;\n    top: 7px;\n  }\n  \n  .placejob-section .form-inner .title-inner h2{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 42px;\n    font-weight: 700;\n  }\n  \n  .placejob-section .form-inner .title-inner p{\n    font-size: 17px;\n    font-weight: 500;\n  }\n  \n  .placejob-section .form-inner .job-form .form-group{\n    position: relative;\n    margin-bottom: 20px;\n  }\n  \n  .placejob-section .form-inner .job-form .form-group:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .placejob-section .form-inner .job-form .form-group input[type='text'],\n  .placejob-section .form-inner .job-form .form-group input[type='email'],\n  .placejob-section .form-inner .job-form .form-group textarea{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 54px;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n    padding: 10px 20px;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n    transition: all 500ms ease;\n  }\n  \n  .placejob-section .form-inner .job-form .form-group textarea{\n    height: 128px;\n    resize: none;\n  }\n  \n  .placejob-section .form-inner .job-form .form-group input:focus,\n  .placejob-section .form-inner .job-form .form-group textarea:focus{\n  \n  }\n  \n  .placejob-section .form-inner .job-form .form-group .nice-select{\n    height: 54px;\n  }\n  \n  .placejob-section .form-inner .job-form .form-group .nice-select:after{\n    border-bottom: 2px solid #b39ea5;\n    border-right: 2px solid #b39ea5;\n  }\n  \n  .placejob-section .form-inner .job-form .column .form-group .nice-select{\n    margin-bottom: 20px;\n  }\n  \n  .placejob-section .form-inner .job-form .column .form-group:last-child .nice-select{\n    margin-bottom: 0px;\n  }\n  \n  .placejob-section .form-inner .job-form .column:first-child .form-group .nice-select{\n    z-index: 1;\n  }\n  \n  .placejob-section .form-inner .job-form .form-group button{\n    display: block;\n    width: 100%;\n    padding: 14px 44px;\n  }\n  \n  \n  \n  /*** \n  \n  ====================================================================\n                          faq-Page\n  ====================================================================\n  \n  ***/\n  \n  .faq-section{\n    position: relative;\n    padding: 95px 0px 130px 0px;\n  }\n  \n  .faq-section .image-box{\n    position: relative;\n    display: block;\n  }\n  \n  .faq-section .image-box img{\n    width: 100%;\n  }\n  \n  .accordion-box .block{\n    position: relative;\n    display: block;\n    background: #fff;\n    margin-bottom: 20px;\n    transition: all 500ms ease;\n  }\n  \n  .accordion-box .block:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .accordion-box .block .acc-content{\n    position:relative;\n    display:none;\n    margin: 20px 20px 0px 20px;\n  }\n  \n  .accordion-box .block .acc-content.current{\n    display:block;  \n  }\n  \n  .accordion-box .block .acc-btn .icon-outer{\n    position: absolute;\n    width: 60px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #001b4421;\n    top: 0px;\n    right: 0px;\n    text-align: center;\n    cursor: pointer;\n    transition: all 500ms ease;\n    z-index: 1;\n  }\n  \n  .accordion-box .block .acc-btn.active .icon-outer{\n  \n  }\n  \n  .accordion-box .block .acc-btn .icon-outer:after{\n    position: absolute;\n    content: '+';\n    font-size: 24px;\n    color: #001b44;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 600;\n    width: 60px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    left: 0px;\n    top: 0px;\n  }\n  \n  .accordion-box .block .acc-btn.active .icon-outer:after{\n    opacity: 0;\n  }\n  \n  .accordion-box .block .acc-btn.active .icon-outer{\n    color: #fff;\n  }\n  \n  .accordion-box .block .acc-btn.active .icon-outer:before{\n    position: relative;\n    font-size: 10px;\n    font-family: 'Flaticon';\n    font-weight: 700;\n    margin: 0px;\n    content: \"\\f123\";\n  }\n  \n  .accordion-box .block .acc-btn{\n    position: relative;\n    display: block;\n    overflow: hidden;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n    background: #fff;\n    padding: 16px 80px 14px 20px;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .accordion-box .block .acc-btn.active{\n    background: #001b44;\n  }\n  \n  .accordion-box .block .acc-btn h5{\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: 700;\n    margin: 0px;\n    transition: all 500ms ease;\n  }\n  \n  .accordion-box .block .acc-btn.active h5{\n    color: #fff;\n  }\n  \n  .accordion-box .block .acc-content .text{\n    position: relative;\n    display: block;\n    background: #fff;\n    border: 1px solid #eae0d9;\n    padding: 30px 30px 30px 30px;\n    border-radius: 5px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  }\n  \n  .accordion-box .block .acc-content .text:before{\n    position: absolute;\n    content: '';\n    background: #fff;\n    width: 20px;\n    height: 20px;\n    left: 30px;\n    top: -9px;\n    transform: rotate(-45deg);\n    box-shadow: 1px -1px 0px 0px #eae0d9;\n    transition: all 500ms ease;\n  }\n  \n  .accordion-box .block .acc-content .text p{\n    font-size: 18px;\n    font-weight: 500;\n  }\n  \n  \n  \n  /*** \n  \n  ====================================================================\n                          Testimonials-Page\n  ====================================================================\n  \n  ***/\n  \n  .clients-style-three{\n    position: relative;\n    padding: 140px 0px 110px 0px;\n  }\n  \n  .clients-style-three #image_block_1 .image-box .video-inner{\n    position: relative;\n    max-width: 100%;\n    padding: 210px 0px 190px 0px;\n    margin-bottom: 10px;\n  }\n  \n  .clients-style-three #image_block_1 .image-box{\n    padding: 0px;\n    margin: 0px;\n  }\n  \n  .clients-style-three #image_block_1 .image-box .video-inner .video-btn{\n    width: 100px;\n    height: 100px;\n    line-height: 100px;\n    font-size: 36px;\n  }\n  \n  .clients-style-three #image_block_1 .image-box .video-inner .border{\n    width: 100px;\n    height: 100px;\n    margin-top: 0px;\n  }\n  \n  .clients-style-three .clients-inner{\n    position: relative;\n    display: block;\n    padding: 0px 100px;\n  }\n  \n  .clients-style-three .clients-inner .clients-logo-box{\n    display: block;\n    max-width: 100%;\n    width: auto;\n    margin: 30px auto;\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.1);\n  }\n  \n  .clients-style-three .clients-inner .clients-logo-box img{\n    display: block;\n    max-width: 100%;\n    width: auto;\n    margin: 0 auto;\n    filter: grayscale(100%);\n    -webkit-filter: grayscale(100%);\n    -moz-filter: grayscale(100%);\n    -o-filter: grayscale(100%);\n    -ms-filter: grayscale(100%);\n    -webkit-transition: all 500ms ease;\n    -moz-transition: all 500ms ease;\n    -ms-transition: all 500ms ease;\n    -o-transition: all 500ms ease;\n    transition: all 500ms ease;\n  }\n  \n  .clients-style-three .clients-inner .clients-logo-box:hover img{\n    filter: grayscale(0%);\n    -webkit-filter: grayscale(0%);\n    -moz-filter: grayscale(0%);\n    -o-filter: grayscale(0%);\n    -ms-filter: grayscale(0%);\n  }\n  \n  .clients-style-three .owl-nav .owl-prev,\n  .clients-style-three .owl-nav .owl-next{\n    position: absolute;\n    display: inline-block;\n    top: 60px;\n    width: 70px;\n    height: 70px;\n    line-height: 70px;\n    text-align: center;\n    border: 1px solid #eae0d9;\n    border-radius: 50%;\n    font-size: 30px;\n    font-weight: 400;\n    color: #001b44;\n    background: #fff;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .clients-style-three .owl-nav .owl-prev{\n    left: -100px;\n  }\n  \n  .clients-style-three .owl-nav .owl-next{\n    right: -100px;\n  }\n  \n  .clients-style-three .owl-nav .owl-prev:hover,\n  .clients-style-three .owl-nav .owl-next:hover{\n    border-color: #fff;\n    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  \n  .testimonial-page-section{\n    position: relative;\n    padding-bottom: 90px;\n  }\n  \n  .testimonial-page-section .testimonial-block-three{\n    margin: 0px 0px 110px 0px;\n  }\n  \n  .testimonial-page-section .testimonial-block-three .inner-box{\n    box-shadow: 0 10px 100px rgba(0, 0, 0, 0.1);\n  }\n  \n  .testimonial-page-section .testimonial-block:nth-child(2) .testimonial-block-three .inner-box .border-shap{\n    height: 384px;\n  }\n  \n  .testimonial-page-section .testimonial-block:nth-child(3) .testimonial-block-three .inner-box .border-shap{\n    height: 422px;\n  }\n  \n  .testimonial-page-section .testimonial-block:nth-child(4) .testimonial-block-three .inner-box .border-shap{\n    height: 422px;\n  }\n  \n  .testimonial-page-section .testimonial-block:nth-child(6) .testimonial-block-three .inner-box .border-shap{\n    height: 384px;\n  }\n  \n  .testimonial-page-section .testimonial-block:nth-child(7) .testimonial-block-three .inner-box .border-shap{\n    height: 384px;\n  }\n  \n  .testimonial-page-section .testimonial-block:nth-child(8) .testimonial-block-three .inner-box .border-shap{\n    height: 422px;\n  }\n  \n  \n  /*** \n  \n  ====================================================================\n                          Service-Page\n  ====================================================================\n  \n  ***/\n  \n  .service-section.service-page{\n    padding: 95px 0px 90px 0px;\n  }\n  \n  .service-section.service-page .service-block-one{\n    margin-top: 0px;\n    margin-bottom: 30px;\n  }\n  \n  .service-section.service-page .sec-title{\n    margin-bottom: 50px;\n  }\n  \n  \n  /** hiring-section **/\n  \n  .hiring-section{\n    position: relative;\n  }\n  \n  .hiring-section .left-column,\n  .hiring-section .right-column{\n    width: 50%;\n  }\n  \n  .hiring-section .left-column{\n    background: #001b44;\n  }\n  \n  .hiring-section .right-column{\n    background: #3e242d;\n  }\n  \n  .hiring-section .left-column .inner-box{\n    position: relative;\n    display: block;\n    text-align: left;\n    max-width: 500px;\n    padding: 120px 50px 130px 0px;\n  }\n  \n  .hiring-section .right-column .inner-box{\n    position: relative;\n    display: block;\n    text-align: left;\n    max-width: 550px;\n    padding: 120px 0px 130px 100px;\n  }\n  \n  .hiring-section .inner-box h2{\n    position: relative;\n    display: block;\n    font-size: 44px;\n    line-height: 55px;\n    color: #fff;\n    font-weight: 700;\n    margin-bottom: 19px;\n  }\n  \n  .hiring-section .inner-box p{\n    font-size: 17px;\n    font-weight: 500;\n    color: rgba(255,255,255,0.6);\n    margin-bottom: 42px;\n  }\n  \n  .hiring-section .inner-box a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #001b44;\n    border-radius: 4px;\n    text-align: center;\n    background: #fff;\n    padding: 15px 44px;\n    text-transform: uppercase;\n    z-index: 1;\n  }\n  \n  .hiring-section .inner-box a:hover{\n    color: #fff;\n  }\n  \n  .hiring-section .inner-box a:hover:after{\n    -webkit-transform: scaleX(1);\n    transform: scaleX(1);\n    -webkit-transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);\n  }\n  \n  .hiring-section .inner-box a:after{\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 4px;\n    -webkit-transform: scaleX(0);\n    transform: scaleX(0);\n    -webkit-transform-origin: 50% 100%;\n    transform-origin: 50% 100%;\n    -webkit-transition-property: transform;\n    transition-property: transform;\n    -webkit-transition-duration: 0.5s;\n    transition-duration: 0.5s;\n    -webkit-transition-timing-function: ease-out;\n    transition-timing-function: ease-out;\n  }\n  \n  .hiring-section .inner-box .icon-box{\n    position: absolute;\n    right: 70px;\n    bottom: 70px;\n    font-size: 130px;\n    line-height: 100px;\n    color: rgba(255,255,255,0.1);\n  }\n  \n  .hiring-section .image-layer .image-1{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n  }\n  \n  .hiring-section .image-layer .image-2{\n    position: absolute;\n    right: 0px;\n    top: 0px;\n  }\n  \n  \n  /** contact-section **/\n  \n  .contact-section{\n    position: relative;\n    padding: 95px 0px 130px 0px\n  }\n  \n  .contact-section .form-inner{\n    position: relative;\n    display: block;\n    background: #fff;\n    padding: 50px 50px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n  }\n  \n  .default-form .form-group{\n    position: relative;\n    margin-bottom: 20px;\n  }\n  \n  .default-form .form-group:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .default-form .form-group input[type='text'], \n  .default-form .form-group input[type='email'], \n  .default-form .form-group textarea {\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 56px;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n    padding: 10px 20px;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n    transition: all 500ms ease;\n  }\n  \n  .default-form .form-group input:focus,\n  .default-form .form-group textarea:focus{\n  \n  }\n  \n  .default-form .form-group textarea{\n    height: 120px;\n    resize: none;\n  }\n  \n  .default-form .form-group button{\n    display: block;\n    width: 100%;\n  }\n  \n  .default-form .form-group .nice-select:after {\n    border-bottom: 2px solid #002c5d;\n    border-right: 2px solid #002c5d;\n  }\n  \n  .contact-section .form-inner .pattern-layer{\n    position: absolute;\n    right: -130px;\n    bottom: -130px;\n    width: 380px;\n    height: 340px;\n    background-repeat: no-repeat;\n    z-index: -1;\n  }\n  \n  \n  /** service-details **/\n  \n  .service-details{\n    position: relative;\n    padding: 95px 0px 130px 0px;\n  }\n  \n  .service-details-content .content-one .image-box{\n    position: relative;\n    display: block;\n    border-radius: 10px;\n    margin-bottom: 43px;\n  }\n  \n  .service-details-content .content-one .image-box img{\n    width: 100%;\n    border-radius: 10px;\n  }\n  \n  .service-details-content p{\n    font-size: 17px;\n    font-weight: 500;\n  }\n  \n  .service-details-content .content-one .text p{\n    margin-bottom: 20px;\n  }\n  \n  .service-details-content .content-one .text p:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .service-details-content .content-one .sec-title{\n    margin-bottom: 37px;\n  }\n  \n  .service-details-content .content-one{\n    margin-bottom: 42px;\n  }\n  \n  .service-details-content .content-two .inner-box{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n    margin-bottom: 73px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column{\n    float: left;\n    position: relative;\n    display: block;\n    width: 33.333%;\n    padding: 36px 40px 26px 30px;\n    border-right: 1px solid #eae0d9;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column:last-child{\n    border: none;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .content-box h5{\n    position: relative;\n    display: block;\n    font-size: 20px;\n    font-weight: 700;\n    color: #a38f96;\n    margin-bottom: 17px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .content-box h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 700;\n    margin-bottom: 64px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .content-box .link a{\n    position: relative;\n    display: inline-block;\n    font-size: 30px;\n    font-weight: 400;\n    color: #001b44;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .content-box .icon-box{\n    position: absolute;\n    right: 30px;\n    bottom: 30px;\n    font-size: 85px;\n    line-height: 85px;\n    color: #001b4421;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box{\n    position: absolute;\n    left: 0px;\n    top: 30px;\n    background: #001b44;\n    width: 100%;\n    padding: 33px 40px 32px 30px;\n    border-radius: 10px 0px 10px 10px;\n    visibility: hidden;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column:nth-child(2) .overlay-box{\n    border-radius: 0px 0px 10px 10px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column:last-child .overlay-box{\n    border-radius: 0px 10px 10px 10px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column:last-child .overlay-box .icon-box{\n    border-top-right-radius: 10px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column:hover .overlay-box{\n    visibility: visible;\n    opacity: 1;\n    top: 0px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box .icon-box{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    font-size: 40px;\n    color: #fff;\n    width: 70px;\n    height: 70px;\n    line-height: 70px;\n    text-align: center;\n    border-bottom-left-radius: 35px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box h5{\n    position: relative;\n    display: block;\n    font-size: 20px;\n    line-height: 30px;\n    font-weight: 700;\n    margin-bottom: 12px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box .list li{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    color: #ae979f;\n    margin-bottom: 8px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box .list li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box .list{\n    margin-bottom: 15px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box .link a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    line-height: 24px;\n    font-weight: 700;\n    color: #fff;\n    text-transform: uppercase;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box .link a i{\n    position: relative;\n    font-size: 30px;\n    font-weight: 400;\n    top: 6px;\n    margin-right: 8px;\n  }\n  \n  .service-details-content .content-two .inner-box .single-column .overlay-box .link a:hover{\n  \n  }\n  \n  .service-details-content .content-three .upper-box{\n    margin-bottom: 42px;\n  }\n  \n  .service-details-content .content-three .upper-box h3{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 40px;\n    font-weight: 700;\n    margin-bottom: 22px;\n  }\n  \n  .service-details-content .content-three .tab-btns li{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n    text-align: center;\n    margin-bottom: 20px;\n    cursor: pointer;\n    padding: 40px 30px 30px 30px;\n  }\n  \n  .service-details-content .content-three .tab-btns li.active-btn:before{\n    position: absolute;\n    content: '';\n    background: #001b44;\n    width: 30px;\n    height: 30px;\n    top: 50%;\n    margin-top: -15px;\n    right: -10px;\n    transform: rotate(-45deg);\n  }\n  \n  .service-details-content .content-three .tab-btns li.active-btn{\n    background: #001b44;\n  }\n  \n  .service-details-content .content-three .tab-btns li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .service-details-content .content-three .tab-btns li .icon-box{\n    position: relative;\n    font-size: 40px;\n    line-height: 40px;\n    margin-bottom: 20px;\n    color: #ddd2d2;\n    transition: all 500ms ease;\n  }\n  \n  .service-details-content .content-three .tab-btns li.active-btn .icon-box{\n  \n  }\n  \n  .service-details-content .content-three .tab-btns li h6{\n    position: relative;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 700;\n    text-transform: uppercase;\n    transition: all 500ms ease;\n  }\n  \n  .service-details-content .content-three .tab-btns li.active-btn h6{\n    color: #fff;\n  }\n  \n  .service-details-content .content-three .tabs-content .inner-box{\n    position: relative;\n    display: block;\n    border-radius: 10px;\n    overflow: hidden;\n  }\n  \n  .service-details-content .content-three .tabs-content .inner-box .image-box{\n    position: relative;\n    display: block;\n  }\n  \n  .service-details-content .content-three .tabs-content .inner-box .image-box img{\n    width: 100%;\n    border-radius: 10px;\n  }\n  \n  .service-details-content .content-three .tabs-content .inner-box .text{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    width: calc(100% - 30px);\n    border-top-right-radius: 10px;\n    background: #001b44;\n    padding: 34px 30px 32px 30px;\n  }\n  \n  .service-details-content .content-three .tabs-content .inner-box .text h3{\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n    color: #fff;\n    margin-bottom: 15px;\n  }\n  \n  .service-details-content .content-three .tabs-content .inner-box .text a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    line-height: 24px;\n    font-weight: 700;\n    color: #fff;\n    text-transform: uppercase;\n  }\n  \n  .service-details-content .content-three .tabs-content .inner-box .text a i{\n    position: relative;\n    font-size: 30px;\n    font-weight: 400;\n    top: 6px;\n    margin-right: 8px;\n  }\n  \n  .service-details-content .content-three .tabs-content .inner-box .text a:hover{\n  \n  }\n  \n  .service-details-content .content-three .tabs-content .inner-box .text p{\n    color: #ae979f;\n    margin-bottom: 19px;\n  }\n  \n  .service-details-content .content-three{\n    margin-bottom: 73px;\n  }\n  \n  .service-details-content .content-four .upper-box{\n    margin-bottom: 32px;\n  }\n  \n  .service-details-content .content-four .upper-box h3{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 40px;\n    font-weight: 700;\n    margin-bottom: 22px;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li{\n    position: relative;\n    display: block;\n    padding: 20px 50px 22px 80px;\n    background: #001b4421;\n    border-radius: 10px;\n    margin-bottom: 20px;\n    transition: all 500ms ease;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li:hover{\n    background: #001b44;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li .icon-box{\n    position: absolute;\n    left: 17px;\n    top: 20px;\n    font-size: 30px;\n    line-height: 30px;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li .icon-box:before{\n    position: absolute;\n    content: '';\n    background: #d9cec7;\n    width: 1px;\n    height: 32px;\n    top: -1px;\n    right: -12px;\n    transition: all 500ms ease;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li:hover .icon-box:before{\n    background: #6b555d;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li h5{\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 700;\n    transition: all 500ms ease;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li:hover h5{\n    color: #fff;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li .more-content{\n    position: absolute;\n    top: 21px;\n    right: 20px;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li .more-content .menu-icon i{\n    position: relative;\n    display: inline-block;\n    font-size: 16px;\n    width: 8px;\n    color: #b4a4a4;\n    transition: all 500ms ease;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li:hover .more-content .menu-icon i{\n    \n  }\n  \n  .service-details-content .content-four .inner-box .list-item li .more-content .text{\n    position: absolute;\n    right: -10px;\n    top: 47px;\n    width: 270px;\n    background: #fff;\n    padding: 23px 30px 22px 30px;\n    z-index: 1;\n    border-radius: 5px;\n    visibility: hidden;\n    opacity: 0;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n    transition: all 500ms ease;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li:hover .more-content .text{\n    visibility: visible;\n    opacity: 1;\n    top: 37px;\n  }\n  \n  .service-details-content .content-four .inner-box .list-item li .more-content .text:before{\n    position: absolute;\n    content: '';\n    background: #fff;\n    width: 15px;\n    height: 15px;\n    top: -5px;\n    right: 8px;\n    transform: rotate(-45deg);\n  }\n  \n  .service-details-content .content-four{\n    margin-bottom: 73px;\n  }\n  \n  .service-details-content .content-five .upper-box{\n    margin-bottom: 29px;\n  }\n  \n  .service-details-content .content-five .upper-box h3 {\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 40px;\n    font-weight: 700;\n  }\n  \n  .project-block-two .inner-box{\n    position: relative;\n    display: block;\n    overflow: hidden;\n    border-radius: 10px;\n  }\n  \n  .project-block-two .inner-box .image-box{\n    position: relative;\n    display: block;\n    border-radius: 10px;\n  }\n  \n  .project-block-two .inner-box .image-box img{\n    width: 100%;\n    border-radius: 10px;\n  }\n  \n  .project-block-two .inner-box .content-box .text{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    width: calc(100% - 60px);\n    padding: 26px 40px 21px 30px;\n    border-top-right-radius: 10px;\n    background: #001b44;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .project-block-two .inner-box:hover .content-box .text{\n    opacity: 1;\n  }\n  \n  .project-block-two .inner-box .content-box .link{\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .project-block-two .inner-box:hover .content-box .link{\n    opacity: 1;\n  }\n  \n  .project-block-two .inner-box .content-box .link a{\n    position: relative;\n    display: inline-block;\n    width: 60px;\n    height: 60px;\n    line-height: 60px;\n    font-size: 14px;\n    color: #fff;\n    font-weight: 700;\n    text-align: center;\n  }\n  \n  .project-block-two .inner-box .content-box .text span{\n    position: relative;\n    display: block;\n    font-size: 12px;\n    line-height: 20px;\n    font-weight: 700;\n    color: #ae979f;\n    text-transform: uppercase;\n    margin-bottom: 9px;\n  }\n  \n  .project-block-two .inner-box .content-box .text h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 700;\n    color: #fff;\n  }\n  \n  .project-block-two .inner-box .content-box .text h3 a{\n    display: inline-block;\n    color: #fff;\n  }\n  \n  .project-block-two .inner-box .content-box .text h3 a:hover{\n  \n  }\n  \n  .service-details-content .content-five .owl-nav {\n    position: absolute;\n    top: -60px;\n    right: 0px;\n  }\n  \n  .service-details-content .content-five .owl-nav .owl-prev, \n  .service-details-content .content-five .owl-nav .owl-next {\n    position: relative;\n    display: inline-block;\n    font-size: 30px;\n    color: #001b44;\n    font-weight: 400;\n    margin: 0px;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .service-details-content .content-five .owl-nav .owl-prev:hover, \n  .service-details-content .content-five .owl-nav .owl-next:hover{\n  \n  }\n  \n  .service-details-content .content-five .owl-nav .owl-prev{\n    margin-right: 20px;\n  }\n  \n  .service-sidebar .categories-widget{\n    position: relative;\n    display: block;\n    background: #001b4421;\n    border-radius: 10px;\n    overflow: hidden;\n    margin-bottom: 50px;\n  }\n  \n  .service-sidebar .categories-widget .categories-list li a{\n    position: relative;\n    display: block;\n    font-size: 20px;\n    line-height: 28px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #001b44;\n    font-weight: 700;\n    padding: 24px 30px 22px 30px;\n    border-bottom: 1px solid #fff;\n  }\n  \n  .service-sidebar .categories-widget .categories-list li a.active,\n  .service-sidebar .categories-widget .categories-list li a:hover{\n    background: #001b44;\n    color: #fff;\n  }\n  \n  .service-sidebar .categories-widget .categories-list li:last-child a{\n    border-bottom: none;\n  }\n  \n  .service-sidebar .categories-widget .categories-list li a:before{\n    position: absolute;\n    content: '';\n    border: 2px solid #cfc2ba;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    top: 28px;\n    right: 30px;\n    transition: all 500ms ease;\n  }\n  \n  .service-sidebar .categories-widget .categories-list li a.active:before,\n  .service-sidebar .categories-widget .categories-list li a:hover:before{\n  \n  }\n  \n  .service-sidebar .categories-widget .categories-list li a:after{\n    position: absolute;\n    content: '';\n    top: 33px;\n    right: 35px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    transform: scale(0,0);\n    transition: all 500ms ease;\n  }\n  \n  .service-sidebar .categories-widget .categories-list li a.active:after,\n  .service-sidebar .categories-widget .categories-list li a:hover:after{\n    transform: scale(1,1);\n  }\n  \n  .service-sidebar{\n    position: relative;\n    display: block;\n    margin-left: 30px;\n  }\n  \n  .service-sidebar .recruitment-widget .widget-content{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  }\n  \n  .service-sidebar .recruitment-widget .widget-content .text{\n    position: relative;\n    background: #001b44;\n    padding: 43px 130px 42px 30px;\n    min-height: 181px;\n  }\n  \n  .service-sidebar .recruitment-widget .widget-content .text h3{\n    position: relative;\n    font-size: 24px;\n    line-height: 32px;\n    color: #fff;\n    font-weight: 700;\n  }\n  \n  .service-sidebar .recruitment-widget .widget-content .text .image-box{\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n  }\n  \n  .service-sidebar .recruitment-widget .widget-content .text .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 177px;\n    height: 175px;\n    background-repeat: no-repeat;\n  }\n  \n  .service-sidebar .recruitment-widget .widget-content .link{\n    position: relative;\n    padding: 12px 30px 16px 30px;\n  }\n  \n  .service-sidebar .recruitment-widget .widget-content .link a{\n    display: inline-block;\n    font-size: 14px;\n    line-height: 24px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #001b44;\n  }\n  \n  .service-sidebar .recruitment-widget .widget-content .link a i{\n    position: relative;\n    top: 6px;\n    font-size: 30px;\n    font-weight: 400;\n    margin-right: 8px;\n  }\n  \n  .service-sidebar .recruitment-widget .widget-content .link a:hover{\n  \n  }\n  \n  .service-sidebar .recruitment-widget{\n    margin-bottom: 50px;\n  }\n  \n  .service-sidebar .subscribe-widget{\n    position: relative;\n    display: block;\n    background: #fff;\n    padding: 43px 30px 50px 30px;\n    border-radius: 10px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n  }\n  \n  .service-sidebar .subscribe-widget h3{\n    position: relative;\n    display: block;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n    margin-bottom: 26px;\n  }\n  \n  .service-sidebar .subscribe-widget .subscribe-form label{\n    position: relative;\n    display: block;\n    font-size: 18px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #001b44;\n    margin-bottom: 13px;\n  }\n  \n  .service-sidebar .subscribe-widget .subscribe-form .form-group input[type='text'],\n  .service-sidebar .subscribe-widget .subscribe-form .form-group input[type='email']{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 54px;\n    background: #001b4421;\n    border-radius: 5px;\n    padding: 10px 20px;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n  }\n  \n  .service-sidebar .subscribe-widget .subscribe-form .form-group{\n    margin-bottom: 24px;\n    position: relative;\n  }\n  \n  .service-sidebar .subscribe-widget .subscribe-form .form-group:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .service-sidebar .subscribe-widget .subscribe-form .select-box{\n    height: 54px;\n  }\n  \n  .service-sidebar .subscribe-widget .subscribe-form .nice-select{\n    border: none !important;\n    background: #001b4421;\n    height: 54px;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n  }\n  \n  .service-sidebar .subscribe-widget .subscribe-form .nice-select:after{\n    border-bottom: 2px solid #7e6970;\n    border-right: 2px solid #7e6970;\n  }\n  \n  .service-sidebar .subscribe-widget .subscribe-form button{\n    display: block;\n    width: 100%;\n  }\n  \n  \n  \n  /*** \n  \n  ====================================================================\n                          Job-Page\n  ====================================================================\n  \n  ***/\n  \n  .findjob-section{\n    position: relative;\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .findjob-section .search-inner .form-group{\n    position: relative;\n    margin: 0px;\n  }\n  \n  .findjob-section .search-inner .form-group input[type='search'],\n  .findjob-section .search-inner .form-group input[type='text'],\n  .findjob-section .search-inner .form-group input[type='email']{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 70px;\n    background: #fff;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n    padding: 10px 20px;\n    font-size: 17px;\n    color: #002c5d;\n    font-weight: 500;\n    padding-left: 50px;\n    transition: all 500ms ease;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .findjob-section .search-inner .form-group i{\n    position: absolute;\n    left: 20px;\n    top: 21px;\n    font-size: 16px;\n    color: #baabab;\n    z-index: 1;\n  }\n  \n  .findjob-section .search-inner .form-group .select-box{\n    height: 70px;\n  }\n  \n  .findjob-section .search-inner .form-group .nice-select{\n    height: 70px;\n    padding-left: 50px;\n    font-size: 17px;\n    color: #002c5d;\n    font-weight: 500;\n    background: #fff;\n    border: 1px solid #eae0d9;\n    line-height: 52px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .findjob-section .search-inner .form-group .nice-select:after{\n    border-bottom: 2px solid #ae979f;\n    border-right: 2px solid #ae979f;\n  }\n  \n  .findjob-section .search-inner .form-group.message-btn{\n    position: relative;\n    display: block;\n    margin-top: 30px;\n  }\n  \n  .findjob-section .search-inner .form-group.message-btn button{\n    display: block;\n    width: 100%;\n    padding: 22px 44px;\n  }\n  \n  .findjob-section .search-inner{\n    margin-bottom: 60px;\n  }\n  \n  .single-job-post{\n    position: relative;\n    display: block;\n    overflow: hidden;\n    border-radius: 10px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  }\n  \n  .single-job-post .job-inner{\n    border: 1px solid #eae0d9;\n    border-top: none;\n    padding: 22px 30px;\n  }\n  \n  .single-job-post .job-header{\n    position: relative;\n    display: block;\n    background: #001b4421;\n    padding: 20px 30px;\n    transition: all 500ms ease;\n  }\n  \n  .single-job-post:hover .job-header{\n    background: #001b44;\n  }\n  \n  .single-job-post .job-header .info li{\n    position: relative;\n    display: inline-block;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n    transition: all 500ms ease;\n  }\n  \n  .single-job-post .job-header .info li i{\n    color: #472c35;\n    margin-right: 8px;\n    font-weight: 600;\n    font-size: 16px;\n    transition: all 500ms ease;\n  }\n  \n  .single-job-post:hover .job-header .info li i{\n    color: rgba(255,255,255,0.5);\n  }\n  \n  .single-job-post:hover .job-header .info li{\n    color: rgba(255,255,255,0.5);\n  }\n  \n  .single-job-post .job-header .info li a{\n    display: inline-block;\n    font-size: 14px;\n    line-height: 20px;\n    margin-right: 10px;\n    color: #002c5d;\n    font-weight: 700;\n    text-transform: uppercase;\n    background: #fff;\n    padding: 4px 6px;\n    text-align: center;\n    border-radius: 5px;\n    border: 1px solid rgba(255,255,255,0.2);\n  }\n  \n  .single-job-post:hover .job-header .info li a{\n    color: rgba(255,255,255,0.5);\n    background: #3f262f;\n  }\n  \n  .single-job-post .job-header .number p{\n    font-size: 17px;\n    font-weight: 500;\n  }\n  \n  .single-job-post .job-title{\n    position: relative;\n    padding: 0px 0px 0px 80px;\n  }\n  \n  .single-job-post .job-title .company-logo{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 60px;\n    height: 60px;\n    line-height: 60px;\n    text-align: center;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n  }\n  \n  .single-job-post .job-title{\n    position: relative;\n    float: left;\n    width: 45%;\n  }\n  \n  .single-job-post .job-title:before{\n    position: absolute;\n    content: '';\n    background: #eae0d9;\n    width: 1px;\n    height: 53px;\n    top: 5px;\n    right: 30px;\n  }\n  \n  .single-job-post .job-inner .job-title h3{\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 700;\n    margin-bottom: 4px;\n  }\n  \n  .single-job-post .job-inner p{\n    position: relative;\n    font-size: 17px;\n    line-height: 28px;\n    color: #002c5d;\n    font-weight: 500;\n  }\n  \n  .single-job-post .job-inner .job-title p i{\n    font-size: 16px;\n    font-weight: 600;\n    color: #baabab;\n    margin-right: 10px;\n  }\n  \n  .single-job-post .job-inner .salary-box{\n    position: relative;\n    float: left;\n    width: 27%;\n    margin-top: 7px;\n  }\n  \n  .single-job-post .job-inner .salary-box:before{\n    position: absolute;\n    content: '';\n    background: #eae0d9;\n    width: 1px;\n    height: 53px;\n    top: -2px;\n    right: 30px;\n  }\n  \n  .single-job-post .job-inner .experience-box{\n    position: relative;\n    float: left;\n    width: 15%;\n    margin-top: 7px;\n  }\n  \n  .single-job-post .job-inner .apply-btn{\n    position: relative;\n    float: left;\n    width: 13%;\n    text-align: right;\n    margin-top: 5px;\n  }\n  \n  .single-job-post .job-inner span{\n    position: relative;\n    display: block;\n    font-size: 12px;\n    line-height: 20px;\n    font-weight: 700;\n    color: #a38f96;\n    margin-bottom: 4px;\n    text-transform: uppercase;\n  }\n  \n  .single-job-post .job-inner .apply-btn a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 20px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #001b44;\n    font-weight: 700;\n    text-transform: uppercase;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n    padding: 15.5px 47.5px;\n    z-index: 1;\n  }\n  \n  .single-job-post:hover .job-inner .apply-btn a{\n    color: #fff;\n  }\n  \n  .single-job-post{\n    margin-bottom: 40px;\n  }\n  \n  .findjob-section .post-jobs .single-job-post:last-child{\n    margin-bottom: 0px;\n  }\n  \n  \n  /** job-details **/\n  \n  .job-details{\n    position: relative;\n    padding: 130px 0px;\n  }\n  \n  .job-details-content .upper-box{\n    position: relative;\n    display: block;\n    background: #efe5df;\n    border-radius: 10px;\n    padding: 40px 40px;\n    margin-bottom: 53px;\n  }\n  \n  .job-details-content .upper-box .inner-box{\n    position: relative;\n    padding-left: 130px;\n    padding-right: 80px;\n  }\n  \n  .job-details-content .upper-box .inner-box .company-logo{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 110px;\n    height: 110px;\n    line-height: 110px;\n    background: #fff;\n    border-radius: 5px;\n    text-align: center;\n  }\n  \n  .job-details-content .upper-box .inner-box .inner span{\n    position: relative;\n    display: inline-block;\n    font-size: 12px;\n    line-height: 20px;\n    color: #002c5d;\n    text-transform: uppercase;\n    font-weight: 700;\n    background: #fff;\n    padding: 6px 13px 4px 13px;\n    border-radius: 5px;\n    margin-bottom: 15px;\n  }\n  \n  .job-details-content .upper-box .inner-box .inner h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 700;\n    margin-bottom: 4px;\n  }\n  \n  .job-details-content .upper-box .inner-box .inner p{\n    font-size: 17px;\n    font-weight: 500;\n  }\n  \n  .job-details-content .upper-box .inner-box .inner p i{\n    font-size: 16px;\n    font-weight: 600;\n    margin-right: 8px;\n    color: #b9a9a9;\n  }\n  \n  .job-details-content .upper-box .inner-box .info{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    z-index: 1;\n  }\n  \n  .job-details-content .upper-box .inner-box .info li{\n    position: relative;\n    display: block;\n    margin-bottom: 10px;\n  }\n  \n  .job-details-content .upper-box .inner-box .info li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .job-details-content .upper-box .inner-box .info li span{\n    position: absolute;\n    top: -40px;\n    right: 0px;\n    font-size: 12px;\n    line-height: 40px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #001b44;\n    font-weight: 700;\n    text-transform: uppercase;\n    background: #fff;\n    border: 1px solid #e7ddd7;\n    text-align: center;\n    width: 120px;\n    height: 40px;\n    border-radius: 5px;\n    z-index: 1;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 500ms ease;\n  }\n  \n  .job-details-content .upper-box .inner-box .info li:hover span{\n    top: -50px;\n    opacity: 1;\n    visibility: visible;\n  }\n  \n  .job-details-content .upper-box .inner-box .info li span:before{\n    position: absolute;\n    content: '';\n    background: #fff;\n    width: 10px;\n    height: 10px;\n    right: 18px;\n    bottom: -5px;\n    transform: rotate(-45deg);\n  }\n  \n  .job-details-content .upper-box .inner-box .info li a{\n    position: relative;\n    display: inline-block;\n    font-size: 20px;\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    text-align: center;\n    border-radius: 50%;\n    background: #fff;\n    color: #b4a4a4;\n    font-weight: 600;\n    z-index: 1;\n  }\n  \n  .job-details-content .upper-box .inner-box .info li a:hover{\n    background: #001b44;\n  }\n  \n  .job-details-content h2{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 40px;\n    font-weight: 700;\n    margin-bottom: 22px;\n  }\n  \n  .job-details-content .text p{\n    font-size: 17px;\n    font-weight: 500;\n    margin-bottom: 20px;\n  }\n  \n  .job-details-content .text h3{\n    position: relative;\n    display: block;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n    margin-bottom: 24px;\n    padding-top: 16px;\n  }\n  \n  .job-details-content .text .list li{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    font-weight: 500;\n    margin-bottom: 10px;\n    padding-left: 30px;\n  }\n  \n  .job-details-content .text .list li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .job-details-content .text .list li span{\n    position: relative;\n    display: inline-block;\n    width: 130px;\n    text-align: left;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #a38f96;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  .job-details-content .text .list{\n    margin-bottom: 21px;\n  }\n  \n  .job-details-content .text .list li:before{\n    position: absolute;\n    content: '>';\n    font-size: 20px;\n    line-height: 26px;\n    font-family: 'Muli', sans-serif;\n    font-weight: 700;\n    left: 0px;\n    top: 1px;\n  }\n  \n  .job-details-content .text{\n    border-bottom: 1px solid #eae0d9;\n    margin-bottom: 40px;\n    padding-bottom: 29px;\n  }\n  \n  .job-details-content .social-box .social-links li{\n    position: relative;\n    display: inline-block;\n    float: left;\n    width: 25%;\n  }\n  \n  .job-details-content .social-box .social-links li a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #fff;\n    text-transform: uppercase;\n    text-align: center;\n    width: 170px;\n    height: 54px;\n    line-height: 54px;\n    border-radius: 5px;\n    font-weight: 700;\n  }\n  \n  .job-details-content .social-box .social-links li a i{\n    margin-right: 10px;\n    font-weight: 400;\n  }\n  \n  .job-details-content .social-box .social-links li:first-child a{\n  \n  }\n  \n  .job-details-content .social-box .social-links li:nth-child(2) a{\n    \n  }\n  \n  .job-details-content .social-box .social-links li:nth-child(3) a{\n    \n  }\n  \n  .job-details-content .social-box .social-links li:last-child a{\n  \n  }\n  \n  .job-details-content .social-box .social-links{\n    margin-right: -25px;\n  }\n  \n  .job-details-content .social-box{\n    margin-bottom: 92px;\n  }\n  \n  .job-details .related-job h2{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 40px;\n    font-weight: 700;\n    margin-bottom: 29px;\n  }\n  \n  .job-details .related-job .single-job-post:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .job-sidebar .apply-btn{\n    position: relative;\n    display: block;\n    margin-bottom: 40px;\n  }\n  \n  .job-sidebar .apply-btn .theme-btn-one{\n    display: block;\n    width: 100%;\n  }\n  \n  .job-sidebar{\n    position: relative;\n    display: block;\n    margin-left: 30px;\n  }\n  \n  .job-sidebar .job-discription{\n    position: relative;\n    display: block;\n    background: #fff;\n    padding: 24px 30px 11px 30px;\n    border: 1px solid #eae0d9;\n    border-radius: 10px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  }\n  \n  .job-sidebar .job-discription .list li{\n    position: relative;\n    display: block;\n    border-bottom: 1px solid #eae0d9;\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n  }\n  \n  .job-sidebar .job-discription .list li:last-child{\n    margin-bottom: 0px;\n    border-bottom: none;\n  }\n  \n  .job-sidebar .job-discription .list li span{\n    position: relative;\n    display: block;\n    font-size: 12px;\n    line-height: 20px;\n    font-weight: 700;\n    color: #a38f96;\n    text-transform: uppercase;\n    margin-bottom: 4px;\n  }\n  \n  .job-sidebar .job-discription .list li p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n  }\n  \n  .job-sidebar .job-discription .list li p a{\n    color: #002c5d;\n  }\n  \n  .job-sidebar .job-discription .list li p a:hover{\n  \n  }\n  \n  .job-sidebar .job-discription{\n    margin-bottom: 40px;\n  }\n  \n  .job-sidebar .support-widget .widget-content{\n    position: relative;\n    display: block;\n    background: #001b44;\n    padding: 40px 30px;\n    border-radius: 10px;\n    overflow: hidden;\n  }\n  \n  .job-sidebar .support-widget .widget-content .image-box{\n    position: relative;\n    display: inline-block;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    margin-bottom: 24px;\n  }\n  \n  .job-sidebar .support-widget .widget-content .image-box img{\n    width: 100%;\n    border-radius: 50%;\n  }\n  \n  .job-sidebar .support-widget .widget-content h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    color: #fff;\n    font-weight: 700;\n  }\n  \n  .job-sidebar .support-widget .widget-content .designation{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    font-weight: 500;\n    color: rgba(255,255,255,0.5);\n    margin-bottom: 15px;\n  }\n  \n  .job-sidebar .support-widget .widget-content .support-info li{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    font-weight: 500;\n    color: #fff;\n  }\n  \n  .job-sidebar .support-widget .widget-content .support-info li a{\n    color: rgba(255,255,255,0.5);\n  }\n  \n  .job-sidebar .support-widget .widget-content .support-info li a:hover{\n  \n  }\n  \n  .job-sidebar .support-widget .widget-content .support-info{\n    margin-bottom: 22px;\n  }\n  \n  .job-sidebar .support-widget .widget-content .social-links li{\n    position: relative;\n    display: inline-block;\n    margin: 0px 3px;\n  }\n  \n  .job-sidebar .support-widget .widget-content .social-links li a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    color: #001b44;\n    background: #fff;\n    width: 42px;\n    height: 42px;\n    line-height: 42px;\n    text-align: center;\n    border-radius: 50%;\n  }\n  \n  .job-sidebar .support-widget .widget-content .social-links li a:hover{\n  \n  }\n  \n  .job-sidebar .support-widget .widget-content .pattern-layer .pattern-1{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 214px;\n    height: 149px;\n    background-repeat: no-repeat;\n  }\n  \n  .job-sidebar .support-widget .widget-content .pattern-layer .pattern-2{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    width: 209px;\n    height: 241px;\n    background-repeat: no-repeat;\n  }\n  \n  .placejob-section .form-inner .job-form .form-group i{\n    position: absolute;\n    left: 35px;\n    top: 12px;\n    font-size: 24px;\n    z-index: 1;\n  }\n  \n  .applynow-section .form-inner .pualification-form .form-group:last-child input[type='text']{\n    padding-left: 55px;\n  }\n  \n  .applynow-section .apply-form .form-group{\n    position: relative;\n    margin-bottom: 30px;\n  }\n  \n  .applynow-section .apply-form .form-group:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .applynow-section .apply-form .form-group input[type='text'],\n  .applynow-section .apply-form .form-group textarea{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 60px;\n    background: #fff;\n    padding: 10px 20px;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n    border-radius: 5px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n  }\n  \n  .applynow-section .apply-form .form-group textarea{\n    height: 140px;\n    resize: none;\n  }\n  \n  .applynow-section .apply-form .form-group .select-box{\n    height: 60px;\n  }\n  \n  .applynow-section .apply-form .form-group .nice-select{\n    border: none !important;\n    height: 60px;\n    background: #fff;\n    padding: 10px 20px;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n    border-radius: 5px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n  }\n  \n  .applynow-section .apply-form .form-group .nice-select:after{\n    border-bottom: 2px solid #ae979f;\n    border-right: 2px solid #ae979f;\n  }\n  \n  .applynow-section .apply-form .form-group button{\n    display: block;\n    width: 100%;\n  }\n  \n  \n  /** growth-style-two **/\n  \n  .growth-style-two{\n    position: relative;\n    padding: 95px 0px 125px 0px;\n  }\n  \n  .growth-style-two .sec-title .top-title:before,\n  .growth-style-two .sec-title .top-title:after{\n    background: #e2d7d0;\n  }\n  \n  .growth-style-two .sec-title .top-title:after{\n    border-left: 2px solid #001b4421;\n    border-bottom: 2px solid #001b4421;\n  }\n  \n  .growth-style-two .sec-title{\n    margin-bottom: 29px;\n  }\n  \n  .growth-style-two #content_block_1 .content-box .inner-box p{\n    margin-bottom: 15px;\n  }\n  \n  .growth-style-two .image-column{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 50%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .growth-style-two .inner-column .text{\n    position: relative;\n    display: block;\n    margin-left: 100px;\n    margin-right: 0px;\n  }\n  \n  .growth-style-two .inner-column .text h2{\n    position: relative;\n    display: block;\n    font-size: 60px;\n    line-height: 72px;\n    color: #fff;\n    font-weight: 800;\n    text-transform: uppercase;\n    margin-bottom: 17px;\n  }\n  \n  .growth-style-two .inner-column .text p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    color: #ae979f;\n    margin-bottom: 32px;\n  }\n  \n  .growth-style-two .inner-column .text .theme-btn-two{\n    padding: 15px 43px;\n  }\n  \n  \n  /** advantages-section **/\n  \n  .advantages-section{\n    position: relative;\n    padding: 95px 0px 120px 0px;\n  }\n  \n  .advantages-section .single-item .inner-box .icon-box{\n    position: relative;\n    margin-bottom: 23px;\n  }\n  \n  .advantages-section .single-item .inner-box h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 700;\n    margin-bottom: 14px;\n  }\n  \n  .advantages-section .single-item .inner-box p{\n    font-size: 17px;\n    font-weight: 500;\n    margin-bottom: 18px;\n  }\n  \n  .advantages-section .single-item .inner-box a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #001b44;\n    text-transform: uppercase;\n  }\n  \n  .advantages-section .owl-dots{\n    display: block;\n    text-align: center;\n    margin-top: 36px;\n  }\n  \n  .advantages-section .single-item .inner-box a i{\n    position: relative;\n    font-size: 30px;\n    font-weight: 400;\n    margin-right: 10px;\n    top: 6px;\n  }\n  \n  .advantages-section .single-item .inner-box a:hover{\n  \n  }\n  \n  .advantages-section .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    width: 100%;\n    height: 100%;\n    background-position: center;\n    background-repeat: no-repeat;\n  }\n  \n  .pricing-section.overview-page-2 .sec-title .top-title:before,\n  .pricing-section.overview-page-2 .sec-title .top-title:after{\n    background: #fff;\n  }\n  \n  .pricing-section.overview-page-2 .sec-title .top-title:after{\n    border-left: 2px solid #001b4421;\n    border-bottom: 2px solid #001b4421;\n  }\n  \n  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box{\n    background: #001b44;\n  }\n  \n  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box h3{\n    color: #fff;\n  }\n  \n  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box .text{\n    color: #001b4421;\n  }\n  \n  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box p{\n    color: #001b4421;\n  }\n  \n  .pricing-section.overview-page-2 .pricing-block-one.popular .inner-box a{\n  \n  }\n  \n  \n  /*** \n  \n  ====================================================================\n                          Blog-Page\n  ====================================================================\n  \n  ***/\n  \n  .sidebar-page-container{\n    position: relative;\n    padding: 130px 0px;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box{\n    margin-bottom: 30px;\n  }\n  \n  .sidebar-page-container .more-btn a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #001b44;\n    border-radius: 4px;\n    text-align: center;\n    padding: 14px 42px;\n    text-transform: uppercase;\n    z-index: 1;\n  }\n  \n  .sidebar-page-container .more-btn a:hover{\n    color: #fff;\n  }\n  \n  .sidebar-page-container .more-btn{\n    position: relative;\n    margin-top: 30px;\n  }\n  \n  .blog-sidebar .search-widget .search-form .form-group{\n    position: relative;\n    margin: 0px;\n  }\n  \n  .blog-sidebar .search-widget .search-form .form-group input[type='search']{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 58px;\n    background: #001b4421;\n    border-radius: 5px;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n    padding: 10px 50px 10px 20px;\n  }\n  \n  .blog-sidebar .search-widget .search-form .form-group button{\n    position: absolute;\n    top: 7px;\n    right: 8px;\n    width: 44px;\n    height: 44px;\n    line-height: 44px;\n    background: #001b44;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    color: #fff;\n    border-radius: 5px;\n    transition: all 500ms ease;\n  }\n  \n  .blog-sidebar .search-widget .search-form .form-group input:focus + button,\n  .blog-sidebar .search-widget .search-form .form-group button:hover{\n  \n  }\n  \n  .blog-sidebar .search-widget{\n    margin-bottom: 50px;\n  }\n  \n  .blog-sidebar .sidebar-widget{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n    margin-bottom: 50px;\n  }\n  \n  .blog-sidebar .sidebar-widget .widget-title{\n    position: relative;\n    display: block;\n    padding: 18px 30px 17px 65px;\n    border-bottom: 1px solid #eae0d9;\n  }\n  \n  .blog-sidebar .sidebar-widget .widget-title:before{\n    position: absolute;\n    content: '';\n    width: 30px;\n    height: 3px;\n    left: 30px;\n    bottom: -2px;\n  }\n  \n  .blog-sidebar .sidebar-widget .widget-title h3{\n    position: relative;\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 700;\n  }\n  \n  .blog-sidebar .sidebar-widget .widget-title i{\n    position: absolute;\n    left: 30px;\n    top: 25px;\n    font-size: 20px;\n    line-height: 20px;\n  }\n  \n  .blog-sidebar .sidebar-widget .widget-content{\n    position: relative;\n    padding: 34px 30px 31px 30px;\n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li{\n    position: relative;\n    display: block;\n    margin-bottom: 16px;\n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li a{\n    position: relative;\n    display: inline-block;\n    font-size: 12px;\n    line-height: 20px;\n    font-family: 'Muli', sans-serif;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #001b44;\n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li a:before{\n    position: absolute;\n    content: '';\n    width: 3px;\n    height: 30px;\n    left: -30px;\n    top: -7px;\n    transform: scale(0,0);\n    transition: all 500ms ease;\n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li a:hover:before{\n    transform: scale(1,1);\n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li a:hover{\n  \n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li a span{\n    position: absolute;\n    display: inline-block;\n    top: -6px;\n    right: -18px;\n    color: #a38f96;\n    transition: all 500ms ease;\n  }\n  \n  .blog-sidebar .categories-widget .widget-content .list li a:hover span{\n  \n  }\n  \n  .blog-sidebar .post-widget .widget-content .post{\n    position: relative;\n    display: block;\n    padding-left: 100px;\n    padding-bottom: 26px;\n    margin-bottom: 29px;\n    min-height: 107px;\n    border-bottom: 1px solid #eae0d9;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post:last-child{\n    margin-bottom: 0px;\n    border-bottom: none;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post .post-thumb{\n    position: absolute;\n    left: 0px;\n    top: 1px;\n    width: 75px;\n    height: 75px;\n    border-radius: 10px;\n    overflow: hidden;\n    z-index: 1;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post .post-thumb img{\n    width: 100%;\n    border-radius: 10px;\n    transition: all 500ms ease;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post:hover .post-thumb img{\n    opacity: 0.2;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post .post-thumb:before{\n    position: absolute;\n    content: '';\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 0px;\n    opacity: 0;\n    z-index: -1;\n    transition: all 500ms ease;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post:hover .post-thumb:before{\n    opacity: 1;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post .post-date{\n    position: relative;\n    display: block;\n    font-size: 12px;\n    line-height: 20px;\n    color: #a38f96;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post h5{\n    position: relative;\n    display: block;\n    font-size: 18px;\n    line-height: 26px;\n    font-weight: 700;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post h5 a{\n    display: inline-block;\n    color: #001b44;\n  }\n  \n  .blog-sidebar .post-widget .widget-content .post h5 a:hover{\n  \n  }\n  \n  .blog-sidebar .post-widget .widget-content {\n    padding: 40px 30px 9px 30px;\n  }\n  \n  .blog-sidebar .sidebar-tags .tags-list li{\n    position: relative;\n    display: inline-block;\n    float: left;\n    margin-right: 10px;\n    margin-bottom: 10px;\n  }\n  \n  .blog-sidebar .sidebar-tags .tags-list li a{\n    position: relative;\n    display: inline-block;\n    font-size: 12px;\n    line-height: 20px;\n    font-family: 'Muli', sans-serif;\n    color: #a38f96;\n    text-transform: uppercase;\n    padding: 10px 8px 8px 8px;\n    text-align: center;\n    font-weight: 700;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.08);\n  }\n  \n  .blog-sidebar .sidebar-tags .tags-list li a:hover{\n    background: #001b44;\n    border-color: #001b44;\n    color: #fff;\n  }\n  \n  .blog-sidebar .sidebar-tags .widget-content {\n    padding: 41px 30px 30px 30px;\n  }\n  \n  .blog-sidebar .gallery-widget .image-list{\n    position: relative;\n    margin: 0px -2.5px;\n  }\n  \n  .blog-sidebar .gallery-widget .image-list li{\n    position: relative;\n    float: left;\n    width: 100px;\n    height: 100px;\n    margin: 0px 2.5px;\n    margin-bottom: 5px;\n  }\n  \n  .blog-sidebar .gallery-widget .image-list li .image-box{\n    position: relative;\n    display: block;\n    width: 100px;\n    height: 100px;\n    border-radius: 5px;\n    overflow: hidden;\n    z-index: 1;\n  }\n  \n  .blog-sidebar .gallery-widget .image-list li .image-box img{\n    width: 100%;\n    border-radius: 5px;\n    transition: all 500ms ease;\n  }\n  \n  .blog-sidebar .gallery-widget .image-list li .image-box:hover img{\n    opacity: 0.2;\n  }\n  \n  .blog-sidebar .gallery-widget .image-list li .image-box:before{\n    position: absolute;\n    content: '';\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 0px;\n    opacity: 0;\n    z-index: -1;\n    transition: all 500ms ease;\n  }\n  \n  .blog-sidebar .gallery-widget .image-list li .image-box:hover:before{\n    opacity: 1;\n  }\n  \n  .blog-sidebar .gallery-widget .widget-content {\n    padding: 41px 30px 35px 30px;\n  }\n  \n  .blog-sidebar .sidebar-resource .inner-box{\n    position: relative;\n    display: block;\n    overflow: hidden;\n    background: #001b4421;\n    border-radius: 10px;\n    padding: 60px 50px;\n  }\n  \n  .blog-sidebar .sidebar-resource .inner-box .iocn-box{\n    position: relative;\n    margin-bottom: 23px;\n  }\n  \n  .blog-sidebar .sidebar-resource .inner-box h3{\n    position: relative;\n    display: block;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n    margin-bottom: 27px;\n  }\n  \n  .blog-sidebar .sidebar-resource .inner-box a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 20px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #001b44;\n    font-weight: 700;\n    text-transform: uppercase;\n    background: #fff;\n    border-radius: 5px;\n    padding: 18px 65px 16px 20px;\n  }\n  \n  .blog-sidebar .sidebar-resource .inner-box a i{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 46px;\n    height: 100%;\n    line-height: 100%;\n    text-align: center;\n    font-size: 24px;\n    border-left: 2px solid #ded4ce;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .blog-sidebar .sidebar-resource .inner-box a:hover{\n  \n  }\n  \n  .blog-sidebar .sidebar-resource .inner-box .pattern-layer .pattern-1{\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 198px;\n    height: 119px;\n    background-repeat: no-repeat;\n  }\n  \n  .blog-sidebar .sidebar-resource .inner-box .pattern-layer .pattern-2{\n    position: absolute;\n    left: 0px;\n    bottom: 0px;\n    width: 219px;\n    height: 225px;\n    background-repeat: no-repeat;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner h2{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 38px;\n    color: #fff;\n    font-weight: 700;\n    margin-bottom: 18px;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner h2 a{\n    display: inline-block;\n    color: #fff;\n  }\n  \n  .news-block-one .inner-box .lower-content .inner h2 a:hover{\n  \n  }\n  \n  .news-block-one .inner-box .lower-content .inner p{\n    font-size: 17px;\n    font-weight: 500;\n    color: rgba(255,255,255,0.5);\n    margin-bottom: 25px;\n  }\n  \n  .sidebar-page-container.blog-list .news-block-one .inner-box .lower-content .inner .post-info li:first-child{\n    padding-left: 50px;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .post-info li img{\n    position: absolute;\n    left: 0px;\n    top: -3px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner{\n    padding: 33px 30px 47px 40px;\n    margin-top: -190px;\n    border-radius: 0px 10px 10px 10px;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .category{\n    margin-bottom: 16px;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box{\n    position: absolute;\n    right: 40px;\n    bottom: 40px;\n    margin-left: 15px;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box:before{\n    position: absolute;\n    left: 0px;\n    top: -17px;\n    content: '';\n    width: 100%;\n    height: 17px;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .share-link{\n    position: relative;\n    display: inline-block;\n    font-size: 16px;\n    color: rgba(255,255,255,0.6);\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n    border: 1px solid rgba(255,255,255,0.2);\n    border-radius: 50%\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .share-link:hover{\n    color: #fff;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links{\n    position: absolute;\n    right: 0px;\n    bottom: 47px;\n    min-width: 115px;\n    background: #fff;\n    border-radius: 5px;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 500ms ease;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box:hover .social-links{\n    opacity: 1;\n    visibility: visible;\n    bottom: 57px;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links:before{\n    position: absolute;\n    content: '';\n    background: #fff;\n    width: 10px;\n    height: 10px;\n    bottom: -5px;\n    right: 14px;\n    transform: rotate(-45deg);\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li{\n    position: relative;\n    display: inline-block;\n    float: left;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li a{\n    position: relative;\n    display: inline-block;\n    font-size: 16px;\n    color: #001b44;\n    width: 35px;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li a:before{\n    position: absolute;\n    content: '';\n    background: #d9cec7;\n    width: 1px;\n    height: 20px;\n    top: 10px;\n    right: 0px;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li:last-child a:before{\n    display: none;\n  }\n  \n  .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box .social-links li a:hover{\n  \n  }\n  \n  .blog-list .news-block-one .inner-box{\n    margin-bottom: 80px;\n  \n  }\n  \n  .blog-list .news-block-one .inner-box .owl-nav{\n    position: absolute;\n    right: 40px;\n    bottom: 210px;\n  }\n  \n  .blog-list .news-block-one .inner-box .owl-nav .owl-prev,\n  .blog-list .news-block-one .inner-box .owl-nav .owl-next{\n    position: relative;\n    display: inline-block;\n    font-size: 10px;\n    font-weight: 700;\n    color: #001b44;\n    background: #fff;\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .blog-list .news-block-one .inner-box .owl-nav .owl-prev{\n    margin-right: 5px;\n  }\n  \n  .blog-list .news-block-one .inner-box .owl-nav .owl-prev:hover,\n  .blog-list .news-block-one .inner-box .owl-nav .owl-next:hover{\n    color: #fff;\n  }\n  \n  .page-title .news-block-one .inner-box{\n    margin-bottom: -20px;\n    max-width: 770px;\n    margin-top: 90px;\n  }\n  \n  .page-title .news-block-one .inner-box .lower-content .inner{\n    border-radius: 10px 10px 0px 0px;\n    margin-top: 0px;\n    padding-bottom: 47px;\n  }\n  \n  .page-title .news-block-one .inner-box .lower-content .inner .post-info li:first-child {\n    padding-left: 50px;\n  }\n  \n  .page-title .news-block-one .inner-box .lower-content .inner .post-info li img {\n    position: absolute;\n    left: 0px;\n    top: -3px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n  }\n  \n  .page-title .news-block-one .inner-box .post-date {\n    position: absolute;\n    right: 20px;\n    top: -30px;\n    width: 70px;\n    height: 70px;\n    line-height: 22px;\n    text-align: center;\n    font-size: 16px;\n    color: #fff;\n    font-weight: 700;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px;\n  }\n  \n  .page-title .news-block-one .inner-box .lower-content{\n    padding-right: 0px;\n  }\n  \n  .page-title .news-block-one .inner-box .lower-content .inner h2{\n    margin-bottom: 25px;\n  }\n  \n  .blog-details-content .inner-box .post-time{\n    position: relative;\n    margin-bottom: 33px;\n  }\n  \n  .blog-details-content .inner-box .post-time h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 32px;\n    font-weight: 700;\n  }\n  \n  .blog-details-content .inner-box .post-time h3 i{\n    position: relative;\n    font-size: 18px;\n    margin-right: 10px;\n  }\n  \n  .blog-details-content .inner-box .image-box{\n    position: relative;\n    display: block;\n    margin-bottom: 43px;\n    border-radius: 10px;\n  }\n  \n  .blog-details-content .inner-box .image-box img{\n    width: 100%;\n    border-radius: 10px;\n  }\n  \n  .blog-details-content .inner-box .text p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    margin-bottom: 20px;\n  }\n  \n  .blog-details-content .inner-box .text h2{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 40px;\n    font-weight: 700;\n    margin-bottom: 22px;\n    padding-top: 15px;\n  }\n  \n  .blog-details-content .inner-box .text h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    margin-bottom: 10px;\n    padding-left: 50px;\n    padding-top: 9px;\n  }\n  \n  .blog-details-content .inner-box .text h3:before{\n    position: absolute;\n    content: '';\n    width: 40px;\n    height: 2px;\n    left: 0px;\n    top: 14px;\n  }\n  \n  .blog-details-content .inner-box .text .list li{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    padding-left: 32px;\n    margin-bottom: 10px;\n  }\n  \n  .blog-details-content .inner-box .text .list{\n    position: relative;\n    padding-top: 5px;\n  }\n  \n  .blog-details-content .inner-box .text .list li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .blog-details-content .inner-box .text .list li:before{\n    position: absolute;\n    content: '*';\n    font-size: 30px;\n    font-weight: 700;\n    font-family: 'Muli', sans-serif;\n    left: 0px;\n    top: 7px;\n  }\n  \n  .blog-details-content .inner-box .two-column{\n    position: relative;\n    padding: 43px 0px;\n  }\n  \n  .blog-details-content .inner-box .two-column .content-box{\n    position: relative;\n    display: block;\n    padding: 80px 50px 70px 40px;\n    width: 100%;\n    border-radius: 10px;\n    overflow: hidden;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n  \n  .blog-details-content .inner-box .two-column .content-box:before{\n    position: absolute;\n    content: '';\n    background: #001b44;\n    width: 100%;\n    height: 100%;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    opacity: 0.9;\n  }\n  \n  .blog-details-content .inner-box .two-column .content-box .inner{\n    position: relative;\n    z-index: 1;\n  }\n  \n  .blog-details-content .inner-box .two-column .content-box .icon-box{\n    position: relative;\n    margin-bottom: 30px;\n  }\n  \n  .blog-details-content .inner-box .two-column .content-box p{\n    position: relative;\n    font-size: 20px;\n    line-height: 32px;\n    color: #fff;\n    margin-bottom: 25px;\n  }\n  \n  .blog-details-content .inner-box .two-column .content-box h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    color: #fff;\n    font-weight: 700;\n  }\n  \n  .blog-details-content .inner-box .two-column .image-box{\n    position: relative;\n    display: block;\n    border-radius: 10px;\n    margin-bottom: 0px;\n  }\n  \n  .blog-details-content .inner-box .two-column .image-box img{\n    width: 100%;\n    border-radius: 10px;\n  }\n  \n  .blog-details-content .inner-box .two-column .content-box .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n  \n  .blog-details-content .inner-box{\n    margin-bottom: 72px;\n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li{\n    position: relative;\n    display: inline-block;\n    float: left;\n    width: 25%;\n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    font-family: 'Nunito Sans', sans-serif;\n    color: #fff;\n    text-transform: uppercase;\n    text-align: center;\n    width: 170px;\n    height: 54px;\n    line-height: 54px;\n    border-radius: 5px;\n    font-weight: 700;\n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li a i{\n    margin-right: 10px;\n    font-weight: 400;\n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li:first-child a{\n  \n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li:nth-child(2) a{\n    \n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li:nth-child(3) a{\n    \n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links li:last-child a{\n  \n  }\n  \n  .blog-details-content .post-share-option .social-box .social-links{\n    margin-right: -25px;\n  }\n  \n  .blog-details-content .post-share-option .tag-list li{\n    position: relative;\n    display: inline-block;\n    margin: 0px 2px;\n  }\n  \n  .blog-details-content .post-share-option .tag-list li a{\n    position: relative;\n    display: inline-block;\n    font-size: 12px;\n    line-height: 20px;\n    font-family: 'Muli', sans-serif;\n    color: #a38f96;\n    text-transform: uppercase;\n    padding: 10px 8px 8px 8px;\n    text-align: center;\n    font-weight: 700;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.08);\n  }\n  \n  .blog-details-content .post-share-option .tag-list li a:hover{\n    color: #fff;\n    background: #001b44;\n    border-color: #001b44;\n  }\n  \n  .blog-details-content .post-share-option .tag-list{\n    margin-bottom: 50px;\n  }\n  \n  .blog-details-content .post-share-option{\n    position: relative;\n    display: block;\n    padding: 60px 0px 50px 0px;\n    border-top: 1px solid #eae0d9;\n  }\n  \n  .blog-details-content .post-share-option:before{\n    position: absolute;\n    content: '';\n    background: #fff;\n    width: 110px;\n    height: 3px;\n    left: 50%;\n    transform: translateX(-50%);\n    top: -1px;\n  }\n  \n  .blog-details-content .post-share-option .icon-box{\n    position: absolute;\n    left: 50%;\n    top: -31px;\n    transform: translateX(-50%);\n    width: 60px;\n    height: 60px;\n    line-height: 60px;\n    background: #fff;\n    font-size: 24px;\n    color: #001b44;\n    text-align: center;\n    border-radius: 50%;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n  }\n  \n  .blog-details-content .author-box{\n    position: relative;\n    display: block;\n    background: #fff;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0px 19px 30px rgba(0, 0, 0, 0.08);\n    padding: 40px 80px 50px 80px;\n    margin-bottom: 50px;\n  }\n  \n  .blog-details-content .author-box:before{\n    position: absolute;\n    content: '';\n    background: #001b4421;\n    width: 100%;\n    height: 90px;\n    left: 0px;\n    top: 0px;\n  }\n  \n  .blog-details-content .author-box .inner .image-box{\n    position: relative;\n    display: inline-block;\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    margin-bottom: 24px;\n  }\n  \n  .blog-details-content .author-box .inner .image-box img{\n    width: 100%;\n    border-radius: 50%;\n  }\n  \n  .blog-details-content .author-box .inner h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    margin-bottom: 5px;\n  }\n  \n  .blog-details-content .author-box .inner span{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    font-weight: 500;\n    color: #a38f96;\n    margin-bottom: 15px;\n  }\n  \n  .blog-details-content .author-box .inner span a{\n    display: inline-block;\n    color: #a38f96;\n  }\n  \n  .blog-details-content .author-box .inner span a:hover{\n  \n  }\n  \n  .blog-details-content .author-box .inner p{\n    font-size: 17px;\n    font-weight: 500;\n    margin-bottom: 22px;\n  }\n  \n  .blog-details-content .author-box .social-links li{\n    position: relative;\n    display: inline-block;\n    margin: 0px 3px;\n  }\n  \n  .blog-details-content .author-box .social-links li a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    color: #001b44;\n    width: 42px;\n    height: 42px;\n    line-height: 42px;\n    text-align: center;\n    border: 1px solid #eae1da;\n    border-radius: 50%;\n  }\n  \n  .blog-details-content .author-box .social-links li a:hover{\n    background: #eae1da;\n  }\n  \n  .blog-details-content .author-box .icon-layer{\n    position: absolute;\n    left: 35px;\n    top: 10px;\n    width: 210px;\n    height: 169px;\n    background-repeat: no-repeat;\n  }\n  \n  .blog-details-content .author-box .signature{\n    position: absolute;\n    top: 40px;\n    right: 40px;\n  }\n  \n  .blog-details-content .nav-btn-box .left-btn,\n  .blog-details-content .nav-btn-box .right-btn{\n    position: relative;\n    display: block;\n    background: #eae0d9;\n    border-radius: 5px;\n  }\n  \n  .blog-details-content .nav-btn-box .left-btn{\n    padding: 21px 50px 23px 65px;\n    margin-left: 35px;\n  }\n  \n  .blog-details-content .nav-btn-box .right-btn{\n    padding: 21px 65px 23px 50px;\n    margin-right: 35px;\n    text-align: right;\n  }\n  \n  .blog-details-content .nav-btn-box .left-btn .image-box{\n    position: absolute;\n    left: -35px;\n    top: 30px;\n    width: 70px;\n    height: 70px;\n    border-radius: 5px;\n  }\n  \n  .blog-details-content .nav-btn-box .right-btn .image-box{\n    position: absolute;\n    right: -35px;\n    top: 30px;\n    width: 70px;\n    height: 70px;\n    border-radius: 5px;\n  }\n  \n  .blog-details-content .nav-btn-box .image-box img{\n    width: 100%;\n    border-radius: 5px;\n  }\n  \n  .blog-details-content .nav-btn-box .inner a{\n    position: relative;\n    display: inline-block;\n    font-size: 12px;\n    line-height: 20px;\n    font-family: 'Muli', sans-serif;\n    color: #a38f96;\n    font-weight: 700;\n    text-transform: uppercase;\n    margin-bottom: 9px;\n  }\n  \n  .blog-details-content .nav-btn-box .left-btn:hover .inner a{\n    padding-left: 25px;\n  }\n  \n  .blog-details-content .nav-btn-box .right-btn:hover .inner a{\n    padding-right: 25px;\n  }\n  \n  .blog-details-content .nav-btn-box .left-btn .inner a i{\n    left: 0px;\n  }\n  \n  .blog-details-content .nav-btn-box .right-btn .inner a i{\n    right: 0px;\n  }\n  \n  .blog-details-content .nav-btn-box .inner a i{\n    position: absolute;\n    top: -1px;\n    display: inline-block;\n    font-size: 16px;\n    opacity: 0;\n    transition: all 500ms ease;\n  }\n  \n  .blog-details-content .nav-btn-box .left-btn:hover .inner a i,\n  .blog-details-content .nav-btn-box .right-btn:hover .inner a i{\n    opacity: 1;\n  }\n  \n  .blog-details-content .nav-btn-box .inner h5{\n    position: relative;\n    display: block;\n    font-size: 18px;\n    line-height: 26px;\n    font-weight: 700;\n  }\n  \n  .blog-details-content .nav-btn-box{\n    position: relative;\n    margin-bottom: 90px;\n  }\n  \n  .group-title{\n    position: relative;\n    display: block;\n    margin-bottom: 24px;\n  }\n  \n  .group-title h2{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 38px;\n    font-weight: 700;\n    margin: 0px;\n  }\n  \n  .blog-details-content .comment-box .comment{\n    position: relative;\n    display: block;\n    border-bottom: 1px solid #eae1da;\n    margin-bottom: 34px;\n    padding: 0px 0px 32px 110px;\n    min-height: 174px;\n  }\n  \n  .blog-details-content .comment-box .comment.reply-comment{\n    margin-left: 40px;\n  }\n  \n  .blog-details-content .comment-box .comment:last-child{\n    margin-bottom: 0px;\n    border-bottom: none;\n  }\n  \n  .blog-details-content .comment-box .comment .thumb-box{\n    position: absolute;\n    left: 0px;\n    top: 6px;\n    width: 80px;\n    height: 80px;\n    border-radius: 5px;\n  }\n  \n  .blog-details-content .comment-box .comment .thumb-box img{\n    width: 100%;\n    border-radius: 5px;\n  }\n  \n  .blog-details-content .comment-box .comment .comment-inner .comment-info{\n    position: relative;\n    margin-bottom: 14px;\n  }\n  \n  .blog-details-content .comment-box .comment .comment-inner .comment-info h3{\n    position: relative;\n    display: block;\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n  }\n  \n  .blog-details-content .comment-box .comment .comment-inner .comment-info .comment-time{\n    position: absolute;\n    top: 2px;\n    right: 0px;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #a38f96;\n    border-bottom: 1px solid #a38f96;\n  }\n  \n  .blog-details-content .comment-box .comment .comment-inner p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    margin-bottom: 13px;\n  }\n  \n  .blog-details-content .comment-box .comment .comment-inner .reply-btn{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 20px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n  \n  .blog-details-content .comment-box .comment .comment-inner .reply-btn i{\n    position: relative;\n    display: inline-block;\n    font-size: 20px;\n    font-weight: 400;\n    margin-right: 10px;\n    top: 2px;\n  }\n  \n  .blog-details-content .comment-box .comment .comment-inner .reply-btn:hover{\n    color: #001b44;\n  }\n  \n  .blog-details-content .comments-form-area{\n    position: relative;\n    display: block;\n    background: #fff;\n    padding: 44px 50px 50px 50px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n    border-radius: 5px;\n  }\n  \n  .blog-details-content .comments-form-area .comment-form .form-group{\n    position: relative;\n    margin-bottom: 20px;\n  }\n  \n  .blog-details-content .comments-form-area .comment-form .form-group:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .blog-details-content .comments-form-area .comment-form .form-group input[type='text'],\n  .blog-details-content .comments-form-area .comment-form .form-group input[type='email'],\n  .blog-details-content .comments-form-area .comment-form .form-group textarea{\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 56px;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n    padding: 10px 20px;\n    font-size: 17px;\n    font-weight: 500;\n    color: #002c5d;\n    transition: all 500ms ease;\n  }\n  \n  .blog-details-content .comments-form-area .comment-form .form-group textarea{\n    resize: none;\n    height: 120px;\n  }\n  \n  .blog-details-content .comments-form-area .comment-form .message-btn button{\n    display: block;\n    width: 100%;\n  }\n  \n  .blog-details-content .comments-form-area .comment-form .form-group input:focus,\n  .blog-details-content .comments-form-area .comment-form .form-group textarea:focus{\n  \n  }\n  \n  .blog-details-content .comments-form-area .group-title h2{\n    margin-bottom: 8px;\n  }\n  \n  .blog-details-content .comments-form-area .group-title p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n  }\n  \n  .blog-details-content .comments-form-area .group-title{\n    margin-bottom: 32px;\n  }\n  \n  \n  \n  /*** \n  \n  ====================================================================\n                          Portfolio-Page\n  ====================================================================\n  \n  ***/\n  \n  .protfolio-page{\n    position: relative;\n    padding: 130px 0px;\n  }\n  \n  .protfolio-page .project-block-two .inner-box{\n    margin-bottom: 30px;\n  }\n  \n  .protfolio-page .more-btn{\n    position: relative;\n    margin-top: 30px;\n  }\n  \n  .protfolio-page .more-btn a{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 26px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #001b44;\n    border-radius: 4px;\n    text-align: center;\n    padding: 14px 42px;\n    text-transform: uppercase;\n    z-index: 1;\n  }\n  \n  .protfolio-page .more-btn a:hover{\n    color: #fff;\n  }\n  \n  .protfolio-page .filters{\n    position: relative;\n    display: block;\n    text-align: center;\n    margin-bottom: 60px;\n  }\n  \n  .protfolio-page .filters .filter-tabs{\n    position: relative;\n    display: inline-block;\n    border: 1px solid #eae0d9;\n    border-radius: 5px;\n    padding: 10px 0px;\n  }\n  \n  .protfolio-page .filters .filter-tabs:before{\n    position: absolute;\n    content: '';\n    width: 3px;\n    height: 12px;\n    left: -2px;\n    top: 19px;\n  }\n  \n  .protfolio-page .filters .filter-tabs li{\n    position: relative;\n    display: inline-block;\n    font-size: 14px;\n    line-height: 24px;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 700;\n    color: #001b44;\n    text-transform: uppercase;\n    margin: 0px 17px;\n    cursor: pointer;\n    transition: all 500ms ease;\n  }\n  \n  .protfolio-page .filters .filter-tabs li:before{\n    position: absolute;\n    content: '';\n    background: #d9cec7;\n    width: 3px;\n    height: 6px;\n    top: 8px;\n    right: -21px;\n    transition: all 500ms ease;\n  }\n  \n  .protfolio-page .filters .filter-tabs li:last-child:before{\n    display: none;\n  }\n  \n  .protfolio-page .filters .filter-tabs li.active:before,\n  .protfolio-page .filters .filter-tabs li:hover:before{\n    height: 12px;\n    top: 7px;\n  }\n  \n  .protfolio-page .filters .filter-tabs li.active,\n  .protfolio-page .filters .filter-tabs li:hover{\n  \n  }\n  \n  .protfolio-page .pagination-wrapper{\n    margin-top: 30px;\n  }\n  \n  .protfolio-page .project-block-one .inner-box{\n    margin-bottom: 30px;\n  }\n  \n  .protfolio-page .project-block-one .inner-box:hover .image-box img {\n    opacity: 0.2;\n  }\n  \n  .protfolio-page .project-block-one .inner-box .content-box{\n    padding: 15px 30px;\n  }\n  \n  .protfolio-page .outer-container{\n    position: relative;\n    padding: 0px 30px;\n  }\n  \n  .portfolio-wide-2 .masonry-item{\n    float: left;\n    width: 20%;\n    padding: 0px 15px;\n  }\n  \n  .portfolio-wide-2 .sortable-masonry{\n    margin: 0px -15px;\n  }\n  \n  \n  /*** \n  \n  ====================================================================\n                          Error-Page\n  ====================================================================\n  \n  ***/\n  \n  .error-section{\n    position: relative;\n    padding: 130px 0px;\n  }\n  \n  .error-section .error-content .image-box{\n    position: relative;\n    display: block;\n    margin-bottom: 36px;\n  }\n  \n  .error-section .error-content .image-box img{\n    width: 100%;\n  }\n  \n  .error-section .error-content h2{\n    position: relative;\n    display: block;\n    font-size: 48px;\n    line-height: 60px;\n    font-weight: 700;\n    margin-bottom: 8px;\n  }\n  \n  .error-section .error-content p{\n    font-size: 20px;\n    line-height: 30px;\n    font-weight: 400;\n    margin-bottom: 32px;\n  }\n  \n  .error-section .error-content .theme-btn-two{\n    padding: 15px 32px;\n  }\n  \n  \n  /*** \n  \n  ====================================================================\n                          Contact-Page\n  ====================================================================\n  \n  ***/\n  \n  .contact-section .form-inner {\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n  }\n  \n  .contact-page-section .form-inner{\n    position: relative;\n    display: block;\n    background: #fff;\n    padding: 50px 50px;\n    padding-top: 43px;\n    box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n    margin-top: 31px;\n  }\n  \n  .contact-page-section .form-inner h2{\n    position: relative;\n    display: block;\n    font-size: 30px;\n    line-height: 40px;\n    font-weight: 700;\n    margin-bottom: 29px;\n  }\n  \n  .contact-page-section #content_block_6 .content-box .sec-title p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    margin-top: 10px;\n  }\n  \n  .contact-page-section #content_block_6 .content-box .sec-title p span{\n    font-weight: 700;\n    color: #001b44;\n  }\n  \n  .contact-page-section #content_block_6 .content-box .sec-title{\n    margin-bottom: 36px;\n  }\n  \n  \n  /** locations-section **/\n  \n  .locations-section{\n    position: relative;\n    padding: 130px 0px;\n  }\n  \n  .locations-section .single-item .inner-box{\n    position: relative;\n    display: block;\n    background: #fff;\n    padding: 34px 40px 37px 40px;\n    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.06);\n  }\n  \n  .locations-section .single-item .inner-box .upper-box{\n    position: relative;\n    margin-bottom: 18px;\n  }\n  \n  .locations-section .single-item .inner-box .upper-box h3{\n    font-size: 22px;\n    line-height: 30px;\n    font-weight: 700;\n    margin-bottom: 10px;\n  }\n  \n  .locations-section .single-item .inner-box .upper-box p{\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n  }\n  \n  .locations-section .single-item .inner-box .info-list li{\n    position: relative;\n    display: block;\n    padding-left: 70px;\n    margin-bottom: 14px;\n  }\n  \n  .locations-section .single-item .inner-box .info-list li:last-child{\n    margin-bottom: 0px;\n  }\n  \n  .locations-section .single-item .inner-box .info-list li i{\n    position: absolute;\n    left: 0px;\n    top: 4px;\n    font-size: 18px;\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    text-align: center;\n    background: #001b4421;\n    border-radius: 50%;\n    transition: all 500ms ease;\n  }\n  \n  .locations-section .single-item .inner-box .info-list li:hover i{\n    background: #001b44;\n  }\n  \n  .locations-section .single-item .inner-box .info-list li p{\n    position: relative;\n    display: block;\n    font-size: 17px;\n    line-height: 28px;\n    color: #001b44;\n    font-weight: 700;\n    margin-bottom: 0px;\n  }\n  \n  .locations-section .single-item .inner-box .info-list li a{\n    position: relative;\n    display: inline-block;\n    font-size: 17px;\n    line-height: 28px;\n    font-weight: 500;\n    color: #002c5d;\n  }\n  \n  .locations-section .single-item .inner-box .info-list li a:hover{\n  \n  }\n  \n  .locations-section .pattern-layer{\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    width: 100%;\n    height: 100%;\n    background-repeat: repeat-x;\n    animation: slide 100s linear infinite;\n    -webkit-animation: slide 100s linear infinite;\n  }\n  a {\n     text-decoration: auto !important;\n}\n\n\n.progress-wrap {\n  position: fixed;\n  right: 50px;\n  bottom: 111px;\n  height: 46px;\n  width: 46px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50px;\n   z-index: 10000;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(15px);\n  -webkit-transition: all 200ms linear;\n  transition: all 200ms linear;\n}\n.progress-wrap.active-progress {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n.progress-wrap svg.progress-circle path {\n  stroke: #001b44;\n  stroke-width: 4;\n  box-sizing: border-box;\n  -webkit-transition: all 200ms linear;\n  transition: all 200ms linear;\n}\n.progress-wrap svg path {\n  fill: none;\n}\n \n#top_scroll{\n  top: 34px;\n  position: relative;\n}\n\n \n#scroll_svg:hover path, .progress-wrap.active-progress:hover path, .progress-wrap.active-progress:hover #top_scroll{\n  stroke: #ff5956 !important;\n  color: #ff5956;\n  top: 26px;\n  position: relative;\n}\n\n.preloader-close:hover {\n  background: white;\n  color: black;\n}\n\n\nul {\n  padding-left: 0 !important;\n}\n\n\n\n  /*--------------------------------------------------------------\n  # Custom Cursor\n  --------------------------------------------------------------*/\n  .custom-cursor__cursor {\n    width: 25px;\n    height: 25px;\n    border-radius: 100%;\n    border: 1px solid #002c5d !important;\n    -webkit-transition: all 200ms ease-out;\n    transition: all 200ms ease-out;\n    position: fixed;\n    pointer-events: none;\n    left: 0;\n    top: 0;\n    -webkit-transform: translate(calc(-50% + 5px), -50%);\n    transform: translate(calc(-50% + 5px), -50%);\n    z-index: 999991;\n  }\n  .custom-cursor__cursor-two {\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n    background-color:#ff5956 !important;\n    opacity: 0.3;\n    position: fixed;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    pointer-events: none;\n    -webkit-transition: width 0.3s, height 0.3s, opacity 0.3s;\n    transition: width 0.3s, height 0.3s, opacity 0.3s;\n    z-index: 999991;\n  }\n  .custom-cursor__hover {\n    background-color: #002c5d !important;\n    opacity: 0.4;\n  }\n  .custom-cursor__innerhover {\n    width: 25px;\n    height: 25px;\n    opacity: 0.4;\n  }\n\n  nav .collapse:nth-of-type(2) {\n    display: none !important;\n}\n\n@media only screen and (max-width: 991px) {\n  .col-sm-12-f {\n    width: 50% !important;\n}\n  footer img {\n    width: 15% !important;\n}\n  .main-header .main-menu {\n      max-width: 920px;\n      margin: 0 auto;\n      float: none;\n      display: none;\n      margin: 0 !important;\n  }\n}\n\n@media  (min-width: 1501px) and  (max-width: 1154px) {\n  .main-menu .navigation > li {\n    margin: 0 !important; \n  }\n}\n@media  (min-width: 992px) and  (max-width: 1700px) {\n\n.industries-section .tabs-content .inner-box .content-box{\n  width: 95% !important;\n}\n}\n@media  (min-width: 992px) and  (max-width: 1500px) {\n\n  .industries-section .tabs-content .inner-box .content-box{\n    width: 80% !important;\n  }\n  }\n.btn.btn-primary{\n  --bs-btn-border-color :none !important\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
